const brShape = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "id": "BR",
      "properties": {
        "name": "Brazil",
        "density": 1
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -57.60279254791258,
                -30.190516950362447
              ],
              [
                -57.61169836377427,
                -30.182962741380845
              ],
              [
                -57.568651895318766,
                -30.176554861910464
              ],
              [
                -57.54860144066515,
                -30.170043638188805
              ],
              [
                -57.50617509031845,
                -30.144308778727332
              ],
              [
                -57.41145218887632,
                -30.039612324324374
              ],
              [
                -57.32515257467044,
                -29.98101139657173
              ],
              [
                -57.3187446726988,
                -29.965508335847993
              ],
              [
                -57.30851273233976,
                -29.84851285216868
              ],
              [
                -57.29151118074784,
                -29.815129851593216
              ],
              [
                -57.26257238929785,
                -29.792598986225883
              ],
              [
                -57.219629275497326,
                -29.77833629692543
              ],
              [
                -57.17746128424621,
                -29.772858471731507
              ],
              [
                -57.13338131996011,
                -29.772135183404675
              ],
              [
                -57.11286578172709,
                -29.766037391110476
              ],
              [
                -57.0941588945226,
                -29.75198129932811
              ],
              [
                -57.020933364846314,
                -29.683354853775825
              ],
              [
                -57.01359531621054,
                -29.673122944247773
              ],
              [
                -57.00884109866691,
                -29.66258103365779
              ],
              [
                -56.97938555282489,
                -29.63498593811957
              ],
              [
                -56.965794648518,
                -29.600879474576754
              ],
              [
                -56.951635300944716,
                -29.58630669471247
              ],
              [
                -56.912412868617686,
                -29.55840130623867
              ],
              [
                -56.90435136659933,
                -29.549616437232
              ],
              [
                -56.89727170160369,
                -29.53566383446882
              ],
              [
                -56.81903357911049,
                -29.47499567815477
              ],
              [
                -56.814951115136566,
                -29.467037358406824
              ],
              [
                -56.812935777154095,
                -29.45711572991144
              ],
              [
                -56.807561398853096,
                -29.444713224683657
              ],
              [
                -56.79983578737847,
                -29.433964610073442
              ],
              [
                -56.78342849397929,
                -29.425799581432805
              ],
              [
                -56.782033237934,
                -29.416601222121717
              ],
              [
                -56.78255002447885,
                -29.40543923706484
              ],
              [
                -56.780818846583365,
                -29.395310559843814
              ],
              [
                -56.77578038446675,
                -29.386422160311334
              ],
              [
                -56.76994093714947,
                -29.37908404103223
              ],
              [
                -56.76270623711295,
                -29.372882875523146
              ],
              [
                -56.75355953731904,
                -29.367405335238832
              ],
              [
                -56.71813535286926,
                -29.35148905529401
              ],
              [
                -56.70550046200415,
                -29.343737569010443
              ],
              [
                -56.688653941677394,
                -29.32957820684075
              ],
              [
                -56.67702675127108,
                -29.313351846155253
              ],
              [
                -56.660645320959325,
                -29.27087381082965
              ],
              [
                -56.65046504742859,
                -29.25134002367174
              ],
              [
                -56.65728633340897,
                -29.23790413306705
              ],
              [
                -56.65630450427388,
                -29.223434871298252
              ],
              [
                -56.65067173798742,
                -29.209068617311868
              ],
              [
                -56.64366960267309,
                -29.196149630169028
              ],
              [
                -56.61728877530051,
                -29.160906254173685
              ],
              [
                -56.58421584464172,
                -29.13227742986002
              ],
              [
                -56.54830072613165,
                -29.10995322043332
              ],
              [
                -56.51331581240348,
                -29.09372700577164
              ],
              [
                -56.44427605804865,
                -29.07812047847129
              ],
              [
                -56.42797215808595,
                -29.06985233833336
              ],
              [
                -56.415750708134055,
                -29.051352329611877
              ],
              [
                -56.41192664686937,
                -29.03181860649996
              ],
              [
                -56.41091895848831,
                -28.99130429430532
              ],
              [
                -56.391617795671856,
                -28.952236823107594
              ],
              [
                -56.32306898861093,
                -28.91647661191823
              ],
              [
                -56.3010031911893,
                -28.88144022722214
              ],
              [
                -56.29482783975572,
                -28.79576059752495
              ],
              [
                -56.286146218633164,
                -28.780154429677737
              ],
              [
                -56.26547561098335,
                -28.771989344057236
              ],
              [
                -56.21845006572467,
                -28.764134572845023
              ],
              [
                -56.18470535017267,
                -28.74418744310537
              ],
              [
                -56.10300491725342,
                -28.64806931470685
              ],
              [
                -56.04081231803676,
                -28.60900185749792
              ],
              [
                -56.02189874204395,
                -28.58574744385445
              ],
              [
                -56.020503480819784,
                -28.54626666562259
              ],
              [
                -56.022958148146515,
                -28.5282834991297
              ],
              [
                -56.021433676333736,
                -28.510403343065136
              ],
              [
                -56.01158932941752,
                -28.496554146297395
              ],
              [
                -55.97913649403818,
                -28.489215866829706
              ],
              [
                -55.95159299317135,
                -28.476710407402976
              ],
              [
                -55.91908851690542,
                -28.47340311383104
              ],
              [
                -55.91066525241564,
                -28.47050919352623
              ],
              [
                -55.90203526919414,
                -28.46513472501752
              ],
              [
                -55.898056198510375,
                -28.460690647282487
              ],
              [
                -55.896919323766674,
                -28.453455986242563
              ],
              [
                -55.89666090865024,
                -28.406843642929815
              ],
              [
                -55.90038162708128,
                -28.39847215727062
              ],
              [
                -55.90560097492005,
                -28.37800846437928
              ],
              [
                -55.88735919099111,
                -28.363332333959473
              ],
              [
                -55.842348992449125,
                -28.346382297609576
              ],
              [
                -55.81253170122591,
                -28.353203653248666
              ],
              [
                -55.7711905484559,
                -28.35754443174539
              ],
              [
                -55.73460362424753,
                -28.36591594963523
              ],
              [
                -55.71884231247563,
                -28.38451946615115
              ],
              [
                -55.71496660528256,
                -28.40446672569407
              ],
              [
                -55.70569069044658,
                -28.407670697044296
              ],
              [
                -55.69424436510552,
                -28.400125966329608
              ],
              [
                -55.6840640754888,
                -28.388033476753925
              ],
              [
                -55.67737196923819,
                -28.373874082836164
              ],
              [
                -55.66360021702974,
                -28.326538575273077
              ],
              [
                -55.67721696504832,
                -28.301837291876023
              ],
              [
                -55.687216348321805,
                -28.290055028715507
              ],
              [
                -55.70145321692719,
                -28.284990805726924
              ],
              [
                -55.7147082098488,
                -28.281890143408326
              ],
              [
                -55.754602408041784,
                -28.265663700375544
              ],
              [
                -55.76659133558356,
                -28.257602142843552
              ],
              [
                -55.77253411839978,
                -28.23197059352662
              ],
              [
                -55.747936166841995,
                -28.215744379089593
              ],
              [
                -55.68406410768465,
                -28.196210763541288
              ],
              [
                -55.64199946911043,
                -28.16034717594508
              ],
              [
                -55.63254268949137,
                -28.154662816055033
              ],
              [
                -55.62383519788894,
                -28.14618779418498
              ],
              [
                -55.62304188846539,
                -28.144350086584907
              ],
              [
                -55.61665218694478,
                -28.129548073025816
              ],
              [
                -55.604740744163664,
                -28.116938857979928
              ],
              [
                -55.58164138757505,
                -28.121073033236467
              ],
              [
                -55.578540791104,
                -28.127480836827665
              ],
              [
                -55.57931594883292,
                -28.13636925895445
              ],
              [
                -55.577093881478696,
                -28.14432755461158
              ],
              [
                -55.56487237426206,
                -28.147737993606032
              ],
              [
                -55.55347774086747,
                -28.145567714359665
              ],
              [
                -55.549731205118164,
                -28.13988334735517
              ],
              [
                -55.54828424225799,
                -28.132235088993077
              ],
              [
                -55.543762581404394,
                -28.124173738849056
              ],
              [
                -55.537871465554886,
                -28.119316136608106
              ],
              [
                -55.52479731297666,
                -28.110634395696493
              ],
              [
                -55.52022393521592,
                -28.106810257779568
              ],
              [
                -55.509914500409685,
                -28.083969352914632
              ],
              [
                -55.50593541086592,
                -28.078905040093595
              ],
              [
                -55.49296462210931,
                -28.073944072429963
              ],
              [
                -55.486530925830436,
                -28.07714813734432
              ],
              [
                -55.48231929250591,
                -28.083142575524565
              ],
              [
                -55.47549802170681,
                -28.08634663802646
              ],
              [
                -55.46485264059732,
                -28.085106171734427
              ],
              [
                -55.440745591882596,
                -28.078905040093595
              ],
              [
                -55.43508704508637,
                -28.07074030710605
              ],
              [
                -55.38984433133547,
                -28.024231539339127
              ],
              [
                -55.38338476176614,
                -28.01420621058542
              ],
              [
                -55.38142105206908,
                -28.008728478147464
              ],
              [
                -55.38242876310726,
                -27.987334565057452
              ],
              [
                -55.38093012053916,
                -27.9782393396337
              ],
              [
                -55.37643430571452,
                -27.973175284531276
              ],
              [
                -55.36909622337344,
                -27.970797977958593
              ],
              [
                -55.35886429398829,
                -27.970281237434953
              ],
              [
                -55.33790950387285,
                -27.963149915669987
              ],
              [
                -55.3330261025931,
                -27.946613598096853
              ],
              [
                -55.329873825668834,
                -27.928113338964117
              ],
              [
                -55.3141125077226,
                -27.91498747966074
              ],
              [
                -55.301761846389056,
                -27.913953994192973
              ],
              [
                -55.28078121876433,
                -27.920568600229725
              ],
              [
                -55.270084184797426,
                -27.9224288730873
              ],
              [
                -55.26023984555289,
                -27.91922506967034
              ],
              [
                -55.2240404809362,
                -27.89380011029027
              ],
              [
                -55.21230993965824,
                -27.87716035743291
              ],
              [
                -55.19773719094002,
                -27.860623933144254
              ],
              [
                -55.17755753838905,
                -27.853595901703297
              ],
              [
                -55.161460348586736,
                -27.85824690688253
              ],
              [
                -55.13970455519156,
                -27.87674696209202
              ],
              [
                -55.11924066349913,
                -27.880880914934455
              ],
              [
                -55.11138586986807,
                -27.852975807618257
              ],
              [
                -55.108698685109395,
                -27.846774564799404
              ],
              [
                -55.099939545788516,
                -27.843777441647596
              ],
              [
                -55.07789955000694,
                -27.843364045299793
              ],
              [
                -55.0677192697211,
                -27.839333129828468
              ],
              [
                -55.04580849067498,
                -27.850702129067468
              ],
              [
                -55.029633766669484,
                -27.850702129067468
              ],
              [
                -55.02580967916876,
                -27.840159922752363
              ],
              [
                -55.04043412951784,
                -27.819489484051022
              ],
              [
                -55.07125911406481,
                -27.79437468881626
              ],
              [
                -55.0811551394205,
                -27.778251564730088
              ],
              [
                -55.06430865693064,
                -27.771017093289768
              ],
              [
                -55.04464575584154,
                -27.77504772782672
              ],
              [
                -55.02759253872457,
                -27.783005944413325
              ],
              [
                -55.00911818840039,
                -27.788380119054175
              ],
              [
                -54.98519201578245,
                -27.785279633930994
              ],
              [
                -54.93299883096767,
                -27.7438352169749
              ],
              [
                -54.91320674232862,
                -27.73691047755179
              ],
              [
                -54.90690221557003,
                -27.72709193714706
              ],
              [
                -54.9015795464003,
                -27.704457684645078
              ],
              [
                -54.8964635645315,
                -27.661152735009022
              ],
              [
                -54.89827227767086,
                -27.623635900806605
              ],
              [
                -54.88979730838828,
                -27.620638431845833
              ],
              [
                -54.865406031843364,
                -27.620845133141525
              ],
              [
                -54.84509722212339,
                -27.6118536242844
              ],
              [
                -54.837009835124086,
                -27.590459412974134
              ],
              [
                -54.833676731478135,
                -27.56534483799278
              ],
              [
                -54.82752724320232,
                -27.54508772836433
              ],
              [
                -54.81889725642152,
                -27.536199228318868
              ],
              [
                -54.80504799552384,
                -27.5263808627935
              ],
              [
                -54.79223220256678,
                -27.523176673413836
              ],
              [
                -54.78654781420045,
                -27.534235555674144
              ],
              [
                -54.78853734667641,
                -27.538576305422087
              ],
              [
                -54.7921288446977,
                -27.54426061885955
              ],
              [
                -54.79373084580345,
                -27.54922177307365
              ],
              [
                -54.79001013762456,
                -27.551288795041568
              ],
              [
                -54.78802059153006,
                -27.552839061347935
              ],
              [
                -54.78169020991701,
                -27.56007363551869
              ],
              [
                -54.780346661979586,
                -27.56214095656536
              ],
              [
                -54.77393877858548,
                -27.56379457286411
              ],
              [
                -54.731899989618704,
                -27.551288795041568
              ],
              [
                -54.72195227731467,
                -27.550978741762847
              ],
              [
                -54.69967972910882,
                -27.55304576351113
              ],
              [
                -54.690326299614426,
                -27.551288795041568
              ],
              [
                -54.68112790684992,
                -27.546431293007863
              ],
              [
                -54.677200465021244,
                -27.541780191416425
              ],
              [
                -54.67645117519401,
                -27.534235555674144
              ],
              [
                -54.67668370636646,
                -27.520592891566974
              ],
              [
                -54.673479769244935,
                -27.509740853281052
              ],
              [
                -54.6664517869146,
                -27.50384982542864
              ],
              [
                -54.65947547099088,
                -27.502816311560633
              ],
              [
                -54.656194008610555,
                -27.50726042074927
              ],
              [
                -54.651233051523576,
                -27.52586380611443
              ],
              [
                -54.63952838157333,
                -27.526794267773557
              ],
              [
                -54.625911624113456,
                -27.51532197537423
              ],
              [
                -54.61524043554074,
                -27.496718428248602
              ],
              [
                -54.60981440216734,
                -27.478528267108224
              ],
              [
                -54.60531857168508,
                -27.467986407294017
              ],
              [
                -54.598497276253404,
                -27.45909801739633
              ],
              [
                -54.58945388937116,
                -27.452586712008177
              ],
              [
                -54.58382115918414,
                -27.452069953558826
              ],
              [
                -54.57855018140851,
                -27.45424048916513
              ],
              [
                -54.57054033313275,
                -27.45568741260775
              ],
              [
                -54.56723303441012,
                -27.459614775640087
              ],
              [
                -54.55762120667737,
                -27.477804806344313
              ],
              [
                -54.55379716275243,
                -27.482972532788445
              ],
              [
                -54.54325516304398,
                -27.487003241173703
              ],
              [
                -54.53353999315625,
                -27.487416647108816
              ],
              [
                -54.46858272857422,
                -27.470260142302017
              ],
              [
                -54.44837724049505,
                -27.458891314094572
              ],
              [
                -54.44765377137168,
                -27.445765499264844
              ],
              [
                -54.46455195354014,
                -27.423337859775035
              ],
              [
                -54.46083126533813,
                -27.412589263432807
              ],
              [
                -54.44455317235941,
                -27.408971795707533
              ],
              [
                -54.404245557234844,
                -27.407421516557786
              ],
              [
                -54.38889767422886,
                -27.411142336517074
              ],
              [
                -54.37871740140213,
                -27.422717748620748
              ],
              [
                -54.374996706368556,
                -27.445765499264844
              ],
              [
                -54.37158607012963,
                -27.45444719252134
              ],
              [
                -54.363472849828725,
                -27.453516877178973
              ],
              [
                -54.35432613258642,
                -27.44628225789772
              ],
              [
                -54.34771154398416,
                -27.435843580389857
              ],
              [
                -54.34610958877984,
                -27.42654191728735
              ],
              [
                -54.34771155648433,
                -27.394295814508666
              ],
              [
                -54.3340172879332,
                -27.406077941188453
              ],
              [
                -54.32151159491655,
                -27.41951384065193
              ],
              [
                -54.306938850308256,
                -27.4289190094265
              ],
              [
                -54.28688839415754,
                -27.428402250292468
              ],
              [
                -54.28192744119192,
                -27.424371378318284
              ],
              [
                -54.27489945765731,
                -27.416103228321294
              ],
              [
                -54.268594924630705,
                -27.40638799705167
              ],
              [
                -54.265804407041635,
                -27.3980164869064
              ],
              [
                -54.26125687009483,
                -27.388714654287075
              ],
              [
                -54.250714882130815,
                -27.38520068416589
              ],
              [
                -54.23924271472434,
                -27.38385710717936
              ],
              [
                -54.23164628421718,
                -27.38054984033828
              ],
              [
                -54.22957921331292,
                -27.371971464021488
              ],
              [
                -54.23180131839157,
                -27.351507728173882
              ],
              [
                -54.22792557265822,
                -27.343032691006734
              ],
              [
                -54.22255122739314,
                -27.33683155184773
              ],
              [
                -54.21815873672234,
                -27.329286829853107
              ],
              [
                -54.18952997897963,
                -27.2608671380202
              ],
              [
                -54.17702428516146,
                -27.24340051917501
              ],
              [
                -54.1647769695849,
                -27.250635215160507
              ],
              [
                -54.155940298575516,
                -27.257663203125723
              ],
              [
                -54.15805904891474,
                -27.27947077125385
              ],
              [
                -54.128190067574884,
                -27.288875858943918
              ],
              [
                -54.09175818393091,
                -27.28515516543796
              ],
              [
                -54.018119254038965,
                -27.212291297995673
              ],
              [
                -54.01088457162421,
                -27.1939979647265
              ],
              [
                -54.00514848491535,
                -27.188210192720046
              ],
              [
                -53.99729366766024,
                -27.18728001493293
              ],
              [
                -53.992694465405116,
                -27.190070548175427
              ],
              [
                -53.98845699946192,
                -27.1937912586099
              ],
              [
                -53.98148068202674,
                -27.195651613588428
              ],
              [
                -53.961791959820474,
                -27.191414138127882
              ],
              [
                -53.961068486439046,
                -27.18076876931684
              ],
              [
                -53.966236124065205,
                -27.16722950639975
              ],
              [
                -53.9641173837822,
                -27.154000294983017
              ],
              [
                -53.950888213460395,
                -27.14779909945125
              ],
              [
                -53.938537551545494,
                -27.155447240361823
              ],
              [
                -53.92541174260787,
                -27.16598926816201
              ],
              [
                -53.909495401605454,
                -27.16826303821176
              ],
              [
                -53.8994184930617,
                -27.158444484064592
              ],
              [
                -53.89084020784204,
                -27.127128585696305
              ],
              [
                -53.882210238660626,
                -27.119893848914344
              ],
              [
                -53.86877437093681,
                -27.125888345265665
              ],
              [
                -53.8578706527186,
                -27.14097793262892
              ],
              [
                -53.84877558963772,
                -27.15751430502721
              ],
              [
                -53.84200597838383,
                -27.1635087914795
              ],
              [
                -53.830017044271315,
                -27.15679083241596
              ],
              [
                -53.81921668105328,
                -27.1397376929465
              ],
              [
                -53.81875158779983,
                -27.131469426678432
              ],
              [
                -53.828260045089316,
                -27.121754210016764
              ],
              [
                -53.8287251487597,
                -27.114416268361133
              ],
              [
                -53.824332647919235,
                -27.109351950086054
              ],
              [
                -53.809759887089974,
                -27.100980319524403
              ],
              [
                -53.80490229736423,
                -27.09436569575092
              ],
              [
                -53.80324865883548,
                -27.08061982508362
              ],
              [
                -53.80500564941368,
                -27.052197726956134
              ],
              [
                -53.800923217172674,
                -27.039071955084836
              ],
              [
                -53.795807246359125,
                -27.035867988805943
              ],
              [
                -53.78004593295274,
                -27.03380091357137
              ],
              [
                -53.77317298346084,
                -27.030183681728218
              ],
              [
                -53.76847042080595,
                -27.02408580793597
              ],
              [
                -53.72459713074561,
                -26.94047334780558
              ],
              [
                -53.712504843072125,
                -26.90450653875674
              ],
              [
                -53.71069617092562,
                -26.873810758466426
              ],
              [
                -53.72242671828279,
                -26.814382842342386
              ],
              [
                -53.734002235464075,
                -26.77738248948563
              ],
              [
                -53.73756790564877,
                -26.775728814627627
              ],
              [
                -53.749660188667136,
                -26.774901977168792
              ],
              [
                -53.7529158211383,
                -26.773248452416354
              ],
              [
                -53.753897669062574,
                -26.76311984168253
              ],
              [
                -53.747283070796165,
                -26.74906374736076
              ],
              [
                -53.747851527668786,
                -26.739141989497764
              ],
              [
                -53.75245072266685,
                -26.73593799091838
              ],
              [
                -53.76108069911848,
                -26.732837497088294
              ],
              [
                -53.76965897029154,
                -26.726636208190328
              ],
              [
                -53.774309858080976,
                -26.714337282585152
              ],
              [
                -53.771726029495944,
                -26.703691880955564
              ],
              [
                -53.76361284207119,
                -26.700798094239346
              ],
              [
                -53.75374263983313,
                -26.69955783548329
              ],
              [
                -53.746042857060104,
                -26.69387346589927
              ],
              [
                -53.739531617875045,
                -26.67557994243794
              ],
              [
                -53.737877961170355,
                -26.657079700580802
              ],
              [
                -53.74294226448338,
                -26.619149296736254
              ],
              [
                -53.74237382938019,
                -26.600545825402733
              ],
              [
                -53.729609747696614,
                -26.565819235270958
              ],
              [
                -53.72681920672275,
                -26.54855921092724
              ],
              [
                -53.72821448096401,
                -26.551866579018228
              ],
              [
                -53.73183183158366,
                -26.545562058632417
              ],
              [
                -53.73560419902937,
                -26.535123326285937
              ],
              [
                -53.737464559520944,
                -26.525304873877257
              ],
              [
                -53.734570677259114,
                -26.518276863036345
              ],
              [
                -53.72743932732334,
                -26.511352206602986
              ],
              [
                -53.71291825578837,
                -26.500500196341772
              ],
              [
                -53.71291825502414,
                -26.500293485640846
              ],
              [
                -53.7127632267871,
                -26.469597689363923
              ],
              [
                -53.72444210454927,
                -26.376063383320343
              ],
              [
                -53.715863814395405,
                -26.34671115318194
              ],
              [
                -53.673230745471805,
                -26.292554161883736
              ],
              [
                -53.66155188430429,
                -26.259791393748582
              ],
              [
                -53.666719519381324,
                -26.219173658383326
              ],
              [
                -53.68511633353211,
                -26.187651066069968
              ],
              [
                -53.73338212433196,
                -26.1263628395844
              ],
              [
                -53.74676632102231,
                -26.091636281963
              ],
              [
                -53.75348425509846,
                -26.058666695477235
              ],
              [
                -53.765008095061766,
                -26.02807421627594
              ],
              [
                -53.792706670364474,
                -26.00058241081273
              ],
              [
                -53.792706670008755,
                -26.000479055057127
              ],
              [
                -53.79286169865308,
                -26.000375699301554
              ],
              [
                -53.82619299376805,
                -25.972677108959786
              ],
              [
                -53.83342769581755,
                -25.962238479113676
              ],
              [
                -53.836063187742425,
                -25.949732734908732
              ],
              [
                -53.83394445981944,
                -25.94032766337423
              ],
              [
                -53.830585488875585,
                -25.93164600724796
              ],
              [
                -53.82960363864503,
                -25.921310735026218
              ],
              [
                -53.84164425115474,
                -25.867670625503703
              ],
              [
                -53.83730342932845,
                -25.809172898165162
              ],
              [
                -53.84035233630322,
                -25.791396181387615
              ],
              [
                -53.849344040688194,
                -25.77289605395366
              ],
              [
                -53.85781897088944,
                -25.763180854016316
              ],
              [
                -53.87704260444372,
                -25.746127635398828
              ],
              [
                -53.88345048560345,
                -25.735585669373382
              ],
              [
                -53.88551753800711,
                -25.722563172056898
              ],
              [
                -53.882520304042224,
                -25.713468111419488
              ],
              [
                -53.87828284172416,
                -25.706130095499482
              ],
              [
                -53.87647415918819,
                -25.697861805785813
              ],
              [
                -53.88753292211293,
                -25.661274947744463
              ],
              [
                -53.898126588574556,
                -25.639467480536304
              ],
              [
                -53.909960488534686,
                -25.629235522327214
              ],
              [
                -53.94809769538293,
                -25.65062956415033
              ],
              [
                -53.96773473791911,
                -25.653213374531525
              ],
              [
                -53.976209674092665,
                -25.6275818738225
              ],
              [
                -53.97827673578786,
                -25.60701468325145
              ],
              [
                -53.98499467090016,
                -25.589341336184937
              ],
              [
                -53.99744869108556,
                -25.574975288673215
              ],
              [
                -54.01651729429612,
                -25.565053408367564
              ],
              [
                -54.03021155029709,
                -25.56215953636785
              ],
              [
                -54.036774453759,
                -25.564536632085204
              ],
              [
                -54.0429239508578,
                -25.568464056851088
              ],
              [
                -54.05537796907054,
                -25.57073779759691
              ],
              [
                -54.07248287056213,
                -25.55533824049281
              ],
              [
                -54.08271480242015,
                -25.550067236366203
              ],
              [
                -54.08927771119667,
                -25.558852243557237
              ],
              [
                -54.08876094657478,
                -25.568360701587224
              ],
              [
                -54.08648718416146,
                -25.579832874260806
              ],
              [
                -54.08576371291343,
                -25.590581562311247
              ],
              [
                -54.08963944736376,
                -25.59740286285697
              ],
              [
                -54.09888952765505,
                -25.5971961522148
              ],
              [
                -54.108966429918354,
                -25.59027149638786
              ],
              [
                -54.11769974658399,
                -25.580556323717868
              ],
              [
                -54.12312577504013,
                -25.571771350293513
              ],
              [
                -54.12596797751815,
                -25.552030948138082
              ],
              [
                -54.12018021734297,
                -25.53549448974304
              ],
              [
                -54.11186031334054,
                -25.51937145774601
              ],
              [
                -54.10715775810217,
                -25.500561235864588
              ],
              [
                -54.11144689900451,
                -25.49591033101249
              ],
              [
                -54.11640783702809,
                -25.49456675222577
              ],
              [
                -54.12209224479154,
                -25.496220396328265
              ],
              [
                -54.12819006610304,
                -25.500561235864588
              ],
              [
                -54.15428666086366,
                -25.528259776913533
              ],
              [
                -54.165087037898886,
                -25.53435762017444
              ],
              [
                -54.17769608729268,
                -25.535804555327278
              ],
              [
                -54.196713010959414,
                -25.529603356697525
              ],
              [
                -54.206944945044654,
                -25.527949711378938
              ],
              [
                -54.21479976355302,
                -25.531463712445163
              ],
              [
                -54.19469763194791,
                -25.563296406585742
              ],
              [
                -54.19025345815723,
                -25.580763034294982
              ],
              [
                -54.20994217871759,
                -25.582209970801486
              ],
              [
                -54.2289591083513,
                -25.577042356702105
              ],
              [
                -54.235108603365305,
                -25.576732290858995
              ],
              [
                -54.243686889063554,
                -25.57755909555496
              ],
              [
                -54.24962967839751,
                -25.59326872527708
              ],
              [
                -54.25562414569226,
                -25.59874644449421
              ],
              [
                -54.263168903334076,
                -25.590064785773244
              ],
              [
                -54.27365922271564,
                -25.568774122643994
              ],
              [
                -54.28440791903421,
                -25.556785176273284
              ],
              [
                -54.29923905720126,
                -25.552651079521283
              ],
              [
                -54.32171830287669,
                -25.555131530019562
              ],
              [
                -54.33308711873795,
                -25.561952825866207
              ],
              [
                -54.34967525129208,
                -25.582416681385187
              ],
              [
                -54.36011389214096,
                -25.58427703911894
              ],
              [
                -54.37778723134905,
                -25.577662450837447
              ],
              [
                -54.38621048791019,
                -25.5771456744271
              ],
              [
                -54.39540889514658,
                -25.58107310016221
              ],
              [
                -54.4028502999125,
                -25.59027149638786
              ],
              [
                -54.40367712531483,
                -25.600193381491387
              ],
              [
                -54.4027986272897,
                -25.61032197910379
              ],
              [
                -54.40507238607954,
                -25.6198304088287
              ],
              [
                -54.4126688249315,
                -25.627271845247755
              ],
              [
                -54.431324018011445,
                -25.63688367074649
              ],
              [
                -54.4374218340105,
                -25.645048522084025
              ],
              [
                -54.437731897738516,
                -25.655383838430822
              ],
              [
                -54.43313269500377,
                -25.67657117846742
              ],
              [
                -54.43731848522936,
                -25.685252812360876
              ],
              [
                -54.44734370572013,
                -25.68918017025646
              ],
              [
                -54.453544878550645,
                -25.683185702916123
              ],
              [
                -54.45654211617212,
                -25.67264374621151
              ],
              [
                -54.45700720255448,
                -25.663135270496518
              ],
              [
                -54.46057287605555,
                -25.642051290438815
              ],
              [
                -54.473026898098205,
                -25.625824907547422
              ],
              [
                -54.491061971367124,
                -25.614042659006337
              ],
              [
                -54.51142248530831,
                -25.60618784054116
              ],
              [
                -54.532299762552775,
                -25.610632007585462
              ],
              [
                -54.538707640927974,
                -25.601330252539938
              ],
              [
                -54.53999955099567,
                -25.586757491162462
              ],
              [
                -54.54563228439426,
                -25.574768578119283
              ],
              [
                -54.56005000924048,
                -25.57022105881288
              ],
              [
                -54.600202610971046,
                -25.574944867970263
              ],
              [
                -54.599944214137146,
                -25.572701510181993
              ],
              [
                -54.59415645397265,
                -25.548620300783888
              ],
              [
                -54.591469277372696,
                -25.52474577608804
              ],
              [
                -54.598497271842234,
                -25.505832196853916
              ],
              [
                -54.60852250214851,
                -25.487642111182097
              ],
              [
                -54.61244990877852,
                -25.465524579293106
              ],
              [
                -54.611829791492546,
                -25.44402718896275
              ],
              [
                -54.6098144110384,
                -25.43276172332131
              ],
              [
                -54.59798051042623,
                -25.39751841541874
              ],
              [
                -54.57565628873838,
                -25.360311362801657
              ],
              [
                -54.547079225120065,
                -25.336643584036995
              ],
              [
                -54.528475709047065,
                -25.314319356381237
              ],
              [
                -54.50356766792203,
                -25.27866261736791
              ],
              [
                -54.48145015423371,
                -25.213240247746555
              ],
              [
                -54.46940954599539,
                -25.195463561962647
              ],
              [
                -54.435664836088094,
                -25.16704152472266
              ],
              [
                -54.42662146118836,
                -25.149471538548116
              ],
              [
                -54.429722045886635,
                -25.13055796206754
              ],
              [
                -54.45519852718239,
                -25.092110698505547
              ],
              [
                -54.463311726878636,
                -25.07278371099822
              ],
              [
                -54.4641902258091,
                -25.05593719342122
              ],
              [
                -54.46227819787848,
                -25.037230324993615
              ],
              [
                -54.45328649900165,
                -25.002813822014154
              ],
              [
                -54.40729446571326,
                -24.821222760516505
              ],
              [
                -54.39974971583042,
                -24.804789732565265
              ],
              [
                -54.37112096260541,
                -24.766652447185052
              ],
              [
                -54.35842945898533,
                -24.731421695737414
              ],
              [
                -54.32130489216872,
                -24.62836640405456
              ],
              [
                -54.320684788089224,
                -24.59591371552765
              ],
              [
                -54.33479243091764,
                -24.527287214238015
              ],
              [
                -54.33453407250522,
                -24.49669497010495
              ],
              [
                -54.32290687098221,
                -24.464345493748162
              ],
              [
                -54.284097850180885,
                -24.411325291965028
              ],
              [
                -54.27169552334558,
                -24.3894146354914
              ],
              [
                -54.26218706665415,
                -24.358512193998422
              ],
              [
                -54.261050158046075,
                -24.329469794702643
              ],
              [
                -54.27433101661627,
                -24.298257368136653
              ],
              [
                -54.28265091861302,
                -24.275312996715208
              ],
              [
                -54.30626706235987,
                -24.2466843835559
              ],
              [
                -54.31412188353107,
                -24.23417871481982
              ],
              [
                -54.31897944744221,
                -24.1967647904056
              ],
              [
                -54.33184687798456,
                -24.165035457230037
              ],
              [
                -54.33463742487732,
                -24.148912579026707
              ],
              [
                -54.32476722763502,
                -24.118216794093534
              ],
              [
                -54.301047742439934,
                -24.089898081757095
              ],
              [
                -54.26621781182504,
                -24.06592007640686
              ],
              [
                -54.24528884409492,
                -24.05062374655651
              ],
              [
                -54.24574983993312,
                -24.050393313236896
              ],
              [
                -54.2736075473938,
                -24.036464568630564
              ],
              [
                -54.36760697301979,
                -23.98468473608939
              ],
              [
                -54.42290077016505,
                -23.913784808592418
              ],
              [
                -54.443157922798385,
                -23.899935438528264
              ],
              [
                -54.61255324941902,
                -23.81115516099948
              ],
              [
                -54.639218318090606,
                -23.804437494650585
              ],
              [
                -54.65459202510971,
                -23.811465207171164
              ],
              [
                -54.679784308177155,
                -23.83668350717109
              ],
              [
                -54.696837526696335,
                -23.845158410496097
              ],
              [
                -54.82742385992503,
                -23.887016215008433
              ],
              [
                -54.89191604248605,
                -23.92060584634886
              ],
              [
                -54.90488684286269,
                -23.933008337748316
              ],
              [
                -54.92674596668738,
                -23.959880018348564
              ],
              [
                -54.94364415648142,
                -23.969181747669314
              ],
              [
                -54.96105913794344,
                -23.97176577883388
              ],
              [
                -54.99457129959779,
                -23.973109318897222
              ],
              [
                -55.01149533512802,
                -23.980550765331284
              ],
              [
                -55.04229448882483,
                -23.98902570640315
              ],
              [
                -55.105572282808964,
                -23.988508959957482
              ],
              [
                -55.13107458969079,
                -24.000394430791452
              ],
              [
                -55.131074588866475,
                -24.000601129446903
              ],
              [
                -55.13128129486654,
                -24.000601129446903
              ],
              [
                -55.16543942256223,
                -24.016827579031904
              ],
              [
                -55.200863606445346,
                -24.01951466307295
              ],
              [
                -55.23683039540022,
                -24.01269330360221
              ],
              [
                -55.2724096318764,
                -24.000601129446903
              ],
              [
                -55.27256466128955,
                -24.000497780118998
              ],
              [
                -55.272668013289596,
                -24.000497780118998
              ],
              [
                -55.27271969070284,
                -24.000394430791452
              ],
              [
                -55.304345658275295,
                -23.994089822019873
              ],
              [
                -55.36718421651915,
                -23.989645802149113
              ],
              [
                -55.398035029009854,
                -23.97682989167823
              ],
              [
                -55.42066932826812,
                -23.95450586067759
              ],
              [
                -55.43017776130502,
                -23.928564025990447
              ],
              [
                -55.445318967957654,
                -23.7354493015495
              ],
              [
                -55.46697139210054,
                -23.67323086062772
              ],
              [
                -55.51130978734276,
                -23.629409402320228
              ],
              [
                -55.53053341847433,
                -23.603467816487345
              ],
              [
                -55.533892359522106,
                -23.569981242731497
              ],
              [
                -55.53306555888496,
                -23.53401464999989
              ],
              [
                -55.53379561039307,
                -23.530444039921825
              ],
              [
                -55.53991266582169,
                -23.500528139148813
              ],
              [
                -55.542470672651135,
                -23.46580178571549
              ],
              [
                -55.51554723004587,
                -23.41019774564383
              ],
              [
                -55.51386775538581,
                -23.379398677815917
              ],
              [
                -55.52487484372947,
                -23.36048518932461
              ],
              [
                -55.55559646111532,
                -23.330305943669273
              ],
              [
                -55.56215940008984,
                -23.30787866944051
              ],
              [
                -55.559007136109955,
                -23.291342201502733
              ],
              [
                -55.535649365678736,
                -23.24586672335824
              ],
              [
                -55.53523595762265,
                -23.229123585771113
              ],
              [
                -55.55714676411802,
                -23.15470951981294
              ],
              [
                -55.560867457020485,
                -23.145924429997457
              ],
              [
                -55.588669378198695,
                -23.130111452985098
              ],
              [
                -55.599392254588146,
                -23.11708914692672
              ],
              [
                -55.600141570442595,
                -23.100552752428563
              ],
              [
                -55.59523231345471,
                -23.064069238886155
              ],
              [
                -55.600684173446524,
                -23.044535509187973
              ],
              [
                -55.61145871164964,
                -23.029135954073997
              ],
              [
                -55.63781368259394,
                -23.000713830541745
              ],
              [
                -55.63998407468838,
                -22.983763790992246
              ],
              [
                -55.63435137281803,
                -22.950071023658655
              ],
              [
                -55.634299681794374,
                -22.93281096254549
              ],
              [
                -55.656572228157025,
                -22.855709767125102
              ],
              [
                -55.65900102024969,
                -22.818296021514822
              ],
              [
                -55.645926867786876,
                -22.787910140969817
              ],
              [
                -55.62858943361645,
                -22.758971423512904
              ],
              [
                -55.61833167155806,
                -22.72569188748135
              ],
              [
                -55.619184329576605,
                -22.716906874431952
              ],
              [
                -55.62566970896371,
                -22.700783696303688
              ],
              [
                -55.62778844066946,
                -22.692102033144703
              ],
              [
                -55.62701332110338,
                -22.68362736365857
              ],
              [
                -55.62150977142091,
                -22.667090811335157
              ],
              [
                -55.620476235155465,
                -22.659339266526715
              ],
              [
                -55.62368016189371,
                -22.638668585601405
              ],
              [
                -55.63119910405598,
                -22.62678321026411
              ],
              [
                -55.64435074466314,
                -22.619548400035626
              ],
              [
                -55.664685438653024,
                -22.612727274436462
              ],
              [
                -55.697913381341756,
                -22.595570667428163
              ],
              [
                -55.7239324609758,
                -22.569629074592257
              ],
              [
                -55.74126988804582,
                -22.537176112407394
              ],
              [
                -55.74829789559723,
                -22.5008993782506
              ],
              [
                -55.7515793446558,
                -22.416253343873986
              ],
              [
                -55.76023515487435,
                -22.391965501208322
              ],
              [
                -55.77015703133656,
                -22.381423512754978
              ],
              [
                -55.81077469934128,
                -22.353104760341434
              ],
              [
                -55.86103002554899,
                -22.289542701332174
              ],
              [
                -55.87201126634181,
                -22.310213271356783
              ],
              [
                -55.87438839077488,
                -22.31734470197359
              ],
              [
                -55.89294023115911,
                -22.306802724542685
              ],
              [
                -55.9552620039594,
                -22.30132497060371
              ],
              [
                -55.97086828092597,
                -22.293883505539405
              ],
              [
                -55.985234331540646,
                -22.283238186125963
              ],
              [
                -55.99856684923858,
                -22.277243707372463
              ],
              [
                -56.01135677817637,
                -22.283858408238864
              ],
              [
                -56.02471512545544,
                -22.287372299323046
              ],
              [
                -56.196797643057764,
                -22.279310763778078
              ],
              [
                -56.21426427681257,
                -22.275383341634615
              ],
              [
                -56.23152421845954,
                -22.265358246792577
              ],
              [
                -56.261083124327065,
                -22.23858971783213
              ],
              [
                -56.31684199622334,
                -22.207687239097023
              ],
              [
                -56.34733109947245,
                -22.180402153958852
              ],
              [
                -56.370843867484645,
                -22.14732914899897
              ],
              [
                -56.39730220859723,
                -22.086247686492914
              ],
              [
                -56.40763749843868,
                -22.075809084217187
              ],
              [
                -56.42179683645599,
                -22.07446544829325
              ],
              [
                -56.49383378227507,
                -22.086557721696227
              ],
              [
                -56.51130040850999,
                -22.091415240443762
              ],
              [
                -56.521635707101964,
                -22.09989028793495
              ],
              [
                -56.53067907367375,
                -22.109088601684057
              ],
              [
                -56.54597530465034,
                -22.130069310660556
              ],
              [
                -56.54907588921897,
                -22.136270468670286
              ],
              [
                -56.55460527022371,
                -22.152083476211768
              ],
              [
                -56.55801591183252,
                -22.15642427287582
              ],
              [
                -56.56530229269292,
                -22.159938308515347
              ],
              [
                -56.56791194990657,
                -22.162315397339587
              ],
              [
                -56.58496517232802,
                -22.190530733393548
              ],
              [
                -56.59573970309524,
                -22.20148607574835
              ],
              [
                -56.62917436271046,
                -22.22474055344573
              ],
              [
                -56.63718419941898,
                -22.228254441829318
              ],
              [
                -56.64834631581301,
                -22.231355099592726
              ],
              [
                -56.65470251775963,
                -22.237349574766437
              ],
              [
                -56.64413468998704,
                -22.255436348334765
              ],
              [
                -56.64881140802284,
                -22.263497881345632
              ],
              [
                -56.66457271456466,
                -22.25998384115692
              ],
              [
                -56.698601643627455,
                -22.223500260387574
              ],
              [
                -56.71537064602148,
                -22.2154387315106
              ],
              [
                -56.720538289262166,
                -22.21946949584671
              ],
              [
                -56.72854813796359,
                -22.23745292002117
              ],
              [
                -56.733199014165805,
                -22.244067467241578
              ],
              [
                -56.7435342989215,
                -22.250371979208573
              ],
              [
                -56.74560135526512,
                -22.248408268854913
              ],
              [
                -56.74678991606789,
                -22.243964121978077
              ],
              [
                -56.75436050873441,
                -22.242620483354017
              ],
              [
                -56.786994182472725,
                -22.251818963240872
              ],
              [
                -56.79456477487912,
                -22.252542380161604
              ],
              [
                -56.80828487135639,
                -22.247994887778606
              ],
              [
                -56.81190222441122,
                -22.24964856230816
              ],
              [
                -56.81314245551245,
                -22.256159765289464
              ],
              [
                -56.819653693739475,
                -22.265461592084776
              ],
              [
                -56.84285640434731,
                -22.28902597470794
              ],
              [
                -56.85605973229686,
                -22.29316008822443
              ],
              [
                -56.8795466642816,
                -22.28995608263416
              ],
              [
                -56.88171707716344,
                -22.277243707372463
              ],
              [
                -56.89200069027353,
                -22.2522323443376
              ],
              [
                -56.903679571876566,
                -22.23693619374892
              ],
              [
                -56.914789994167,
                -22.26287765939924
              ],
              [
                -56.92494441706193,
                -22.2623609329571
              ],
              [
                -56.9425919194391,
                -22.253989364234602
              ],
              [
                -56.952100386643764,
                -22.25357598312845
              ],
              [
                -56.96052363523696,
                -22.254816126453548
              ],
              [
                -56.96548457200479,
                -22.250888705570155
              ],
              [
                -56.96455440906193,
                -22.234869138482985
              ],
              [
                -56.97571651372641,
                -22.241690376004836
              ],
              [
                -56.98646521413506,
                -22.241380340224243
              ],
              [
                -57.01116654341957,
                -22.23383553576492
              ],
              [
                -57.02765133156437,
                -22.235075828986012
              ],
              [
                -57.05948401616562,
                -22.232698738023032
              ],
              [
                -57.07162796974018,
                -22.235695900498364
              ],
              [
                -57.07922439923011,
                -22.23858971783213
              ],
              [
                -57.08506384014835,
                -22.23807299155236
              ],
              [
                -57.09074824531373,
                -22.23641931726897
              ],
              [
                -57.10847326772886,
                -22.233525500015496
              ],
              [
                -57.11327917632126,
                -22.22939138971801
              ],
              [
                -57.11462276523682,
                -22.225050589160528
              ],
              [
                -57.11503617835939,
                -22.222880188971352
              ],
              [
                -57.12418290841552,
                -22.218539388771493
              ],
              [
                -57.154155226741786,
                -22.207997274745356
              ],
              [
                -57.17038162861702,
                -22.205723529807603
              ],
              [
                -57.177926390592006,
                -22.20737720344987
              ],
              [
                -57.18361080273085,
                -22.210891241276617
              ],
              [
                -57.18996699773937,
                -22.213578367254254
              ],
              [
                -57.199527144191016,
                -22.212854950692826
              ],
              [
                -57.206400103782116,
                -22.20748054866547
              ],
              [
                -57.209449023118665,
                -22.192081061528736
              ],
              [
                -57.213789842102756,
                -22.188153643756117
              ],
              [
                -57.22748408879234,
                -22.19125414975446
              ],
              [
                -57.252443813058655,
                -22.210581205617057
              ],
              [
                -57.271667436117,
                -22.213785057701596
              ],
              [
                -57.31631587397576,
                -22.20365647535542
              ],
              [
                -57.33176713650313,
                -22.202416332836236
              ],
              [
                -57.33305904003814,
                -22.205413494168045
              ],
              [
                -57.3348160363569,
                -22.211718003041327
              ],
              [
                -57.33993200972337,
                -22.216989060125925
              ],
              [
                -57.3512491472076,
                -22.217195750582096
              ],
              [
                -57.366648722557045,
                -22.20913422234397
              ],
              [
                -57.37502030329456,
                -22.207273858234423
              ],
              [
                -57.37863765424973,
                -22.21337167680747
              ],
              [
                -57.38499385606086,
                -22.213268331584278
              ],
              [
                -57.41786006052271,
                -22.193837929878544
              ],
              [
                -57.43227779415949,
                -22.188670369712476
              ],
              [
                -57.44318152675592,
                -22.1879469533745
              ],
              [
                -57.46395544854126,
                -22.180402153958852
              ],
              [
                -57.4724820603572,
                -22.180298808777756
              ],
              [
                -57.51118770534725,
                -22.188773714904155
              ],
              [
                -57.53459713103081,
                -22.17440768303739
              ],
              [
                -57.54229691023874,
                -22.171513717804512
              ],
              [
                -57.55469926383892,
                -22.17027357577371
              ],
              [
                -57.55997024941939,
                -22.17161706297459
              ],
              [
                -57.5640010210324,
                -22.17440768303739
              ],
              [
                -57.57273432709171,
                -22.177714878870795
              ],
              [
                -57.59671219775058,
                -22.181022225048114
              ],
              [
                -57.61407547970681,
                -22.17699146262956
              ],
              [
                -57.627201291956744,
                -22.165105866878616
              ],
              [
                -57.638931845422846,
                -22.144538680050378
              ],
              [
                -57.65448645002433,
                -22.104541117233826
              ],
              [
                -57.6636848554289,
                -22.100613703521972
              ],
              [
                -57.67081620437439,
                -22.102370720183117
              ],
              [
                -57.67851599304956,
                -22.10640147906427
              ],
              [
                -57.68962641803972,
                -22.10929529187277
              ],
              [
                -57.70993526353437,
                -22.108468531120863
              ],
              [
                -57.723267780373014,
                -22.104747807411822
              ],
              [
                -57.73634192552693,
                -22.103714356526634
              ],
              [
                -57.75618566919789,
                -22.110638928322174
              ],
              [
                -57.760268105372134,
                -22.110742273418285
              ],
              [
                -57.769931592998624,
                -22.10743492998104
              ],
              [
                -57.77365230921303,
                -22.107745115469314
              ],
              [
                -57.77561600317263,
                -22.111155653804005
              ],
              [
                -57.77742467893853,
                -22.1170467751457
              ],
              [
                -57.777786419696334,
                -22.122317826224535
              ],
              [
                -57.7754093064134,
                -22.12397149821006
              ],
              [
                -57.787501594923526,
                -22.1296559301847
              ],
              [
                -57.79530472441508,
                -22.130999416738515
              ],
              [
                -57.805484984350365,
                -22.128622328792822
              ],
              [
                -57.81576859672058,
                -22.128312293440953
              ],
              [
                -57.83178828572457,
                -22.141127990184913
              ],
              [
                -57.84388058191151,
                -22.143711918960566
              ],
              [
                -57.84868648521364,
                -22.14030122912831
              ],
              [
                -57.8628458315982,
                -22.125831860455254
              ],
              [
                -57.871372431848904,
                -22.121180879811888
              ],
              [
                -57.878193729352006,
                -22.122111136004918
              ],
              [
                -57.89550532797593,
                -22.128932364145786
              ],
              [
                -57.906254025975294,
                -22.128932364145786
              ],
              [
                -57.939998740123116,
                -22.118390411714465
              ],
              [
                -57.95245276336975,
                -22.10598809870097
              ],
              [
                -57.961392786031666,
                -22.09007175449744
              ],
              [
                -57.972864945570024,
                -22.081183327690905
              ],
              [
                -57.9731336581733,
                -22.081048438351676
              ],
              [
                -57.98624914749632,
                -22.07446544829325
              ],
              [
                -57.98800614975278,
                -22.064130192417576
              ],
              [
                -57.98836787861782,
                -22.049040615782978
              ],
              [
                -57.986817583798306,
                -22.035294676932498
              ],
              [
                -57.96485509712676,
                -21.97669356762653
              ],
              [
                -57.96263300943253,
                -21.9669783919329
              ],
              [
                -57.95322790611757,
                -21.958193471738866
              ],
              [
                -57.92992183482779,
                -21.91736907834256
              ],
              [
                -57.92537431472191,
                -21.90496679113689
              ],
              [
                -57.93276404178176,
                -21.881919083474617
              ],
              [
                -57.94666499472834,
                -21.865485900782613
              ],
              [
                -57.9559150824248,
                -21.851119917408464
              ],
              [
                -57.94893876261587,
                -21.83385998061391
              ],
              [
                -57.935709601710286,
                -21.812052574910425
              ],
              [
                -57.93477942593898,
                -21.792932287497393
              ],
              [
                -57.938448444771595,
                -21.774638761100146
              ],
              [
                -57.93901688718877,
                -21.75531178983062
              ],
              [
                -57.89560868427214,
                -21.688442497378688
              ],
              [
                -57.901138063383996,
                -21.678934034471165
              ],
              [
                -57.91178340993668,
                -21.673042936583858
              ],
              [
                -57.924340776419356,
                -21.65867682413862
              ],
              [
                -57.93483109995374,
                -21.64069349951627
              ],
              [
                -57.93901689033194,
                -21.623743623477857
              ],
              [
                -57.93214392464544,
                -21.606690404562112
              ],
              [
                -57.91932817050844,
                -21.583952782028877
              ],
              [
                -57.91209346308948,
                -21.564005617326572
              ],
              [
                -57.92160193579109,
                -21.55542741338966
              ],
              [
                -57.93979203737467,
                -21.548192689765276
              ],
              [
                -57.94811193412431,
                -21.530519260313568
              ],
              [
                -57.94914546075857,
                -21.50829837011799
              ],
              [
                -57.94526973151939,
                -21.487214422901538
              ],
              [
                -57.9299218349103,
                -21.45310801112114
              ],
              [
                -57.86331090754204,
                -21.35688643135088
              ],
              [
                -57.85555944240798,
                -21.33073816482941
              ],
              [
                -57.866308144672956,
                -21.3209196849064
              ],
              [
                -57.8823278464676,
                -21.316372225944686
              ],
              [
                -57.8906477457121,
                -21.30593352915972
              ],
              [
                -57.89364497970643,
                -21.30035247510331
              ],
              [
                -57.89994950132989,
                -21.29508145464616
              ],
              [
                -57.90491044103337,
                -21.287433360458788
              ],
              [
                -57.90429031906203,
                -21.274927624233808
              ],
              [
                -57.89901932576531,
                -21.267176185922917
              ],
              [
                -57.87070064216872,
                -21.24764249888807
              ],
              [
                -57.84785965837665,
                -21.21622322001901
              ],
              [
                -57.833958702981874,
                -21.173848601579724
              ],
              [
                -57.82987626182772,
                -21.127029722289368
              ],
              [
                -57.83602575794691,
                -21.082484648419452
              ],
              [
                -57.85173539261657,
                -21.051995550136574
              ],
              [
                -57.85245886587581,
                -21.037836230632067
              ],
              [
                -57.82538041066724,
                -20.99856210071191
              ],
              [
                -57.81602697693076,
                -20.97541106033034
              ],
              [
                -57.81757727309715,
                -20.95360364792543
              ],
              [
                -57.83602575479238,
                -20.938514076957144
              ],
              [
                -57.840314899814345,
                -20.95598072116757
              ],
              [
                -57.84703283581413,
                -20.95598072116757
              ],
              [
                -57.8699254956325,
                -20.932726335332216
              ],
              [
                -57.89302486396844,
                -20.914846312648855
              ],
              [
                -57.898089153968606,
                -20.914846312648855
              ],
              [
                -57.901138061567686,
                -20.912365819686507
              ],
              [
                -57.90801102657255,
                -20.9105054687347
              ],
              [
                -57.9148323173384,
                -20.905647902357863
              ],
              [
                -57.917932905599464,
                -20.894382451950342
              ],
              [
                -57.9086828222762,
                -20.88156668374676
              ],
              [
                -57.86739335467444,
                -20.860069301744815
              ],
              [
                -57.85710973828346,
                -20.849733950820347
              ],
              [
                -57.85964188593284,
                -20.831647236329108
              ],
              [
                -57.87070064665125,
                -20.816454392538514
              ],
              [
                -57.887650510752394,
                -20.805912351504023
              ],
              [
                -57.908011026472174,
                -20.80198495971895
              ],
              [
                -57.9339525988269,
                -20.79971123027821
              ],
              [
                -57.94041215053537,
                -20.793613378352912
              ],
              [
                -57.93307409406093,
                -20.784621654590932
              ],
              [
                -57.91793290267138,
                -20.77407968771091
              ],
              [
                -57.90666743795239,
                -20.762194091492262
              ],
              [
                -57.89876094396401,
                -20.756613036602648
              ],
              [
                -57.87700517006097,
                -20.75237561065876
              ],
              [
                -57.86527461508314,
                -20.747414622754718
              ],
              [
                -57.857678180838086,
                -20.739869871318604
              ],
              [
                -57.86021032718084,
                -20.73025807881456
              ],
              [
                -57.86894364262144,
                -20.722196529140373
              ],
              [
                -57.884343219376184,
                -20.711964593681486
              ],
              [
                -57.890647743289584,
                -20.706383537812542
              ],
              [
                -57.89447180573465,
                -20.69997572546601
              ],
              [
                -57.900207888532364,
                -20.6851962534105
              ],
              [
                -57.90429032385351,
                -20.678995054530795
              ],
              [
                -57.91808792970692,
                -20.66979663802551
              ],
              [
                -57.93400427578879,
                -20.667419562977642
              ],
              [
                -57.94718176439985,
                -20.675067661037918
              ],
              [
                -57.956380167067316,
                -20.709897552655924
              ],
              [
                -57.96501012937561,
                -20.71103441771146
              ],
              [
                -57.97441524440885,
                -20.70400646311315
              ],
              [
                -57.9806164169332,
                -20.69274100636804
              ],
              [
                -57.981081500441135,
                -20.68116544035918
              ],
              [
                -57.973588421762706,
                -20.66194185067364
              ],
              [
                -57.973123329886995,
                -20.65119311481068
              ],
              [
                -57.977825884582806,
                -20.64013434472729
              ],
              [
                -57.9909517003301,
                -20.620600680281267
              ],
              [
                -57.99363887729923,
                -20.606751417037096
              ],
              [
                -57.992553669564494,
                -20.585047287591173
              ],
              [
                -57.99332881548385,
                -20.573781824778813
              ],
              [
                -58.004749307491,
                -20.549803959846496
              ],
              [
                -58.00893509901693,
                -20.525722747124394
              ],
              [
                -58.01002030516965,
                -20.500091248705548
              ],
              [
                -58.007901570584345,
                -20.47983408182116
              ],
              [
                -57.99214025896091,
                -20.450895283608002
              ],
              [
                -57.98940140961652,
                -20.43311860827125
              ],
              [
                -58.00418086873647,
                -20.425160428412102
              ],
              [
                -58.02314611739384,
                -20.420716230840814
              ],
              [
                -58.04562536875446,
                -20.40934744964914
              ],
              [
                -58.067122761765056,
                -20.393534431579408
              ],
              [
                -58.082987428359694,
                -20.37617116561903
              ],
              [
                -58.09079056944386,
                -20.35942800346573
              ],
              [
                -58.09771520983311,
                -20.334623309322065
              ],
              [
                -58.09993729671109,
                -20.309198504092517
              ],
              [
                -58.09032548122142,
                -20.28170664723097
              ],
              [
                -58.095079712231666,
                -20.272198173264012
              ],
              [
                -58.10308955948177,
                -20.264446710782124
              ],
              [
                -58.10975581923505,
                -20.260726015367368
              ],
              [
                -58.12003942819434,
                -20.261346121889954
              ],
              [
                -58.1262406009925,
                -20.267030537925265
              ],
              [
                -58.13094315595043,
                -20.272818298502
              ],
              [
                -58.13704097424649,
                -20.274368583418223
              ],
              [
                -58.15631628558896,
                -20.261656193926303
              ],
              [
                -58.16267248565139,
                -20.243156022492894
              ],
              [
                -58.155282755889004,
                -20.22641286088384
              ],
              [
                -58.11854081364043,
                -20.214423936451794
              ],
              [
                -58.120504516496986,
                -20.203881932934223
              ],
              [
                -58.12990962609932,
                -20.19251311292762
              ],
              [
                -58.13704097492057,
                -20.18558847920019
              ],
              [
                -58.14406897069431,
                -20.183521430994467
              ],
              [
                -58.15233719850361,
                -20.18465830000208
              ],
              [
                -58.158331665246905,
                -20.18114431048683
              ],
              [
                -58.15879675270654,
                -20.16512461004479
              ],
              [
                -58.11631872579441,
                -20.150448503928338
              ],
              [
                -58.103554648064495,
                -20.14404062965085
              ],
              [
                -58.098283651124135,
                -20.138149517252643
              ],
              [
                -58.08624304280146,
                -20.120889585998572
              ],
              [
                -58.0795767834245,
                -20.117375594283892
              ],
              [
                -58.053531861411386,
                -20.107660425153565
              ],
              [
                -58.02237097196578,
                -20.064975686655373
              ],
              [
                -57.997101195887694,
                -20.055260516865438
              ],
              [
                -57.985680704881574,
                -20.053090106803143
              ],
              [
                -57.97581050681424,
                -20.04750905212172
              ],
              [
                -57.968937540873526,
                -20.03975758672082
              ],
              [
                -57.96635371890426,
                -20.031075947032488
              ],
              [
                -57.9591706949809,
                -20.026218362807533
              ],
              [
                -57.94320267798442,
                -20.028078714843147
              ],
              [
                -57.91793290295742,
                -20.03417653356951
              ],
              [
                -57.89560868305017,
                -20.024151306509573
              ],
              [
                -57.88113928200444,
                -20.009165141045752
              ],
              [
                -57.869770465394865,
                -19.992938714593635
              ],
              [
                -57.859745238187884,
                -19.980122977766328
              ],
              [
                -57.96046259399842,
                -19.893099752437788
              ],
              [
                -58.04112951407692,
                -19.823440013416157
              ],
              [
                -58.116938844574975,
                -19.758017695931063
              ],
              [
                -58.12463861673331,
                -19.729905555677405
              ],
              [
                -58.089757028183726,
                -19.659418927300628
              ],
              [
                -58.077458053775445,
                -19.634717771536412
              ],
              [
                -58.05048296530896,
                -19.580147545189348
              ],
              [
                -58.023559519556095,
                -19.525680333905076
              ],
              [
                -58.01126054346168,
                -19.50087579835044
              ],
              [
                -58.011208868250144,
                -19.500772452364917
              ],
              [
                -58.011208868841855,
                -19.500669106379256
              ],
              [
                -57.980047968891014,
                -19.43886398199877
              ],
              [
                -57.91162838831436,
                -19.302851779543072
              ],
              [
                -57.84310543950732,
                -19.16683940268116
              ],
              [
                -57.81204790205409,
                -19.105034384209926
              ],
              [
                -57.78900020072039,
                -19.059248928290938
              ],
              [
                -57.77189530712511,
                -19.04870699285492
              ],
              [
                -57.715826374102384,
                -19.044572835465594
              ],
              [
                -57.72176916234051,
                -19.001164624601067
              ],
              [
                -57.7275569278793,
                -18.941943480384737
              ],
              [
                -57.731794397007704,
                -18.921996399351613
              ],
              [
                -57.742233028346334,
                -18.91362472898514
              ],
              [
                -57.78233395846702,
                -18.910420986177492
              ],
              [
                -57.77106849430675,
                -18.87631451902102
              ],
              [
                -57.72399125350478,
                -18.733687454595707
              ],
              [
                -57.677017379460935,
                -18.591060532435943
              ],
              [
                -57.63004349107148,
                -18.448433460540624
              ],
              [
                -57.583017941598065,
                -18.305703200755595
              ],
              [
                -57.566739875097866,
                -18.256093925736515
              ],
              [
                -57.55387244886461,
                -18.244518455999625
              ],
              [
                -57.535734013902456,
                -18.240487620672095
              ],
              [
                -57.46679765878095,
                -18.23955749721898
              ],
              [
                -57.46566077905622,
                -18.21775006631924
              ],
              [
                -57.47454911982345,
                -18.208034841070827
              ],
              [
                -57.49072382846907,
                -18.205554210916322
              ],
              [
                -57.5111876954661,
                -18.205554210916322
              ],
              [
                -57.551081903869715,
                -18.183643428288626
              ],
              [
                -57.58549841499719,
                -18.122768678112433
              ],
              [
                -57.63691647568364,
                -18.00112245890073
              ],
              [
                -57.73008908465123,
                -17.84609318333392
              ],
              [
                -57.69877315362043,
                -17.843095811610862
              ],
              [
                -57.69680945599587,
                -17.825112481580934
              ],
              [
                -57.711330514776286,
                -17.800824363270923
              ],
              [
                -57.72931393650822,
                -17.779327220499763
              ],
              [
                -57.73298296164986,
                -17.768475150705193
              ],
              [
                -57.724456341423455,
                -17.736642369219773
              ],
              [
                -57.740372686282285,
                -17.73023453347385
              ],
              [
                -57.75489375612556,
                -17.720622629266785
              ],
              [
                -57.76755448416723,
                -17.70873708278976
              ],
              [
                -57.777941456900805,
                -17.695508019923967
              ],
              [
                -57.785899605045806,
                -17.67752437633225
              ],
              [
                -57.78796667008622,
                -17.658920947364216
              ],
              [
                -57.78755325294575,
                -17.620473615404645
              ],
              [
                -57.78956865731472,
                -17.60414412493749
              ],
              [
                -57.788276723195104,
                -17.580579412893695
              ],
              [
                -57.79075720194771,
                -17.555774829681603
              ],
              [
                -57.80073075022147,
                -17.533450582327408
              ],
              [
                -57.814425001455795,
                -17.519704621532625
              ],
              [
                -57.83674922090644,
                -17.51102298538711
              ],
              [
                -57.854112514001706,
                -17.508542646613538
              ],
              [
                -57.87700516985669,
                -17.512263304978475
              ],
              [
                -57.90568559241014,
                -17.520324856413456
              ],
              [
                -57.94356441556142,
                -17.51784436752325
              ],
              [
                -57.98149491907463,
                -17.508749341512345
              ],
              [
                -58.01017532757783,
                -17.496760286013906
              ],
              [
                -58.053686883173455,
                -17.462343778617875
              ],
              [
                -58.06572749537321,
                -17.45593593501171
              ],
              [
                -58.10112585271972,
                -17.44125984248653
              ],
              [
                -58.11202957538424,
                -17.433508330866513
              ],
              [
                -58.139366408708156,
                -17.4045695322967
              ],
              [
                -58.1522338511829,
                -17.396404779780248
              ],
              [
                -58.16318925568237,
                -17.393407552152027
              ],
              [
                -58.174558064184424,
                -17.392063884464946
              ],
              [
                -58.18840735014208,
                -17.388549919288863
              ],
              [
                -58.20406530718565,
                -17.377387788236753
              ],
              [
                -58.220240035873715,
                -17.344314932511292
              ],
              [
                -58.23155717511637,
                -17.329742181150987
              ],
              [
                -58.239928751043585,
                -17.325194589690863
              ],
              [
                -58.256155149943105,
                -17.322507403831217
              ],
              [
                -58.26452672991722,
                -17.32002691299764
              ],
              [
                -58.27439692875098,
                -17.314032455979376
              ],
              [
                -58.29227697383259,
                -17.299666398065153
              ],
              [
                -58.30214717321081,
                -17.29377528813983
              ],
              [
                -58.31217240000288,
                -17.290881406898936
              ],
              [
                -58.34369502885743,
                -17.286954050243487
              ],
              [
                -58.38116043969689,
                -17.267213618168082
              ],
              [
                -58.399143840302386,
                -17.23744802126512
              ],
              [
                -58.40482824610706,
                -17.19962086034681
              ],
              [
                -58.40627519320834,
                -17.11011734555028
              ],
              [
                -58.410977740245045,
                -17.08820645206001
              ],
              [
                -58.42162308453077,
                -17.07063645727176
              ],
              [
                -58.42679073042424,
                -17.055236911735182
              ],
              [
                -58.43247513260219,
                -16.985370311139327
              ],
              [
                -58.439193069788374,
                -16.96728357304622
              ],
              [
                -58.456349648237826,
                -16.937001210777076
              ],
              [
                -58.4662715325483,
                -16.887288584823963
              ],
              [
                -58.46663326685857,
                -16.875506350297993
              ],
              [
                -58.464049433244476,
                -16.866101111800983
              ],
              [
                -58.45510940948042,
                -16.848324411333653
              ],
              [
                -58.452939004287444,
                -16.84129646916691
              ],
              [
                -58.45624629595531,
                -16.80243578947037
              ],
              [
                -58.476658488001426,
                -16.726988220016423
              ],
              [
                -58.480275844375164,
                -16.683683429591085
              ],
              [
                -58.47267939919352,
                -16.649576882716232
              ],
              [
                -58.45588456070189,
                -16.619087804420687
              ],
              [
                -58.35609737316196,
                -16.50953380603908
              ],
              [
                -58.3426615003217,
                -16.473153599866293
              ],
              [
                -58.36359045589445,
                -16.436670044347284
              ],
              [
                -58.36229854221536,
                -16.419306721870203
              ],
              [
                -58.3388374438499,
                -16.400496530602574
              ],
              [
                -58.33454829406379,
                -16.386647181185243
              ],
              [
                -58.33956090970594,
                -16.28928879015763
              ],
              [
                -58.34974116575509,
                -16.28040043231979
              ],
              [
                -58.39294266718518,
                -16.279366954735767
              ],
              [
                -58.40033240255764,
                -16.284224599804105
              ],
              [
                -58.4142333608644,
                -16.308925915500875
              ],
              [
                -58.42162308920765,
                -16.31843435969368
              ],
              [
                -58.44224198113868,
                -16.328459542591702
              ],
              [
                -58.464721231249335,
                -16.331250082182706
              ],
              [
                -58.53696488083094,
                -16.328769585856055
              ],
              [
                -58.7274442132355,
                -16.322155029104493
              ],
              [
                -58.917768515939315,
                -16.315437124563335
              ],
              [
                -59.10824784783376,
                -16.308719219988205
              ],
              [
                -59.29867550318303,
                -16.30210466313685
              ],
              [
                -59.48910314563077,
                -16.295386608282193
              ],
              [
                -59.67955663887464,
                -16.288772051368753
              ],
              [
                -59.87001013230886,
                -16.282157494425785
              ],
              [
                -60.06041195013751,
                -16.275439589695434
              ],
              [
                -60.12983923418358,
                -16.27306244102883
              ],
              [
                -60.16069006034783,
                -16.26479416965507
              ],
              [
                -60.179810340358365,
                -16.222006093748657
              ],
              [
                -60.186967530224585,
                -16.108731386505507
              ],
              [
                -60.19376297670828,
                -16.001451073025304
              ],
              [
                -60.20699214724328,
                -15.853036399761667
              ],
              [
                -60.22482051506846,
                -15.651394947277677
              ],
              [
                -60.23797216934263,
                -15.502670201630513
              ],
              [
                -60.246395425223696,
                -15.478278900947979
              ],
              [
                -60.26045141680674,
                -15.456058053423156
              ],
              [
                -60.35212540649647,
                -15.349604588078796
              ],
              [
                -60.46018082673007,
                -15.224237565799017
              ],
              [
                -60.529478923200244,
                -15.143725689389994
              ],
              [
                -60.58224055999528,
                -15.098870543944008
              ],
              [
                -60.38930659978763,
                -15.096493426450836
              ],
              [
                -60.274972494047745,
                -15.095149841575017
              ],
              [
                -60.269804849701266,
                -15.08336761140329
              ],
              [
                -60.272905436987784,
                -15.01856536785342
              ],
              [
                -60.276858693099676,
                -14.936606658039336
              ],
              [
                -60.28088944587777,
                -14.854647735790966
              ],
              [
                -60.28486852537814,
                -14.772688833389601
              ],
              [
                -60.28882176745013,
                -14.690729950407354
              ],
              [
                -60.29171564737868,
                -14.630061816792415
              ],
              [
                -60.30404047586311,
                -14.608151003076028
              ],
              [
                -60.35271969772452,
                -14.575388432628033
              ],
              [
                -60.36920447798777,
                -14.542832259100186
              ],
              [
                -60.338431158810415,
                -14.532600285108956
              ],
              [
                -60.34380549937069,
                -14.490948961633594
              ],
              [
                -60.37669754833398,
                -14.419945542965497
              ],
              [
                -60.39134782900544,
                -14.35710716343748
              ],
              [
                -60.39992611712447,
                -14.340777412141039
              ],
              [
                -60.45431554174705,
                -14.296645477794328
              ],
              [
                -60.464340778564484,
                -14.278352133462638
              ],
              [
                -60.46563269046019,
                -14.251066989012315
              ],
              [
                -60.462015341040846,
                -14.223885193531917
              ],
              [
                -60.46240290729664,
                -14.198460300790476
              ],
              [
                -60.47568375386662,
                -14.176032776160891
              ],
              [
                -60.47893937979075,
                -14.162700398665633
              ],
              [
                -60.477647451848945,
                -14.139962534255568
              ],
              [
                -60.473513341003006,
                -14.11722497151356
              ],
              [
                -60.46826819583675,
                -14.10368590172041
              ],
              [
                -60.4613952295548,
                -14.098621593939269
              ],
              [
                -60.437236501797045,
                -14.09200707991683
              ],
              [
                -60.41943396747535,
                -14.0769175042572
              ],
              [
                -60.40940873902993,
                -14.055316762759956
              ],
              [
                -60.396515463296524,
                -14.008394488187134
              ],
              [
                -60.38796300423964,
                -13.9893774266587
              ],
              [
                -60.38718786140224,
                -13.98327964961661
              ],
              [
                -60.389694181171244,
                -13.974908237364593
              ],
              [
                -60.395740317107226,
                -13.970980748728618
              ],
              [
                -60.40542964446413,
                -13.966743218957507
              ],
              [
                -60.41160498108805,
                -13.960542095173624
              ],
              [
                -60.40672155575012,
                -13.950413483023349
              ],
              [
                -60.408633586046626,
                -13.944522400622263
              ],
              [
                -60.430441047479185,
                -13.926745806838891
              ],
              [
                -60.43855423877082,
                -13.918374095225344
              ],
              [
                -60.4488120109191,
                -13.8967733615371
              ],
              [
                -60.457312781452934,
                -13.87093510001399
              ],
              [
                -60.46312638321861,
                -13.843443287495406
              ],
              [
                -60.46527095642656,
                -13.816571558750136
              ],
              [
                -60.4726348367308,
                -13.797864546356774
              ],
              [
                -60.49061825586294,
                -13.78773623824666
              ],
              [
                -60.56606583242076,
                -13.769959350110534
              ],
              [
                -60.57513504243353,
                -13.765618475192143
              ],
              [
                -60.57957923447935,
                -13.761071206720336
              ],
              [
                -60.58487605212019,
                -13.749082052402864
              ],
              [
                -60.58862259089254,
                -13.744534483661631
              ],
              [
                -60.59508215706266,
                -13.741640767484416
              ],
              [
                -60.61807816672366,
                -13.736886504803886
              ],
              [
                -60.652701385954074,
                -13.718799877988909
              ],
              [
                -60.72557172956321,
                -13.662844690367434
              ],
              [
                -60.80196875405507,
                -13.604181457777235
              ],
              [
                -60.87067255790227,
                -13.575449196398198
              ],
              [
                -60.87824315410312,
                -13.570384894405588
              ],
              [
                -60.89674332404467,
                -13.55291835545619
              ],
              [
                -60.9292994821512,
                -13.546200502237912
              ],
              [
                -60.97787532052338,
                -13.542996445895
              ],
              [
                -61.02200700389804,
                -13.535245123173251
              ],
              [
                -61.041256470727916,
                -13.515194610999327
              ],
              [
                -61.0412564648651,
                -13.474576854196945
              ],
              [
                -61.04722509091101,
                -13.46455159917015
              ],
              [
                -61.06011837193886,
                -13.467135573335066
              ],
              [
                -61.072184810740325,
                -13.47437016029459
              ],
              [
                -61.076008871225255,
                -13.478297644880563
              ],
              [
                -61.11871943934404,
                -13.484498762459795
              ],
              [
                -61.133576417461704,
                -13.494007283088505
              ],
              [
                -61.13931250550104,
                -13.514057794449672
              ],
              [
                -61.1491051873278,
                -13.519845524609986
              ],
              [
                -61.2150443033176,
                -13.517468244106045
              ],
              [
                -61.23788530130854,
                -13.52439309130112
              ],
              [
                -61.24855648430975,
                -13.52439309130112
              ],
              [
                -61.26002864945086,
                -13.520052218530214
              ],
              [
                -61.28121597309288,
                -13.507236294349203
              ],
              [
                -61.31713109848929,
                -13.500931829546234
              ],
              [
                -61.332375650008935,
                -13.494834058729138
              ],
              [
                -61.34772355471798,
                -13.493697242223602
              ],
              [
                -61.41547134475269,
                -13.528113581910219
              ],
              [
                -61.45875035844822,
                -13.543719874648424
              ],
              [
                -61.50342463689205,
                -13.548164094583184
              ],
              [
                -61.55081192424525,
                -13.538035491185923
              ],
              [
                -61.56086299072473,
                -13.532661148673615
              ],
              [
                -61.58807064939419,
                -13.507649982606965
              ],
              [
                -61.593060161673066,
                -13.50679436593477
              ],
              [
                -61.59711400884829,
                -13.506099477816823
              ],
              [
                -61.66809158397316,
                -13.51250728964056
              ],
              [
                -61.692896270026615,
                -13.517984978904407
              ],
              [
                -61.7157372612357,
                -13.526563377486532
              ],
              [
                -61.73511592022501,
                -13.538035491185923
              ],
              [
                -61.75433956365375,
                -13.53028416853837
              ],
              [
                -61.774234976583514,
                -13.533384577412612
              ],
              [
                -61.79428544682281,
                -13.540309424819766
              ],
              [
                -61.81397415116763,
                -13.544236609472916
              ],
              [
                -61.836350061488346,
                -13.540619465712352
              ],
              [
                -61.84797725557712,
                -13.530800903349467
              ],
              [
                -61.86859614648198,
                -13.463931517474949
              ],
              [
                -61.87231686038193,
                -13.456076848970966
              ],
              [
                -61.879913281394735,
                -13.449152002670784
              ],
              [
                -61.89949864701019,
                -13.439230095064552
              ],
              [
                -61.90983394184876,
                -13.431892161636314
              ],
              [
                -61.95835810869876,
                -13.38548668237374
              ],
              [
                -61.97535965938619,
                -13.37411791887501
              ],
              [
                -61.99778722862516,
                -13.36409266570052
              ],
              [
                -62.003264923850836,
                -13.360475222727976
              ],
              [
                -62.01866451135677,
                -13.336807574656849
              ],
              [
                -62.0196980361875,
                -13.332570050313723
              ],
              [
                -62.03359900372833,
                -13.32554215907163
              ],
              [
                -62.07773068043157,
                -13.27789652566582
              ],
              [
                -62.09922807494643,
                -13.262600281240195
              ],
              [
                -62.10940832359942,
                -13.248957587763872
              ],
              [
                -62.11245723887787,
                -13.231801099778899
              ],
              [
                -62.11250891216238,
                -13.164776729224652
              ],
              [
                -62.114679318919734,
                -13.150203915950803
              ],
              [
                -62.12046708489476,
                -13.148757059459813
              ],
              [
                -62.129148716930374,
                -13.150927344197576
              ],
              [
                -62.139845754110674,
                -13.147000162296763
              ],
              [
                -62.16237665877334,
                -13.120748249776915
              ],
              [
                -62.17245357470882,
                -13.117854536936226
              ],
              [
                -62.173952182770556,
                -13.140798747966233
              ],
              [
                -62.20092729014896,
                -13.122712141067774
              ],
              [
                -62.21152094644136,
                -13.120334862227416
              ],
              [
                -62.221649546123,
                -13.121265284641185
              ],
              [
                -62.25916661732332,
                -13.130773498790425
              ],
              [
                -62.273636029614025,
                -13.138421769483452
              ],
              [
                -62.290327524183084,
                -13.142039211083548
              ],
              [
                -62.31053299955471,
                -13.133977552787119
              ],
              [
                -62.321591759320214,
                -13.143692761341184
              ],
              [
                -62.33502762532675,
                -13.145139617820252
              ],
              [
                -62.38184647362234,
                -13.139868625950141
              ],
              [
                -62.38970130224782,
                -13.13707825991028
              ],
              [
                -62.40670284984717,
                -13.126536276352738
              ],
              [
                -62.41026850473483,
                -13.125709200819308
              ],
              [
                -62.424117806849665,
                -13.126536276352738
              ],
              [
                -62.42747676141248,
                -13.124572385049792
              ],
              [
                -62.42871699491807,
                -13.114547136136304
              ],
              [
                -62.43093907911657,
                -13.109792878953924
              ],
              [
                -62.45848262102961,
                -13.077960236434967
              ],
              [
                -62.47212519533621,
                -13.068451722657565
              ],
              [
                -62.492692429473735,
                -13.065041275665212
              ],
              [
                -62.55460078725569,
                -13.066798172598396
              ],
              [
                -62.64167557827763,
                -13.030004581893719
              ],
              [
                -62.64518957409006,
                -13.025353672213374
              ],
              [
                -62.64751500432669,
                -13.001582389966297
              ],
              [
                -62.65133907648749,
                -12.99248756520157
              ],
              [
                -62.65790197320647,
                -12.98463260251998
              ],
              [
                -62.66746212594365,
                -12.97636455290075
              ],
              [
                -62.68663406482461,
                -12.964995496647354
              ],
              [
                -62.69898474638402,
                -12.966649346876512
              ],
              [
                -62.709164992876495,
                -12.97460735578366
              ],
              [
                -62.722032433782964,
                -12.982565665212308
              ],
              [
                -62.7413077322163,
                -12.985356030579165
              ],
              [
                -62.75789586708732,
                -12.985149336847888
              ],
              [
                -62.76864456382419,
                -12.990627021175476
              ],
              [
                -62.770453243401576,
                -13.010470821544073
              ],
              [
                -62.7898319031666,
                -13.000652268153278
              ],
              [
                -62.80740189503454,
                -12.988870124447704
              ],
              [
                -62.820165967555674,
                -12.974917396375696
              ],
              [
                -62.82507523249822,
                -12.958691037636658
              ],
              [
                -62.826677216001904,
                -12.950009600895612
              ],
              [
                -62.831431447532346,
                -12.944945304336828
              ],
              [
                -62.83892451715223,
                -12.942774719864927
              ],
              [
                -62.84900142369557,
                -12.942154638710495
              ],
              [
                -62.86011186539752,
                -12.94029439525056
              ],
              [
                -62.86507280069844,
                -12.935540139338034
              ],
              [
                -62.86791498889518,
                -12.929028686459711
              ],
              [
                -62.92046994057978,
                -12.862263014900103
              ],
              [
                -62.923777227846884,
                -12.852857851017061
              ],
              [
                -62.9288931805089,
                -12.846036358373365
              ],
              [
                -62.93803991571024,
                -12.849447104687096
              ],
              [
                -62.946514848086835,
                -12.855234828474291
              ],
              [
                -62.95514482393239,
                -12.857508759519837
              ],
              [
                -62.96449824058604,
                -12.856578337475344
              ],
              [
                -62.975298630851746,
                -12.852857851017061
              ],
              [
                -62.988011027467344,
                -12.843866074635631
              ],
              [
                -62.99917313458985,
                -12.829086574743421
              ],
              [
                -63.00707962246309,
                -12.809966207446994
              ],
              [
                -63.0100251852119,
                -12.787952129219956
              ],
              [
                -63.014727739962126,
                -12.777720191615314
              ],
              [
                -63.025683149915714,
                -12.765731357979416
              ],
              [
                -63.04790401042595,
                -12.746714339147397
              ],
              [
                -63.0511079459852,
                -12.74216677817452
              ],
              [
                -63.0521931542159,
                -12.736482402103334
              ],
              [
                -63.0511079503775,
                -12.730798026074401
              ],
              [
                -63.04345984406097,
                -12.719119233661244
              ],
              [
                -63.047077196863505,
                -12.713538204587023
              ],
              [
                -63.05358842694905,
                -12.708370562855857
              ],
              [
                -63.05782587915504,
                -12.701962458832528
              ],
              [
                -63.06475052038174,
                -12.666202355245627
              ],
              [
                -63.075034143604285,
                -12.652663321059524
              ],
              [
                -63.10521316813041,
                -12.645221749311188
              ],
              [
                -63.12505693501813,
                -12.63592023536232
              ],
              [
                -63.136684120011154,
                -12.633749651795707
              ],
              [
                -63.13947466023442,
                -12.635610194913408
              ],
              [
                -63.167069869151746,
                -12.647392332908526
              ],
              [
                -63.17166907289569,
                -12.652353280604201
              ],
              [
                -63.17611324181526,
                -12.66361868474464
              ],
              [
                -63.180712448500564,
                -12.667856204797465
              ],
              [
                -63.18557002999496,
                -12.668476285720237
              ],
              [
                -63.19730058672466,
                -12.666822736593913
              ],
              [
                -63.201848109501995,
                -12.667856204797465
              ],
              [
                -63.222673713566536,
                -12.682532354713294
              ],
              [
                -63.232027134481505,
                -12.691110441440506
              ],
              [
                -63.235954555063245,
                -12.698552013618535
              ],
              [
                -63.247323357713675,
                -12.701342377883432
              ],
              [
                -63.31791336211864,
                -12.701962458832528
              ],
              [
                -63.330419057492385,
                -12.697001510826647
              ],
              [
                -63.35946121965814,
                -12.674677395401313
              ],
              [
                -63.37108841611236,
                -12.669923141208564
              ],
              [
                -63.393309283012876,
                -12.66454880612402
              ],
              [
                -63.43144649783354,
                -12.636953703526155
              ],
              [
                -63.435218862025756,
                -12.630338906446612
              ],
              [
                -63.43816442265488,
                -12.619176849583242
              ],
              [
                -63.44534744449206,
                -12.614835982971442
              ],
              [
                -63.454235801804195,
                -12.612045619007452
              ],
              [
                -63.4625040380915,
                -12.60512108211813
              ],
              [
                -63.466379769283655,
                -12.595302534140677
              ],
              [
                -63.46699988227097,
                -12.585794026708877
              ],
              [
                -63.468756880273354,
                -12.575768785340568
              ],
              [
                -63.476198290135784,
                -12.564813422823377
              ],
              [
                -63.485758417315814,
                -12.557475198670305
              ],
              [
                -63.496145376335804,
                -12.553341025989852
              ],
              [
                -63.50751419946594,
                -12.551584130288076
              ],
              [
                -63.52022660210691,
                -12.551170743064661
              ],
              [
                -63.54218907834701,
                -12.547966691663095
              ],
              [
                -63.55872554927398,
                -12.539905340449222
              ],
              [
                -63.600428421911026,
                -12.506108833051801
              ],
              [
                -63.654843712847786,
                -12.478307042020099
              ],
              [
                -63.65773758486844,
                -12.475413031274297
              ],
              [
                -63.80139806684852,
                -12.454949164002773
              ],
              [
                -63.81498896999371,
                -12.457222943700659
              ],
              [
                -63.845581419026544,
                -12.466938143324386
              ],
              [
                -63.86289302517729,
                -12.46921192305213
              ],
              [
                -63.863203082347184,
                -12.474792950492843
              ],
              [
                -63.89689611546733,
                -12.515720686403121
              ],
              [
                -63.90247717263009,
                -12.525435886662247
              ],
              [
                -63.90914343810355,
                -12.534324312598496
              ],
              [
                -63.921235724003836,
                -12.544349553480078
              ],
              [
                -63.93906409386573,
                -12.54414285987007
              ],
              [
                -63.95001948599535,
                -12.536804635893596
              ],
              [
                -63.959321258928895,
                -12.528019857161853
              ],
              [
                -63.97244706886776,
                -12.523885684622222
              ],
              [
                -64.00417639244725,
                -12.5354611274412
              ],
              [
                -64.0228315748226,
                -12.53783810393532
              ],
              [
                -64.04445817451422,
                -12.509106190697826
              ],
              [
                -64.10445451005927,
                -12.507142451270667
              ],
              [
                -64.11982824621344,
                -12.48967579064564
              ],
              [
                -64.13476273334199,
                -12.510863086313856
              ],
              [
                -64.14478796336846,
                -12.52037159291487
              ],
              [
                -64.15525244479606,
                -12.516960998236755
              ],
              [
                -64.1831060349693,
                -12.487918744858106
              ],
              [
                -64.19754960323128,
                -12.478720429209304
              ],
              [
                -64.21522294256005,
                -12.473759482524702
              ],
              [
                -64.23656530282176,
                -12.475413031274297
              ],
              [
                -64.24571203522275,
                -12.479443856790846
              ],
              [
                -64.25682247404309,
                -12.49081275564415
              ],
              [
                -64.26385046137517,
                -12.495256818213257
              ],
              [
                -64.26870804876474,
                -12.497220557614106
              ],
              [
                -64.2782423527944,
                -12.499287643818988
              ],
              [
                -64.28754410819553,
                -12.497117210814643
              ],
              [
                -64.29769853110245,
                -12.465697981773488
              ],
              [
                -64.31265885191506,
                -12.461873849908766
              ],
              [
                -64.35319901517101,
                -12.46921192305213
              ],
              [
                -64.37676347124551,
                -12.46590467536519
              ],
              [
                -64.39572871452691,
                -12.457326290495555
              ],
              [
                -64.41133500552795,
                -12.445130767925916
              ],
              [
                -64.42487422403887,
                -12.431384743209364
              ],
              [
                -64.43236730788593,
                -12.42094611642305
              ],
              [
                -64.44407202295433,
                -12.399758822831481
              ],
              [
                -64.45252111667418,
                -12.390353664268083
              ],
              [
                -64.46164200646813,
                -12.385289371266419
              ],
              [
                -64.483630328342,
                -12.377641258420644
              ],
              [
                -64.48977982941291,
                -12.373610583555571
              ],
              [
                -64.49244116303878,
                -12.356557312565647
              ],
              [
                -64.47443192304159,
                -12.316456357793488
              ],
              [
                -64.46931596086748,
                -12.294855679337319
              ],
              [
                -64.46815323894106,
                -12.272634770465514
              ],
              [
                -64.46905758148196,
                -12.261059330827917
              ],
              [
                -64.47303665711179,
                -12.253204375157008
              ],
              [
                -64.48939225213664,
                -12.239458503297865
              ],
              [
                -64.49424984292601,
                -12.238011648487785
              ],
              [
                -64.50884843255568,
                -12.2360479096067
              ],
              [
                -64.51024369061213,
                -12.237288070870115
              ],
              [
                -64.510347044713,
                -12.239561850070077
              ],
              [
                -64.51148392449447,
                -12.242662403454691
              ],
              [
                -64.5321028214601,
                -12.232223778626683
              ],
              [
                -64.54843257602599,
                -12.219097987654319
              ],
              [
                -64.5548921353881,
                -12.2177544796413
              ],
              [
                -64.58104040145791,
                -12.217444289117495
              ],
              [
                -64.59341691224519,
                -12.215997434336511
              ],
              [
                -64.6405716582747,
                -12.195120185284914
              ],
              [
                -64.66485957677145,
                -12.180960776867858
              ],
              [
                -64.67534989272853,
                -12.171038886446736
              ],
              [
                -64.67718440921561,
                -12.16762829296428
              ],
              [
                -64.68594356757002,
                -12.159153407577897
              ],
              [
                -64.68899246812927,
                -12.153882271943901
              ],
              [
                -64.68857906354359,
                -12.147164431853428
              ],
              [
                -64.68157690493001,
                -12.134865415963128
              ],
              [
                -64.68157690744918,
                -12.1265972243368
              ],
              [
                -64.686460324798,
                -12.109957344281018
              ],
              [
                -64.68992264878452,
                -12.104376318797591
              ],
              [
                -64.70638159488894,
                -12.106133363933429
              ],
              [
                -64.71028316313101,
                -12.111921082946333
              ],
              [
                -64.71364212667042,
                -12.138482702876018
              ],
              [
                -64.71627763307261,
                -12.146544351271025
              ],
              [
                -64.7283957530091,
                -12.149851597927656
              ],
              [
                -64.7395320257942,
                -12.144580612548866
              ],
              [
                -64.74418290784827,
                -12.133625254811516
              ],
              [
                -64.7367931712197,
                -12.119775887426062
              ],
              [
                -64.76857417806316,
                -12.086496277941254
              ],
              [
                -64.78048560006195,
                -12.067686116528193
              ],
              [
                -64.7851881547912,
                -12.04742895060456
              ],
              [
                -64.79250036838326,
                -12.032546116632995
              ],
              [
                -64.80929520579559,
                -12.025828126986235
              ],
              [
                -64.8276145056174,
                -12.022314187152189
              ],
              [
                -64.83983598361469,
                -12.016733162052937
              ],
              [
                -64.86208268584004,
                -12.024794659449734
              ],
              [
                -64.88350256026384,
                -12.021383916158472
              ],
              [
                -64.9044831911213,
                -12.014045846051532
              ],
              [
                -64.9251537694533,
                -12.009911825733681
              ],
              [
                -64.9676059561453,
                -12.007948087225166
              ],
              [
                -64.98344477901415,
                -12.003917263464755
              ],
              [
                -64.99744909213283,
                -11.99626915319878
              ],
              [
                -65.00943803141986,
                -11.984280329234146
              ],
              [
                -65.01633683768242,
                -11.968467375216296
              ],
              [
                -65.01463150732188,
                -11.950277145743545
              ],
              [
                -65.00085974307545,
                -11.931053599248129
              ],
              [
                -64.99649308376273,
                -11.921235057496789
              ],
              [
                -64.99812088925198,
                -11.908936043712782
              ],
              [
                -65.00458044578751,
                -11.898394074896181
              ],
              [
                -65.01452815672408,
                -11.893846517723658
              ],
              [
                -65.0179388015522,
                -11.893639824235528
              ],
              [
                -65.02809321931856,
                -11.888885573589645
              ],
              [
                -65.03367428006761,
                -11.879790609527614
              ],
              [
                -65.0384543441307,
                -11.858499828667576
              ],
              [
                -65.03920365086125,
                -11.848681287379732
              ],
              [
                -65.03744665174698,
                -11.828424124543172
              ],
              [
                -65.03845434108318,
                -11.818708930174903
              ],
              [
                -65.04331192970425,
                -11.807650228261208
              ],
              [
                -65.05630854962216,
                -11.785636021171923
              ],
              [
                -65.06555863896264,
                -11.753079996681992
              ],
              [
                -65.0810615669879,
                -11.743468149465668
              ],
              [
                -65.09919999254797,
                -11.73623342740239
              ],
              [
                -65.11356604439368,
                -11.722590907441507
              ],
              [
                -65.11046545870323,
                -11.69995662097801
              ],
              [
                -65.11341101194091,
                -11.690551467491133
              ],
              [
                -65.12785456920822,
                -11.694582140256328
              ],
              [
                -65.1339782351372,
                -11.70264378623765
              ],
              [
                -65.13800899636841,
                -11.715252838724382
              ],
              [
                -65.14353837257357,
                -11.763828658043904
              ],
              [
                -65.15149654685888,
                -11.77313046515806
              ],
              [
                -65.16446732397986,
                -11.769823069166511
              ],
              [
                -65.18245072477983,
                -11.756697282636377
              ],
              [
                -65.1961966545944,
                -11.741814451495989
              ],
              [
                -65.20185522813476,
                -11.727965238026938
              ],
              [
                -65.20232031033879,
                -11.69148158807932
              ],
              [
                -65.20025325974994,
                -11.681973238113716
              ],
              [
                -65.19133907541553,
                -11.666883714081486
              ],
              [
                -65.18927201622812,
                -11.657065173824613
              ],
              [
                -65.19335445285857,
                -11.632363803285198
              ],
              [
                -65.19092565732394,
                -11.623165343556568
              ],
              [
                -65.16743871954935,
                -11.615517235003857
              ],
              [
                -65.17397579296518,
                -11.606525619012672
              ],
              [
                -65.19544734784463,
                -11.592159522588483
              ],
              [
                -65.20735876288678,
                -11.587611966163074
              ],
              [
                -65.21454178729032,
                -11.587508619435948
              ],
              [
                -65.21924434400879,
                -11.584511414137346
              ],
              [
                -65.2234043000585,
                -11.57107558859595
              ],
              [
                -65.22361099825693,
                -11.557949653091727
              ],
              [
                -65.21598872530775,
                -11.539966271353336
              ],
              [
                -65.21598873378841,
                -11.530147881838369
              ],
              [
                -65.22265498449033,
                -11.517435333436586
              ],
              [
                -65.23304195315393,
                -11.50834037107049
              ],
              [
                -65.25756242166736,
                -11.49531793281051
              ],
              [
                -65.29246984473866,
                -11.504722935306445
              ],
              [
                -65.31954829769016,
                -11.476404280759956
              ],
              [
                -65.3530087871972,
                -11.390621394659208
              ],
              [
                -65.35476578777318,
                -11.382353206408885
              ],
              [
                -65.35373225908168,
                -11.372431320446278
              ],
              [
                -65.3475052455303,
                -11.360752390063546
              ],
              [
                -65.33006444962413,
                -11.340495231389786
              ],
              [
                -65.32644709897642,
                -11.32778283390634
              ],
              [
                -65.33481868684991,
                -11.321168343487942
              ],
              [
                -65.3539131304074,
                -11.310626377354103
              ],
              [
                -65.37448034908967,
                -11.29584689537503
              ],
              [
                -65.38727026836433,
                -11.277553474821564
              ],
              [
                -65.3886138520827,
                -11.253162147364929
              ],
              [
                -65.3786144613704,
                -11.242000025949581
              ],
              [
                -65.36605709081005,
                -11.234041878098045
              ],
              [
                -65.36001094789027,
                -11.218849009438658
              ],
              [
                -65.36833085125409,
                -11.205413110097618
              ],
              [
                -65.38520320876313,
                -11.193630908454397
              ],
              [
                -65.39814815181778,
                -11.17802457789652
              ],
              [
                -65.39473751007513,
                -11.153426632421814
              ],
              [
                -65.37967382681668,
                -11.136373372789269
              ],
              [
                -65.34104569742192,
                -11.106607791172305
              ],
              [
                -65.33329422830461,
                -11.088520989318758
              ],
              [
                -65.33704077247415,
                -11.067747097760387
              ],
              [
                -65.3426993395642,
                -11.050590491468295
              ],
              [
                -65.34197587095747,
                -11.032813804881732
              ],
              [
                -65.32644710460927,
                -11.009352748499103
              ],
              [
                -65.31784297773062,
                -11.002014681041489
              ],
              [
                -65.30965226396428,
                -10.996640351394944
              ],
              [
                -65.30298600342778,
                -10.990749213061466
              ],
              [
                -65.29911027082946,
                -10.98206756318519
              ],
              [
                -65.29960119504537,
                -10.969665206211749
              ],
              [
                -65.30451045731063,
                -10.96201709859108
              ],
              [
                -65.31011735085838,
                -10.956539422216277
              ],
              [
                -65.31277868525076,
                -10.950958324016504
              ],
              [
                -65.31897986071047,
                -10.865382210595296
              ],
              [
                -65.32711889777897,
                -10.850499382042045
              ],
              [
                -65.34218257493153,
                -10.834893051324507
              ],
              [
                -65.36029516718936,
                -10.82259411596224
              ],
              [
                -65.39969844804413,
                -10.812258843321427
              ],
              [
                -65.40473689690947,
                -10.799236330667421
              ],
              [
                -65.3897765699695,
                -10.75376107058996
              ],
              [
                -65.38225764981217,
                -10.715623877814432
              ],
              [
                -65.38106909140242,
                -10.698053883843674
              ],
              [
                -65.38675350096308,
                -10.669528536468256
              ],
              [
                -65.40078364912691,
                -10.655472481028191
              ],
              [
                -65.41861202203155,
                -10.644517127625543
              ],
              [
                -65.43569108212998,
                -10.625810244225441
              ],
              [
                -65.43563940453775,
                -10.610824068077333
              ],
              [
                -65.42923152686377,
                -10.561421404653919
              ],
              [
                -65.43199621587172,
                -10.550672706789442
              ],
              [
                -65.43589778661395,
                -10.546951999338981
              ],
              [
                -65.43930843141372,
                -10.538167001873738
              ],
              [
                -65.44163387113697,
                -10.527831728370728
              ],
              [
                -65.44248653301518,
                -10.519356808572219
              ],
              [
                -65.44147884087644,
                -10.513362322861191
              ],
              [
                -65.4367246082549,
                -10.504060554083166
              ],
              [
                -65.43569108269179,
                -10.49920299500111
              ],
              [
                -65.43791316755718,
                -10.492588391316048
              ],
              [
                -65.44997961438017,
                -10.474915049223604
              ],
              [
                -65.449979613966,
                -10.46809375200876
              ],
              [
                -65.42538163375325,
                -10.463132846119848
              ],
              [
                -65.41093807088289,
                -10.4491802114045
              ],
              [
                -65.3872702629847,
                -10.406702151201204
              ],
              [
                -65.39143021618608,
                -10.403498214727328
              ],
              [
                -65.39308386163025,
                -10.400190931515526
              ],
              [
                -65.39473750916535,
                -10.392439475904187
              ],
              [
                -65.39464619565292,
                -10.392070063907758
              ],
              [
                -65.39018998229935,
                -10.374042668268157
              ],
              [
                -65.379234578741,
                -10.351408381433835
              ],
              [
                -65.36502356050609,
                -10.332184761947996
              ],
              [
                -65.32781652854344,
                -10.314408052911384
              ],
              [
                -65.31562089065388,
                -10.291257012850895
              ],
              [
                -65.30536311853801,
                -10.242164400746473
              ],
              [
                -65.28807735246703,
                -10.216222847372473
              ],
              [
                -65.28482173713157,
                -10.206817730362678
              ],
              [
                -65.28683711768028,
                -10.196482436259227
              ],
              [
                -65.2968106686379,
                -10.17333139448283
              ],
              [
                -65.29911027127301,
                -10.162996118922663
              ],
              [
                -65.30146154822485,
                -10.119691268073147
              ],
              [
                -65.30556982482675,
                -10.098400569857825
              ],
              [
                -65.3241475020265,
                -10.046414082486253
              ],
              [
                -65.33293249599147,
                -10.00838022884519
              ],
              [
                -65.33683407255991,
                -9.967245909690915
              ],
              [
                -65.33329422268805,
                -9.926834682875745
              ],
              [
                -65.32523270572341,
                -9.905130693350857
              ],
              [
                -65.30358028365059,
                -9.864513071725915
              ],
              [
                -65.29911026754274,
                -9.841258581479247
              ],
              [
                -65.30438126578412,
                -9.825652341271299
              ],
              [
                -65.31660273603745,
                -9.812526419686035
              ],
              [
                -65.33032283495537,
                -9.800744304428207
              ],
              [
                -65.34006384558015,
                -9.789685615395351
              ],
              [
                -65.35373226225,
                -9.745037171402673
              ],
              [
                -65.35605769621112,
                -9.741626432429255
              ],
              [
                -65.37050126288158,
                -9.71062064267203
              ],
              [
                -65.39799312167295,
                -9.68674606989955
              ],
              [
                -65.41623490786502,
                -9.680131585323398
              ],
              [
                -65.44248653587466,
                -9.679821545440548
              ],
              [
                -65.4518399659366,
                -9.681371744854022
              ],
              [
                -65.46522416044867,
                -9.696461253662399
              ],
              [
                -65.51077694244674,
                -9.734081828518539
              ],
              [
                -65.51713313022222,
                -9.743176631769995
              ],
              [
                -65.52139645066853,
                -9.758576480159494
              ],
              [
                -65.52542719877161,
                -9.767877976481449
              ],
              [
                -65.5353232358658,
                -9.782450751196007
              ],
              [
                -65.54682124894248,
                -9.795163286614384
              ],
              [
                -65.55080032890108,
                -9.797023525746273
              ],
              [
                -65.56281510902464,
                -9.799194105156309
              ],
              [
                -65.56798274261384,
                -9.80208781046235
              ],
              [
                -65.5699206119828,
                -9.806015282364932
              ],
              [
                -65.57061824438252,
                -9.815833811855729
              ],
              [
                -65.57188432378591,
                -9.818831164167099
              ],
              [
                -65.57705195906418,
                -9.826169074351487
              ],
              [
                -65.5793774089358,
                -9.832783858611803
              ],
              [
                -65.58397659744108,
                -9.837227763069723
              ],
              [
                -65.59612057230687,
                -9.837951489801567
              ],
              [
                -65.61438818821661,
                -9.833920671381586
              ],
              [
                -65.62888341776635,
                -9.826892500663389
              ],
              [
                -65.6584940126334,
                -9.807358788393579
              ],
              [
                -65.6637133299733,
                -9.802914583405745
              ],
              [
                -65.67262751723115,
                -9.792579320722753
              ],
              [
                -65.67895789061917,
                -9.789375575538454
              ],
              [
                -65.68360876690971,
                -9.789892308633235
              ],
              [
                -65.69435746862831,
                -9.793716433954385
              ],
              [
                -65.69707047862897,
                -9.794336513666028
              ],
              [
                -65.705054491998,
                -9.793303047479812
              ],
              [
                -65.7131160119722,
                -9.794233167047436
              ],
              [
                -65.71730179656926,
                -9.7912358146787
              ],
              [
                -65.71373613088495,
                -9.77873027288754
              ],
              [
                -65.70996374399532,
                -9.755992514194864
              ],
              [
                -65.72549251032174,
                -9.75681928716771
              ],
              [
                -65.76319046440796,
                -9.772322181589875
              ],
              [
                -65.77244055880912,
                -9.76880839649358
              ],
              [
                -65.7773498200527,
                -9.763434071784019
              ],
              [
                -65.77995947199429,
                -9.755992514194864
              ],
              [
                -65.78220739623019,
                -9.746277330872164
              ],
              [
                -65.78856359179025,
                -9.733048061858184
              ],
              [
                -65.79450638182544,
                -9.737698960331617
              ],
              [
                -65.80264542161089,
                -9.757336020275481
              ],
              [
                -65.80388566372312,
                -9.76477757785694
              ],
              [
                -65.80370479412016,
                -9.775526227242677
              ],
              [
                -65.8064178095627,
                -9.78441463739181
              ],
              [
                -65.81652054753343,
                -9.785964836681496
              ],
              [
                -65.82212743784005,
                -9.781830671478666
              ],
              [
                -65.82739844319781,
                -9.773976027940485
              ],
              [
                -65.83166174506933,
                -9.76529431096153
              ],
              [
                -65.83406470472447,
                -9.758266440295143
              ],
              [
                -65.85042028980476,
                -9.77531953400249
              ],
              [
                -65.86246089283746,
                -9.781830671478666
              ],
              [
                -65.87442398849635,
                -9.781313938380666
              ],
              [
                -65.9152742073964,
                -9.771702101867685
              ],
              [
                -65.92933020213694,
                -9.770255249181453
              ],
              [
                -65.9469518614225,
                -9.77139206200649
              ],
              [
                -65.96565872811301,
                -9.776766386683086
              ],
              [
                -66.01038468940341,
                -9.804051696628255
              ],
              [
                -66.02947913376855,
                -9.80828920837725
              ],
              [
                -66.04278580970397,
                -9.804878469570403
              ],
              [
                -66.06932165623296,
                -9.790099001871093
              ],
              [
                -66.08172399955932,
                -9.785654796823708
              ],
              [
                -66.08699499923411,
                -9.78451798401119
              ],
              [
                -66.10198115476376,
                -9.787411689350183
              ],
              [
                -66.10606359925492,
                -9.790409041727813
              ],
              [
                -66.11311742558864,
                -9.802397850316181
              ],
              [
                -66.11818171996589,
                -9.806015282364932
              ],
              [
                -66.1235819100163,
                -9.805085162805833
              ],
              [
                -66.12792272761746,
                -9.801157690900402
              ],
              [
                -66.13169510385585,
                -9.797023525746273
              ],
              [
                -66.13546748995108,
                -9.795163286614384
              ],
              [
                -66.19065791759644,
                -9.800847651046265
              ],
              [
                -66.20796953147767,
                -9.808082515142317
              ],
              [
                -66.23897538997319,
                -9.828132960480485
              ],
              [
                -66.25732051719082,
                -9.834850790919733
              ],
              [
                -66.35527319564044,
                -9.84963025810234
              ],
              [
                -66.37173213421647,
                -9.855934701973787
              ],
              [
                -66.41327999140503,
                -9.879189191951038
              ],
              [
                -66.43271032396504,
                -9.886113715342008
              ],
              [
                -66.45286413978432,
                -9.888697681043825
              ],
              [
                -66.51384232909831,
                -9.883943436506387
              ],
              [
                -66.63187129945734,
                -9.904303920474064
              ],
              [
                -66.64262000196172,
                -9.907921352232174
              ],
              [
                -66.64892451595027,
                -9.915879341551786
              ],
              [
                -66.65249018890064,
                -9.92611125662117
              ],
              [
                -66.65481564173136,
                -9.93717024488823
              ],
              [
                -66.66008662602542,
                -9.945334927233393
              ],
              [
                -66.67000849685843,
                -9.951536024017829
              ],
              [
                -66.75160559700207,
                -9.982645454928301
              ],
              [
                -66.77062252293709,
                -9.992567329638488
              ],
              [
                -66.90265580292485,
                -10.093129575669305
              ],
              [
                -67.06429968295917,
                -10.25694386729184
              ],
              [
                -67.11003332610328,
                -10.28257537978819
              ],
              [
                -67.12073034685532,
                -10.284539080496893
              ],
              [
                -67.1417626545501,
                -10.285572604220029
              ],
              [
                -67.15173620689325,
                -10.288983253156168
              ],
              [
                -67.15907426009926,
                -10.297148133716437
              ],
              [
                -67.16486202016694,
                -10.30851695088175
              ],
              [
                -67.17230342728922,
                -10.319575708983963
              ],
              [
                -67.1847057697051,
                -10.326707046925256
              ],
              [
                -67.20175899239905,
                -10.326810393662063
              ],
              [
                -67.24103308242752,
                -10.316371772360156
              ],
              [
                -67.25917150883697,
                -10.313684588195123
              ],
              [
                -67.30066768437217,
                -10.315131536403985
              ],
              [
                -67.32350866759735,
                -10.318852244269854
              ],
              [
                -67.33782303870593,
                -10.326086928950916
              ],
              [
                -67.3394250089596,
                -10.33487192730824
              ],
              [
                -67.33368892296926,
                -10.356679365358321
              ],
              [
                -67.33529089479244,
                -10.366291212551362
              ],
              [
                -67.34283565203977,
                -10.372492354595344
              ],
              [
                -67.3534809973173,
                -10.376213062343965
              ],
              [
                -67.36500484148527,
                -10.378073416215507
              ],
              [
                -67.40918819117368,
                -10.37879688090622
              ],
              [
                -67.41833492080653,
                -10.381484083752026
              ],
              [
                -67.4292903257386,
                -10.39037242857997
              ],
              [
                -67.43187414692456,
                -10.397917190733764
              ],
              [
                -67.43223587989726,
                -10.406082033253329
              ],
              [
                -67.43662837698395,
                -10.417450849749438
              ],
              [
                -67.45052933872398,
                -10.435951041267794
              ],
              [
                -67.46804764790716,
                -10.452280763523888
              ],
              [
                -67.48820145646083,
                -10.46478646889964
              ],
              [
                -67.52933589800334,
                -10.478532410057612
              ],
              [
                -67.56509598701123,
                -10.495895674384291
              ],
              [
                -67.58462967956048,
                -10.501786813411844
              ],
              [
                -67.59997758028801,
                -10.515429370066938
              ],
              [
                -67.6111396891314,
                -10.528761886464334
              ],
              [
                -67.63082841075627,
                -10.559561050937104
              ],
              [
                -67.64348913644204,
                -10.574547227359796
              ],
              [
                -67.67382320186663,
                -10.599351905787007
              ],
              [
                -67.68467525259769,
                -10.610514027906834
              ],
              [
                -67.69604406994522,
                -10.64048638013164
              ],
              [
                -67.7051391190748,
                -10.676659835780821
              ],
              [
                -67.72172725490026,
                -10.705495298366607
              ],
              [
                -67.75578202346556,
                -10.714176948624498
              ],
              [
                -67.77495398071264,
                -10.70652884067805
              ],
              [
                -67.8142797466881,
                -10.675936408731411
              ],
              [
                -67.83334834820005,
                -10.664980980290483
              ],
              [
                -67.84776607402286,
                -10.660950232822202
              ],
              [
                -67.86264888578401,
                -10.658779801450079
              ],
              [
                -67.98181473685764,
                -10.66436082485365
              ],
              [
                -68.0102367769784,
                -10.659709997053543
              ],
              [
                -68.02713496802407,
                -10.661777006596639
              ],
              [
                -68.04377478320987,
                -10.666944718215277
              ],
              [
                -68.07457393305516,
                -10.681724125548866
              ],
              [
                -68.09788000553182,
                -10.697743843681558
              ],
              [
                -68.11209102485353,
                -10.714073601904243
              ],
              [
                -68.14728267645732,
                -10.779599327564533
              ],
              [
                -68.20355831054052,
                -10.83892387373448
              ],
              [
                -68.2175626229388,
                -10.858044143040052
              ],
              [
                -68.24376257183205,
                -10.91695522649949
              ],
              [
                -68.25750850629464,
                -10.938762735554384
              ],
              [
                -68.27435502388686,
                -10.96005343588059
              ],
              [
                -68.29332027399332,
                -10.978967011495978
              ],
              [
                -68.31383581580249,
                -10.99343637788561
              ],
              [
                -68.33114742185306,
                -11.000464405198436
              ],
              [
                -68.37827632604747,
                -11.005011886011566
              ],
              [
                -68.39641475665383,
                -11.014417037996
              ],
              [
                -68.42819576182903,
                -11.04366588598614
              ],
              [
                -68.44240677888597,
                -11.047696633216681
              ],
              [
                -68.4596667093392,
                -11.044802774965003
              ],
              [
                -68.47656490233952,
                -11.044802774965003
              ],
              [
                -68.49330806609122,
                -11.047386593069705
              ],
              [
                -68.53609615101838,
                -11.061545919287553
              ],
              [
                -68.58803096415346,
                -11.098649568312679
              ],
              [
                -68.6157295312846,
                -11.112498854398613
              ],
              [
                -68.75833064888,
                -11.141127622149646
              ],
              [
                -68.77592647585183,
                -11.140610888569807
              ],
              [
                -68.78398799483082,
                -11.135339830523295
              ],
              [
                -68.7870110676339,
                -11.126038100345854
              ],
              [
                -68.79117102264283,
                -11.085110397487314
              ],
              [
                -68.78564164212106,
                -11.059272141329826
              ],
              [
                -68.7739886068614,
                -11.035087582839713
              ],
              [
                -68.75763301844538,
                -11.011936566605522
              ],
              [
                -68.77455704807454,
                -11.00346161016869
              ],
              [
                -68.80465856984549,
                -10.994676613581763
              ],
              [
                -68.83168534633243,
                -11.000361058482671
              ],
              [
                -68.8589188261435,
                -11.010489637478754
              ],
              [
                -68.88403356895532,
                -11.016380700701157
              ],
              [
                -68.90814062575187,
                -11.013383495732214
              ],
              [
                -68.95542456287004,
                -11.000464405198436
              ],
              [
                -68.97893733997951,
                -11.001704640894209
              ],
              [
                -68.98338151022482,
                -11.002428067904523
              ],
              [
                -68.9925024002246,
                -11.002428067904523
              ],
              [
                -68.99699825298008,
                -11.001704640894209
              ],
              [
                -69.0713089588486,
                -10.969975246359551
              ],
              [
                -69.08688940383706,
                -10.967184734815941
              ],
              [
                -69.12148677624067,
                -10.970595401761768
              ],
              [
                -69.15851293886786,
                -10.962120445307061
              ],
              [
                -69.23680273524535,
                -10.95292206183494
              ],
              [
                -69.29351762100936,
                -10.95498914636914
              ],
              [
                -69.3295877682421,
                -10.949408048168717
              ],
              [
                -69.36307409802247,
                -10.940106317971228
              ],
              [
                -69.39594030905312,
                -10.935042028451532
              ],
              [
                -69.46337805375042,
                -10.951268439271324
              ],
              [
                -69.50288468580419,
                -10.95529918651726
              ],
              [
                -69.57763464177715,
                -10.952301906431986
              ],
              [
                -69.5962381579891,
                -10.95199186628379
              ],
              [
                -69.7202099178613,
                -10.964910956851625
              ],
              [
                -69.75343786599979,
                -10.958296391495224
              ],
              [
                -69.79105830892682,
                -10.934318526331401
              ],
              [
                -69.80831824008322,
                -10.927187227376853
              ],
              [
                -69.83508662856678,
                -10.925326836270239
              ],
              [
                -69.87570430497622,
                -10.928014001107117
              ],
              [
                -69.89513464239712,
                -10.926877112121359
              ],
              [
                -69.91420324711132,
                -10.92139943572994
              ],
              [
                -69.95611283233703,
                -10.919332351189519
              ],
              [
                -70.19873368369382,
                -11.041185414597049
              ],
              [
                -70.23948055141875,
                -11.055138047383686
              ],
              [
                -70.28939998628678,
                -11.064749892792893
              ],
              [
                -70.34102473757054,
                -11.06723028907545
              ],
              [
                -70.39130590886168,
                -11.059065447898513
              ],
              [
                -70.43727209325282,
                -11.03674120539703
              ],
              [
                -70.46249019277508,
                -11.013900229310808
              ],
              [
                -70.50719031005956,
                -10.961293671579162
              ],
              [
                -70.53411372777305,
                -10.93814258015068
              ],
              [
                -70.55555944931294,
                -10.942793482804442
              ],
              [
                -70.64134232702625,
                -11.010799677625934
              ],
              [
                -70.64113562251183,
                -10.929874392213222
              ],
              [
                -70.64085140036545,
                -10.802646997687901
              ],
              [
                -70.64051550192313,
                -10.675419600017976
              ],
              [
                -70.64020544508944,
                -10.548088888430511
              ],
              [
                -70.63984371038367,
                -10.420861517217778
              ],
              [
                -70.63948197456727,
                -10.29353079131919
              ],
              [
                -70.63917191617145,
                -10.166200055856294
              ],
              [
                -70.63886185795886,
                -10.038869323307345
              ],
              [
                -70.63865963569685,
                -9.955891602759019
              ],
              [
                -70.63855179211708,
                -9.911641830162692
              ],
              [
                -70.63844844008068,
                -9.851800536996853
              ],
              [
                -70.62901749267495,
                -9.811596300131656
              ],
              [
                -70.62322973482375,
                -9.801054344282356
              ],
              [
                -70.6150906927677,
                -9.79226928086657
              ],
              [
                -70.6054530456184,
                -9.785034717107905
              ],
              [
                -70.5952469542211,
                -9.77904031274698
              ],
              [
                -70.5900793102207,
                -9.77904031274698
              ],
              [
                -70.57956315052932,
                -9.785654796823708
              ],
              [
                -70.57416296604244,
                -9.784931370488588
              ],
              [
                -70.56915035585219,
                -9.779143659366781
              ],
              [
                -70.5666698760326,
                -9.767051203515624
              ],
              [
                -70.56336258966753,
                -9.76074675920778
              ],
              [
                -70.551244472602,
                -9.744107051799771
              ],
              [
                -70.54341548314886,
                -9.726950310633956
              ],
              [
                -70.54186518600534,
                -9.70824336986363
              ],
              [
                -70.54863480128127,
                -9.687676189542998
              ],
              [
                -70.56021032032751,
                -9.673310107031828
              ],
              [
                -70.58961422006622,
                -9.65026260705478
              ],
              [
                -70.60080216924865,
                -9.63527644435487
              ],
              [
                -70.60728755533569,
                -9.616776195561773
              ],
              [
                -70.61467729470377,
                -9.584116856745663
              ],
              [
                -70.62441829711028,
                -9.565823300528411
              ],
              [
                -70.61922482070442,
                -9.564479794255167
              ],
              [
                -70.59266312026618,
                -9.563756067373545
              ],
              [
                -70.58744381082431,
                -9.565616607255693
              ],
              [
                -70.57387873953836,
                -9.567786886617721
              ],
              [
                -70.56452531253838,
                -9.56540991398295
              ],
              [
                -70.57806453391005,
                -9.541845378554132
              ],
              [
                -70.57615251517956,
                -9.529133141150243
              ],
              [
                -70.56785844798854,
                -9.519211262908279
              ],
              [
                -70.55512020099134,
                -9.516007216643208
              ],
              [
                -70.55718725259801,
                -9.512596477090076
              ],
              [
                -70.559796921595,
                -9.504948525258115
              ],
              [
                -70.56194148755135,
                -9.501744478960207
              ],
              [
                -70.54326045185874,
                -9.493476146792126
              ],
              [
                -70.53829952234987,
                -9.480970602232064
              ],
              [
                -70.53566402949946,
                -9.464434238028652
              ],
              [
                -70.52535457389511,
                -9.446760760108726
              ],
              [
                -70.52375259653448,
                -9.443970100259946
              ],
              [
                -70.52499284165734,
                -9.430947822029996
              ],
              [
                -70.56697994479624,
                -9.435288681595315
              ],
              [
                -70.58687537434434,
                -9.439526194501713
              ],
              [
                -70.60638321295198,
                -9.448827693010719
              ],
              [
                -70.6271313083085,
                -9.466604517548562
              ],
              [
                -70.66209042210485,
                -9.509186037954901
              ],
              [
                -70.6808489542325,
                -9.527685987775783
              ],
              [
                -70.7472790193582,
                -9.56458314089162
              ],
              [
                -70.76779456120751,
                -9.579879344279021
              ],
              [
                -70.8053891551118,
                -9.61801635515102
              ],
              [
                -70.82518122680936,
                -9.6336225978305
              ],
              [
                -70.87548824317973,
                -9.66049452422961
              ],
              [
                -70.89158545850945,
                -9.678581385908476
              ],
              [
                -70.92026587152739,
                -9.720129133010282
              ],
              [
                -70.9315571736743,
                -9.729740969903466
              ],
              [
                -70.95747290228306,
                -9.745347211270154
              ],
              [
                -70.96904842484713,
                -9.754855701356341
              ],
              [
                -70.97760086710937,
                -9.766741163653322
              ],
              [
                -70.98956395947427,
                -9.792062587629042
              ],
              [
                -70.99721208352916,
                -9.80353496353916
              ],
              [
                -71.0154280124863,
                -9.817487357724275
              ],
              [
                -71.07746558193978,
                -9.833817324766187
              ],
              [
                -71.14425737191333,
                -9.863066219144489
              ],
              [
                -71.16105220277915,
                -9.875571760110194
              ],
              [
                -71.17391962925325,
                -9.897275750146921
              ],
              [
                -71.18311803840413,
                -9.920633585968044
              ],
              [
                -71.19650223768097,
                -9.939857256664974
              ],
              [
                -71.2451297558486,
                -9.956083575086968
              ],
              [
                -71.28032141336134,
                -9.983472227752857
              ],
              [
                -71.29970007634692,
                -9.993394102456328
              ],
              [
                -71.31344600336165,
                -9.994220875273632
              ],
              [
                -71.32171423264035,
                -9.989466631140369
              ],
              [
                -71.32894893674319,
                -9.983368881149826
              ],
              [
                -71.33964595289686,
                -9.979751449611832
              ],
              [
                -71.35406367231069,
                -9.981301648661056
              ],
              [
                -71.35959306691664,
                -9.986882966074402
              ],
              [
                -71.3636238182779,
                -9.994530915079984
              ],
              [
                -71.3733906660022,
                -10.002282410038983
              ],
              [
                -71.39142574098452,
                -10.006829934742763
              ],
              [
                -71.42868444900678,
                -10.00672658211548
              ],
              [
                -71.60701981599162,
                -10.006519876860889
              ],
              [
                -71.7853551849858,
                -10.006106465764802
              ],
              [
                -71.96363887499524,
                -10.005899759923333
              ],
              [
                -72.14197424400484,
                -10.005693054081826
              ],
              [
                -72.19566605699193,
                -10.005589700867667
              ],
              [
                -72.18460729821814,
                -9.984609040385699
              ],
              [
                -72.18352210307539,
                -9.967039216482087
              ],
              [
                -72.18553747504775,
                -9.949675785113605
              ],
              [
                -72.18393550897707,
                -9.92900526206318
              ],
              [
                -72.17835445548869,
                -9.918670000409122
              ],
              [
                -72.16269649192995,
                -9.900066409045758
              ],
              [
                -72.16042273785158,
                -9.88766421493421
              ],
              [
                -72.16290319084985,
                -9.877225305901032
              ],
              [
                -72.17111974462262,
                -9.856864821495828
              ],
              [
                -72.17385859962677,
                -9.845806132948221
              ],
              [
                -72.1947358795323,
                -9.80580858912963
              ],
              [
                -72.265222529527,
                -9.762193611904635
              ],
              [
                -72.27700476652802,
                -9.724263298408895
              ],
              [
                -72.26511917917185,
                -9.686539376645369
              ],
              [
                -72.26165685639151,
                -9.667419048789144
              ],
              [
                -72.26765133267021,
                -9.649539180645183
              ],
              [
                -72.29488480277332,
                -9.617499621988964
              ],
              [
                -72.30413488966346,
                -9.60085991278674
              ],
              [
                -72.30692542095382,
                -9.579982690914317
              ],
              [
                -72.30563350802439,
                -9.550630443621758
              ],
              [
                -72.30677038811334,
                -9.540915258810445
              ],
              [
                -72.31266149657154,
                -9.532543580236474
              ],
              [
                -72.32294510797354,
                -9.532130193681015
              ],
              [
                -72.33452062257346,
                -9.533990433179595
              ],
              [
                -72.34454585353198,
                -9.532853620152988
              ],
              [
                -72.36247758320275,
                -9.520658115865329
              ],
              [
                -72.39022782556188,
                -9.49647349982594
              ],
              [
                -72.40950313403245,
                -9.486344928066968
              ],
              [
                -72.43022538111097,
                -9.482210761943584
              ],
              [
                -72.49079016172713,
                -9.486448274709236
              ],
              [
                -72.5356453042338,
                -9.481590682087964
              ],
              [
                -72.55445552828506,
                -9.476009662948803
              ],
              [
                -72.59605505798444,
                -9.455545825774017
              ],
              [
                -72.6365176968235,
                -9.44293663380579
              ],
              [
                -72.65594803117533,
                -9.439009160846807
              ],
              [
                -72.65982377852961,
                -9.439836234438774
              ],
              [
                -72.66778194685762,
                -9.445313907075533
              ],
              [
                -72.67227779219766,
                -9.446657413463532
              ],
              [
                -72.67801388188975,
                -9.445003867139658
              ],
              [
                -72.68679886655526,
                -9.43745896115987
              ],
              [
                -72.69170813672262,
                -9.435081988303272
              ],
              [
                -72.8133027780092,
                -9.410897370797
              ],
              [
                -73.21498367619047,
                -9.409036830709528
              ],
              [
                -73.19353796790891,
                -9.375654060490085
              ],
              [
                -73.14082800051489,
                -9.322840616538592
              ],
              [
                -73.11757360755354,
                -9.291938164099102
              ],
              [
                -73.10119218510268,
                -9.260002244432972
              ],
              [
                -73.09023676790552,
                -9.244189003907422
              ],
              [
                -73.07840287275519,
                -9.236851090638838
              ],
              [
                -73.06419186175613,
                -9.234784157437403
              ],
              [
                -73.04791378285552,
                -9.230339950618422
              ],
              [
                -73.03437454926781,
                -9.222588350212432
              ],
              [
                -73.02853511989424,
                -9.210599536639384
              ],
              [
                -73.0278633173613,
                -9.183107521797842
              ],
              [
                -72.98238806041523,
                -9.147140779444712
              ],
              [
                -72.97200110634816,
                -9.134428538615506
              ],
              [
                -72.96368119763537,
                -9.115514896753515
              ],
              [
                -72.95939205291033,
                -9.08564590681778
              ],
              [
                -72.97003739290275,
                -9.001929994594468
              ],
              [
                -72.97608353973376,
                -8.985393625153305
              ],
              [
                -73.003678758258,
                -8.94415589728793
              ],
              [
                -73.01670121498552,
                -8.930409887629105
              ],
              [
                -73.053804891667,
                -8.906018568845854
              ],
              [
                -73.06863603396157,
                -8.89371971285242
              ],
              [
                -73.14584061092502,
                -8.782201729285834
              ],
              [
                -73.16346228141073,
                -8.739620489526462
              ],
              [
                -73.17457271056841,
                -8.720706843193808
              ],
              [
                -73.1919876741244,
                -8.703860430958965
              ],
              [
                -73.21100460067429,
                -8.69393854750663
              ],
              [
                -73.26914057889279,
                -8.681639389596498
              ],
              [
                -73.28986283133945,
                -8.670477345679132
              ],
              [
                -73.30810461912719,
                -8.653217546194004
              ],
              [
                -73.35058264451655,
                -8.598337144941441
              ],
              [
                -73.35699052595294,
                -8.581800771689796
              ],
              [
                -73.3576623167944,
                -8.562990470440047
              ],
              [
                -73.34825720357851,
                -8.518341991120261
              ],
              [
                -73.34929073290236,
                -8.49808483538401
              ],
              [
                -73.35642207412178,
                -8.479791266848075
              ],
              [
                -73.3705297384296,
                -8.465218480006252
              ],
              [
                -73.37941809458934,
                -8.461911385395592
              ],
              [
                -73.40050207170717,
                -8.459430764007521
              ],
              [
                -73.41021723728068,
                -8.455503288718871
              ],
              [
                -73.42024247840595,
                -8.446201784640511
              ],
              [
                -73.4365205413585,
                -8.42522090077918
              ],
              [
                -73.4472692517893,
                -8.416126089978603
              ],
              [
                -73.52654089362794,
                -8.372407727751675
              ],
              [
                -73.54082942108978,
                -8.359075100679041
              ],
              [
                -73.54767656062788,
                -8.34016175103438
              ],
              [
                -73.55271501454709,
                -8.299130702221653
              ],
              [
                -73.56173253996306,
                -8.272672140494896
              ],
              [
                -73.59061967365972,
                -8.234741792354683
              ],
              [
                -73.60328039333973,
                -8.211590625280728
              ],
              [
                -73.60617426918319,
                -8.192780320631183
              ],
              [
                -73.60054154396934,
                -8.155470051448871
              ],
              [
                -73.60110998228303,
                -8.136143012717556
              ],
              [
                -73.61185869019724,
                -8.112578758161142
              ],
              [
                -73.64472489739606,
                -8.06834365622084
              ],
              [
                -73.65164953071765,
                -8.04601926127298
              ],
              [
                -73.66803096525068,
                -8.01377327983541
              ],
              [
                -73.70590978940041,
                -7.9938261595698155
              ],
              [
                -73.74849117427328,
                -7.976979741452969
              ],
              [
                -73.77879939406832,
                -7.954138612014319
              ],
              [
                -73.7849489006254,
                -7.9403928959850525
              ],
              [
                -73.79577510544574,
                -7.892230314649635
              ],
              [
                -73.7946382181596,
                -7.874143434626183
              ],
              [
                -73.77960038993069,
                -7.874453775253518
              ],
              [
                -73.74611405652007,
                -7.886442597175268
              ],
              [
                -73.71371293323679,
                -7.866288782434159
              ],
              [
                -73.70255081829004,
                -7.82784139372656
              ],
              [
                -73.71216263184641,
                -7.788153843623566
              ],
              [
                -73.74223832570897,
                -7.764072852107349
              ],
              [
                -73.77960038970754,
                -7.752910803545863
              ],
              [
                -73.81114884719824,
                -7.739268132784223
              ],
              [
                -73.83879573376154,
                -7.720561171302012
              ],
              [
                -73.96938207495148,
                -7.5846520942636095
              ],
              [
                -74.00966386409668,
                -7.561087834794282
              ],
              [
                -74.01847468748502,
                -7.5435176863947575
              ],
              [
                -73.98448639767143,
                -7.5294072504779415
              ],
              [
                -73.97142329439595,
                -7.523983949721047
              ],
              [
                -73.95871089715665,
                -7.501969891004307
              ],
              [
                -73.95778072471728,
                -7.48036921912896
              ],
              [
                -73.94987423060941,
                -7.465176345923097
              ],
              [
                -73.94431900994975,
                -7.448743161452562
              ],
              [
                -73.95054602031875,
                -7.423215012334585
              ],
              [
                -73.97943314650885,
                -7.374535839014478
              ],
              [
                -73.98289546934181,
                -7.35644910609392
              ],
              [
                -73.96106217634143,
                -7.35644910609392
              ],
              [
                -73.9204703380707,
                -7.372158713533075
              ],
              [
                -73.90202184770149,
                -7.3733988745427075
              ],
              [
                -73.87974930775874,
                -7.365027337079363
              ],
              [
                -73.84342077912979,
                -7.343116624088434
              ],
              [
                -73.82585078784604,
                -7.337432102103082
              ],
              [
                -73.80027095863113,
                -7.335675207321797
              ],
              [
                -73.76076432184792,
                -7.337432102103082
              ],
              [
                -73.74125646908668,
                -7.334434896085892
              ],
              [
                -73.72474584763171,
                -7.324823047293375
              ],
              [
                -73.71309281116055,
                -7.304669228858942
              ],
              [
                -73.71609004654468,
                -7.28637580208809
              ],
              [
                -73.72453914529522,
                -7.267565641460536
              ],
              [
                -73.73453853335734,
                -7.225087571816338
              ],
              [
                -73.80355240698945,
                -7.126488908177729
              ],
              [
                -73.8067621495111,
                -7.117879282090888
              ],
              [
                -73.81233740184457,
                -7.10292449552813
              ],
              [
                -73.80657547791175,
                -7.078223118197416
              ],
              [
                -73.79226110760858,
                -7.0500078007118505
              ],
              [
                -73.76771480607728,
                -6.959264087926284
              ],
              [
                -73.7654927178455,
                -6.904176959331601
              ],
              [
                -73.75942073405089,
                -6.887433732355876
              ],
              [
                -73.74859452543302,
                -6.875548253814328
              ],
              [
                -73.70678828721911,
                -6.849606563991287
              ],
              [
                -73.69696977088688,
                -6.837204351553892
              ],
              [
                -73.685084190567,
                -6.811882892355143
              ],
              [
                -73.67195837256573,
                -6.800720690792998
              ],
              [
                -73.64405310331537,
                -6.783977613731572
              ],
              [
                -73.5938752854903,
                -6.743980012438094
              ],
              [
                -73.51320837647174,
                -6.697781304542965
              ],
              [
                -73.44540889556598,
                -6.6395936203842645
              ],
              [
                -73.40628983285485,
                -6.615615668410243
              ],
              [
                -73.37068477376503,
                -6.583886408407159
              ],
              [
                -73.34918737826709,
                -6.57644499053159
              ],
              [
                -73.27849402009626,
                -6.57572156316111
              ],
              [
                -73.23358719751045,
                -6.564042627391193
              ],
              [
                -73.1989639889285,
                -6.545645851289245
              ],
              [
                -73.17147212838874,
                -6.517430531351955
              ],
              [
                -73.14780432363284,
                -6.47619276746358
              ],
              [
                -73.13178463000624,
                -6.435265043715756
              ],
              [
                -73.12703039634914,
                -6.413044136500294
              ],
              [
                -73.12697871638062,
                -6.3913399630886225
              ],
              [
                -73.13380000720511,
                -6.368085588100078
              ],
              [
                -73.15571081308913,
                -6.322713652469245
              ],
              [
                -73.16155024910464,
                -6.299769317677267
              ],
              [
                -73.1720405688114,
                -6.219670914314525
              ],
              [
                -73.17767330149826,
                -6.202411027296627
              ],
              [
                -73.22599076378773,
                -6.14794404971399
              ],
              [
                -73.23529252298115,
                -6.123656131614563
              ],
              [
                -73.23477575653146,
                -6.077560692976315
              ],
              [
                -73.21885941539436,
                -6.04025033066754
              ],
              [
                -73.19710363937553,
                -6.0050070539750156
              ],
              [
                -73.14000117934127,
                -5.8785030960109586
              ],
              [
                -73.10563635162269,
                -5.846980453336377
              ],
              [
                -73.00135331304116,
                -5.70879771008629
              ],
              [
                -72.9871939693352,
                -5.681099123451001
              ],
              [
                -72.9769103594506,
                -5.651746913448002
              ],
              [
                -72.96047725484671,
                -5.559246109901084
              ],
              [
                -72.96032222582407,
                -5.531237483282388
              ],
              [
                -72.96910721931425,
                -5.499198107463434
              ],
              [
                -72.97349971622073,
                -5.466125188965837
              ],
              [
                -72.9641979579819,
                -5.433775735512274
              ],
              [
                -72.9347940666607,
                -5.372177419738213
              ],
              [
                -72.93050492458336,
                -5.356467809958232
              ],
              [
                -72.92399369376055,
                -5.313576348423753
              ],
              [
                -72.91624222808301,
                -5.299106956285204
              ],
              [
                -72.90539017725965,
                -5.285671088159806
              ],
              [
                -72.89665686067906,
                -5.271615083140121
              ],
              [
                -72.89489986172875,
                -5.255698742498712
              ],
              [
                -72.90032588669946,
                -5.194617199636287
              ],
              [
                -72.90559688420782,
                -5.179114283796801
              ],
              [
                -72.91495031827421,
                -5.164438179657627
              ],
              [
                -72.92197831313622,
                -5.14686818781148
              ],
              [
                -72.91794755109285,
                -5.132088727602923
              ],
              [
                -72.89381465709612,
                -5.1258875556959245
              ],
              [
                -72.88068884309145,
                -5.125267437566769
              ],
              [
                -72.87283402486064,
                -5.123613786093247
              ],
              [
                -72.85893306500617,
                -5.11606903117683
              ],
              [
                -72.85769282991075,
                -5.112141619496386
              ],
              [
                -72.85702103713069,
                -5.097568871680871
              ],
              [
                -72.85397212706782,
                -5.092504579913135
              ],
              [
                -72.84901118995374,
                -5.092091164700088
              ],
              [
                -72.83635046393873,
                -5.096225279278588
              ],
              [
                -72.83113114408845,
                -5.096638694491941
              ],
              [
                -72.79030676389927,
                -5.088783871161903
              ],
              [
                -72.77294348189868,
                -5.081135760143586
              ],
              [
                -72.76017940303694,
                -5.0647026580453725
              ],
              [
                -72.74757035400852,
                -5.055090841243091
              ],
              [
                -72.72881180896366,
                -5.0572612499729725
              ],
              [
                -72.70798620695538,
                -5.063152362740186
              ],
              [
                -72.65419104095548,
                -5.063152362740186
              ],
              [
                -72.64478593005255,
                -5.0605685434914385
              ],
              [
                -72.63507076095509,
                -5.051783547728124
              ],
              [
                -72.63243526196713,
                -5.042791849069374
              ],
              [
                -72.63160843897556,
                -5.033180032308046
              ],
              [
                -72.62726761901682,
                -5.022431335479729
              ],
              [
                -72.61434851099547,
                -5.009718932873213
              ],
              [
                -72.58659826913865,
                -4.996696533034448
              ],
              [
                -72.5622069947679,
                -4.970238246865007
              ],
              [
                -72.5464456758036,
                -4.958249115365443
              ],
              [
                -72.52851395980825,
                -4.9501877636007725
              ],
              [
                -72.50975540980824,
                -4.947500446064268
              ],
              [
                -72.49513098088606,
                -4.946983712004876
              ],
              [
                -72.48892981021277,
                -4.941195990116611
              ],
              [
                -72.48588089788885,
                -4.932565930489275
              ],
              [
                -72.4806615862024,
                -4.923367763841127
              ],
              [
                -72.47967973033239,
                -4.919646978206053
              ],
              [
                -72.47993811401001,
                -4.914169296783228
              ],
              [
                -72.47947302797391,
                -4.908071534500019
              ],
              [
                -72.47647578549159,
                -4.9024902058522155
              ],
              [
                -72.47177323306717,
                -4.900733310066447
              ],
              [
                -72.45797562667565,
                -4.90042326963373
              ],
              [
                -72.45260128021197,
                -4.899183107903016
              ],
              [
                -72.4311038864539,
                -4.887814357865793
              ],
              [
                -72.41467077353552,
                -4.87634196061723
              ],
              [
                -72.40412878303445,
                -4.860218956939415
              ],
              [
                -72.39684241162966,
                -4.805648837247152
              ],
              [
                -72.38609370621649,
                -4.793969746567798
              ],
              [
                -72.34470088644608,
                -4.782600996767399
              ],
              [
                -72.33942989073093,
                -4.7773300091102255
              ],
              [
                -72.33684607434252,
                -4.769888738485038
              ],
              [
                -72.33193680510384,
                -4.76327394190866
              ],
              [
                -72.31979285025419,
                -4.760173537666516
              ],
              [
                -72.28237911300413,
                -4.765444525306056
              ],
              [
                -72.26930497602233,
                -4.764927791265353
              ],
              [
                -72.2510631877435,
                -4.758829728735403
              ],
              [
                -72.23313146610766,
                -4.748391100283114
              ],
              [
                -72.18243688978335,
                -4.710667412585208
              ],
              [
                -72.12709143146992,
                -4.680074955227961
              ],
              [
                -72.10802282732132,
                -4.664261992585908
              ],
              [
                -72.09660233454295,
                -4.6497925384673815
              ],
              [
                -72.07872228953183,
                -4.613412359948054
              ],
              [
                -72.07112585069726,
                -4.605144014690362
              ],
              [
                -72.0627026006628,
                -4.605661049141986
              ],
              [
                -72.05355586379125,
                -4.610208308563155
              ],
              [
                -72.0435823147069,
                -4.613825747168606
              ],
              [
                -72.03552079555865,
                -4.6118621578712995
              ],
              [
                -72.02616736366043,
                -4.605661049141986
              ],
              [
                -72.00983760810422,
                -4.591604982402772
              ],
              [
                -71.98027868726948,
                -4.582303169133595
              ],
              [
                -71.93314978019954,
                -4.5367245246898165
              ],
              [
                -71.90720821686593,
                -4.518431239194522
              ],
              [
                -71.89015499316055,
                -4.513676985818056
              ],
              [
                -71.80762772911062,
                -4.5044785194867485
              ],
              [
                -71.80065140426993,
                -4.502411282999742
              ],
              [
                -71.79698238678932,
                -4.497967370472792
              ],
              [
                -71.79574214522378,
                -4.491145880631495
              ],
              [
                -71.79305497390183,
                -4.484634731633493
              ],
              [
                -71.78483841899204,
                -4.480500559102042
              ],
              [
                -71.77434810100326,
                -4.481534027127916
              ],
              [
                -71.75145544143615,
                -4.492076001856607
              ],
              [
                -71.74018998152893,
                -4.4955900935796205
              ],
              [
                -71.72106970686033,
                -4.492799729903
              ],
              [
                -71.70964921169876,
                -4.484738078436138
              ],
              [
                -71.69931392183705,
                -4.48163737393051
              ],
              [
                -71.68334591047542,
                -4.493523157522733
              ],
              [
                -71.67306230072583,
                -4.503651745062551
              ],
              [
                -71.66520747519543,
                -4.507578923578643
              ],
              [
                -71.65652583575063,
                -4.506752149153963
              ],
              [
                -71.64381343348052,
                -4.502307936196728
              ],
              [
                -71.62350459366225,
                -4.482257454746161
              ],
              [
                -71.61342769634915,
                -4.479260397471223
              ],
              [
                -71.61714839822633,
                -4.500344346940222
              ],
              [
                -71.57156978259195,
                -4.480707252707204
              ],
              [
                -71.55756547217919,
                -4.479363744273778
              ],
              [
                -71.5323473728986,
                -4.484634731633493
              ],
              [
                -71.5245959068909,
                -4.485151465646806
              ],
              [
                -71.51906652954875,
                -4.479157050668693
              ],
              [
                -71.51286536143994,
                -4.4571429800622
              ],
              [
                -71.50614742231473,
                -4.448564594638042
              ],
              [
                -71.49234981653086,
                -4.442776873303665
              ],
              [
                -71.47741532196434,
                -4.440606290038148
              ],
              [
                -71.44697790353385,
                -4.4402962496326825
              ],
              [
                -71.40077917695064,
                -4.433371713488324
              ],
              [
                -71.38698156604981,
                -4.434921915513897
              ],
              [
                -71.37762813572682,
                -4.442673526501822
              ],
              [
                -71.37116858220217,
                -4.453215501155656
              ],
              [
                -71.36326208652066,
                -4.45920991610536
              ],
              [
                -71.34956783256865,
                -4.453525541561859
              ],
              [
                -71.34589880234245,
                -4.45011479666789
              ],
              [
                -71.33701045926993,
                -4.438332660398439
              ],
              [
                -71.33075760665184,
                -4.435128609117354
              ],
              [
                -71.32409135456773,
                -4.436575764768416
              ],
              [
                -71.31845861830422,
                -4.439366128416374
              ],
              [
                -71.31515132513789,
                -4.4399862092272295
              ],
              [
                -71.30538448518992,
                -4.427067258162046
              ],
              [
                -71.3051261025452,
                -4.416628630359607
              ],
              [
                -71.30724483573925,
                -4.406810083383941
              ],
              [
                -71.30460933021968,
                -4.394924299979089
              ],
              [
                -71.28848629159259,
                -4.380765187410271
              ],
              [
                -71.26481848483587,
                -4.375494200149789
              ],
              [
                -71.2416674353173,
                -4.380041459378598
              ],
              [
                -71.21407222981063,
                -4.410840909058754
              ],
              [
                -71.20068803447845,
                -4.395648028012696
              ],
              [
                -71.18616695244951,
                -4.372186802104391
              ],
              [
                -71.1696821688989,
                -4.362781642408588
              ],
              [
                -71.16311925967644,
                -4.369086097661967
              ],
              [
                -71.15247392024108,
                -4.391720549149853
              ],
              [
                -71.14410233366718,
                -4.399265166048402
              ],
              [
                -71.12849605544658,
                -4.401849136502106
              ],
              [
                -71.11955603311914,
                -4.396371455619644
              ],
              [
                -71.10604264138559,
                -4.373840350913461
              ],
              [
                -71.08157384940127,
                -4.364125150813681
              ],
              [
                -71.02932898366699,
                -4.3858294810741265
              ],
              [
                -71.00997615133555,
                -4.369809525265454
              ],
              [
                -71.00545446658958,
                -4.3475887614933395
              ],
              [
                -70.98971899707242,
                -4.366192387248844
              ],
              [
                -70.96868669161854,
                -4.385312747070127
              ],
              [
                -70.94809362417938,
                -4.364228497614087
              ],
              [
                -70.93884355017384,
                -4.34510843829152
              ],
              [
                -70.92633785561628,
                -4.328985436226081
              ],
              [
                -70.89639135970351,
                -4.299839836209083
              ],
              [
                -70.88657283846949,
                -4.283510140674585
              ],
              [
                -70.88112097067987,
                -4.265629942780778
              ],
              [
                -70.87370540183245,
                -4.25074710252049
              ],
              [
                -70.85825415310653,
                -4.2433058326181925
              ],
              [
                -70.84275122318746,
                -4.238138192283507
              ],
              [
                -70.83980566464668,
                -4.228733032809451
              ],
              [
                -70.8483064362719,
                -4.2044450332098116
              ],
              [
                -70.84518001810153,
                -4.191009348695381
              ],
              [
                -70.83223506425827,
                -4.179433606132088
              ],
              [
                -70.78456356008688,
                -4.156282721927634
              ],
              [
                -70.7742541143416,
                -4.155042560367829
              ],
              [
                -70.71211320164646,
                -4.171888989524241
              ],
              [
                -70.69405228891377,
                -4.172302376711996
              ],
              [
                -70.68307104371222,
                -4.163827338515392
              ],
              [
                -70.67203812418089,
                -4.133441577776297
              ],
              [
                -70.66289139699737,
                -4.1221761761412195
              ],
              [
                -70.64676835351035,
                -4.115665027566066
              ],
              [
                -70.63105871161167,
                -4.11897212503738
              ],
              [
                -70.62958593518265,
                -4.133441577776297
              ],
              [
                -70.63317745089594,
                -4.151838509246179
              ],
              [
                -70.63253149653667,
                -4.166824696049883
              ],
              [
                -70.58527339471374,
                -4.194523139803714
              ],
              [
                -70.57656591645677,
                -4.183877818834445
              ],
              [
                -70.57232845421706,
                -4.165894574878344
              ],
              [
                -70.5656363500544,
                -4.1488411517193216
              ],
              [
                -70.5496941765467,
                -4.140676454372412
              ],
              [
                -70.53411372978829,
                -4.146774215789097
              ],
              [
                -70.52938533718712,
                -4.161347015392896
              ],
              [
                -70.52638810643329,
                -4.176023161829835
              ],
              [
                -70.51597530325591,
                -4.1823276168774575
              ],
              [
                -70.50088578398805,
                -4.177366670191088
              ],
              [
                -70.46000972050126,
                -4.144603632636401
              ],
              [
                -70.44422257531279,
                -4.137369056462212
              ],
              [
                -70.42993403786727,
                -4.134165005350167
              ],
              [
                -70.41533545143494,
                -4.135612160924909
              ],
              [
                -70.39866980057657,
                -4.142330003114818
              ],
              [
                -70.37368424242463,
                -4.16455076609299
              ],
              [
                -70.3614369301252,
                -4.168168204409036
              ],
              [
                -70.34306595559612,
                -4.139435992389168
              ],
              [
                -70.33061193709548,
                -4.1431567774862055
              ],
              [
                -70.31870052307305,
                -4.156282721927634
              ],
              [
                -70.3111040885035,
                -4.170855521554994
              ],
              [
                -70.3093470906901,
                -4.19121604228992
              ],
              [
                -70.3183904632901,
                -4.228939726405364
              ],
              [
                -70.31671098363329,
                -4.247026617781513
              ],
              [
                -70.3069958091889,
                -4.2602556088290084
              ],
              [
                -70.25759314278436,
                -4.299219755413762
              ],
              [
                -70.24798132150144,
                -4.302113465792509
              ],
              [
                -70.23917049008122,
                -4.301803425394715
              ],
              [
                -70.23131567805574,
                -4.303663968208469
              ],
              [
                -70.22472692520687,
                -4.31306882737889
              ],
              [
                -70.2167429153743,
                -4.32888178899959
              ],
              [
                -70.2056324847476,
                -4.3429378550640685
              ],
              [
                -70.18656388409379,
                -4.3262981190062835
              ],
              [
                -70.17025997270939,
                -4.288471087452097
              ],
              [
                -70.15726334673201,
                -4.270177502347991
              ],
              [
                -70.13889237380731,
                -4.260462302426029
              ],
              [
                -70.11651648273906,
                -4.258292019657664
              ],
              [
                -70.09662105253356,
                -4.2657332895793765
              ],
              [
                -70.08574316766165,
                -4.283923527870329
              ],
              [
                -70.08109228993796,
                -4.30883160860234
              ],
              [
                -70.0756145829,
                -4.316169531790476
              ],
              [
                -70.0633414271269,
                -4.328468401800588
              ],
              [
                -70.05096492480247,
                -4.3372534806394825
              ],
              [
                -70.03703812853196,
                -4.340870919064202
              ],
              [
                -70.0229046187376,
                -4.338907029438274
              ],
              [
                -69.98939245872957,
                -4.31461932979784
              ],
              [
                -69.971822469214,
                -4.29095141062912
              ],
              [
                -69.96257238915378,
                -4.264286434399029
              ],
              [
                -69.9649494998846,
                -4.236484343087203
              ],
              [
                -69.9638642987949,
                -4.234314060327872
              ],
              [
                -69.9627274208932,
                -4.232040430771353
              ],
              [
                -69.96164221179619,
                -4.229766500789004
              ],
              [
                -69.96050533370155,
                -4.227596218032178
              ],
              [
                -69.95942012238761,
                -4.22542563484947
              ],
              [
                -69.95833492248106,
                -4.223152005296425
              ],
              [
                -69.95719803536132,
                -4.220878075317573
              ],
              [
                -69.95611283407239,
                -4.218811139361867
              ],
              [
                -69.95507931000151,
                -4.21664085660915
              ],
              [
                -69.95391658488607,
                -4.214366926632843
              ],
              [
                -69.95277970697224,
                -4.212093297084162
              ],
              [
                -69.95169449664037,
                -4.209922713907217
              ],
              [
                -69.95055761956519,
                -4.2077524311578465
              ],
              [
                -69.94942073226792,
                -4.205581847982543
              ],
              [
                -69.94833553116004,
                -4.203411565234789
              ],
              [
                -69.9471986532388,
                -4.201137935690382
              ],
              [
                -69.9178464355829,
                -4.040010667008375
              ],
              [
                -69.8885200651843,
                -3.878780356251091
              ],
              [
                -69.85916784699938,
                -3.717653095980456
              ],
              [
                -69.82981563013863,
                -3.556525839657474
              ],
              [
                -69.8004634207597,
                -3.3952955407532643
              ],
              [
                -69.77116288034337,
                -3.234168291814564
              ],
              [
                -69.74173315679016,
                -3.0729379999567077
              ],
              [
                -69.7124067777454,
                -2.911810757717451
              ],
              [
                -69.68308040679237,
                -2.7506838189968357
              ],
              [
                -69.653702352193,
                -2.589453235996093
              ],
              [
                -69.62435013885003,
                -2.42832615273447
              ],
              [
                -69.59499792371159,
                -2.267095575067047
              ],
              [
                -69.5656973874715,
                -2.1059684967929284
              ],
              [
                -69.53631933618169,
                -1.9448414207550582
              ],
              [
                -69.50696712392536,
                -1.7836110000154903
              ],
              [
                -69.47761490930348,
                -1.6224837777246728
              ],
              [
                -69.46642696058024,
                -1.5610921938942437
              ],
              [
                -69.45193172204908,
                -1.5108626617712129
              ],
              [
                -69.45226761806857,
                -1.490502147377346
              ],
              [
                -69.4339483247232,
                -1.4221860304080551
              ],
              [
                -69.43469763268452,
                -1.3764007099882547
              ],
              [
                -69.41831620235624,
                -1.2841064919399658
              ],
              [
                -69.42106507221897,
                -1.2393101763556693
              ],
              [
                -69.42110673001417,
                -1.2386312872609746
              ],
              [
                -69.39945430496361,
                -1.1827173836503713
              ],
              [
                -69.41046138561668,
                -1.152745019811109
              ],
              [
                -69.44815934315145,
                -1.0920769400265347
              ],
              [
                -69.44828853428827,
                -1.0803980798878037
              ],
              [
                -69.44193233266967,
                -1.059830797323037
              ],
              [
                -69.43976192224386,
                -1.0486687461198074
              ],
              [
                -69.44503291910428,
                -1.0107382311223394
              ],
              [
                -69.4428625090128,
                -1.0083611053760215
              ],
              [
                -69.44691910796355,
                -1.000816341089385
              ],
              [
                -69.4499680180837,
                -0.9967855920413093
              ],
              [
                -69.45508398487809,
                -0.9946151598208306
              ],
              [
                -69.46513505103027,
                -0.9930648832806245
              ],
              [
                -69.47123287001376,
                -0.9880005915049872
              ],
              [
                -69.4931436770364,
                -0.9561679110970254
              ],
              [
                -69.50247127378825,
                -0.9502767701257087
              ],
              [
                -69.52427872798927,
                -0.9409750357954564
              ],
              [
                -69.53259863328101,
                -0.9340504272076288
              ],
              [
                -69.53923905399974,
                -0.9206145219785677
              ],
              [
                -69.538618937925,
                -0.9105892852188442
              ],
              [
                -69.53621598316991,
                -0.9011842041407037
              ],
              [
                -69.53732702728419,
                -0.889505344092326
              ],
              [
                -69.54329565399283,
                -0.8786532581431695
              ],
              [
                -69.55024613518303,
                -0.8731755793426218
              ],
              [
                -69.55750667413542,
                -0.8694548705994681
              ],
              [
                -69.5641987719584,
                -0.8634603828854158
              ],
              [
                -69.57324214809249,
                -0.8491977035975393
              ],
              [
                -69.57567093901463,
                -0.8391724668635909
              ],
              [
                -69.57272538309851,
                -0.8135409678551715
              ],
              [
                -69.58068355417608,
                -0.7993816353530063
              ],
              [
                -69.61835567184063,
                -0.7569035627787286
              ],
              [
                -69.6283809010837,
                -0.7334424960382927
              ],
              [
                -69.62197302219236,
                -0.7153557613246648
              ],
              [
                -69.59076045820544,
                -0.6682268592883385
              ],
              [
                -69.58422338901825,
                -0.6445590239788351
              ],
              [
                -69.5869622397938,
                -0.6324667018738321
              ],
              [
                -69.59269832405712,
                -0.6240951635941413
              ],
              [
                -69.59926123106855,
                -0.6164470526428962
              ],
              [
                -69.60453222704759,
                -0.6063184692174572
              ],
              [
                -69.60657344592612,
                -0.5964999260772973
              ],
              [
                -69.60706437206659,
                -0.5668376782557306
              ],
              [
                -69.61171525104865,
                -0.5446168103165316
              ],
              [
                -69.61975093595962,
                -0.524566337023629
              ],
              [
                -69.63207576491912,
                -0.506892989448559
              ],
              [
                -69.64951656099599,
                -0.49201019218442255
              ],
              [
                -69.66649227004882,
                -0.48291515150039954
              ],
              [
                -69.74646154804239,
                -0.4530461726766581
              ],
              [
                -69.76157690507006,
                -0.4408505414158368
              ],
              [
                -69.79144588196942,
                -0.4081910123147867
              ],
              [
                -69.80175533102721,
                -0.400956325993435
              ],
              [
                -69.82477718101318,
                -0.3902076244967901
              ],
              [
                -69.83477657102117,
                -0.38317963169847846
              ],
              [
                -69.84229549198568,
                -0.3731543950813073
              ],
              [
                -69.8516747640015,
                -0.3508301804624748
              ],
              [
                -69.85810848097648,
                -0.34142506196580824
              ],
              [
                -69.87523921798606,
                -0.33057301371837444
              ],
              [
                -69.91497839398286,
                -0.3216846665794901
              ],
              [
                -69.93363358598673,
                -0.31434661473037245
              ],
              [
                -69.9443564459837,
                -0.3054582675933582
              ],
              [
                -69.96665482600461,
                -0.27228200475530984
              ],
              [
                -70.0175561119903,
                -0.22566985569856657
              ],
              [
                -70.05636511300627,
                -0.18102142654269274
              ],
              [
                -70.06804398599469,
                -0.16014414172000754
              ],
              [
                -70.0738059080045,
                -0.1249008216726044
              ],
              [
                -70.07248815999976,
                -0.0746713248219377
              ],
              [
                -70.07181636600004,
                -0.04914316823545774
              ],
              [
                -70.06995601499983,
                0.018036193607048993
              ],
              [
                -70.06726883999713,
                0.11301747454999386
              ],
              [
                -70.06427160700912,
                0.22195140020908471
              ],
              [
                -70.06137772597457,
                0.3308853071992101
              ],
              [
                -70.05869055206246,
                0.4258666130562922
              ],
              [
                -70.05683020095469,
                0.4930459505440831
              ],
              [
                -70.05610673092745,
                0.5185741025679811
              ],
              [
                -70.05424637904785,
                0.5881306034514733
              ],
              [
                -70.03941524290349,
                0.5745913516049777
              ],
              [
                -70.0206566980468,
                0.5798623743885147
              ],
              [
                -69.99923681691885,
                0.5897842267322777
              ],
              [
                -69.97649918592518,
                0.5904043448509121
              ],
              [
                -69.95285721798714,
                0.585753477737966
              ],
              [
                -69.93389196798336,
                0.5889574150918755
              ],
              [
                -69.91446163002945,
                0.5945384781599282
              ],
              [
                -69.84591284192469,
                0.5986725739160079
              ],
              [
                -69.80532100492411,
                0.606940802982745
              ],
              [
                -69.76754553300208,
                0.6206867483619114
              ],
              [
                -69.73287064582608,
                0.6389801765501459
              ],
              [
                -69.69468176311027,
                0.6687458462935246
              ],
              [
                -69.67948889210162,
                0.6700377559139101
              ],
              [
                -69.65127356007906,
                0.6573770266148378
              ],
              [
                -69.61915665720859,
                0.6506591116130126
              ],
              [
                -69.60458390313536,
                0.6674022632926431
              ],
              [
                -69.5941194260292,
                0.689313053463917
              ],
              [
                -69.57422400013105,
                0.6979430337680034
              ],
              [
                -69.55564632176204,
                0.7001650642400783
              ],
              [
                -69.52342606609604,
                0.7209390400579961
              ],
              [
                -69.50371150818486,
                0.7296206937506444
              ],
              [
                -69.4780799969136,
                0.7328245935636527
              ],
              [
                -69.45787451178012,
                0.7280703421182166
              ],
              [
                -69.43971024613268,
                0.7157714015693168
              ],
              [
                -69.36893937216564,
                0.6444062570370257
              ],
              [
                -69.36255733203784,
                0.6409439152227636
              ],
              [
                -69.34232600889155,
                0.6502456494621792
              ],
              [
                -69.3202601729868,
                0.6563434838975686
              ],
              [
                -69.30214758391533,
                0.6565501774196799
              ],
              [
                -69.29281998719546,
                0.6455948198955159
              ],
              [
                -69.29705745502416,
                0.6181029291245627
              ],
              [
                -69.27899654206824,
                0.619239818601768
              ],
              [
                -69.2423837889782,
                0.613762102291247
              ],
              [
                -69.2261832280642,
                0.6147956450073838
              ],
              [
                -69.21905187995797,
                0.6195498588846552
              ],
              [
                -69.20835485801962,
                0.6346393872678455
              ],
              [
                -69.2006033940998,
                0.6394969854618568
              ],
              [
                -69.19013891703013,
                0.6397036789838919
              ],
              [
                -69.17140620922495,
                0.6327790704631995
              ],
              [
                -69.16233699580427,
                0.6314354123569668
              ],
              [
                -69.14365596588982,
                0.6375332467893156
              ],
              [
                -69.13745479393033,
                0.650142302701149
              ],
              [
                -69.14120133484819,
                0.6681773640008469
              ],
              [
                -69.15207922404366,
                0.6905532897044553
              ],
              [
                -69.15949479187536,
                0.6973228780942572
              ],
              [
                -69.18119889387245,
                0.7075031349250515
              ],
              [
                -69.1892604168642,
                0.7151512458952654
              ],
              [
                -69.19225764994285,
                0.7289488646957025
              ],
              [
                -69.18502295001217,
                0.7376821917710479
              ],
              [
                -69.17455847196138,
                0.7454336495094546
              ],
              [
                -69.16776302178927,
                0.7560272934002217
              ],
              [
                -69.16776302176092,
                0.7789716263498697
              ],
              [
                -69.17760738128362,
                0.8235684577801221
              ],
              [
                -69.17538529504989,
                0.8444457053339962
              ],
              [
                -69.16931331414511,
                0.8480630673122267
              ],
              [
                -69.15975317401455,
                0.8496133438439725
              ],
              [
                -69.15233760621977,
                0.8542642485464185
              ],
              [
                -69.152389282833,
                0.8678034253979537
              ],
              [
                -69.15892635208857,
                0.8761750388469121
              ],
              [
                -69.17073441578405,
                0.8831513208007704
              ],
              [
                -69.1938854567623,
                0.8920913414444088
              ],
              [
                -69.20998266630211,
                0.9075426587292934
              ],
              [
                -69.20432409705275,
                0.9436644550212357
              ],
              [
                -69.2261832282846,
                0.9572037070242783
              ],
              [
                -69.22912878526328,
                0.9674356373262144
              ],
              [
                -69.23016231413986,
                0.9791144974093746
              ],
              [
                -69.23284948795755,
                0.9883645583725019
              ],
              [
                -69.24023921713604,
                0.9956509557496738
              ],
              [
                -69.25718908724976,
                1.006916428796957
              ],
              [
                -69.2742681477198,
                1.0282070635453033
              ],
              [
                -69.2888150636916,
                1.038438993876895
              ],
              [
                -69.33878617428093,
                1.0641222415945764
              ],
              [
                -69.35496089804467,
                1.0670677745405739
              ],
              [
                -69.3708514001974,
                1.062985352099967
              ],
              [
                -69.41816117320678,
                1.0286205257015055
              ],
              [
                -69.42841894588084,
                1.0304808425312142
              ],
              [
                -69.44728084401162,
                1.0416946422136115
              ],
              [
                -69.45237097232148,
                1.0462422001882197
              ],
              [
                -69.4554198819287,
                1.0507380096758228
              ],
              [
                -69.45976070130163,
                1.0551822208896677
              ],
              [
                -69.46872656306331,
                1.0594196634726916
              ],
              [
                -69.47826086507584,
                1.0606598997296415
              ],
              [
                -69.51009354676268,
                1.056112341752222
              ],
              [
                -69.5429597570678,
                1.0555956079396918
              ],
              [
                -69.5532950440802,
                1.0568358441964636
              ],
              [
                -69.5967549241867,
                1.0719253728078906
              ],
              [
                -69.6199059657008,
                1.0727521469085368
              ],
              [
                -69.71602412879606,
                1.0585928142658674
              ],
              [
                -69.72651444586585,
                1.0610216133984953
              ],
              [
                -69.72806473766103,
                1.082984077259797
              ],
              [
                -69.73682389325671,
                1.0883584844504526
              ],
              [
                -69.74966548671244,
                1.0905288415729593
              ],
              [
                -69.76255875714024,
                1.0910973238742754
              ],
              [
                -69.78767350268309,
                1.0842243135180445
              ],
              [
                -69.82935054583514,
                1.0572492312465005
              ],
              [
                -69.85219152906377,
                1.0594196634726916
              ],
              [
                -69.85193314603166,
                1.1192609690652362
              ],
              [
                -69.85154557401306,
                1.1879906221958885
              ],
              [
                -69.85110632406675,
                1.256616928792564
              ],
              [
                -69.850770425144,
                1.3253465072885235
              ],
              [
                -69.85035701410615,
                1.394050324456117
              ],
              [
                -69.84999527903786,
                1.4628058152752028
              ],
              [
                -69.8496077060393,
                1.5314837963032804
              ],
              [
                -69.84924597100151,
                1.6001876143181866
              ],
              [
                -69.84880672199837,
                1.668891432642039
              ],
              [
                -69.85617061471402,
                1.707674710062277
              ],
              [
                -69.84118458899174,
                1.7075791743887725
              ],
              [
                -69.80754309201205,
                1.707364669763347
              ],
              [
                -69.78919795870547,
                1.7127906754223856
              ],
              [
                -69.74635819387937,
                1.7351664520615
              ],
              [
                -69.72914994302837,
                1.738990582849655
              ],
              [
                -69.71145076545208,
                1.7385255224002296
              ],
              [
                -69.6900825619145,
                1.7354766425743635
              ],
              [
                -69.64905147308396,
                1.7389389094663983
              ],
              [
                -69.58029597941714,
                1.7702289456317193
              ],
              [
                -69.54195206647313,
                1.7727094182478296
              ],
              [
                -69.46919165051715,
                1.7573873587994333
              ],
              [
                -69.39338232592056,
                1.7252705485312905
              ],
              [
                -69.35240291490274,
                1.7202062565499223
              ],
              [
                -69.30452470090212,
                1.7202062565499223
              ],
              [
                -69.17838252880625,
                1.720309603316334
              ],
              [
                -68.9999954846556,
                1.7204646234659389
              ],
              [
                -68.79548600348124,
                1.7206713169987495
              ],
              [
                -68.59102819929282,
                1.720878010531573
              ],
              [
                -68.41264115514474,
                1.7210330306811907
              ],
              [
                -68.28644730706634,
                1.7211363774476025
              ],
              [
                -68.23859493002725,
                1.7211880508308084
              ],
              [
                -68.16330236793422,
                1.7212913975972073
              ],
              [
                -68.18040726725125,
                1.729688773010681
              ],
              [
                -68.18877885057476,
                1.7358383562571735
              ],
              [
                -68.19172440524692,
                1.7424270130509074
              ],
              [
                -68.19074255437725,
                1.7550102329527244
              ],
              [
                -68.193533082664,
                1.763743635591548
              ],
              [
                -68.20154292881149,
                1.7686787441301872
              ],
              [
                -68.23895666437303,
                1.7702806190151033
              ],
              [
                -68.24112707515141,
                1.788341518013934
              ],
              [
                -68.23895666507063,
                1.8102523845363314
              ],
              [
                -68.24831009988036,
                1.8221121771301854
              ],
              [
                -68.27368322829446,
                1.8252644037425008
              ],
              [
                -68.28024613382911,
                1.8293984246441244
              ],
              [
                -68.26081579745619,
                1.8582081385988145
              ],
              [
                -68.2008194591179,
                2.0078372846316794
              ],
              [
                -68.1921894931461,
                2.014891002022162
              ],
              [
                -68.18743526369332,
                2.008250671706372
              ],
              [
                -68.18728023336965,
                1.988200196893406
              ],
              [
                -68.18516150016697,
                1.9807587789233234
              ],
              [
                -68.17709997609214,
                1.9731881774972428
              ],
              [
                -68.16976192299735,
                1.9697259105436962
              ],
              [
                -68.14914302710021,
                1.9655400659995659
              ],
              [
                -68.12614701327276,
                1.9562124193092805
              ],
              [
                -68.11110917230907,
                1.942414874690434
              ],
              [
                -68.10123897375858,
                1.9241214452523687
              ],
              [
                -68.07922481419214,
                1.8599651838588847
              ],
              [
                -68.05865759208905,
                1.8164018176054413
              ],
              [
                -68.03178584872954,
                1.7775153433311324
              ],
              [
                -67.99824784231566,
                1.749971777652317
              ],
              [
                -67.96486486800903,
                1.7401532339732946
              ],
              [
                -67.92884639526439,
                1.7412901986187244
              ],
              [
                -67.89318965655916,
                1.749713410735766
              ],
              [
                -67.86053015237691,
                1.7615215298938207
              ],
              [
                -67.82084265277412,
                1.7840008035910895
              ],
              [
                -67.79045691026374,
                1.8125778370090961
              ],
              [
                -67.66974076294417,
                1.9733431976498248
              ],
              [
                -67.59294958598134,
                2.054811094923708
              ],
              [
                -67.5543989664668,
                2.0731303612495213
              ],
              [
                -67.52732051491179,
                2.0965914298089925
              ],
              [
                -67.5102672948779,
                2.1074177549795863
              ],
              [
                -67.47533402393198,
                2.1118618162838514
              ],
              [
                -67.46608394354519,
                2.11635770118794
              ],
              [
                -67.44913407359317,
                2.1341343970690265
              ],
              [
                -67.4397289622519,
                2.1395604029102215
              ],
              [
                -67.42463944676588,
                2.1381135481327616
              ],
              [
                -67.38174800684405,
                2.1227398148535155
              ],
              [
                -67.36577998998091,
                2.114962519798215
              ],
              [
                -67.340613566341,
                2.09010611960174
              ],
              [
                -67.32040808114878,
                2.053079886328531
              ],
              [
                -67.28862707691782,
                1.974893549388954
              ],
              [
                -67.26475256400781,
                1.9325446574851064
              ],
              [
                -67.155715291394,
                1.7880831510966706
              ],
              [
                -67.11716467506507,
                1.709793468985196
              ],
              [
                -67.08295487458147,
                1.604631825664648
              ],
              [
                -67.07360144044196,
                1.5411989930796233
              ],
              [
                -67.09819942169517,
                1.2533612804230112
              ],
              [
                -67.09447871869108,
                1.2012197589478129
              ],
              [
                -67.08610713734105,
                1.17600172171599
              ],
              [
                -67.06522985903088,
                1.1726943999779256
              ],
              [
                -66.97820674705487,
                1.1968272961922968
              ],
              [
                -66.91340450091282,
                1.2148623578680509
              ],
              [
                -66.87506058790294,
                1.2225104689914148
              ],
              [
                -66.856767130843,
                1.206077357245421
              ],
              [
                -66.80855301987526,
                1.1627725098735233
              ],
              [
                -66.74039180595247,
                1.1015876211406488
              ],
              [
                -66.66220536306875,
                1.0314110384994248
              ],
              [
                -66.58407059822571,
                0.9611311093038686
              ],
              [
                -66.51590938427485,
                0.8999462210914092
              ],
              [
                -66.46769527228668,
                0.8566413742787673
              ],
              [
                -66.44945349123242,
                0.840208262786391
              ],
              [
                -66.40707881721346,
                0.8020710545651858
              ],
              [
                -66.3462039799757,
                0.7593862884645219
              ],
              [
                -66.28507076080172,
                0.7458470365547459
              ],
              [
                -66.22827836114355,
                0.7627969569098653
              ],
              [
                -66.20874467001498,
                0.7631069971939864
              ],
              [
                -66.18903011122707,
                0.7549421524059755
              ],
              [
                -66.17306209389804,
                0.7430565237857315
              ],
              [
                -66.15634476684193,
                0.7330312870862093
              ],
              [
                -66.13438228408488,
                0.731119296895813
              ],
              [
                -66.11112788888329,
                0.7418162875433103
              ],
              [
                -66.07919185381817,
                0.7775763699638739
              ],
              [
                -66.05746191414184,
                0.7869815261085373
              ],
              [
                -66.01384700607863,
                0.7896686921199056
              ],
              [
                -65.9941841230914,
                0.7947329838589157
              ],
              [
                -65.97408199074772,
                0.8069802510572802
              ],
              [
                -65.95266211002556,
                0.8279609204677268
              ],
              [
                -65.91424068220459,
                0.8746247623137031
              ],
              [
                -65.89176143390983,
                0.8956053566669269
              ],
              [
                -65.87196936120549,
                0.908989588502477
              ],
              [
                -65.78541133685601,
                0.9491421338361595
              ],
              [
                -65.74543961606342,
                0.9741535523987369
              ],
              [
                -65.72097082601036,
                0.9819050102015945
              ],
              [
                -65.7010495610407,
                0.9843854827075684
              ],
              [
                -65.62872839395642,
                0.9820083569637824
              ],
              [
                -65.60810949724483,
                0.9852640052929295
              ],
              [
                -65.59604305079152,
                0.983610306884421
              ],
              [
                -65.58294307522014,
                0.9776675676322852
              ],
              [
                -65.57085079031347,
                0.9685725268163073
              ],
              [
                -65.55984370988814,
                0.9579788077399501
              ],
              [
                -65.53581416901409,
                0.928471579726982
              ],
              [
                -65.52511714692336,
                0.9083177594435021
              ],
              [
                -65.51850256400672,
                0.8865103158794087
              ],
              [
                -65.51700394680165,
                0.86279080702729
              ],
              [
                -65.53317867110017,
                0.8163337338301749
              ],
              [
                -65.56328019319902,
                0.7779381587355343
              ],
              [
                -65.58733557194397,
                0.7391291215359367
              ],
              [
                -65.58521683816522,
                0.691483485661534
              ],
              [
                -65.57431311102059,
                0.6702444494360978
              ],
              [
                -65.56048966609772,
                0.6560334436143761
              ],
              [
                -65.54266129578124,
                0.6493154535061438
              ],
              [
                -65.51969112112346,
                0.6508658051350985
              ],
              [
                -65.49783199105084,
                0.6587206096153504
              ],
              [
                -65.4728722751168,
                0.672518228393689
              ],
              [
                -65.45121984918916,
                0.6901399026598255
              ],
              [
                -65.43274552509038,
                0.7209390400579961
              ],
              [
                -65.41388362596703,
                0.7416095940206645
              ],
              [
                -65.40943945410537,
                0.7552521926900458
              ],
              [
                -65.41083471683935,
                0.7838808979449361
              ],
              [
                -65.40962032110258,
                0.7921491646085775
              ],
              [
                -65.40000850400965,
                0.8165404273533041
              ],
              [
                -65.38902726199134,
                0.8356607048478251
              ],
              [
                -65.32719641119307,
                0.910281498132875
              ],
              [
                -65.31027237984237,
                0.9186530364881612
              ],
              [
                -65.28438248710424,
                0.91937653892837
              ],
              [
                -65.24337723905039,
                0.9131236842986445
              ],
              [
                -65.2231459150685,
                0.9143639205482665
              ],
              [
                -65.2030437828056,
                0.9238206750119919
              ],
              [
                -65.17898840290357,
                0.9553949884745107
              ],
              [
                -65.16844641171183,
                0.9964777298476609
              ],
              [
                -65.16017818281688,
                1.0801935644556564
              ],
              [
                -65.1367687590209,
                1.1269090801535886
              ],
              [
                -65.10051774185084,
                1.1361074677944114
              ],
              [
                -65.05961584479499,
                1.1323867590111572
              ],
              [
                -65.02248632881066,
                1.1399831967226903
              ],
              [
                -65.0207034916925,
                1.1440139457960197
              ],
              [
                -65.01969580186108,
                1.1577082180601264
              ],
              [
                -65.0174478757539,
                1.162979203399553
              ],
              [
                -65.01321040935393,
                1.1657697913209655
              ],
              [
                -65.00334020972092,
                1.1693870782403826
              ],
              [
                -64.99936112470314,
                1.1719708975298797
              ],
              [
                -64.96646907608606,
                1.200599678368604
              ],
              [
                -64.95605627417248,
                1.2068008596946755
              ],
              [
                -64.9329310712701,
                1.21300204102263
              ],
              [
                -64.91466345298026,
                1.2147590111047815
              ],
              [
                -64.89740352409152,
                1.2196682827873004
              ],
              [
                -64.87771480410179,
                1.234912831658952
              ],
              [
                -64.85531307035671,
                1.258684014275765
              ],
              [
                -64.83929337592366,
                1.2708279349505975
              ],
              [
                -64.8214391680977,
                1.2705695680416926
              ],
              [
                -64.7713130298728,
                1.2467467120286972
              ],
              [
                -64.75121089761367,
                1.2433360435156462
              ],
              [
                -64.73087622114043,
                1.2475735612428749
              ],
              [
                -64.60421728632424,
                1.3312893968515491
              ],
              [
                -64.59116898566279,
                1.350099559383568
              ],
              [
                -64.5702658689339,
                1.3954973293691038
              ],
              [
                -64.55119726514305,
                1.4195268039974533
              ],
              [
                -64.52791703328616,
                1.4357274608194985
              ],
              [
                -64.47505204379398,
                1.4630126590178634
              ],
              [
                -64.43309078044389,
                1.4940443277001385
              ],
              [
                -64.40900956291088,
                1.507505994896361
              ],
              [
                -64.38642696176628,
                1.510244834381174
              ],
              [
                -64.36459366908053,
                1.4970932074773549
              ],
              [
                -64.36381852263942,
                1.477352773689172
              ],
              [
                -64.38503169779342,
                1.436399214788809
              ],
              [
                -64.39136206141043,
                1.4177182356203992
              ],
              [
                -64.39477270645139,
                1.392190082699585
              ],
              [
                -64.38957922444251,
                1.369297422513876
              ],
              [
                -64.37009720969623,
                1.3587296150331374
              ],
              [
                -64.35294063334092,
                1.3658350054897752
              ],
              [
                -64.34074499670167,
                1.3842060945233556
              ],
              [
                -64.32188309727115,
                1.4244360757342454
              ],
              [
                -64.30152258374694,
                1.4466569820229187
              ],
              [
                -64.23214697304786,
                1.4971448808597974
              ],
              [
                -64.17708573362965,
                1.5511467200836941
              ],
              [
                -64.12972428445207,
                1.5780702047972446
              ],
              [
                -64.1095446374334,
                1.5984565559951214
              ],
              [
                -64.09295650245929,
                1.6226152143816346
              ],
              [
                -64.08086421799474,
                1.6473941036154998
              ],
              [
                -64.07541235381977,
                1.6654291657668865
              ],
              [
                -64.07254431280971,
                1.6845753558898287
              ],
              [
                -64.07595495495174,
                1.7453725461117229
              ],
              [
                -64.06029699827195,
                1.8074618716122584
              ],
              [
                -64.05360490056684,
                1.8937098562520045
              ],
              [
                -64.0366291911681,
                1.9272736718893142
              ],
              [
                -63.99502966298375,
                1.958021137966907
              ],
              [
                -63.95833939702892,
                1.9707077048430806
              ],
              [
                -63.92082230503906,
                1.9743249919494634
              ],
              [
                -63.80227657190975,
                1.9723097299660515
              ],
              [
                -63.783207968772174,
                1.9749968961573376
              ],
              [
                -63.762640748328856,
                1.9856680508519793
              ],
              [
                -63.61753332448449,
                2.1011648247842962
              ],
              [
                -63.561981160750065,
                2.1263571020060037
              ],
              [
                -63.548958700270504,
                2.1283725142287935
              ],
              [
                -63.5205366610836,
                2.124496709938124
              ],
              [
                -63.51066646296339,
                2.124600056707818
              ],
              [
                -63.44343542513115,
                2.1371832769911743
              ],
              [
                -63.41175777166274,
                2.1493789469011673
              ],
              [
                -63.40219763090197,
                2.170514563074983
              ],
              [
                -63.4039029527497,
                2.188497952581358
              ],
              [
                -63.4005956634496,
                2.2046211002489136
              ],
              [
                -63.386545943074886,
                2.2358889060259237
              ],
              [
                -63.372638712357436,
                2.2668394613394627
              ],
              [
                -63.370519980359525,
                2.2811538904139312
              ],
              [
                -63.37279374327083,
                2.3491084484213958
              ],
              [
                -63.371243449478015,
                2.3651280993447807
              ],
              [
                -63.36111487035755,
                2.4000097379314465
              ],
              [
                -63.36488724899048,
                2.4130838557055077
              ],
              [
                -63.38483435217176,
                2.4205769473514325
              ],
              [
                -63.51066646350028,
                2.42465929508067
              ],
              [
                -63.57381506402894,
                2.434374492560793
              ],
              [
                -63.70409134928438,
                2.4375783927275556
              ],
              [
                -63.767033243986404,
                2.4293102002742955
              ],
              [
                -63.8313187267144,
                2.4286384462522896
              ],
              [
                -63.95182816703607,
                2.4615046727714778
              ],
              [
                -64.01079097527982,
                2.468170840056069
              ],
              [
                -64.03249507635515,
                2.4630032009794576
              ],
              [
                -64.04797216760942,
                2.471323066847182
              ],
              [
                -64.05662797029383,
                2.4885313560697155
              ],
              [
                -64.05781652946081,
                2.510442223940859
              ],
              [
                -64.05053015389116,
                2.534678544483221
              ],
              [
                -64.01218623764319,
                2.60376976851722
              ],
              [
                -64.00769038927385,
                2.6227867767473554
              ],
              [
                -64.00443477349175,
                2.679527460918973
              ],
              [
                -63.997871865337245,
                2.7059857375740135
              ],
              [
                -63.99756180884685,
                2.714925834523446
              ],
              [
                -64.00086909954263,
                2.7253644597314293
              ],
              [
                -64.01223791766205,
                2.744019754498251
              ],
              [
                -64.02908443105038,
                2.7979697760348987
              ],
              [
                -64.10595312885575,
                2.9472115356815096
              ],
              [
                -64.13750158524839,
                2.987260515437356
              ],
              [
                -64.17346838342739,
                3.0519078315125214
              ],
              [
                -64.20530106436269,
                3.089166448717078
              ],
              [
                -64.22292272853007,
                3.123996416748432
              ],
              [
                -64.22537735747089,
                3.1655958995355746
              ],
              [
                -64.21630814575514,
                3.2514305091648534
              ],
              [
                -64.21987381787095,
                3.2928749724731063
              ],
              [
                -64.24560868314336,
                3.4189397228702916
              ],
              [
                -64.24214636529716,
                3.442969352523113
              ],
              [
                -64.23212113318371,
                3.4611334513260554
              ],
              [
                -64.20506852091604,
                3.49707439905148
              ],
              [
                -64.19785966145074,
                3.5150837782415616
              ],
              [
                -64.19563757077947,
                3.532912000175144
              ],
              [
                -64.19574092925963,
                3.570067573446355
              ],
              [
                -64.20297562401178,
                3.59471698391804
              ],
              [
                -64.22209591004692,
                3.6162146178774606
              ],
              [
                -64.26555578973526,
                3.6522072398078826
              ],
              [
                -64.32415686221209,
                3.7241149741590838
              ],
              [
                -64.34735957516688,
                3.7382999218815742
              ],
              [
                -64.39448848524685,
                3.7560767714386407
              ],
              [
                -64.43453771721194,
                3.778478389909637
              ],
              [
                -64.5314310307739,
                3.853512666523829
              ],
              [
                -64.57496842581602,
                3.9142066752650666
              ],
              [
                -64.59610408488308,
                3.935884866743077
              ],
              [
                -64.64289709183244,
                3.972962631790702
              ],
              [
                -64.66279252127345,
                3.9969922634625648
              ],
              [
                -64.66289587427359,
                3.9969922634625648
              ],
              [
                -64.70744095992082,
                4.0829560671643685
              ],
              [
                -64.71953324599032,
                4.123237884214798
              ],
              [
                -64.72710384037872,
                4.1407819041559035
              ],
              [
                -64.74190913561024,
                4.157189109385586
              ],
              [
                -64.76294144948386,
                4.168997382197904
              ],
              [
                -64.78366369455973,
                4.177084569486385
              ],
              [
                -64.80125952605698,
                4.18853112854849
              ],
              [
                -64.81304175044075,
                4.210571034806195
              ],
              [
                -64.81554805646425,
                4.231034902478061
              ],
              [
                -64.81291255732081,
                4.252790605201954
              ],
              [
                -64.8050577406291,
                4.271885127940534
              ],
              [
                -64.791621864769,
                4.284416528152472
              ],
              [
                -64.74593990198399,
                4.287620579347428
              ],
              [
                -64.69987035942869,
                4.264159353887976
              ],
              [
                -64.66098384588018,
                4.227469137521951
              ],
              [
                -64.64802418625945,
                4.207904447086818
              ],
              [
                -64.63690262873142,
                4.191114798479801
              ],
              [
                -64.62106379976711,
                4.146879665572716
              ],
              [
                -64.60822220563041,
                4.126493308292283
              ],
              [
                -64.58967037074284,
                4.11887118165523
              ],
              [
                -64.36498123898295,
                4.151866448932439
              ],
              [
                -64.24059606634731,
                4.142022065712692
              ],
              [
                -64.17269323870173,
                4.12339290440893
              ],
              [
                -64.14669998964241,
                4.110551163729117
              ],
              [
                -64.12509924325177,
                4.088485421146674
              ],
              [
                -64.10814937274763,
                4.058099660792515
              ],
              [
                -64.09577286437649,
                4.0243806660452055
              ],
              [
                -64.07902970802583,
                3.953093309490158
              ],
              [
                -64.06381099188025,
                3.9115968683274818
              ],
              [
                -64.03766272239821,
                3.8825032441760423
              ],
              [
                -63.99642492406862,
                3.880797721681403
              ],
              [
                -63.95694412908197,
                3.9018816689877136
              ],
              [
                -63.916843223080065,
                3.9293737183676107
              ],
              [
                -63.8751403421102,
                3.9498117483809154
              ],
              [
                -63.83111202170515,
                3.9494500346049914
              ],
              [
                -63.79059770033837,
                3.9330428299392213
              ],
              [
                -63.77101233197534,
                3.928805311007364
              ],
              [
                -63.74589758367443,
                3.930278002804539
              ],
              [
                -63.69075883221412,
                3.9439981908437423
              ],
              [
                -63.671586872679306,
                3.9462459835924593
              ],
              [
                -63.62280432196229,
                3.935213112589307
              ],
              [
                -63.5542296935924,
                3.875371714678033
              ],
              [
                -63.51066646217389,
                3.854546134439261
              ],
              [
                -63.46886023227125,
                3.8672328543950734
              ],
              [
                -63.45537267912518,
                3.900589834083761
              ],
              [
                -63.448241334421475,
                3.939373121430828
              ],
              [
                -63.425400346072955,
                3.9683633990544864
              ],
              [
                -63.3914489330667,
                3.9715674500784686
              ],
              [
                -63.35170976117517,
                3.958726010147632
              ],
              [
                -63.28597733445006,
                3.9208211704173004
              ],
              [
                -63.25119909310313,
                3.8865596057636935
              ],
              [
                -63.19321814092427,
                3.8067455396855605
              ],
              [
                -63.130844684821064,
                3.762122859081281
              ],
              [
                -63.024959678349305,
                3.6377636248725986
              ],
              [
                -63.01069697833202,
                3.6149741559974067
              ],
              [
                -62.99705440107424,
                3.599135359510125
              ],
              [
                -62.97514359515262,
                3.5830640327883736
              ],
              [
                -62.951062381043,
                3.5701709202334277
              ],
              [
                -62.931011920524135,
                3.5637628185835033
              ],
              [
                -62.90770585355997,
                3.560972455335252
              ],
              [
                -62.889412396801305,
                3.560817435154834
              ],
              [
                -62.87199743946388,
                3.565468340995779
              ],
              [
                -62.85127518821923,
                3.5772246388826208
              ],
              [
                -62.831586463857114,
                3.5948720040992344
              ],
              [
                -62.82233638454145,
                3.5988253191475588
              ],
              [
                -62.80776363364203,
                3.5966808733067883
              ],
              [
                -62.79644649374354,
                3.597300954031743
              ],
              [
                -62.78631791082063,
                3.6044063461028175
              ],
              [
                -62.7710216880164,
                3.623345846665347
              ],
              [
                -62.749575967159636,
                3.6603719365185547
              ],
              [
                -62.73991247535105,
                3.7004470572811896
              ],
              [
                -62.74042923944025,
                3.741943196645752
              ],
              [
                -62.74957596632983,
                3.783568519761837
              ],
              [
                -62.76683589800648,
                3.822041766019034
              ],
              [
                -62.77019486566244,
                3.847828292565245
              ],
              [
                -62.77427730073763,
                3.8548561748139263
              ],
              [
                -62.779806685518636,
                3.86129011344503
              ],
              [
                -62.78512935633271,
                3.8722971476200003
              ],
              [
                -62.78879838097308,
                3.8994013459723385
              ],
              [
                -62.78280391469744,
                3.9200460694725523
              ],
              [
                -62.773192099547295,
                3.93994152879208
              ],
              [
                -62.76626745779423,
                3.9646945878886832
              ],
              [
                -62.76740433680886,
                3.9870962070997056
              ],
              [
                -62.770659955163886,
                4.005389791327403
              ],
              [
                -62.76621578220957,
                4.020711854845853
              ],
              [
                -62.74435664639431,
                4.034018355482226
              ],
              [
                -62.72745845438193,
                4.038514241473289
              ],
              [
                -62.67066605531429,
                4.043656044934565
              ],
              [
                -62.588655561558774,
                4.030711258057717
              ],
              [
                -62.560956990491,
                4.037790813910971
              ],
              [
                -62.54881303149874,
                4.0774525498860115
              ],
              [
                -62.54860632424536,
                4.098071437288477
              ],
              [
                -62.546435914459025,
                4.1139102350222805
              ],
              [
                -62.53697912445826,
                4.125408166932922
              ],
              [
                -62.51491329249017,
                4.1331081041023126
              ],
              [
                -62.48370072596866,
                4.13918002881211
              ],
              [
                -62.4751741146367,
                4.143882608475113
              ],
              [
                -62.469851438478535,
                4.151608081940992
              ],
              [
                -62.4665441518033,
                4.168739015205706
              ],
              [
                -62.46297847644503,
                4.174707593155262
              ],
              [
                -62.42809688008065,
                4.183182330940869
              ],
              [
                -62.38417191940933,
                4.1734674315915905
              ],
              [
                -62.19265905644106,
                4.094738202703144
              ],
              [
                -62.15359167238469,
                4.09029399006782
              ],
              [
                -62.111113646631324,
                4.10484095283378
              ],
              [
                -62.03504594060674,
                4.159876426526519
              ],
              [
                -61.990190794352095,
                4.166413411849641
              ],
              [
                -61.96859004727224,
                4.160083120119976
              ],
              [
                -61.950348263525996,
                4.152228162720487
              ],
              [
                -61.931486367637724,
                4.1464146049884985
              ],
              [
                -61.908231972041335,
                4.146156237997281
              ],
              [
                -61.88812984177952,
                4.150161226789092
              ],
              [
                -61.866890826024104,
                4.157034089190575
              ],
              [
                -61.84704707795309,
                4.166051698060715
              ],
              [
                -61.831027382908,
                4.176929549290853
              ],
              [
                -61.779195921758955,
                4.232688451246077
              ],
              [
                -61.75635494142827,
                4.2463569665799525
              ],
              [
                -61.73780310150583,
                4.252067177613364
              ],
              [
                -61.71888952240038,
                4.2546508475730205
              ],
              [
                -61.68054561383176,
                4.252480564806844
              ],
              [
                -61.64915217897788,
                4.24341128240358
              ],
              [
                -61.640522218374706,
                4.24191275382976
              ],
              [
                -61.628223223908066,
                4.24346295580265
              ],
              [
                -61.610188152212814,
                4.251627953720349
              ],
              [
                -61.59907771478733,
                4.254392480577006
              ],
              [
                -61.58540930037262,
                4.25341068599225
              ],
              [
                -61.5765726281118,
                4.249715737524368
              ],
              [
                -61.56727087297738,
                4.248527249343813
              ],
              [
                -61.55215552202285,
                4.254961188394993
              ],
              [
                -61.5421044513786,
                4.263022539103705
              ],
              [
                -61.53350032483467,
                4.273590350119643
              ],
              [
                -61.52673070914975,
                4.285501669541501
              ],
              [
                -61.522364056068945,
                4.2977750032121245
              ],
              [
                -61.516421265758595,
                4.3747728755327335
              ],
              [
                -61.50187434738192,
                4.401851239489327
              ],
              [
                -61.45818192959255,
                4.419137193707537
              ],
              [
                -61.438622397286196,
                4.421152456335673
              ],
              [
                -61.38108068652345,
                4.417741711461741
              ],
              [
                -61.36002254690183,
                4.4189305001046915
              ],
              [
                -61.333228308875285,
                4.423865309874707
              ],
              [
                -61.308242754150584,
                4.433322143074705
              ],
              [
                -61.29304988418676,
                4.4480499636154365
              ],
              [
                -61.29584041142643,
                4.469004729461025
              ],
              [
                -61.32294470228201,
                4.508847325330702
              ],
              [
                -61.315580807497774,
                4.520784481957358
              ],
              [
                -61.29726151606378,
                4.523730166280253
              ],
              [
                -61.2380661591527,
                4.515875208373974
              ],
              [
                -61.2201085992601,
                4.5106817310863265
              ],
              [
                -61.18592464023481,
                4.494119504626261
              ],
              [
                -61.168587195217775,
                4.490243699094513
              ],
              [
                -61.15119808162979,
                4.492052568569921
              ],
              [
                -61.095465048192246,
                4.507684673795766
              ],
              [
                -61.011955933575955,
                4.518304158677654
              ],
              [
                -60.97728104543769,
                4.534969732015323
              ],
              [
                -60.947799645310006,
                4.573598003419718
              ],
              [
                -60.94040991437211,
                4.594061872429224
              ],
              [
                -60.93105647650058,
                4.637392423914338
              ],
              [
                -60.903435422373846,
                4.699584969674798
              ],
              [
                -60.895813151553696,
                4.708525069326735
              ],
              [
                -60.88795833774816,
                4.7111348766310766
              ],
              [
                -60.868683028644675,
                4.711186550034613
              ],
              [
                -60.860027223586044,
                4.712426711719476
              ],
              [
                -60.763676512798334,
                4.7550855099336395
              ],
              [
                -60.71814957845534,
                4.7842827858198165
              ],
              [
                -60.68006404356275,
                4.817949811369194
              ],
              [
                -60.612626307265195,
                4.900580693264274
              ],
              [
                -60.591929891183064,
                4.949724805934504
              ],
              [
                -60.59867366351162,
                4.9968794929445215
              ],
              [
                -60.66430273498505,
                5.170254007501448
              ],
              [
                -60.684869955110806,
                5.188314924710392
              ],
              [
                -60.71101822912093,
                5.1981592860427455
              ],
              [
                -60.739853678843346,
                5.202138361775068
              ],
              [
                -60.695179402962374,
                5.211931049747599
              ],
              [
                -60.67295853673329,
                5.213016247101312
              ],
              [
                -60.61355647819723,
                5.208933824597858
              ],
              [
                -60.601774251865415,
                5.206582535501585
              ],
              [
                -60.58970780380781,
                5.2012081845692295
              ],
              [
                -60.57939835679259,
                5.194851983054775
              ],
              [
                -60.56828792388441,
                5.189710181127901
              ],
              [
                -60.553844361000664,
                5.188056539024332
              ],
              [
                -60.4974136971246,
                5.195937199182133
              ],
              [
                -60.477492431910065,
                5.191932267986223
              ],
              [
                -60.470025186855054,
                5.186867976134647
              ],
              [
                -60.463126384170394,
                5.18002085873143
              ],
              [
                -60.45635677100598,
                5.174698181204455
              ],
              [
                -60.4489670412375,
                5.174233101991958
              ],
              [
                -60.43912268098366,
                5.181390278456121
              ],
              [
                -60.42741796900122,
                5.200768942045696
              ],
              [
                -60.419795695830864,
                5.207228490330365
              ],
              [
                -60.39894425519248,
                5.208313706459923
              ],
              [
                -60.3549934489481,
                5.193172504258822
              ],
              [
                -60.33308264202086,
                5.1937667857042555
              ],
              [
                -60.31406571485884,
                5.206918431261481
              ],
              [
                -60.27373225977504,
                5.247355237471131
              ],
              [
                -60.25520625900876,
                5.256450297297158
              ],
              [
                -60.21342586308814,
                5.267224835950803
              ],
              [
                -60.200300049021024,
                5.2634524537078065
              ],
              [
                -60.190946614947535,
                5.239939675242578
              ],
              [
                -60.17655472806143,
                5.22714976206789
              ],
              [
                -60.13172542401188,
                5.24340199840136
              ],
              [
                -60.123017945163475,
                5.231852321500085
              ],
              [
                -60.09123693884503,
                5.158239232750313
              ],
              [
                -60.08870391501687,
                5.155393807574168
              ],
              [
                -60.07573400899534,
                5.140824279844081
              ],
              [
                -60.055115112993064,
                5.125088805766917
              ],
              [
                -60.01100927786901,
                5.10002573252964
              ],
              [
                -59.98310400503004,
                5.085943910030613
              ],
              [
                -59.981502035018,
                5.057418518620506
              ],
              [
                -59.99927872553628,
                4.9968794929445215
              ],
              [
                -60.00020890498726,
                4.958329028888742
              ],
              [
                -60.00359370761343,
                4.939828747848522
              ],
              [
                -60.01100928118587,
                4.921716317846751
              ],
              [
                -60.017959759015284,
                4.892234837436948
              ],
              [
                -60.02046606333322,
                4.83229008244765
              ],
              [
                -60.034522059100084,
                4.787796877737696
              ],
              [
                -60.03007788062696,
                4.744362677767698
              ],
              [
                -60.03245499403522,
                4.725423173580189
              ],
              [
                -60.03847530240101,
                4.708008335291719
              ],
              [
                -60.047053590810876,
                4.691756148636643
              ],
              [
                -60.07563065857167,
                4.650285839209223
              ],
              [
                -60.080669106024324,
                4.638322545164855
              ],
              [
                -60.08320125264281,
                4.627082979212121
              ],
              [
                -60.08428645746471,
                4.616928554737801
              ],
              [
                -60.0876971001033,
                4.607523394619302
              ],
              [
                -60.09707637835067,
                4.598557758864775
              ],
              [
                -60.106145589235155,
                4.595353707488833
              ],
              [
                -60.126221884822556,
                4.594991993672109
              ],
              [
                -60.13482601217165,
                4.593545138405467
              ],
              [
                -60.16154272430122,
                4.565200474718547
              ],
              [
                -60.16485001385054,
                4.546209297773828
              ],
              [
                -60.15999243380811,
                4.527786828742029
              ],
              [
                -60.148778646839396,
                4.5130073345845
              ],
              [
                -60.13286230245035,
                4.5048681729854065
              ],
              [
                -60.120925050479634,
                4.5023620130122355
              ],
              [
                -60.112010865818824,
                4.5021553194062465
              ],
              [
                -60.10619726888733,
                4.506599532363366
              ],
              [
                -60.10384598905017,
                4.517994118267774
              ],
              [
                -60.098600827400105,
                4.526003795955559
              ],
              [
                -60.087774615153016,
                4.525538735340058
              ],
              [
                -60.07687088887427,
                4.519957707530668
              ],
              [
                -60.07154821958885,
                4.512542273970156
              ],
              [
                -60.06625138192826,
                4.494326198231932
              ],
              [
                -60.05560604134897,
                4.491587507957333
              ],
              [
                -60.040180627583744,
                4.495928374102954
              ],
              [
                -60.02069860785128,
                4.498873757985577
              ],
              [
                -59.9969791296452,
                4.490760733535108
              ],
              [
                -59.98455094360443,
                4.488796843856013
              ],
              [
                -59.97889237119505,
                4.495411339661876
              ],
              [
                -59.974551554328905,
                4.503705521451311
              ],
              [
                -59.96468136004985,
                4.506496185560289
              ],
              [
                -59.95313167806534,
                4.50587610474189
              ],
              [
                -59.94331315099065,
                4.503912215057363
              ],
              [
                -59.93429561384078,
                4.498253677168056
              ],
              [
                -59.91992956255146,
                4.479210827057198
              ],
              [
                -59.914555214114124,
                4.474353226912591
              ],
              [
                -59.905279300796145,
                4.475283648561562
              ],
              [
                -59.88582311688041,
                4.48474018142341
              ],
              [
                -59.872929846951834,
                4.484688508022062
              ],
              [
                -59.86884741498497,
                4.480916349726373
              ],
              [
                -59.871689614735374,
                4.468229628443379
              ],
              [
                -59.867633016528444,
                4.46197684647826
              ],
              [
                -59.86324052262469,
                4.460659174749992
              ],
              [
                -59.852362632456156,
                4.460762521552204
              ],
              [
                -59.84763424026914,
                4.4602457875411945
              ],
              [
                -59.82624018993548,
                4.45461278597092
              ],
              [
                -59.81768774555924,
                4.456835042643052
              ],
              [
                -59.80962622366311,
                4.4657493051876305
              ],
              [
                -59.79626786099294,
                4.448204983818373
              ],
              [
                -59.73795101001263,
                4.415571428632793
              ],
              [
                -59.72991532152673,
                4.407535613979585
              ],
              [
                -59.72234472386045,
                4.397717067020024
              ],
              [
                -59.713508058940874,
                4.389371512416748
              ],
              [
                -59.701958374736385,
                4.385650727159945
              ],
              [
                -59.690460369605084,
                4.384462238950854
              ],
              [
                -59.68673966373145,
                4.381180677600335
              ],
              [
                -59.687115055821465,
                4.371465477487794
              ],
              [
                -59.687385621863065,
                4.364463431328948
              ],
              [
                -59.69361262900795,
                4.340692165151432
              ],
              [
                -59.727796587331255,
                4.305293783284794
              ],
              [
                -59.738467776520245,
                4.286587111357495
              ],
              [
                -59.73668493753652,
                4.282091225176668
              ],
              [
                -59.726556359341885,
                4.2706966397553865
              ],
              [
                -59.72448929678975,
                4.264056007089402
              ],
              [
                -59.72660803267244,
                4.257699878553615
              ],
              [
                -59.73552221919612,
                4.245840232588662
              ],
              [
                -59.7379510123095,
                4.240000838063745
              ],
              [
                -59.740534830002254,
                4.222327333900897
              ],
              [
                -59.74043147460103,
                4.21364560203622
              ],
              [
                -59.73846777161704,
                4.2027677507376495
              ],
              [
                -59.726737221692105,
                4.1764644887042826
              ],
              [
                -59.71032995841955,
                4.164449822710039
              ],
              [
                -59.66736100217129,
                4.150574613975295
              ],
              [
                -59.64617366698725,
                4.134038225268673
              ],
              [
                -59.64899003030009,
                4.119801302819352
              ],
              [
                -59.66010046520966,
                4.103187404101819
              ],
              [
                -59.663252724987984,
                4.079726179382787
              ],
              [
                -59.65369258529292,
                4.064197422124713
              ],
              [
                -59.619818684430065,
                4.032726520550577
              ],
              [
                -59.6057368574648,
                4.007146686826628
              ],
              [
                -59.59971655212583,
                4.002263250381251
              ],
              [
                -59.59537573326978,
                3.9963721826991
              ],
              [
                -59.59628007150074,
                3.970637328937158
              ],
              [
                -59.59000138275394,
                3.966709850359763
              ],
              [
                -59.58038956515601,
                3.967123237533409
              ],
              [
                -59.548686075264,
                3.9619297607398796
              ],
              [
                -59.53682633198969,
                3.957692241788277
              ],
              [
                -59.52959163559029,
                3.9494500346049914
              ],
              [
                -59.52765377011368,
                3.9395281416202534
              ],
              [
                -59.52922989730222,
                3.931905714791318
              ],
              [
                -59.53470759784844,
                3.9270997885001044
              ],
              [
                -59.54457779889878,
                3.9257046067981887
              ],
              [
                -59.56315548041915,
                3.9181858272055283
              ],
              [
                -59.58178483128251,
                3.8991946523877865
              ],
              [
                -59.59633174399935,
                3.8758884486375305
              ],
              [
                -59.602507076652444,
                3.8556829491464475
              ],
              [
                -59.59971655271085,
                3.8331263102194186
              ],
              [
                -59.59540157249191,
                3.8165382489726416
              ],
              [
                -59.59860550978135,
                3.802404674047646
              ],
              [
                -59.61829423060673,
                3.7871859578537688
              ],
              [
                -59.65911860850114,
                3.7689182109582315
              ],
              [
                -59.67180517599074,
                3.7562317916236005
              ],
              [
                -59.68015091938635,
                3.7311170195756134
              ],
              [
                -59.68077103885027,
                3.7191540278400423
              ],
              [
                -59.679556640836324,
                3.7103431131975118
              ],
              [
                -59.68012507964161,
                3.7016872187504117
              ],
              [
                -59.686222900408666,
                3.6902151243156665
              ],
              [
                -59.69505957329115,
                3.6830580587593538
              ],
              [
                -59.717642173750654,
                3.6732136762781313
              ],
              [
                -59.75554683579862,
                3.6381253386310295
              ],
              [
                -59.83766068323189,
                3.6092897822457752
              ],
              [
                -59.86287878507202,
                3.5817205245538215
              ],
              [
                -59.86303381326217,
                3.5523682344736156
              ],
              [
                -59.84763423828096,
                3.5304575139954957
              ],
              [
                -59.82954748763075,
                3.5097611183242874
              ],
              [
                -59.82135677241235,
                3.4843879802283966
              ],
              [
                -59.838539187080166,
                3.4430210259157206
              ],
              [
                -59.841355549298136,
                3.4253991973533577
              ],
              [
                -59.82404394271296,
                3.4316778149684546
              ],
              [
                -59.828488118811876,
                3.38341216267733
              ],
              [
                -59.82709285696879,
                3.3766943212713776
              ],
              [
                -59.82099503515224,
                3.3634908683155524
              ],
              [
                -59.821770184528525,
                3.3565921700560835
              ],
              [
                -59.82680863592784,
                3.351941264352564
              ],
              [
                -59.83368160309176,
                3.3502877158104183
              ],
              [
                -59.83998612190941,
                3.3498740282482293
              ],
              [
                -59.84319006203218,
                3.3490214172813744
              ],
              [
                -59.853732057974504,
                3.315380236653597
              ],
              [
                -59.879621946901224,
                3.272566127921369
              ],
              [
                -59.88401444266844,
                3.26254088914455
              ],
              [
                -59.89763118922399,
                3.2173759418498515
              ],
              [
                -59.90424576986703,
                3.208229150792475
              ],
              [
                -59.91150630393224,
                3.2018727228546386
              ],
              [
                -59.916673950242604,
                3.194173087186387
              ],
              [
                -59.9168548153267,
                3.1811504914214463
              ],
              [
                -59.91393509810917,
                3.1746393437606
              ],
              [
                -59.905434325099456,
                3.165234185800934
              ],
              [
                -59.90321223995173,
                3.158671364762887
              ],
              [
                -59.905718545410146,
                3.1547955600408066
              ],
              [
                -59.91837927390669,
                3.1528319711985224
              ],
              [
                -59.921557370896736,
                3.1500929810715967
              ],
              [
                -59.92018794715415,
                3.143995220561064
              ],
              [
                -59.91269486465036,
                3.133401574658138
              ],
              [
                -59.91160966199696,
                3.126425366523745
              ],
              [
                -59.91486527228936,
                3.1199655918724725
              ],
              [
                -59.92075639031393,
                3.1167618416707206
              ],
              [
                -59.92737096995321,
                3.1143328918983846
              ],
              [
                -59.93266780393765,
                3.1100437000759134
              ],
              [
                -59.95938452137402,
                3.0664806287626716
              ],
              [
                -59.969228880204184,
                3.0427093672590444
              ],
              [
                -59.973983111691176,
                3.017646271083149
              ],
              [
                -59.97041743901924,
                2.9604405241944978
              ],
              [
                -59.97297542290352,
                2.939304906276046
              ],
              [
                -59.99372351134304,
                2.857294431181399
              ],
              [
                -60.00007971238423,
                2.6940485841437254
              ],
              [
                -59.99646236112409,
                2.6747732088285967
              ],
              [
                -59.965043090325935,
                2.613433292789348
              ],
              [
                -59.96532731161126,
                2.608058960085769
              ],
              [
                -59.970262412926644,
                2.5957600930718403
              ],
              [
                -59.97098588084532,
                2.592556042639594
              ],
              [
                -59.966024942525344,
                2.5886802381753675
              ],
              [
                -59.95313167215817,
                2.5839259861314785
              ],
              [
                -59.94902339958837,
                2.579843788549052
              ],
              [
                -59.94072932774807,
                2.5629970626599414
              ],
              [
                -59.93923071538389,
                2.555452447731784
              ],
              [
                -59.93951493132882,
                2.5429982601986385
              ],
              [
                -59.935845909420294,
                2.5238782057812763
              ],
              [
                -59.90677791516985,
                2.458765833075196
              ],
              [
                -59.905072591232006,
                2.4478619974706515
              ],
              [
                -59.90403906355828,
                2.4262096468827483
              ],
              [
                -59.901816977957075,
                2.415616001844361
              ],
              [
                -59.901506916300036,
                2.404505472741852
              ],
              [
                -59.911816366721546,
                2.3878140677378115
              ],
              [
                -59.91344417360233,
                2.378718950934845
              ],
              [
                -59.90313472590082,
                2.359598746619061
              ],
              [
                -59.88406612119656,
                2.3460077448408
              ],
              [
                -59.84424943038421,
                2.3254405355696766
              ],
              [
                -59.813631145141926,
                2.299188953487832
              ],
              [
                -59.80120296199237,
                2.292729329642114
              ],
              [
                -59.79184952881322,
                2.290869087759606
              ],
              [
                -59.77226415981115,
                2.290352203690065
              ],
              [
                -59.763246625148234,
                2.2879752279518737
              ],
              [
                -59.74169755089065,
                2.2637905813817434
              ],
              [
                -59.74022477302156,
                2.2294775006968175
              ],
              [
                -59.745754150022215,
                2.1908234051260798
              ],
              [
                -59.74497900457173,
                2.1535131181251432
              ],
              [
                -59.735858113846106,
                2.123721609165482
              ],
              [
                -59.73539302585675,
                2.1135155148105236
              ],
              [
                -59.738571126592845,
                2.103619460773057
              ],
              [
                -59.74983658843572,
                2.085971948400486
              ],
              [
                -59.75296301273546,
                2.0754558137708465
              ],
              [
                -59.751464397151665,
                2.062252512939374
              ],
              [
                -59.74040564056855,
                2.0414011005772617
              ],
              [
                -59.73709834801044,
                2.0304197553138548
              ],
              [
                -59.73779598050816,
                2.0222290732442416
              ],
              [
                -59.74353206463014,
                2.00566685227646
              ],
              [
                -59.74534073816365,
                1.9971659797044534
              ],
              [
                -59.742808593805506,
                1.9709660717639825
              ],
              [
                -59.7438162850946,
                1.9618452688195127
              ],
              [
                -59.74836380924274,
                1.9512514740081819
              ],
              [
                -59.760869508532586,
                1.9319245768768525
              ],
              [
                -59.76453853339116,
                1.9205298446390935
              ],
              [
                -59.7651328129114,
                1.9046393777973596
              ],
              [
                -59.76355668119417,
                1.8825734909672964
              ],
              [
                -59.75875077227186,
                1.862135465975757
              ],
              [
                -59.74968155979434,
                1.8513092912334916
              ],
              [
                -59.73751176021415,
                1.850792557396522
              ],
              [
                -59.71722876053652,
                1.858053118447632
              ],
              [
                -59.7055757239666,
                1.857407050937792
              ],
              [
                -59.66798112058441,
                1.8427052222107594
              ],
              [
                -59.65547542495028,
                1.8397080157452756
              ],
              [
                -59.64911922159904,
                1.8413615640222523
              ],
              [
                -59.64645788674184,
                1.8399663826635568
              ],
              [
                -59.64547603437078,
                1.827693202985036
              ],
              [
                -59.666482504240086,
                1.7871013568110898
              ],
              [
                -59.68247635812427,
                1.7656038773927225
              ],
              [
                -59.68084855058521,
                1.7573873587994333
              ],
              [
                -59.658963582895076,
                1.7340813110131463
              ],
              [
                -59.649816853461715,
                1.7270016068692915
              ],
              [
                -59.63966243458301,
                1.721756458046073
              ],
              [
                -59.62816442889556,
                1.7188109249902062
              ],
              [
                -59.60793310592517,
                1.7199995630171114
              ],
              [
                -59.5905698241203,
                1.7249086846354373
              ],
              [
                -59.57271561634676,
                1.7271566270189727
              ],
              [
                -59.551476604531715,
                1.7205162968491448
              ],
              [
                -59.53072851623902,
                1.7030754785354103
              ],
              [
                -59.502823241936824,
                1.6576518709865515
              ],
              [
                -59.4860025648324,
                1.6360770319019777
              ],
              [
                -59.454764160311306,
                1.6113239793781946
              ],
              [
                -59.445514079398265,
                1.601014538656035
              ],
              [
                -59.425877034993825,
                1.5659520454905986
              ],
              [
                -59.416833659322194,
                1.5552808911203226
              ],
              [
                -59.41210526595224,
                1.5532654789845017
              ],
              [
                -59.399728760815805,
                1.5520253178015553
              ],
              [
                -59.39463863184598,
                1.5494414984574036
              ],
              [
                -59.39096960455112,
                1.5436536289659322
              ],
              [
                -59.383864095906425,
                1.5278923460028668
              ],
              [
                -59.38016922953246,
                1.5233447879131736
              ],
              [
                -59.36802526881249,
                1.520399254896046
              ],
              [
                -59.34769059242815,
                1.5260319540181393
              ],
              [
                -59.33856970239278,
                1.5246367726897228
              ],
              [
                -59.3269425052775,
                1.509521407026406
              ],
              [
                -59.32472041819411,
                1.490762767489263
              ],
              [
                -59.32032792251087,
                1.4735287931800505
              ],
              [
                -59.30218949475966,
                1.4629609856355352
              ],
              [
                -59.29381791152336,
                1.4521088242816866
              ],
              [
                -59.272423868280455,
                1.4041530715184982
              ],
              [
                -59.259918172204465,
                1.3874358311182373
              ],
              [
                -59.24214147986707,
                1.3777981445041623
              ],
              [
                -59.17795935106252,
                1.3571275899770852
              ],
              [
                -59.01109615047685,
                1.3275686129250188
              ],
              [
                -58.97202466079584,
                1.3123112958476248
              ],
              [
                -58.96649939075774,
                1.310153781940299
              ],
              [
                -58.94598384582331,
                1.2989915803889929
              ],
              [
                -58.92748368354248,
                1.284212091903372
              ],
              [
                -58.91172237117387,
                1.2602342908349653
              ],
              [
                -58.90645137620817,
                1.2385301936973458
              ],
              [
                -58.89787308770537,
                1.217807890834773
              ],
              [
                -58.87213822482548,
                1.197240683245018
              ],
              [
                -58.85203609231066,
                1.1887141246444939
              ],
              [
                -58.83400101780607,
                1.185820189956886
              ],
              [
                -58.815965941711774,
                1.1872671197473084
              ],
              [
                -58.79596716300685,
                1.1918146777521446
              ],
              [
                -58.771937622695695,
                1.2012714323293903
              ],
              [
                -58.75281734187412,
                1.2149657046313203
              ],
              [
                -58.73690100111771,
                1.2323290123614654
              ],
              [
                -58.70920243456705,
                1.2722749398538644
              ],
              [
                -58.69773026489534,
                1.2810598653994116
              ],
              [
                -58.68258907157157,
                1.2824551969216353
              ],
              [
                -58.58052811729625,
                1.272740000289944
              ],
              [
                -58.57417191624473,
                1.2753754929745804
              ],
              [
                -58.56140783748341,
                1.2851423629894523
              ],
              [
                -58.55696366346604,
                1.2868992579714178
              ],
              [
                -58.55231278430901,
                1.284625478957925
              ],
              [
                -58.54673173026358,
                1.2804397848177091
              ],
              [
                -58.5427526446786,
                1.276357287228699
              ],
              [
                -58.54306270333909,
                1.2743935485072027
              ],
              [
                -58.53505285551432,
                1.2715513622955694
              ],
              [
                -58.52714636130026,
                1.2668487841271723
              ],
              [
                -58.51892981051978,
                1.2672623213946794
              ],
              [
                -58.48761389202969,
                1.316458234958499
              ],
              [
                -58.481102662276804,
                1.3338732161624576
              ],
              [
                -58.481722777490745,
                1.3580577108535066
              ],
              [
                -58.48807898077455,
                1.378883435741234
              ],
              [
                -58.50699255407597,
                1.4181832960601939
              ],
              [
                -58.51365881386174,
                1.4388796873505827
              ],
              [
                -58.50175434658587,
                1.453781149180559
              ],
              [
                -58.49887935341144,
                1.4573798097041002
              ],
              [
                -58.42643023253741,
                1.4698053053834286
              ],
              [
                -58.41345821182052,
                1.4720301148780695
              ],
              [
                -58.386379760587126,
                1.4901943602826113
              ],
              [
                -58.385914673013495,
                1.4997287001955018
              ],
              [
                -58.39170243350349,
                1.520838478647463
              ],
              [
                -58.390255492676914,
                1.5307603689475329
              ],
              [
                -58.383124145478504,
                1.5372199924077292
              ],
              [
                -58.3602831634989,
                1.5473744129397382
              ],
              [
                -58.35139481592255,
                1.5533171523671352
              ],
              [
                -58.34426346930572,
                1.5654869850466058
              ],
              [
                -58.338734090706495,
                1.5801889637016908
              ],
              [
                -58.331912801370116,
                1.5933922640573395
              ],
              [
                -58.32049231025354,
                1.6012212321871666
              ],
              [
                -58.31615149009256,
                1.5988957797487138
              ],
              [
                -58.30633296867574,
                1.5827727830509062
              ],
              [
                -58.29920162065036,
                1.5751763451525982
              ],
              [
                -58.281993367555046,
                1.5665721260826062
              ],
              [
                -58.260547649366345,
                1.5603193463543328
              ],
              [
                -58.23858516434862,
                1.5567019091427403
              ],
              [
                -58.21967158978856,
                1.5560559918597978
              ],
              [
                -58.20695918861489,
                1.5599576326757847
              ],
              [
                -58.19776078301291,
                1.5659003721079399
              ],
              [
                -58.187270467597074,
                1.5676057439493345
              ],
              [
                -58.17063065562732,
                1.558820668044273
              ],
              [
                -58.16287919126171,
                1.549182981331041
              ],
              [
                -58.15554113825374,
                1.527375612177449
              ],
              [
                -58.148616496690614,
                1.5190815836418847
              ],
              [
                -58.1164220785771,
                1.5105548746760964
              ],
              [
                -58.069138143624095,
                1.5090046732015863
              ],
              [
                -58.02722855747646,
                1.5168594779806321
              ],
              [
                -58.011157185455296,
                1.5361863745429984
              ],
              [
                -57.99358719899351,
                1.5684841914548016
              ],
              [
                -57.98697261561988,
                1.5868292938084803
              ],
              [
                -57.98392370699791,
                1.6041150918366984
              ],
              [
                -57.98976314303965,
                1.634604190275945
              ],
              [
                -57.991003376654305,
                1.6504171467312967
              ],
              [
                -57.98500891089394,
                1.6577035443695156
              ],
              [
                -57.96914424667753,
                1.6554814386882637
              ],
              [
                -57.939016886269144,
                1.6433116059368997
              ],
              [
                -57.92222204686385,
                1.6424848318100587
              ],
              [
                -57.90537552915521,
                1.6485567547317606
              ],
              [
                -57.87147579075811,
                1.6692532965364926
              ],
              [
                -57.790757203733776,
                1.7049358705419053
              ],
              [
                -57.75882116708047,
                1.7134624294036802
              ],
              [
                -57.723112752532366,
                1.7116537107792331
              ],
              [
                -57.63857010869185,
                1.6961766312478708
              ],
              [
                -57.60787430987555,
                1.697106902357322
              ],
              [
                -57.561158813645164,
                1.7089665446412532
              ],
              [
                -57.53128983587366,
                1.7315491650206492
              ],
              [
                -57.46478226675787,
                1.8157300636191596
              ],
              [
                -57.45429195154014,
                1.8338167993703227
              ],
              [
                -57.42948726430363,
                1.9002985131230892
              ],
              [
                -57.419513713357205,
                1.909186936008779
              ],
              [
                -57.40556107635443,
                1.9142770647532428
              ],
              [
                -57.38452876775536,
                1.9252065863161545
              ],
              [
                -57.3687674574372,
                1.939650198430096
              ],
              [
                -57.35615840715957,
                1.955282298395163
              ],
              [
                -57.34148229946184,
                1.9688473127994237
              ],
              [
                -57.31941646402882,
                1.9771414918150323
              ],
              [
                -57.29481848283251,
                1.9748418760047557
              ],
              [
                -57.25864497956568,
                1.9522334185194004
              ],
              [
                -57.23843949341638,
                1.9485384711299556
              ],
              [
                -57.15291499824651,
                2.0022044351004555
              ],
              [
                -57.10449418219326,
                2.0214539724783043
              ],
              [
                -57.07405676220101,
                1.9971659797044534
              ],
              [
                -57.06780391458839,
                1.9686922926469181
              ],
              [
                -57.05597001180095,
                1.9480734106731894
              ],
              [
                -57.03746984912859,
                1.932389637333046
              ],
              [
                -57.01116654601425,
                1.9185662560482637
              ],
              [
                -56.99323482290387,
                1.914845471976675
              ],
              [
                -56.976853394110044,
                1.9145871050569307
              ],
              [
                -56.94352209420013,
                1.9182560655311638
              ],
              [
                -56.9219213463351,
                1.9181010453792817
              ],
              [
                -56.91344641146509,
                1.912830059789469
              ],
              [
                -56.906831826984444,
                1.903244046218573
              ],
              [
                -56.89070878025393,
                1.8901957657230224
              ],
              [
                -56.87763464484459,
                1.8856483577316179
              ],
              [
                -56.80647619731481,
                1.8735818715456802
              ],
              [
                -56.79273026634966,
                1.873530198161889
              ],
              [
                -56.7806379810087,
                1.8790595506546652
              ],
              [
                -56.73764318834642,
                1.9129850799412875
              ],
              [
                -56.72415564089561,
                1.9161374567888207
              ],
              [
                -56.70410518446707,
                1.912830059789469
              ],
              [
                -56.683951376059895,
                1.91210663241432
              ],
              [
                -56.669662841954185,
                1.9198580906474685
              ],
              [
                -56.65640783695661,
                1.9300641848389843
              ],
              [
                -56.63956132163756,
                1.9368596854783269
              ],
              [
                -56.62023433442018,
                1.934560069675442
              ],
              [
                -56.60442134625503,
                1.924586505708257
              ],
              [
                -56.59010697434814,
                1.9129850799412875
              ],
              [
                -56.574862426255855,
                1.9054661519399128
              ],
              [
                -56.55892024833766,
                1.9066547899832678
              ],
              [
                -56.52850866771446,
                1.9240180984843922
              ],
              [
                -56.48181901190803,
                1.9416139372374928
              ],
              [
                -56.429806681714375,
                1.9227002769794537
              ],
              [
                -56.41518225108801,
                1.919703070495548
              ],
              [
                -56.396527059546735,
                1.9216668092998788
              ],
              [
                -56.367174846898,
                1.928875697006751
              ],
              [
                -56.34795121367791,
                1.9266019178973457
              ],
              [
                -56.32862422603994,
                1.9184627590670278
              ],
              [
                -56.29270910612058,
                1.895466751303535
              ],
              [
                -56.273795531367284,
                1.8875085995497256
              ],
              [
                -56.25793086883531,
                1.8856483577316179
              ],
              [
                -56.20976843355202,
                1.888542217439901
              ],
              [
                -56.14527624473443,
                1.8717731529000126
              ],
              [
                -56.08264440855022,
                1.846555039507556
              ],
              [
                -56.019650837793634,
                1.8335067590685556
              ],
              [
                -55.95381506424818,
                1.853273030027441
              ],
              [
                -55.92203405838332,
                1.8862167649538033
              ],
              [
                -55.91676306208766,
                1.9222352165236292
              ],
              [
                -55.92234411675494,
                1.9621553091243584
              ],
              [
                -55.92358435083512,
                2.0065969731943554
              ],
              [
                -55.9203804127878,
                2.01938688688942
              ],
              [
                -55.91676306266333,
                2.0285078400900227
              ],
              [
                -55.91513525341697,
                2.0376544797764566
              ],
              [
                -55.91826167741866,
                2.050392720119955
              ],
              [
                -55.92580643862435,
                2.061684105709123
              ],
              [
                -55.95996455853908,
                2.0909845671415446
              ],
              [
                -55.99577632604938,
                2.137389970530766
              ],
              [
                -56.00440629007926,
                2.1449864087539994
              ],
              [
                -56.03132971271956,
                2.1634866822832253
              ],
              [
                -56.04484309997365,
                2.1847256452536934
              ],
              [
                -56.05401566497149,
                2.224051344598764
              ],
              [
                -56.072929239298446,
                2.2415180003381545
              ],
              [
                -56.09145524093104,
                2.245910538523387
              ],
              [
                -56.13525101785172,
                2.248546031392725
              ],
              [
                -56.14677486184641,
                2.256194143077266
              ],
              [
                -56.14388098018969,
                2.2747459399646632
              ],
              [
                -56.13199540307039,
                2.3043565924818883
              ],
              [
                -56.116802530416784,
                2.3330886473093173
              ],
              [
                -56.10378007116677,
                2.349056775035505
              ],
              [
                -56.091455241886905,
                2.3518989614740646
              ],
              [
                -56.08228267402852,
                2.347713116788692
              ],
              [
                -56.07342016724873,
                2.3423904576157186
              ],
              [
                -56.062154705026025,
                2.34156368344178
              ],
              [
                -56.050243287666234,
                2.3470413627720044
              ],
              [
                -56.042569337281606,
                2.3551028616149625
              ],
              [
                -56.01334631389991,
                2.398821099836439
              ],
              [
                -56.00817867125888,
                2.4162877558655143
              ],
              [
                -56.007506876227545,
                2.4606777483745472
              ],
              [
                -55.996913208941905,
                2.503259172547301
              ],
              [
                -55.9892392582284,
                2.520829175533494
              ],
              [
                -55.9830122486807,
                2.5264618751219454
              ],
              [
                -55.971023316906646,
                2.5303376795609185
              ],
              [
                -55.947200477985604,
                2.528167096887163
              ],
              [
                -55.925031291293415,
                2.5156615364291612
              ],
              [
                -55.87066768318352,
                2.470909679754946
              ],
              [
                -55.85376949078954,
                2.4626414872740785
              ],
              [
                -55.78312780742813,
                2.445174831164497
              ],
              [
                -55.77356766745083,
                2.4400588654862054
              ],
              [
                -55.76612626254167,
                2.4312739391676814
              ],
              [
                -55.75460241651134,
                2.40941474485727
              ],
              [
                -55.74411210220441,
                2.401043205654722
              ],
              [
                -55.7242941892955,
                2.3969090343355077
              ],
              [
                -55.64538427691187,
                2.4166494695692524
              ],
              [
                -55.608306437415166,
                2.4339611054700963
              ],
              [
                -55.58732580651637,
                2.433857758697425
              ],
              [
                -55.568205526539685,
                2.4312739391676814
              ],
              [
                -55.511309774534766,
                2.436389904841482
              ],
              [
                -55.47430945008345,
                2.4358214975916765
              ],
              [
                -55.43555212594265,
                2.4308605520771116
              ],
              [
                -55.39958532715398,
                2.4301886478416304
              ],
              [
                -55.37105993651558,
                2.4425393382454406
              ],
              [
                -55.36276586840569,
                2.4579389086784817
              ],
              [
                -55.360078693963125,
                2.4762323389953216
              ],
              [
                -55.354523478649945,
                2.494887633265977
              ],
              [
                -55.33775447658609,
                2.5112689981286525
              ],
              [
                -55.320520386189365,
                2.5182970293677585
              ],
              [
                -55.30279536882983,
                2.5196922108108275
              ],
              [
                -55.28698238150191,
                2.5139044910660537
              ],
              [
                -55.27525183080355,
                2.4993316947324504
              ],
              [
                -55.251919922213325,
                2.497884839905628
              ],
              [
                -55.17195064547869,
                2.559328252182461
              ],
              [
                -55.13779252165407,
                2.562170288467721
              ],
              [
                -55.13308996477317,
                2.5528684779566704
              ],
              [
                -55.13660396648608,
                2.5338000969065604
              ],
              [
                -55.128852499454815,
                2.5256867743196736
              ],
              [
                -55.12089432931044,
                2.52480832674384
              ],
              [
                -55.11247106837049,
                2.527805383179379
              ],
              [
                -55.07629756829316,
                2.545220516262648
              ],
              [
                -55.03774694820236,
                2.577931572799557
              ],
              [
                -55.01774817183017,
                2.5905924539270506
              ],
              [
                -54.976872111792964,
                2.6069221455660316
              ],
              [
                -54.95909541672316,
                2.608989081056538
              ],
              [
                -54.95366939145201,
                2.5990671898529363
              ],
              [
                -54.960232301619016,
                2.585683181720771
              ],
              [
                -54.9795592868124,
                2.5660977663081304
              ],
              [
                -54.982814900297996,
                2.552351744087068
              ],
              [
                -54.97857743240678,
                2.543049933585559
              ],
              [
                -54.8802888597997,
                2.4473452636065964
              ],
              [
                -54.84191910885166,
                2.433496044993089
              ],
              [
                -54.792490600012094,
                2.4481720377890848
              ],
              [
                -54.77549435293047,
                2.457335351507597
              ],
              [
                -54.7598052562223,
                2.4657937140634107
              ],
              [
                -54.74303625695188,
                2.4665172916877847
              ],
              [
                -54.721177123370396,
                2.4579905820649444
              ],
              [
                -54.707663737374844,
                2.4503424702318335
              ],
              [
                -54.70319372479555,
                2.4458465851876476
              ],
              [
                -54.702547771933894,
                2.425744586406098
              ],
              [
                -54.70110083025166,
                2.419905043116638
              ],
              [
                -54.69683752381772,
                2.40910470454002
              ],
              [
                -54.69559729027612,
                2.4035236784043903
              ],
              [
                -54.69725093491389,
                2.3973224214246907
              ],
              [
                -54.70203100641871,
                2.3957205464542177
              ],
              [
                -54.707276164263,
                2.395875566612639
              ],
              [
                -54.709963336912416,
                2.394790275290417
              ],
              [
                -54.71569942287218,
                2.375928437874963
              ],
              [
                -54.706733561689795,
                2.3531907961221736
              ],
              [
                -54.70544165108971,
                2.3425454777733257
              ],
              [
                -54.70655269360898,
                2.3328819537660235
              ],
              [
                -54.704123901998976,
                2.3248204549402147
              ],
              [
                -54.69249670567678,
                2.3189810619212645
              ],
              [
                -54.67285966108227,
                2.3159838553343977
              ],
              [
                -54.65337764560293,
                2.31650058919185
              ],
              [
                -54.63412817363665,
                2.320117876408013
              ],
              [
                -54.615292115986634,
                2.326267459955679
              ],
              [
                -54.5881619884232,
                2.3243553944681437
              ],
              [
                -54.56464921079475,
                2.3148468906347714
              ],
              [
                -54.5442886962091,
                2.3002224212011204
              ],
              [
                -54.526408649977725,
                2.282652418595678
              ],
              [
                -54.549146280552506,
                2.2794485184767894
              ],
              [
                -54.545787314145706,
                2.2685965066601157
              ],
              [
                -54.51142248587749,
                2.243430065810881
              ],
              [
                -54.49266394117166,
                2.222707836580973
              ],
              [
                -54.47664424797475,
                2.21412960398519
              ],
              [
                -54.43395951473272,
                2.209323678730799
              ],
              [
                -54.42708654940238,
                2.207153246337896
              ],
              [
                -54.41148026623806,
                2.1997118282282506
              ],
              [
                -54.40254024326017,
                2.197128008755808
              ],
              [
                -54.3878124609755,
                2.196301234593014
              ],
              [
                -54.38052608276536,
                2.1976964159927515
              ],
              [
                -54.37391149980748,
                2.1965079281336997
              ],
              [
                -54.360940714186334,
                2.1881879122705454
              ],
              [
                -54.33505082235214,
                2.1639000693633883
              ],
              [
                -54.32285518443521,
                2.157337098827363
              ],
              [
                -54.314018513382656,
                2.154856626134601
              ],
              [
                -54.263789022703676,
                2.1481904590472176
              ],
              [
                -54.24647741698084,
                2.1516010526678744
              ],
              [
                -54.229785929525875,
                2.157233752057376
              ],
              [
                -54.210045533170266,
                2.1615746168242516
              ],
              [
                -54.19449092705497,
                2.1630732952030494
              ],
              [
                -54.18854813737295,
                2.1613162498991896
              ],
              [
                -54.157387248455144,
                2.121654523558685
              ],
              [
                -54.148137165143034,
                2.1143939623520707
              ],
              [
                -54.134908000118884,
                2.1106733284337817
              ],
              [
                -54.11152669762109,
                2.114270486996543
              ],
              [
                -54.11139522223165,
                2.114290615582466
              ],
              [
                -54.09842443958394,
                2.1279591271499028
              ],
              [
                -54.08421342007512,
                2.1693260752188066
              ],
              [
                -54.076668661848736,
                2.1836921775513582
              ],
              [
                -54.06927893004774,
                2.188342932425952
              ],
              [
                -54.04845332982898,
                2.188808143105506
              ],
              [
                -54.04333736159075,
                2.18772285180434
              ],
              [
                -54.03326045737921,
                2.1803331070927725
              ],
              [
                -54.027989461867236,
                2.178576211999564
              ],
              [
                -54.02137487816122,
                2.1805914740182675
              ],
              [
                -54.01171138433508,
                2.190565038200343
              ],
              [
                -54.00597530246135,
                2.194337495743303
              ],
              [
                -53.96391068672638,
                2.209323678730799
              ],
              [
                -53.94613399379503,
                2.221984409186855
              ],
              [
                -53.93874426353071,
                2.2401228189328575
              ],
              [
                -53.93776241015856,
                2.2646173555496265
              ],
              [
                -53.93290482522907,
                2.2696299743704276
              ],
              [
                -53.921639364220304,
                2.2659610137859056
              ],
              [
                -53.901227173252,
                2.264514008778622
              ],
              [
                -53.888463094030136,
                2.2738158190249234
              ],
              [
                -53.879368042959214,
                2.2906107208315034
              ],
              [
                -53.86681066857287,
                2.3049249997244674
              ],
              [
                -53.84345292231211,
                2.3066303716656678
              ],
              [
                -53.830895548457256,
                2.3101443121070226
              ],
              [
                -53.82107702806432,
                2.323631967067194
              ],
              [
                -53.811826944721005,
                2.3404267187393675
              ],
              [
                -53.80097489312139,
                2.3538108767533146
              ],
              [
                -53.78345658303626,
                2.3640944814117955
              ],
              [
                -53.76480139149415,
                2.3686937131918087
              ],
              [
                -53.748264934828924,
                2.364663038870929
              ],
              [
                -53.73736120711761,
                2.349056775035505
              ],
              [
                -53.738032998864895,
                2.3388246935644004
              ],
              [
                -53.74816158134253,
                2.31934277562158
              ],
              [
                -53.748730021459274,
                2.312676458220686
              ],
              [
                -53.742167115877244,
                2.3085424371499843
              ],
              [
                -53.713176635669264,
                2.30735379906546
              ],
              [
                -53.6459972744342,
                2.27846672415107
              ],
              [
                -53.629460816958236,
                2.275314497418975
              ],
              [
                -53.59530269399119,
                2.2738674924104703
              ],
              [
                -53.57902461879165,
                2.2704052253665576
              ],
              [
                -53.54734696428572,
                2.2517499315024407
              ],
              [
                -53.53179235795656,
                2.247047353002375
              ],
              [
                -53.511535198053416,
                2.2522668155701244
              ],
              [
                -53.473242960432415,
                2.254127057445953
              ],
              [
                -53.46213252763296,
                2.2589846561054956
              ],
              [
                -53.42544226150699,
                2.286011489085649
              ],
              [
                -53.39040564027369,
                2.2990339333308354
              ],
              [
                -53.378520060484746,
                2.307560492608283
              ],
              [
                -53.351079875827274,
                2.341718703599374
              ],
              [
                -53.348806112081895,
                2.3476614434027763
              ],
              [
                -53.34410355759672,
                2.349625182280476
              ],
              [
                -53.33092606655282,
                2.3456977045254583
              ],
              [
                -53.32255448410179,
                2.3385663266351147
              ],
              [
                -53.29743973866409,
                2.3036848384679995
              ],
              [
                -53.234187784951935,
                2.2509748307209825
              ],
              [
                -53.23465287253916,
                2.241259633411235
              ],
              [
                -53.2543415930683,
                2.234179928976003
              ],
              [
                -53.272221639332194,
                2.21996899694731
              ],
              [
                -53.279714722085515,
                2.2049828139453873
              ],
              [
                -53.268500935284706,
                2.195732677142811
              ],
              [
                -53.25284297779083,
                2.1965079281336997
              ],
              [
                -53.13228186189414,
                2.2192972429386373
              ],
              [
                -53.113368286870504,
                2.2193489163239297
              ],
              [
                -53.09223262669344,
                2.211907498206091
              ],
              [
                -53.06122676681183,
                2.1862759970207093
              ],
              [
                -53.019110474136745,
                2.181986805629394
              ],
              [
                -52.98092159204548,
                2.173253552909832
              ],
              [
                -52.9596825763991,
                2.1752171415425052
              ],
              [
                -52.95322302345991,
                2.1790412724653754
              ],
              [
                -52.94438635200758,
                2.190978425281511
              ],
              [
                -52.93906367928913,
                2.195732677142811
              ],
              [
                -52.93410274386063,
                2.196404581363357
              ],
              [
                -52.92314734002155,
                2.193665741736195
              ],
              [
                -52.91715287228934,
                2.195732677142811
              ],
              [
                -52.906714233084955,
                2.2049828139453873
              ],
              [
                -52.90030635694654,
                2.21412960398519
              ],
              [
                -52.892399860961675,
                2.2368670952278595
              ],
              [
                -52.880152547637856,
                2.2603799877265582
              ],
              [
                -52.862737589679035,
                2.2742292061092337
              ],
              [
                -52.81969112212919,
                2.2915408417727066
              ],
              [
                -52.7077082921172,
                2.358926842388287
              ],
              [
                -52.690603394221704,
                2.3729829046577273
              ],
              [
                -52.67721919861247,
                2.3903978872564866
              ],
              [
                -52.65608353783976,
                2.4309122254634348
              ],
              [
                -52.61918656404132,
                2.4634682614578516
              ],
              [
                -52.59040279197164,
                2.5047061775882726
              ],
              [
                -52.56906042617419,
                2.5503881553827945
              ],
              [
                -52.56368607836155,
                2.559328252182461
              ],
              [
                -52.55794999421878,
                2.5656327058248514
              ],
              [
                -52.55345414071584,
                2.573384014309343
              ],
              [
                -52.55190385071667,
                2.5865616293021896
              ],
              [
                -52.55577958141347,
                2.598137068883134
              ],
              [
                -52.57205765800479,
                2.6229934702967435
              ],
              [
                -52.57577836048638,
                2.6337421357241806
              ],
              [
                -52.57159256971336,
                2.6385997345682335
              ],
              [
                -52.55102535243501,
                2.645989629827362
              ],
              [
                -52.54296382902437,
                2.651518982715392
              ],
              [
                -52.539604858296045,
                2.6594253114336843
              ],
              [
                -52.53330033343788,
                2.6898627393106733
              ],
              [
                -52.455268918583734,
                2.8650457399169893
              ],
              [
                -52.44844763050471,
                2.8743475507503318
              ],
              [
                -52.44162634484647,
                2.8813240590953475
              ],
              [
                -52.43346146865675,
                2.886595045186186
              ],
              [
                -52.422351031600925,
                2.8905222227420064
              ],
              [
                -52.409276898092024,
                2.897343710933511
              ],
              [
                -52.410672157865214,
                2.9055600802066155
              ],
              [
                -52.41785518215252,
                2.915481971753183
              ],
              [
                -52.42219600562316,
                2.9274710993031596
              ],
              [
                -52.416563274906565,
                2.942508956834039
              ],
              [
                -52.35320796600063,
                3.058418979071501
              ],
              [
                -52.351554321879995,
                3.0659638948625747
              ],
              [
                -52.3611144601341,
                3.1093202726118103
              ],
              [
                -52.36183793228418,
                3.131954719725645
              ],
              [
                -52.35532670315538,
                3.1515918098247173
              ],
              [
                -52.31935990558251,
                3.177636700849953
              ],
              [
                -52.29910274162792,
                3.225333944496866
              ],
              [
                -52.27946569556184,
                3.242490411631064
              ],
              [
                -52.267011678563705,
                3.2449193614438694
              ],
              [
                -52.25926021635996,
                3.2433174863167857
              ],
              [
                -52.25119869266646,
                3.2430591193608214
              ],
              [
                -52.23807287690525,
                3.2497252872538906
              ],
              [
                -52.22791845770551,
                3.260112239752742
              ],
              [
                -52.09275874773538,
                3.4813906230138447
              ],
              [
                -52.09203527938924,
                3.490201537359324
              ],
              [
                -52.093792279595,
                3.4994000021635077
              ],
              [
                -52.0935855697868,
                3.5068671078849887
              ],
              [
                -52.07418107033366,
                3.516633980035692
              ],
              [
                -52.0659903600347,
                3.5288556388050427
              ],
              [
                -52.05449235026359,
                3.5567090999481645
              ],
              [
                -52.012763629948175,
                3.619108327936142
              ],
              [
                -52.00310014081973,
                3.6423111839780846
              ],
              [
                -51.99537451121003,
                3.685331688113754
              ],
              [
                -51.98842403270235,
                3.704555392575554
              ],
              [
                -51.97284358649311,
                3.7216860241804444
              ],
              [
                -51.963309286134724,
                3.7254584824222485
              ],
              [
                -51.955816204416884,
                3.724425014527477
              ],
              [
                -51.94871069458033,
                3.7250967686590593
              ],
              [
                -51.940080731263464,
                3.7339593567161815
              ],
              [
                -51.9381945380003,
                3.7425116039893456
              ],
              [
                -51.94098506423527,
                3.7635697141423448
              ],
              [
                -51.93865962552253,
                3.773569116944375
              ],
              [
                -51.93093400149076,
                3.781398237163658
              ],
              [
                -51.89972143556776,
                3.796668626739201
              ],
              [
                -51.8354101174552,
                3.8675428947703616
              ],
              [
                -51.81861527255035,
                3.891081328345338
              ],
              [
                -51.80623877294467,
                3.9175140730536797
              ],
              [
                -51.79753129170854,
                3.9499667685705955
              ],
              [
                -51.78319108133761,
                3.9809467724480276
              ],
              [
                -51.75794714288957,
                4.002521617366235
              ],
              [
                -51.68321692537811,
                4.039374062770456
              ],
              [
                -51.6516007145874,
                4.047674853287101
              ],
              [
                -51.631743941557595,
                4.067816362513291
              ],
              [
                -51.595814579612274,
                4.157863567404651
              ],
              [
                -51.596906386853526,
                4.215504342260991
              ],
              [
                -51.58534650994687,
                4.2338177553558936
              ],
              [
                -51.57160397040475,
                4.235419029872183
              ],
              [
                -51.55968177049935,
                4.22370028409314
              ],
              [
                -51.55215410186173,
                4.2071801182236594
              ],
              [
                -51.53921464895143,
                4.149237414581595
              ],
              [
                -51.51187089957738,
                4.08030840638672
              ],
              [
                -51.450998502812624,
                3.9705264714755546
              ],
              [
                -51.43683834293177,
                3.929510712953411
              ],
              [
                -51.4282120404322,
                3.957749623292665
              ],
              [
                -51.43541419470679,
                3.9859074185449965
              ],
              [
                -51.46349036145596,
                4.0319276858801825
              ],
              [
                -51.498158332821376,
                4.1054141670382105
              ],
              [
                -51.546701630307275,
                4.255031788678796
              ],
              [
                -51.56102454278483,
                4.357123104663983
              ],
              [
                -51.56004798255124,
                4.369370902216812
              ],
              [
                -51.54768275603944,
                4.421784854641173
              ],
              [
                -51.53784299597836,
                4.432061252008896
              ],
              [
                -51.516497573827586,
                4.4411221227670445
              ],
              [
                -51.49067429358298,
                4.427744420053773
              ],
              [
                -51.45342484383704,
                4.402280849738096
              ],
              [
                -51.389230183628925,
                4.35890223184804
              ],
              [
                -51.29828784932009,
                4.258537167877277
              ],
              [
                -51.22443496736895,
                4.165042564658016
              ],
              [
                -51.18692982094839,
                4.078849233756206
              ],
              [
                -51.17943274851991,
                4.025214049788312
              ],
              [
                -51.17943901766561,
                3.9249367160941886
              ],
              [
                -51.18023099741519,
                3.8044436701774287
              ],
              [
                -51.197487009014885,
                3.6995208417267196
              ],
              [
                -51.17613684922637,
                3.6483422501810683
              ],
              [
                -51.17345130111835,
                3.671332103785914
              ],
              [
                -51.15562903758128,
                3.7377384243527567
              ],
              [
                -51.14883378641583,
                3.827093741712499
              ],
              [
                -51.1363826170251,
                3.867743279392768
              ],
              [
                -51.11636308747864,
                3.9061954962887055
              ],
              [
                -51.09315225917343,
                3.907228964212789
              ],
              [
                -51.07990475017954,
                3.88226951218714
              ],
              [
                -51.09000313481989,
                3.7249507612762494
              ],
              [
                -51.0844399855609,
                3.5920720271836464
              ],
              [
                -51.07938534988422,
                3.492087616202185
              ],
              [
                -51.096476638458604,
                3.449020847567424
              ],
              [
                -51.09274174023643,
                3.3763284015527413
              ],
              [
                -51.03600381116581,
                3.2292139552283614
              ],
              [
                -51.027815836864896,
                3.1816125476714845
              ],
              [
                -51.0406269051278,
                3.150936879641918
              ],
              [
                -51.03370854446944,
                3.1271043308395505
              ],
              [
                -51.01839603084899,
                3.092004579629447
              ],
              [
                -51.01398321465337,
                3.0723861161338517
              ],
              [
                -51.01921494912653,
                3.0569946561541785
              ],
              [
                -51.01677941331164,
                3.0355718300746415
              ],
              [
                -51.00401852006204,
                3.022652280925055
              ],
              [
                -50.997278640564915,
                3.0054907070191588
              ],
              [
                -50.98887632313732,
                2.9806225878754042
              ],
              [
                -50.98645070083728,
                2.958362172407379
              ],
              [
                -50.97973032242967,
                2.938649976110549
              ],
              [
                -50.964471377576956,
                2.9163273724323324
              ],
              [
                -50.95180834736929,
                2.889752529588712
              ],
              [
                -50.94420122513876,
                2.875178230518083
              ],
              [
                -50.94598988423485,
                2.863222750830368
              ],
              [
                -50.94951097644603,
                2.847861033481601
              ],
              [
                -50.94872624762344,
                2.8367485510898423
              ],
              [
                -50.94454021550105,
                2.822200389230378
              ],
              [
                -50.93432673386879,
                2.814447878826664
              ],
              [
                -50.92292232943225,
                2.808905307064259
              ],
              [
                -50.91734778368384,
                2.8007264912183882
              ],
              [
                -50.902803180672514,
                2.793754489338771
              ],
              [
                -50.8986228616048,
                2.7792042245643995
              ],
              [
                -50.89359908525747,
                2.762941828191727
              ],
              [
                -50.882564507018785,
                2.7483519071471076
              ],
              [
                -50.87498464894432,
                2.728656234798813
              ],
              [
                -50.87341406402115,
                2.703868029953942
              ],
              [
                -50.865833116493945,
                2.6841645466095176
              ],
              [
                -50.85224682298203,
                2.666133238164007
              ],
              [
                -50.84636658101164,
                2.647292580301138
              ],
              [
                -50.84391823710721,
                2.6267623228803667
              ],
              [
                -50.83469411787062,
                2.593356379287537
              ],
              [
                -50.81895911526191,
                2.5523950055273064
              ],
              [
                -50.82192949328116,
                2.5283879104878637
              ],
              [
                -50.83006751181992,
                2.518011774247165
              ],
              [
                -50.83682206904666,
                2.5145938200539044
              ],
              [
                -50.84024003725074,
                2.506537127909778
              ],
              [
                -50.83946692688697,
                2.4974633412922738
              ],
              [
                -50.833485480579895,
                2.490708698334632
              ],
              [
                -50.82363847570618,
                2.4896914536420534
              ],
              [
                -50.817860481310994,
                2.495306728465872
              ],
              [
                -50.812855597604326,
                2.5021019290266864
              ],
              [
                -50.80553137997986,
                2.504380665294689
              ],
              [
                -50.79161536403414,
                2.494574288252709
              ],
              [
                -50.77422941216155,
                2.465337215744895
              ],
              [
                -50.76298971812212,
                2.4435616901864954
              ],
              [
                -50.76106780244708,
                2.418754559205683
              ],
              [
                -50.7518989182067,
                2.397004570014559
              ],
              [
                -50.742421027273004,
                2.3784853692042773
              ],
              [
                -50.74413001228934,
                2.3672549699036995
              ],
              [
                -50.739572720843924,
                2.35146724836031
              ],
              [
                -50.733819231926795,
                2.3132776119697778
              ],
              [
                -50.72052681330977,
                2.292556283885601
              ],
              [
                -50.71764256326255,
                2.2584964627834987
              ],
              [
                -50.712617557123025,
                2.2368034047761216
              ],
              [
                -50.69726773090796,
                2.216079372998806
              ],
              [
                -50.68602985246777,
                2.198476774237001
              ],
              [
                -50.67926998512233,
                2.171698244104762
              ],
              [
                -50.6955460276654,
                2.147284222037326
              ],
              [
                -50.70319576600116,
                2.141302727304553
              ],
              [
                -50.71324622375074,
                2.138495240199774
              ],
              [
                -50.72996985534588,
                2.139634458081052
              ],
              [
                -50.7372940744016,
                2.1344668191642446
              ],
              [
                -50.76585852832431,
                2.14325595121204
              ],
              [
                -50.77822831821955,
                2.1499697359216383
              ],
              [
                -50.78571529883745,
                2.1618106019633685
              ],
              [
                -50.79255123583742,
                2.1618106019633685
              ],
              [
                -50.79255123622634,
                2.1549746938107575
              ],
              [
                -50.791127082538694,
                2.15053949507616
              ],
              [
                -50.78571529799952,
                2.141302727304553
              ],
              [
                -50.78042558548457,
                2.136379335258645
              ],
              [
                -50.773426886871896,
                2.1338565024119314
              ],
              [
                -50.76724199047998,
                2.130682645001688
              ],
              [
                -50.76455644457571,
                2.123968860303425
              ],
              [
                -50.76573645679421,
                2.117621145489261
              ],
              [
                -50.77086341184966,
                2.1081404312997103
              ],
              [
                -50.77806555909432,
                2.0831566502160817
              ],
              [
                -50.779693162390096,
                2.0709495641629068
              ],
              [
                -50.771962042386285,
                2.0609397986727087
              ],
              [
                -50.76789303320292,
                2.0514183767173604
              ],
              [
                -50.76154537734037,
                2.0438500284471557
              ],
              [
                -50.75157630067486,
                2.045111369754093
              ],
              [
                -50.745961066639765,
                2.053045938116605
              ],
              [
                -50.74502519330501,
                2.0640322404405964
              ],
              [
                -50.745472785204136,
                2.0757509829592147
              ],
              [
                -50.74413001259337,
                2.0860049953325506
              ],
              [
                -50.73473059786554,
                2.103827205805375
              ],
              [
                -50.72061113193805,
                2.1193708303333123
              ],
              [
                -50.70205644335966,
                2.130316424907727
              ],
              [
                -50.67926998540231,
                2.1344668191642446
              ],
              [
                -50.659982876481095,
                2.130682645001688
              ],
              [
                -50.61955508254149,
                2.105237859166536
              ],
              [
                -50.60014135245248,
                2.075201652820875
              ],
              [
                -50.59410559862362,
                2.0287133319211357
              ],
              [
                -50.5899145167016,
                2.017157270481438
              ],
              [
                -50.55972246056218,
                1.9631208803839237
              ],
              [
                -50.533436653739,
                1.9303653625568478
              ],
              [
                -50.5222061833742,
                1.9125022943134324
              ],
              [
                -50.515248175724274,
                1.8728701608120615
              ],
              [
                -50.50918535160844,
                1.8571638555650005
              ],
              [
                -50.500721809059705,
                1.8439395250990722
              ],
              [
                -50.49087480373793,
                1.8328310995349741
              ],
              [
                -50.46654212169759,
                1.8154158173447192
              ],
              [
                -50.43260657485504,
                1.8024762913827097
              ],
              [
                -50.3933813146195,
                1.7977969961228342
              ],
              [
                -50.353098110778774,
                1.8048770007295296
              ],
              [
                -50.33055579310782,
                1.8180606233458585
              ],
              [
                -50.30504179053604,
                1.8135513695636833
              ],
              [
                -50.29076087166189,
                1.81195715555325
              ],
              [
                -50.268381313433096,
                1.8117129086879995
              ],
              [
                -50.25788326761261,
                1.807806761404642
              ],
              [
                -50.22241713844162,
                1.8139829324443322
              ],
              [
                -50.20693108641236,
                1.8138705728777806
              ],
              [
                -50.183156481800204,
                1.818862762497788
              ],
              [
                -50.16459838947713,
                1.8156342275182586
              ],
              [
                -50.137875227540604,
                1.7989353126929155
              ],
              [
                -50.091553115664446,
                1.782098351843421
              ],
              [
                -50.004051142656714,
                1.7516008411466242
              ],
              [
                -49.9505970403477,
                1.7213263973015414
              ],
              [
                -49.922960033232265,
                1.690189428620575
              ],
              [
                -49.91015891101388,
                1.6642627593162291
              ],
              [
                -49.90078925922798,
                1.6116505431405488
              ],
              [
                -49.89998937962723,
                1.5776063460594663
              ],
              [
                -49.899083012755376,
                1.557998550534985
              ],
              [
                -49.895128033327566,
                1.5311453656902205
              ],
              [
                -49.88756262941587,
                1.4691430148519877
              ],
              [
                -49.87633880132546,
                1.4334391110950935
              ],
              [
                -49.87355149113521,
                1.3923036439695904
              ],
              [
                -49.873046483554205,
                1.3598503566125277
              ],
              [
                -49.88302553350456,
                1.3077138669927288
              ],
              [
                -49.89524098101945,
                1.2897767443153667
              ],
              [
                -49.91291909054227,
                1.272327214088937
              ],
              [
                -49.940427929220675,
                1.2586688427305424
              ],
              [
                -49.975328327246764,
                1.2450328531662602
              ],
              [
                -50.025020761275236,
                1.2303802949762959
              ],
              [
                -50.067295868253964,
                1.2252134074494256
              ],
              [
                -50.102193094792106,
                1.2147442150928789
              ],
              [
                -50.11804519184098,
                1.2158428001992605
              ],
              [
                -50.13071701390922,
                1.2201020237451783
              ],
              [
                -50.14127256593254,
                1.2254121396701665
              ],
              [
                -50.14974066805649,
                1.2212091710110053
              ],
              [
                -50.14767033506929,
                1.205357309702518
              ],
              [
                -50.13818887695144,
                1.1937117968586703
              ],
              [
                -50.1202391118374,
                1.1852148302833763
              ],
              [
                -50.09801706973457,
                1.1946642244049737
              ],
              [
                -50.06739555791188,
                1.1871896847816228
              ],
              [
                -50.02616519671836,
                1.1976414523789685
              ],
              [
                -49.99869295090957,
                1.199679471578888
              ],
              [
                -49.97545725219719,
                1.197503856979163
              ],
              [
                -49.94476327486489,
                1.218544687163133
              ],
              [
                -49.92152184082389,
                1.2184812220359718
              ],
              [
                -49.90485592373263,
                1.2067731453373818
              ],
              [
                -49.89073645719124,
                1.1860212504836873
              ],
              [
                -49.88756262884937,
                1.1748721175615002
              ],
              [
                -49.89004472592101,
                1.165228572734964
              ],
              [
                -49.90807044189659,
                1.1332868372132963
              ],
              [
                -49.938872850975,
                1.097235415574904
              ],
              [
                -49.978830532988745,
                1.0722110034315124
              ],
              [
                -50.01427161411105,
                1.0708682465845947
              ],
              [
                -50.031564908223324,
                1.1059431314002488
              ],
              [
                -50.04116777311468,
                1.0879580908518451
              ],
              [
                -50.046742317132484,
                1.0529239138730935
              ],
              [
                -50.060902472970795,
                1.018866273723365
              ],
              [
                -50.09642493376951,
                1.0036074547373521
              ],
              [
                -50.106109179226394,
                0.995306741933286
              ],
              [
                -50.141428188802756,
                0.9414736689008928
              ],
              [
                -50.15583248578834,
                0.9273135101609881
              ],
              [
                -50.17039954293017,
                0.9164899647268422
              ],
              [
                -50.24864661394233,
                0.8800723233445789
              ],
              [
                -50.26158606720609,
                0.8698184619320216
              ],
              [
                -50.30280514212368,
                0.825425545009037
              ],
              [
                -50.31248938686436,
                0.8172060976641302
              ],
              [
                -50.34557044193072,
                0.7362734912951043
              ],
              [
                -50.353423632160826,
                0.726711362250207
              ],
              [
                -50.366688605938585,
                0.715562229527148
              ],
              [
                -50.43321692601399,
                0.678656320001331
              ],
              [
                -50.45335852814124,
                0.6640486008100346
              ],
              [
                -50.46589108011446,
                0.6464297806094764
              ],
              [
                -50.4996638659526,
                0.5559756407779208
              ],
              [
                -50.560658332054004,
                0.447984134181333
              ],
              [
                -50.60895748604451,
                0.37392814386478307
              ],
              [
                -50.693959113989095,
                0.28644439768803853
              ],
              [
                -50.79063880099716,
                0.16950104172497274
              ],
              [
                -50.801665818990905,
                0.16901275457031506
              ],
              [
                -50.81920325400193,
                0.17365143559804283
              ],
              [
                -50.853993293001906,
                0.17365143559804283
              ],
              [
                -50.92894446500293,
                0.15542227068159467
              ],
              [
                -50.97984778599658,
                0.12042877415333793
              ],
              [
                -51.0174047520005,
                0.07143789404485346
              ],
              [
                -51.069162564,
                -0.01934173037970295
              ],
              [
                -51.081410285999866,
                -0.03252532277298912
              ],
              [
                -51.09727942600024,
                -0.03789641810006872
              ],
              [
                -51.16014563700013,
                -0.03932057175511532
              ],
              [
                -51.20156816299962,
                -0.0490861951418853
              ],
              [
                -51.20787512900005,
                -0.05315520625554009
              ],
              [
                -51.210275845000844,
                -0.06182219997474178
              ],
              [
                -51.21519934799976,
                -0.06865813564166981
              ],
              [
                -51.23932857999991,
                -0.07256438593547093
              ],
              [
                -51.26545162699978,
                -0.08342864368513483
              ],
              [
                -51.30894934800097,
                -0.07675546883798415
              ],
              [
                -51.32697506399959,
                -0.07952239339123195
              ],
              [
                -51.32697506399732,
                -0.08570728577816004
              ],
              [
                -51.31769771999801,
                -0.09067147905570722
              ],
              [
                -51.29393470000189,
                -0.0957984378476195
              ],
              [
                -51.28221594999787,
                -0.10312265128149276
              ],
              [
                -51.27574622300272,
                -0.1132138033516901
              ],
              [
                -51.27253170500114,
                -0.12184010334707716
              ],
              [
                -51.266346809001995,
                -0.1271298182656548
              ],
              [
                -51.25121008999663,
                -0.127373952454616
              ],
              [
                -51.322499152997445,
                -0.21526457941552624
              ],
              [
                -51.33755449098967,
                -0.26100025255468645
              ],
              [
                -51.35667884001249,
                -0.2904599000093345
              ],
              [
                -51.363840299012814,
                -0.3261044304851822
              ],
              [
                -51.37071692603,
                -0.34295014019492154
              ],
              [
                -51.38841712097227,
                -0.37371183669178465
              ],
              [
                -51.40099036395553,
                -0.38958097210145765
              ],
              [
                -51.430775520024504,
                -0.4143205792807678
              ],
              [
                -51.443023241039036,
                -0.4283993597560172
              ],
              [
                -51.44554602799198,
                -0.44036223548285347
              ],
              [
                -51.444447395052684,
                -0.4553362122142061
              ],
              [
                -51.445179817016204,
                -0.4714494818362237
              ],
              [
                -51.45360266805138,
                -0.4867489708297744
              ],
              [
                -51.48623613200417,
                -0.5171851551508869
              ],
              [
                -51.50609290295511,
                -0.5319149601615117
              ],
              [
                -51.521839973033934,
                -0.5382626368756205
              ],
              [
                -51.53652910101776,
                -0.5355770856757046
              ],
              [
                -51.56248938702963,
                -0.5254859429381834
              ],
              [
                -51.580189582058665,
                -0.5251604306845347
              ],
              [
                -51.580189581947735,
                -0.5319963382249399
              ],
              [
                -51.57079016798087,
                -0.5316708259712275
              ],
              [
                -51.564320441949995,
                -0.5333798028564846
              ],
              [
                -51.552845832033945,
                -0.5382626368756205
              ],
              [
                -51.55284583201296,
                -0.5455868503520114
              ],
              [
                -51.56908118399406,
                -0.550062756501872
              ],
              [
                -51.587635870954564,
                -0.5518531114512824
              ],
              [
                -51.5876358709862,
                -0.5586890565490512
              ],
              [
                -51.57359778602353,
                -0.5597470089275324
              ],
              [
                -51.56110592398624,
                -0.5586890565490512
              ],
              [
                -51.551625128990196,
                -0.554375906525258
              ],
              [
                -51.54670162701295,
                -0.5455868503520114
              ],
              [
                -51.53237870995463,
                -0.5518531114512824
              ],
              [
                -51.57900956898633,
                -0.6042619738243871
              ],
              [
                -51.62857011591694,
                -0.6760393036172971
              ],
              [
                -51.635650193853856,
                -0.6822241866733556
              ],
              [
                -51.64981035088534,
                -0.6905249744944678
              ],
              [
                -51.65648352792582,
                -0.6958960769154439
              ],
              [
                -51.69749915292652,
                -0.7471656090415946
              ],
              [
                -51.70051022016778,
                -0.7596982064150781
              ],
              [
                -51.71373450385486,
                -0.7932267949383052
              ],
              [
                -51.724191861010304,
                -0.8776994786897838
              ],
              [
                -51.710845506811886,
                -0.978610907263734
              ],
              [
                -51.71117102810744,
                -1.0111630343836984
              ],
              [
                -51.71288001197226,
                -1.0204403590760585
              ],
              [
                -51.71548417898199,
                -1.0275204384714107
              ],
              [
                -51.71910559795246,
                -1.0333798093445432
              ],
              [
                -51.724191861213,
                -1.039157839707744
              ],
              [
                -51.73273678280146,
                -1.045586819483832
              ],
              [
                -51.75177975185487,
                -1.0552710720670444
              ],
              [
                -51.784820115893226,
                -1.0835913897035918
              ],
              [
                -51.80064856677645,
                -1.0927059582949854
              ],
              [
                -51.82209225186222,
                -1.1236304491669231
              ],
              [
                -51.83409583193324,
                -1.1346981664437137
              ],
              [
                -51.90831458183234,
                -1.1579728939269665
              ],
              [
                -51.92935136574916,
                -1.1783179359795113
              ],
              [
                -51.93024654886517,
                -1.2234025858915853
              ],
              [
                -51.9160050124747,
                -1.309177395363949
              ],
              [
                -51.921457486606876,
                -1.3257789714355737
              ],
              [
                -51.93455970039568,
                -1.3395322025540446
              ],
              [
                -51.96442623647894,
                -1.3606096849444302
              ],
              [
                -51.99535071509734,
                -1.3964169353151457
              ],
              [
                -52.00845292922522,
                -1.4016252817659016
              ],
              [
                -52.06578528608223,
                -1.4050432356542109
              ],
              [
                -52.08726966122556,
                -1.4016252817659016
              ],
              [
                -52.15135657539582,
                -1.3809547272110265
              ],
              [
                -52.16612708206134,
                -1.3708635465875776
              ],
              [
                -52.17943274669082,
                -1.3568662188005893
              ],
              [
                -52.19538326711575,
                -1.3449846456327594
              ],
              [
                -52.21458899558723,
                -1.3400203958430277
              ],
              [
                -52.238107877122154,
                -1.3463681103075342
              ],
              [
                -52.24917558436282,
                -1.3537736269722616
              ],
              [
                -52.2759903645909,
                -1.384454096714797
              ],
              [
                -52.285471157544315,
                -1.3900692208328662
              ],
              [
                -52.30833899607539,
                -1.39365000595795
              ],
              [
                -52.33324134010539,
                -1.4078101650131878
              ],
              [
                -52.401966926471175,
                -1.4220517396996366
              ],
              [
                -52.421986457542786,
                -1.4303525277860836
              ],
              [
                -52.442209439561125,
                -1.443129222188963
              ],
              [
                -52.457834439347536,
                -1.4582659180829305
              ],
              [
                -52.46401933432,
                -1.4735652950170415
              ],
              [
                -52.47508704294541,
                -1.4840634035873965
              ],
              [
                -52.55809485660093,
                -1.5187314363900555
              ],
              [
                -52.575347460186826,
                -1.5231259271040545
              ],
              [
                -52.618275520660426,
                -1.525648759835454
              ],
              [
                -52.68211829309689,
                -1.544854434258014
              ],
              [
                -52.69741777298151,
                -1.5524227822504542
              ],
              [
                -52.70604407468037,
                -1.5606421547825702
              ],
              [
                -52.71003170426614,
                -1.5678035748940689
              ],
              [
                -52.71108964753259,
                -1.5768368032118203
              ],
              [
                -52.71104895636836,
                -1.5902645222675778
              ],
              [
                -52.70811926983514,
                -1.6000301907566996
              ],
              [
                -52.70055091035564,
                -1.6002742874050266
              ],
              [
                -52.690500454229664,
                -1.5964494055864265
              ],
              [
                -52.680043098728795,
                -1.5940081386774625
              ],
              [
                -52.658273892235755,
                -1.5914853059350453
              ],
              [
                -52.59504147007337,
                -1.573500264908121
              ],
              [
                -52.4230850893556,
                -1.566094597932911
              ],
              [
                -52.34390214798164,
                -1.5524227822504542
              ],
              [
                -52.326771614663805,
                -1.5470517547251164
              ],
              [
                -52.291249152274816,
                -1.523614120398279
              ],
              [
                -52.27912350195781,
                -1.5182430928826607
              ],
              [
                -52.26349850193412,
                -1.5254859285951428
              ],
              [
                -52.25039628725203,
                -1.5422501859033035
              ],
              [
                -52.24144446478184,
                -1.5617001072070167
              ],
              [
                -52.236561653735755,
                -1.5853818382386806
              ],
              [
                -52.233387824685515,
                -1.5934383795472022
              ],
              [
                -52.231068488479885,
                -1.6027157045283187
              ],
              [
                -52.231922980391296,
                -1.6144344466402585
              ],
              [
                -52.23680579286782,
                -1.6255835798431233
              ],
              [
                -52.25230872305082,
                -1.6449520856316644
              ],
              [
                -52.25861568973247,
                -1.6554501943171684
              ],
              [
                -52.26333574174164,
                -1.676853189388784
              ],
              [
                -52.26024329252868,
                -1.695245008218628
              ],
              [
                -52.24876868460167,
                -1.7030576031499802
              ],
              [
                -52.22232011588437,
                -1.691176029725747
              ],
              [
                -52.20889238169925,
                -1.691827054267458
              ],
              [
                -52.20396887917875,
                -1.6901994929132373
              ],
              [
                -52.20034746052339,
                -1.684747049717911
              ],
              [
                -52.198963995930185,
                -1.6739234287409859
              ],
              [
                -52.19713294148874,
                -1.6696916190122464
              ],
              [
                -52.162993944048615,
                -1.6349423204646618
              ],
              [
                -52.14195716046742,
                -1.6227352348261292
              ],
              [
                -52.12376868409979,
                -1.6190731842431711
              ],
              [
                -52.077381965688545,
                -1.6212705047208202
              ],
              [
                -52.07249915377455,
                -1.6195615277537339
              ],
              [
                -52.0566300127873,
                -1.6109352273004995
              ],
              [
                -52.04629472570809,
                -1.6075985387760727
              ],
              [
                -52.03661048042004,
                -1.60719161088648
              ],
              [
                -52.01577714781986,
                -1.6086564912037509
              ],
              [
                -52.00475012870833,
                -1.6075985387760727
              ],
              [
                -51.958648240308975,
                -1.5933569639267031
              ],
              [
                -51.91462154858263,
                -1.5709774321690753
              ],
              [
                -51.66954505122377,
                -1.4016252817659016
              ],
              [
                -51.59504147067815,
                -1.3868955138059016
              ],
              [
                -51.57677161379031,
                -1.3776994543529497
              ],
              [
                -51.557972786344145,
                -1.3654111035010388
              ],
              [
                -51.483998175913975,
                -1.3401018114622927
              ],
              [
                -51.46202551976149,
                -1.329359606334536
              ],
              [
                -51.43748938765251,
                -1.3126767648538902
              ],
              [
                -51.41771399557272,
                -1.2916805479240634
              ],
              [
                -51.40949459441396,
                -1.268161648536196
              ],
              [
                -51.39964759005257,
                -1.2510718792282964
              ],
              [
                -51.37633216097386,
                -1.2400041618889506
              ],
              [
                -51.326975064101696,
                -1.2308895932337804
              ],
              [
                -51.326975063995135,
                -1.2370744764241093
              ],
              [
                -51.33482825383584,
                -1.2406551864130542
              ],
              [
                -51.33991451715992,
                -1.2448869960335784
              ],
              [
                -51.34357662723261,
                -1.2502580985727312
              ],
              [
                -51.34740149587,
                -1.2575822746873118
              ],
              [
                -51.32848059807236,
                -1.2538388085641061
              ],
              [
                -51.305327929080725,
                -1.2438290436283679
              ],
              [
                -51.28343665298849,
                -1.231377861626626
              ],
              [
                -51.268299934213516,
                -1.2203915599170791
              ],
              [
                -51.25218665319394,
                -1.201918250879332
              ],
              [
                -51.22785397003873,
                -1.1626929719215073
              ],
              [
                -51.21369381417138,
                -1.1449521030748244
              ],
              [
                -51.187489387255866,
                -1.1216773756057188
              ],
              [
                -51.161488410883145,
                -1.1036109194262056
              ],
              [
                -51.03294837088466,
                -1.0380184716946164
              ],
              [
                -51.0034073561558,
                -1.0137672075594342
              ],
              [
                -50.99111894379386,
                -0.9872372074271561
              ],
              [
                -50.99657141818478,
                -0.9707984628551851
              ],
              [
                -51.006092903087385,
                -0.9528134224091062
              ],
              [
                -51.009755011800245,
                -0.9359676748773557
              ],
              [
                -50.99730384015026,
                -0.9224586157620329
              ],
              [
                -50.976673957055816,
                -0.9201799548531387
              ],
              [
                -50.957427538097285,
                -0.9498837369819226
              ],
              [
                -50.93590247316404,
                -0.9566383040991613
              ],
              [
                -50.93590247297949,
                -0.9491512968485154
              ],
              [
                -50.947377082144115,
                -0.9424781453509997
              ],
              [
                -50.95327714786309,
                -0.9313290125463659
              ],
              [
                -50.952219204996574,
                -0.9191220024631312
              ],
              [
                -50.9427384110524,
                -0.9087867254182687
              ],
              [
                -50.92861894409227,
                -0.9056942838673585
              ],
              [
                -50.88133704297186,
                -0.9149716085211703
              ],
              [
                -50.85423743409712,
                -0.9113908985835341
              ],
              [
                -50.8395889961013,
                -0.9127743632305872
              ],
              [
                -50.82664954314977,
                -0.9224586157620329
              ],
              [
                -50.82168535090643,
                -0.9353166503620812
              ],
              [
                -50.8219294912147,
                -0.9506161771153425
              ],
              [
                -50.82664954289683,
                -0.9838192536085774
              ],
              [
                -50.824452277883076,
                -1.030938392296147
              ],
              [
                -50.82664954311926,
                -1.0453427228428582
              ],
              [
                -50.83389238175538,
                -1.0586890258958137
              ],
              [
                -50.8438614570138,
                -1.0658505209208888
              ],
              [
                -50.85545813676095,
                -1.0714657200557496
              ],
              [
                -50.86766516812669,
                -1.0795224113519657
              ],
              [
                -50.89240475186197,
                -1.1122372196357202
              ],
              [
                -50.9017634758181,
                -1.121026275978694
              ],
              [
                -50.91234290304426,
                -1.1255835978349669
              ],
              [
                -50.925282356195105,
                -1.1276995026333148
              ],
              [
                -50.956410286032586,
                -1.1285132832840201
              ],
              [
                -50.84748287684244,
                -1.197849197398577
              ],
              [
                -50.83006751208815,
                -1.213799748851572
              ],
              [
                -50.81993567592486,
                -1.2317033738885315
              ],
              [
                -50.818592902768025,
                -1.252373928277267
              ],
              [
                -50.829253709796845,
                -1.3121070057331716
              ],
              [
                -50.82664954305974,
                -1.3708635465875776
              ],
              [
                -50.82347571510286,
                -1.3763974052952137
              ],
              [
                -50.81655839806641,
                -1.3822567762691063
              ],
              [
                -50.809315559212,
                -1.3902320520718543
              ],
              [
                -50.80553137922002,
                -1.4016252817659016
              ],
              [
                -50.813343879397706,
                -1.4137509516171973
              ],
              [
                -50.818104620402664,
                -1.4248999344676727
              ],
              [
                -50.81920325340518,
                -1.4362931641845307
              ],
              [
                -50.80968176939517,
                -1.4576961589575048
              ],
              [
                -50.77867591123192,
                -1.498630490605138
              ],
              [
                -50.76671302041089,
                -1.5407854558056406
              ],
              [
                -50.75332597664864,
                -1.5570615198347164
              ],
              [
                -50.689279751666454,
                -1.6120744451356845
              ],
              [
                -50.67955481672301,
                -1.6290015337788863
              ],
              [
                -50.670480924425554,
                -1.696465791894683
              ],
              [
                -50.66380774556554,
                -1.7194149327630204
              ],
              [
                -50.654693163827886,
                -1.7379697331034687
              ],
              [
                -50.673939582089446,
                -1.7647437559009878
              ],
              [
                -50.69102942589166,
                -1.765394780446083
              ],
              [
                -50.73729407582919,
                -1.7379697331034687
              ],
              [
                -50.72642981645313,
                -1.7611629706901561
              ],
              [
                -50.717977423543694,
                -1.768763764871493
              ],
              [
                -50.709508149991336,
                -1.7909484702521707
              ],
              [
                -50.71728258053987,
                -1.822472989535348
              ],
              [
                -50.73950701208414,
                -1.8326512941855575
              ],
              [
                -50.75832788478322,
                -1.8453973454145787
              ],
              [
                -50.76693559994163,
                -1.863288954097155
              ],
              [
                -50.76700867682918,
                -1.8820572077690998
              ],
              [
                -50.787567287020586,
                -1.8973696537074316
              ],
              [
                -50.81490464977341,
                -1.896456056263392
              ],
              [
                -50.836214284224226,
                -1.8827549486639779
              ],
              [
                -50.85842752057684,
                -1.865648054363927
              ],
              [
                -50.879803424867156,
                -1.851950702129977
              ],
              [
                -50.888415321344986,
                -1.868147453876577
              ],
              [
                -50.892733904389466,
                -1.8792345491783204
              ],
              [
                -50.87988748391721,
                -1.8826721811218674
              ],
              [
                -50.87051577886949,
                -1.90146326724727
              ],
              [
                -50.85342169883435,
                -1.908323209387943
              ],
              [
                -50.85438487512668,
                -1.9330801679910563
              ],
              [
                -50.84421518590441,
                -1.955300924847602
              ],
              [
                -50.83142022802506,
                -1.9630107740159695
              ],
              [
                -50.818606997302595,
                -1.969006689138409
              ],
              [
                -50.82194703635562,
                -1.9459519478726854
              ],
              [
                -50.82615952162983,
                -1.9305761118526858
              ],
              [
                -50.81844088908545,
                -1.9246157973067646
              ],
              [
                -50.791954984665026,
                -1.9272305606649054
              ],
              [
                -50.73720730386628,
                -1.921348357049801
              ],
              [
                -50.71325829408476,
                -1.9145659249780653
              ],
              [
                -50.702143604362654,
                -1.90947204090035
              ],
              [
                -50.69782028487343,
                -1.8881663837004599
              ],
              [
                -50.70034101423223,
                -1.8719622714761257
              ],
              [
                -50.69858776993881,
                -1.8540622508355697
              ],
              [
                -50.69002098174838,
                -1.84299843862037
              ],
              [
                -50.676329423246145,
                -1.8302426235275966
              ],
              [
                -50.66773851197462,
                -1.8080999778135147
              ],
              [
                -50.660043749060144,
                -1.8030042912171187
              ],
              [
                -50.63360790891519,
                -1.8115910856820518
              ],
              [
                -50.61058067689938,
                -1.8142025443244552
              ],
              [
                -50.5917048825612,
                -1.8431943167956846
              ],
              [
                -50.5653376940078,
                -1.890720310654464
              ],
              [
                -50.54723059784848,
                -1.9069149594627728
              ],
              [
                -50.52481035121761,
                -1.9214820469095075
              ],
              [
                -50.50450598950866,
                -1.9291318107269184
              ],
              [
                -50.48961341172095,
                -1.9284807861737827
              ],
              [
                -50.476226366583916,
                -1.9260393689930884
              ],
              [
                -50.4666641911039,
                -1.927829611407337
              ],
              [
                -50.462961391865825,
                -1.939711185040342
              ],
              [
                -50.46593176929535,
                -1.947198117623612
              ],
              [
                -50.47996985626497,
                -1.9670549673927762
              ],
              [
                -50.484038865610785,
                -1.977634341738247
              ],
              [
                -50.4700821617377,
                -1.9699033124818288
              ],
              [
                -50.45665442634142,
                -1.9439429948535187
              ],
              [
                -50.44302324115566,
                -1.9359677187503737
              ],
              [
                -50.44188391783999,
                -1.9469540209691525
              ],
              [
                -50.443226691939394,
                -1.956638274088314
              ],
              [
                -50.44709225137401,
                -1.9655086714144478
              ],
              [
                -50.45335852790597,
                -1.9738908754369304
              ],
              [
                -50.45750891745394,
                -1.9838192252322042
              ],
              [
                -50.45425370999996,
                -1.9935848940030088
              ],
              [
                -50.443023241646145,
                -2.0116513512068894
              ],
              [
                -50.43590247345575,
                -2.0450986016213126
              ],
              [
                -50.42857825375548,
                -2.0629208120322815
              ],
              [
                -50.41576087017418,
                -2.0731746741811117
              ],
              [
                -50.40977942614336,
                -2.047458603202347
              ],
              [
                -50.403879361692105,
                -2.035821276334812
              ],
              [
                -50.39464270780641,
                -2.0254859985949474
              ],
              [
                -50.38247636670947,
                -2.0171852101602044
              ],
              [
                -50.37875643992759,
                -2.005425309247409
              ],
              [
                -50.37790712134018,
                -1.9987514813649927
              ],
              [
                -50.373702917250206,
                -1.9870772020659162
              ],
              [
                -50.37284057095006,
                -1.9737278939780545
              ],
              [
                -50.36445586155807,
                -1.9612280422630335
              ],
              [
                -50.34100750171627,
                -1.9362451627629327
              ],
              [
                -50.31253899877305,
                -1.9087736991507045
              ],
              [
                -50.280769956748934,
                -1.8938286749922437
              ],
              [
                -50.25133216111325,
                -1.9017880284565425
              ],
              [
                -50.23155676931945,
                -1.8957658260340378
              ],
              [
                -50.207346157328026,
                -1.89714929075932
              ],
              [
                -50.18272864524711,
                -1.9042294456325934
              ],
              [
                -50.161936002261406,
                -1.9156226757225305
              ],
              [
                -50.15477454281713,
                -1.8827450345845367
              ],
              [
                -50.136586066609524,
                -1.8619930637438413
              ],
              [
                -50.110422329591465,
                -1.8492163689806052
              ],
              [
                -50.024891730673374,
                -1.8261043966526127
              ],
              [
                -50.00059973854559,
                -1.8236629794911032
              ],
              [
                -49.976918097673725,
                -1.8261043966526127
              ],
              [
                -49.95270748604772,
                -1.8334286481398254
              ],
              [
                -49.93224036332697,
                -1.8429500699298489
              ],
              [
                -49.87535559747295,
                -1.8795711772396981
              ],
              [
                -49.86929277361467,
                -1.8887672370009474
              ],
              [
                -49.867054816841964,
                -1.9055314947364348
              ],
              [
                -49.8704727860806,
                -1.9190406297301617
              ],
              [
                -49.894398567551285,
                -1.963311501094653
              ],
              [
                -49.87482662765434,
                -1.9429664580226638
              ],
              [
                -49.8602595689008,
                -1.9224585837387085
              ],
              [
                -49.854237434654046,
                -1.9429664580226638
              ],
              [
                -49.85065670532865,
                -1.9625790609170233
              ],
              [
                -49.85016842475589,
                -1.982680007365888
              ],
              [
                -49.85342363201454,
                -2.004978124174355
              ],
              [
                -49.86119544291697,
                -2.026543951055474
              ],
              [
                -49.88194739591859,
                -2.0665830129510647
              ],
              [
                -49.88756262914378,
                -2.0874976651684185
              ],
              [
                -49.88072669214375,
                -2.0874976651684185
              ],
              [
                -49.860259569680736,
                -2.0458310418038654
              ],
              [
                -49.853423632680645,
                -2.0458310418038654
              ],
              [
                -49.847971158875225,
                -2.0624326187187316
              ],
              [
                -49.8375138003888,
                -2.0811499503741646
              ],
              [
                -49.8249405585781,
                -2.097751527338711
              ],
              [
                -49.812489387942875,
                -2.1080055397313595
              ],
              [
                -49.82892818903758,
                -2.0577938809611678
              ],
              [
                -49.839182095014564,
                -2.004978124174355
              ],
              [
                -49.837880012367,
                -1.9266903935461095
              ],
              [
                -49.84658769398372,
                -1.909356376639816
              ],
              [
                -49.846587694112344,
                -1.9017880284565425
              ],
              [
                -49.834706184162236,
                -1.9059384226347678
              ],
              [
                -49.83088131439377,
                -1.9180640929012276
              ],
              [
                -49.832346157439225,
                -1.949639534808403
              ],
              [
                -49.82335364581621,
                -1.9281552738972214
              ],
              [
                -49.819813606117066,
                -1.9117977938173045
              ],
              [
                -49.81045488115426,
                -1.9005672447620272
              ],
              [
                -49.78453528552037,
                -1.8951148014825814
              ],
              [
                -49.760487434794,
                -1.8967425130746152
              ],
              [
                -49.747181769203365,
                -1.9047176389398581
              ],
              [
                -49.73741614505098,
                -1.91627370027503
              ],
              [
                -49.72370358050081,
                -1.9291318107269184
              ],
              [
                -49.72789466141654,
                -1.9108212569889178
              ],
              [
                -49.72130286339923,
                -1.9040666143879692
              ],
              [
                -49.7106827458714,
                -1.9082984241892509
              ],
              [
                -49.70262610590108,
                -1.9224585837387085
              ],
              [
                -49.69399980417054,
                -1.9073218873611566
              ],
              [
                -49.67609615776784,
                -1.9086239364653161
              ],
              [
                -49.654204882618416,
                -1.9201799978040248
              ],
              [
                -49.61945553223055,
                -1.9502905593626454
              ],
              [
                -49.60464433408621,
                -1.9678686729800756
              ],
              [
                -49.59434973884438,
                -1.9883765473385069
              ],
              [
                -49.59276282563525,
                -2.0116513512068894
              ],
              [
                -49.579416470223826,
                -1.9943173341824703
              ],
              [
                -49.59292558576911,
                -1.9640439412723207
              ],
              [
                -49.6343481109838,
                -1.909356376639816
              ],
              [
                -49.64736894425872,
                -1.9156226757225305
              ],
              [
                -49.64928137896329,
                -1.907972911913211
              ],
              [
                -49.654774542521615,
                -1.8951148014825814
              ],
              [
                -49.63170325356768,
                -1.8678524349065062
              ],
              [
                -49.59801184783049,
                -1.8427059732773996
              ],
              [
                -49.563343879375374,
                -1.8352190407546238
              ],
              [
                -49.537464972504864,
                -1.8609351112971435
              ],
              [
                -49.522368943293706,
                -1.7959936851671354
              ],
              [
                -49.51081295552283,
                -1.7789853309186978
              ],
              [
                -49.48521887849258,
                -1.7639299001129858
              ],
              [
                -49.46646074078996,
                -1.7643368280069804
              ],
              [
                -49.45799719933264,
                -1.778741084054058
              ],
              [
                -49.46300208178334,
                -1.8057593537957946
              ],
              [
                -49.452870246228,
                -1.7999813982821011
              ],
              [
                -49.43590247219033,
                -1.7849259674533366
              ],
              [
                -49.42202714852188,
                -1.7789853309186978
              ],
              [
                -49.42821204232139,
                -1.7987606145969879
              ],
              [
                -49.45116126126388,
                -1.8246395163130018
              ],
              [
                -49.456166145790704,
                -1.8366839210954051
              ],
              [
                -49.45421301966021,
                -1.8561336925837846
              ],
              [
                -49.44758053238611,
                -1.869886924178957
              ],
              [
                -49.43480383979144,
                -1.8799781051371913
              ],
              [
                -49.414662238876744,
                -1.8882788934809704
              ],
              [
                -49.37922115712585,
                -1.8964168505855323
              ],
              [
                -49.37043209587748,
                -1.9050433014291446
              ],
              [
                -49.36742102867479,
                -1.9257138567165903
              ],
              [
                -49.36974036461745,
                -1.9401995285623164
              ],
              [
                -49.37580318830028,
                -1.9572078830202633
              ],
              [
                -49.384348110780984,
                -1.9728329229809582
              ],
              [
                -49.39411373546547,
                -1.9838192252322042
              ],
              [
                -49.394113736735704,
                -1.991306308055361
              ],
              [
                -49.38109290373546,
                -1.991306308055361
              ],
              [
                -49.38906816279942,
                -2.0056291487315114
              ],
              [
                -49.412912564152634,
                -2.0274390722698374
              ],
              [
                -49.4220271471683,
                -2.0389949835060466
              ],
              [
                -49.42552649596531,
                -2.0508765572465286
              ],
              [
                -49.42821204226338,
                -2.1315242902791653
              ],
              [
                -49.430490688368366,
                -2.1412085435477493
              ],
              [
                -49.440297003479564,
                -2.1609025623924696
              ],
              [
                -49.44554602796935,
                -2.1837704386957015
              ],
              [
                -49.452992317993484,
                -2.190850593738613
              ],
              [
                -49.461984829536085,
                -2.196465718188274
              ],
              [
                -49.46983802056437,
                -2.2035458732392517
              ],
              [
                -49.495838996483215,
                -2.2466773775713715
              ],
              [
                -49.50011145755325,
                -2.2522112366381304
              ],
              [
                -49.50300045538587,
                -2.2583961202791945
              ],
              [
                -49.503977017797936,
                -2.310235341385368
              ],
              [
                -49.506459115039746,
                -2.319594082523861
              ],
              [
                -49.51227779950452,
                -2.326755503067457
              ],
              [
                -49.5190323561027,
                -2.3335914113278635
              ],
              [
                -49.524403450441824,
                -2.341241175420113
              ],
              [
                -49.52721106707402,
                -2.3508440132493744
              ],
              [
                -49.528920050575586,
                -2.3707821291385915
              ],
              [
                -49.53132076669511,
                -2.3804663826209724
              ],
              [
                -49.54893958287291,
                -2.4030901627284953
              ],
              [
                -49.551747200998555,
                -2.412774416241486
              ],
              [
                -49.55068925763582,
                -2.4237607189273103
              ],
              [
                -49.54600989447312,
                -2.4425594668320376
              ],
              [
                -49.54210364493271,
                -2.4971656184656346
              ],
              [
                -49.5457657541892,
                -2.516534125684166
              ],
              [
                -49.60781816104942,
                -2.6049128919966607
              ],
              [
                -49.6172582679067,
                -2.615004223848513
              ],
              [
                -49.640533007158446,
                -2.619724227267685
              ],
              [
                -49.66063392024625,
                -2.6317686329228707
              ],
              [
                -49.676909958107295,
                -2.649102350569871
              ],
              [
                -49.688954233266024,
                -2.669040767496248
              ],
              [
                -49.66368567589838,
                -2.6776669185366795
              ],
              [
                -49.61986243461773,
                -2.6701799854369765
              ],
              [
                -49.54491126111129,
                -2.6423478577178843
              ],
              [
                -49.52741451482658,
                -2.6283503782620112
              ],
              [
                -49.523548957652814,
                -2.615655248443212
              ],
              [
                -49.523793096002436,
                -2.600762497551053
              ],
              [
                -49.518299933334006,
                -2.5802547722325744
              ],
              [
                -49.51195227832523,
                -2.573500279430268
              ],
              [
                -49.49201412716553,
                -2.5624325609494845
              ],
              [
                -49.48656165286273,
                -2.560316655922175
              ],
              [
                -49.48253333154847,
                -2.556817286086749
              ],
              [
                -49.47940019330351,
                -2.538832243593347
              ],
              [
                -49.47728430743533,
                -2.532484528528428
              ],
              [
                -49.45274817581666,
                -2.507500896657405
              ],
              [
                -49.44261634012523,
                -2.4923641994803125
              ],
              [
                -49.4356990238795,
                -2.4703915939697247
              ],
              [
                -49.434437628204954,
                -2.451836792464837
              ],
              [
                -49.43675696499672,
                -2.4139950497778417
              ],
              [
                -49.435699022504146,
                -2.3952775673387485
              ],
              [
                -49.4268285792828,
                -2.367282759370021
              ],
              [
                -49.3316137356367,
                -2.2047665067514988
              ],
              [
                -49.3139542316298,
                -2.160414369074798
              ],
              [
                -49.306019661212886,
                -2.1244442854866494
              ],
              [
                -49.30475826619845,
                -2.104587435457239
              ],
              [
                -49.30052649595181,
                -2.0909156192241904
              ],
              [
                -49.232004361798964,
                -1.948174804668146
              ],
              [
                -49.20409095016883,
                -1.9073218873611566
              ],
              [
                -49.17564856721468,
                -1.8814429854829597
              ],
              [
                -49.168324348801534,
                -1.878106447107456
              ],
              [
                -49.16002356634363,
                -1.8757462953451587
              ],
              [
                -49.14556909846958,
                -1.8567584298014745
              ],
              [
                -49.14276431131259,
                -1.8399459536514078
              ],
              [
                -49.12866458513475,
                -1.8007072290642852
              ],
              [
                -49.12300603340757,
                -1.768008342066191
              ],
              [
                -49.08673009637768,
                -1.7488938468423576
              ],
              [
                -49.0496484205966,
                -1.7217920586037243
              ],
              [
                -49.008864369457534,
                -1.6811240545835233
              ],
              [
                -48.991542957097174,
                -1.6354838394918632
              ],
              [
                -48.96558946067669,
                -1.5997193993934196
              ],
              [
                -48.92607902356795,
                -1.5935991078017175
              ],
              [
                -48.90311715932224,
                -1.5842295518464862
              ],
              [
                -48.87787376687949,
                -1.5711694047942786
              ],
              [
                -48.86478048147604,
                -1.5599610875821996
              ],
              [
                -48.85636876064791,
                -1.5590305160546138
              ],
              [
                -48.8573168347308,
                -1.566525109312933
              ],
              [
                -48.87508358758935,
                -1.586137411247802
              ],
              [
                -48.89285097409462,
                -1.5982519654505494
              ],
              [
                -48.89567830772435,
                -1.622542661346998
              ],
              [
                -48.90316645585298,
                -1.6384217116514284
              ],
              [
                -48.911606783484416,
                -1.6729796384339841
              ],
              [
                -48.93030272299619,
                -1.6860405366413658
              ],
              [
                -48.93684850409342,
                -1.6935068898582908
              ],
              [
                -48.943394304494625,
                -1.7000378647163852
              ],
              [
                -48.94620122277954,
                -1.7047046922376716
              ],
              [
                -48.942477072903216,
                -1.71965166896047
              ],
              [
                -48.943431694599894,
                -1.7429973730402606
              ],
              [
                -48.95559937366051,
                -1.7663291073198208
              ],
              [
                -48.9687041566397,
                -1.7859247358443966
              ],
              [
                -48.99581502135394,
                -1.7933676558358294
              ],
              [
                -49.011721398311025,
                -1.8073603274050987
              ],
              [
                -49.01828883411543,
                -1.8279010982260715
              ],
              [
                -49.032324509689,
                -1.8390960466610151
              ],
              [
                -49.03326892850638,
                -1.8465676574268357
              ],
              [
                -49.0173233711861,
                -1.8472632953332968
              ],
              [
                -49.00241773871154,
                -1.842860392575074
              ],
              [
                -48.99212388726082,
                -1.832596015682156
              ],
              [
                -48.98275523360769,
                -1.8139263020210876
              ],
              [
                -48.95657702244723,
                -1.8036795001092427
              ],
              [
                -48.92946479121285,
                -1.7878322948456178
              ],
              [
                -48.91729221563719,
                -1.7626337093425808
              ],
              [
                -48.91073330221634,
                -1.742097445019181
              ],
              [
                -48.90025794133159,
                -1.73455162892876
              ],
              [
                -48.89305579241901,
                -1.722832886720742
              ],
              [
                -48.883900520129416,
                -1.7174618591342101
              ],
              [
                -48.88141842324434,
                -1.7134741460428948
              ],
              [
                -48.8902481767602,
                -1.6937802781061053
              ],
              [
                -48.89073645740635,
                -1.6864560266925288
              ],
              [
                -48.88239498671986,
                -1.6796201187951891
              ],
              [
                -48.86400305918978,
                -1.6715634272269975
              ],
              [
                -48.85631262876938,
                -1.66594815279683
              ],
              [
                -48.853586392096446,
                -1.6618791743121424
              ],
              [
                -48.84776770654346,
                -1.6496720886515241
              ],
              [
                -48.84666907459205,
                -1.6451961822807042
              ],
              [
                -48.84508216047172,
                -1.6413713004507173
              ],
              [
                -48.841297980382166,
                -1.6416968127204725
              ],
              [
                -48.83678137847859,
                -1.6427547651505294
              ],
              [
                -48.829660611459516,
                -1.6405575948830355
              ],
              [
                -48.81969153573012,
                -1.6403947636415157
              ],
              [
                -48.81533769390181,
                -1.6383602744025496
              ],
              [
                -48.81281490867596,
                -1.6340471992765953
              ],
              [
                -48.8132218096884,
                -1.625420898815079
              ],
              [
                -48.81187903664539,
                -1.6212705047208202
              ],
              [
                -48.73680579324758,
                -1.511407185060522
              ],
              [
                -48.735422329459745,
                -1.5074194720233909
              ],
              [
                -48.73582923117897,
                -1.5031063969337204
              ],
              [
                -48.735829230477634,
                -1.4987931716318592
              ],
              [
                -48.73306230352301,
                -1.4943172653044348
              ],
              [
                -48.72899329259914,
                -1.4926082883511773
              ],
              [
                -48.718658006754055,
                -1.491957263817901
              ],
              [
                -48.71568762900012,
                -1.4909807270180373
              ],
              [
                -48.7039688791558,
                -1.4789364727312884
              ],
              [
                -48.699330206531144,
                -1.472914270484503
              ],
              [
                -48.69522050671,
                -1.4636369455789058
              ],
              [
                -48.67637140735391,
                -1.4175705759265191
              ],
              [
                -48.65694627047951,
                -1.3833794706231322
              ],
              [
                -48.64212135343967,
                -1.385674730153637
              ],
              [
                -48.63073297803233,
                -1.4062114446457492
              ],
              [
                -48.61820513797711,
                -1.4278905314639474
              ],
              [
                -48.6064347004663,
                -1.456231428867424
              ],
              [
                -48.57591712057819,
                -1.5126278185085476
              ],
              [
                -48.561756964794306,
                -1.5289038825088457
              ],
              [
                -48.552316860486,
                -1.544366090749805
              ],
              [
                -48.543853319260116,
                -1.565606404637376
              ],
              [
                -48.53502356721478,
                -1.581475540803334
              ],
              [
                -48.52391516777111,
                -1.5803361727571161
              ],
              [
                -48.50230872268082,
                -1.6120744451356845
              ],
              [
                -48.490223762092825,
                -1.6190731842431711
              ],
              [
                -48.465931770640815,
                -1.6212705047208202
              ],
              [
                -48.4526261062364,
                -1.6256649954638005
              ],
              [
                -48.44204667942343,
                -1.6364072007846169
              ],
              [
                -48.433990037547304,
                -1.6496720886515241
              ],
              [
                -48.42833411437187,
                -1.6622861022032236
              ],
              [
                -48.42145748676204,
                -1.645114916873248
              ],
              [
                -48.42446855335269,
                -1.6261531887612564
              ],
              [
                -48.43097896946028,
                -1.60719161088648
              ],
              [
                -48.434559699419566,
                -1.5902645222675778
              ],
              [
                -48.443023240866694,
                -1.5700008953643771
              ],
              [
                -48.47838294167216,
                -1.5350887658034202
              ],
              [
                -48.4828995432463,
                -1.511407185060522
              ],
              [
                -48.46483313707297,
                -1.5220679746821777
              ],
              [
                -48.44790605452496,
                -1.5259742721027665
              ],
              [
                -48.42804928326185,
                -1.5241838795259948
              ],
              [
                -48.37580318840283,
                -1.5105119136662444
              ],
              [
                -48.35582434848877,
                -1.5004208831790726
              ],
              [
                -48.33958899621219,
                -1.4872372608458004
              ],
              [
                -48.32530676943332,
                -1.4704728533811469
              ],
              [
                -48.33413652356056,
                -1.4686826110237665
              ],
              [
                -48.366281704432865,
                -1.4704728533811469
              ],
              [
                -48.37755286375449,
                -1.4691708043163754
              ],
              [
                -48.38809160081335,
                -1.4660783626812823
              ],
              [
                -48.39793860545034,
                -1.461846553008953
              ],
              [
                -48.4072159504644,
                -1.456231428867424
              ],
              [
                -48.41763261604478,
                -1.4651018258829707
              ],
              [
                -48.434925911008115,
                -1.4709611968871168
              ],
              [
                -48.45555579253348,
                -1.472914270484503
              ],
              [
                -48.476144985431574,
                -1.4704728533811469
              ],
              [
                -48.496571418263436,
                -1.4613583597165607
              ],
              [
                -48.50328528592418,
                -1.448500249680129
              ],
              [
                -48.50157630095456,
                -1.4312476489627
              ],
              [
                -48.49657141762636,
                -1.4083797739236366
              ],
              [
                -48.489816860682396,
                -1.32691818925123
              ],
              [
                -48.48275288310696,
                -1.2813005071368204
              ],
              [
                -48.454006543764905,
                -1.2441598133566398
              ],
              [
                -48.43590301622787,
                -1.2186884413091916
              ],
              [
                -48.423172892789346,
                -1.232515502196832
              ],
              [
                -48.42853363526535,
                -1.2654396329807394
              ],
              [
                -48.42538650809791,
                -1.2973124959053206
              ],
              [
                -48.40982011596616,
                -1.3028296809122661
              ],
              [
                -48.33971106720058,
                -1.3160133031061538
              ],
              [
                -48.33458411440411,
                -1.313653301643767
              ],
              [
                -48.331613735980454,
                -1.2942033806218383
              ],
              [
                -48.326486783379124,
                -1.279473612748604
              ],
              [
                -48.32005774577372,
                -1.229587469079586
              ],
              [
                -48.305043098063365,
                -1.1882463603706623
              ],
              [
                -48.28136145673581,
                -1.167087462549555
              ],
              [
                -48.25015214783541,
                -1.189385653284927
              ],
              [
                -48.2573136058762,
                -1.1735165174695426
              ],
              [
                -48.26939856723089,
                -1.1617164351390985
              ],
              [
                -48.27700761573696,
                -1.149997618220411
              ],
              [
                -48.27065995993781,
                -1.1346981664437137
              ],
              [
                -48.27814693903089,
                -1.1285132832840201
              ],
              [
                -48.27065995982749,
                -1.121026275978694
              ],
              [
                -48.2589412102078,
                -1.1261532818437316
              ],
              [
                -48.24815833202522,
                -1.1228166685163958
              ],
              [
                -48.23668372280692,
                -1.1168758820018487
              ],
              [
                -48.22288977816228,
                -1.1135393437825993
              ],
              [
                -48.23460852797717,
                -1.1088192657988343
              ],
              [
                -48.247141079887605,
                -1.1093075341888554
              ],
              [
                -48.274403450162445,
                -1.1135393437825993
              ],
              [
                -48.27782141803928,
                -1.108493753538837
              ],
              [
                -48.29112708212028,
                -1.0795224113519657
              ],
              [
                -48.29600989480513,
                -1.0555965843262656
              ],
              [
                -48.291737434160765,
                -1.0436337459293832
              ],
              [
                -48.27769934810773,
                -1.0396461080962256
              ],
              [
                -48.23094641801884,
                -1.038750911830657
              ],
              [
                -48.212513801150195,
                -1.0365536665292345
              ],
              [
                -48.1981095039728,
                -1.0304501239077926
              ],
              [
                -48.18748938679363,
                -1.0186499665463844
              ],
              [
                -48.185536262064055,
                -1.009942325860588
              ],
              [
                -48.184681770116605,
                -0.9982235841271596
              ],
              [
                -48.18293209512306,
                -0.988213819308733
              ],
              [
                -48.177845831902225,
                -0.9838192536085774
              ],
              [
                -48.17617753810916,
                -0.9797502752740753
              ],
              [
                -48.1638077460759,
                -0.9628231872133984
              ],
              [
                -48.160796679061434,
                -0.9600562579140253
              ],
              [
                -48.158680793183954,
                -0.9364560183704761
              ],
              [
                -48.15396074097337,
                -0.9149716085211703
              ],
              [
                -48.15217037686599,
                -0.9142391683887428
              ],
              [
                -48.14781653621793,
                -0.9105771179401949
              ],
              [
                -48.14305579306449,
                -0.9058570399959958
              ],
              [
                -48.14028886588411,
                -0.90129971818121
              ],
              [
                -48.14574134002115,
                -0.8861630226914654
              ],
              [
                -48.146555141972705,
                -0.8807919202375388
              ],
              [
                -48.141102668031785,
                -0.8547502637316593
              ],
              [
                -48.14028886588165,
                -0.8429501064497015
              ],
              [
                -48.14354407484217,
                -0.8332658539459011
              ],
              [
                -48.15054277295469,
                -0.8267554586046555
              ],
              [
                -48.15758216090973,
                -0.8213843561618609
              ],
              [
                -48.16079667886532,
                -0.8160132537200459
              ],
              [
                -48.15916907517605,
                -0.7966448238398057
              ],
              [
                -48.154042120864695,
                -0.7818335655537768
              ],
              [
                -48.111561652911675,
                -0.7245419064369119
              ],
              [
                -48.0379125639341,
                -0.6617163888732547
              ],
              [
                -48.025257941961584,
                -0.675713791362427
              ],
              [
                -48.0211075510484,
                -0.6835263107996883
              ],
              [
                -48.01744544193107,
                -0.6958960769154439
              ],
              [
                -48.01781165314086,
                -0.7027320595918097
              ],
              [
                -48.023548956981045,
                -0.7154273379696108
              ],
              [
                -48.023589648072935,
                -0.7232398574157267
              ],
              [
                -48.021351691851926,
                -0.7250301748198723
              ],
              [
                -48.01207434816672,
                -0.7310523768636238
              ],
              [
                -48.00999915284107,
                -0.7336564749066812
              ],
              [
                -48.00255286401716,
                -0.7465145845305312
              ],
              [
                -47.969634568990536,
                -0.7794735641454084
              ],
              [
                -47.96214758986521,
                -0.7818335655537768
              ],
              [
                -47.94611568905599,
                -0.7404924575906295
              ],
              [
                -47.877919075158474,
                -0.6968726887872245
              ],
              [
                -47.86623811611153,
                -0.6735054303035793
              ],
              [
                -47.85008704284813,
                -0.6709937134541045
              ],
              [
                -47.82127845015446,
                -0.6797828447616326
              ],
              [
                -47.802444412923,
                -0.6903337529436652
              ],
              [
                -47.807380349066115,
                -0.6773098829471101
              ],
              [
                -47.82222997511154,
                -0.6648927996433305
              ],
              [
                -47.825285627855706,
                -0.6394830156235486
              ],
              [
                -47.82461635893356,
                -0.6066516423507923
              ],
              [
                -47.81591823299706,
                -0.5886997992562645
              ],
              [
                -47.81280014895528,
                -0.5738358161829136
              ],
              [
                -47.80907086104986,
                -0.5651674564045097
              ],
              [
                -47.789888971041044,
                -0.5825437947250139
              ],
              [
                -47.7750450370246,
                -0.5992925042681413
              ],
              [
                -47.76949982704761,
                -0.6197437467214566
              ],
              [
                -47.77025305913264,
                -0.6371396127962833
              ],
              [
                -47.74681555886305,
                -0.6338843400379742
              ],
              [
                -47.72516842398934,
                -0.6441382764822591
              ],
              [
                -47.716420050894406,
                -0.6677385157994926
              ],
              [
                -47.715728318934715,
                -0.7129859209488981
              ],
              [
                -47.722401495930676,
                -0.7243791503092669
              ],
              [
                -47.735218878973235,
                -0.7354468674180608
              ],
              [
                -47.74339758986305,
                -0.7462704127855804
              ],
              [
                -47.73631751210019,
                -0.757256789391134
              ],
              [
                -47.72866777301105,
                -0.7565243492626631
              ],
              [
                -47.652821417994865,
                -0.7238908819263066
              ],
              [
                -47.62661699111377,
                -0.7072079657596977
              ],
              [
                -47.61058509016416,
                -0.6939430033852945
              ],
              [
                -47.597279426104656,
                -0.6773414277433881
              ],
              [
                -47.58828691294327,
                -0.6416968594663935
              ],
              [
                -47.57809959204164,
                -0.6354075030562146
              ],
              [
                -47.587163442926375,
                -0.6139637636671034
              ],
              [
                -47.584513540012814,
                -0.5782469803968464
              ],
              [
                -47.5734759980017,
                -0.582808733459724
              ],
              [
                -47.55919596903917,
                -0.591270700146619
              ],
              [
                -47.538439839945354,
                -0.6107802553220987
              ],
              [
                -47.543008736997876,
                -0.6270068984993619
              ],
              [
                -47.534494595111816,
                -0.6373023689235339
              ],
              [
                -47.52940833208883,
                -0.6460914251164109
              ],
              [
                -47.52741451709178,
                -0.6574846544554191
              ],
              [
                -47.523996548901735,
                -0.6691219804356683
              ],
              [
                -47.51943925692355,
                -0.6760393036172971
              ],
              [
                -47.50914466094119,
                -0.687269776838113
              ],
              [
                -47.4932755198693,
                -0.7120907246938
              ],
              [
                -47.48737545515357,
                -0.7282854475864508
              ],
              [
                -47.48766028611994,
                -0.7457008038917466
              ],
              [
                -47.49669348886899,
                -0.764743721484764
              ],
              [
                -47.424061652869156,
                -0.764743721484764
              ],
              [
                -47.408599413157894,
                -0.7710914357916041
              ],
              [
                -47.40636145710444,
                -0.8014462422766983
              ],
              [
                -47.39305579294731,
                -0.8125952999230185
              ],
              [
                -47.393055793010966,
                -0.8007138021471712
              ],
              [
                -47.390858528145365,
                -0.7897275006331778
              ],
              [
                -47.38634192592729,
                -0.7799618325292085
              ],
              [
                -47.37938391817698,
                -0.7709286796637175
              ],
              [
                -47.38491777292338,
                -0.7671851385093059
              ],
              [
                -47.38927161414159,
                -0.7626278918227586
              ],
              [
                -47.39199785086103,
                -0.7562801775176105
              ],
              [
                -47.39305579293263,
                -0.7471656090415946
              ],
              [
                -47.41413326714596,
                -0.7369117476740994
              ],
              [
                -47.43879146989739,
                -0.7033016684849184
              ],
              [
                -47.4483129549319,
                -0.6958960769154439
              ],
              [
                -47.45103919195479,
                -0.7071265501425826
              ],
              [
                -47.45470130084159,
                -0.7165666308628965
              ],
              [
                -47.46019446491287,
                -0.7245419064369119
              ],
              [
                -47.468739387037694,
                -0.7306454489910916
              ],
              [
                -47.470041469935914,
                -0.6218400861972407
              ],
              [
                -47.464426235933345,
                -0.6090633922347155
              ],
              [
                -47.448312954988694,
                -0.6071102811557518
              ],
              [
                -47.46190344998637,
                -0.5928687445008745
              ],
              [
                -47.44640052004846,
                -0.5851376406988829
              ],
              [
                -47.43016516799039,
                -0.5800106724839666
              ],
              [
                -47.4143774080113,
                -0.581231380989991
              ],
              [
                -47.39981035098639,
                -0.5928687445008745
              ],
              [
                -47.40453040300643,
                -0.5997860676688141
              ],
              [
                -47.409657356005305,
                -0.6097958323601713
              ],
              [
                -47.41413326701699,
                -0.6139462262625407
              ],
              [
                -47.410023567000145,
                -0.6283505190521111
              ],
              [
                -47.414702929142095,
                -0.6613095361081854
              ],
              [
                -47.40733801994322,
                -0.6815731621635264
              ],
              [
                -47.40880286411431,
                -0.6700985923067239
              ],
              [
                -47.407297330101656,
                -0.6602515837270325
              ],
              [
                -47.40217037684655,
                -0.6525204048051101
              ],
              [
                -47.39305579302205,
                -0.6481259142609654
              ],
              [
                -47.390288865951625,
                -0.661553632745915
              ],
              [
                -47.38573157496921,
                -0.6727841059622527
              ],
              [
                -47.37804114497471,
                -0.6798641852720099
              ],
              [
                -47.36571204294325,
                -0.6815731621635264
              ],
              [
                -47.36571204292378,
                -0.6760393036172971
              ],
              [
                -47.3740128249258,
                -0.6703426889444916
              ],
              [
                -47.380238411094375,
                -0.6588681190912004
              ],
              [
                -47.381092902842695,
                -0.6454403255005817
              ],
              [
                -47.37315833186415,
                -0.6338843400379742
              ],
              [
                -47.359445766875474,
                -0.6309546546410567
              ],
              [
                -47.346424934111326,
                -0.6373023689235339
              ],
              [
                -47.32469641806067,
                -0.6548804813113362
              ],
              [
                -47.32628333191833,
                -0.6390926863234175
              ],
              [
                -47.33267167906632,
                -0.6291643372415548
              ],
              [
                -47.34019934795709,
                -0.620212487372015
              ],
              [
                -47.34520423098868,
                -0.6071102811557518
              ],
              [
                -47.328846809067244,
                -0.6134579578810688
              ],
              [
                -47.31663977793484,
                -0.6075985495371473
              ],
              [
                -47.30589759005302,
                -0.5979143346538384
              ],
              [
                -47.294016079986456,
                -0.5928687445008745
              ],
              [
                -47.27912350206706,
                -0.5992164212239525
              ],
              [
                -47.277088995989764,
                -0.614190360453283
              ],
              [
                -47.27904212086206,
                -0.6325008754030963
              ],
              [
                -47.27635657502201,
                -0.6481259142609654
              ],
              [
                -47.26952063702201,
                -0.6481259142609654
              ],
              [
                -47.257883267032476,
                -0.6408830788300135
              ],
              [
                -47.25080318897849,
                -0.647067961880207
              ],
              [
                -47.24958248606399,
                -0.6605770959817627
              ],
              [
                -47.25584876192395,
                -0.6760393036172971
              ],
              [
                -47.238758918076826,
                -0.6647274898895772
              ],
              [
                -47.23448645701115,
                -0.6510555996592315
              ],
              [
                -47.237660285961496,
                -0.6358374886715917
              ],
              [
                -47.24278723895718,
                -0.620212487372015
              ],
              [
                -47.19810950395797,
                -0.6515438680411741
              ],
              [
                -47.1945694650155,
                -0.663832293635713
              ],
              [
                -47.19994055898625,
                -0.6769344998714666
              ],
              [
                -47.20860755107876,
                -0.6818173339080447
              ],
              [
                -47.21548417890236,
                -0.6691219804356683
              ],
              [
                -47.22232011590236,
                -0.6691219804356683
              ],
              [
                -47.225331183839806,
                -0.679620013527517
              ],
              [
                -47.230620897941535,
                -0.687269776838113
              ],
              [
                -47.238514777983184,
                -0.6926408792585929
              ],
              [
                -47.24901282493215,
                -0.6958960769154439
              ],
              [
                -47.249012825138614,
                -0.7027320595918097
              ],
              [
                -47.23595130086484,
                -0.7164038747352897
              ],
              [
                -47.22911536386485,
                -0.7164038747352897
              ],
              [
                -47.22223873601679,
                -0.7023251317196083
              ],
              [
                -47.2082413398853,
                -0.6991512745725875
              ],
              [
                -47.19090735595962,
                -0.7028134001022633
              ],
              [
                -47.1739395820007,
                -0.7095679671628754
              ],
              [
                -47.17406165292479,
                -0.6988257623175266
              ],
              [
                -47.17198645703955,
                -0.6921526108760905
              ],
              [
                -47.167632616121026,
                -0.6871884363277103
              ],
              [
                -47.16087805894348,
                -0.6815731621635264
              ],
              [
                -47.15489661407766,
                -0.6975237132973082
              ],
              [
                -47.15420488189531,
                -0.7133114332041117
              ],
              [
                -47.15843665309345,
                -0.7287737159694747
              ],
              [
                -47.16710364500593,
                -0.7437476552520605
              ],
              [
                -47.17365475213053,
                -0.7484677331703826
              ],
              [
                -47.190907355861626,
                -0.7562801775176105
              ],
              [
                -47.19440670498742,
                -0.7610002554377263
              ],
              [
                -47.19082597608656,
                -0.7701962395349284
              ],
              [
                -47.182728645148785,
                -0.7697079711512811
              ],
              [
                -47.173573370955665,
                -0.7640926969733699
              ],
              [
                -47.16710364509901,
                -0.757256789391134
              ],
              [
                -47.15575110595568,
                -0.7640926969733699
              ],
              [
                -47.14801998594893,
                -0.7741024617109341
              ],
              [
                -47.14305579306075,
                -0.7860653750938204
              ],
              [
                -47.139759894870345,
                -0.7989234096321405
              ],
              [
                -47.13467363204257,
                -0.7805315165302762
              ],
              [
                -47.13853919215296,
                -0.7596982064150781
              ],
              [
                -47.13955644412295,
                -0.7413876538464783
              ],
              [
                -47.12608802003746,
                -0.7306454489910916
              ],
              [
                -47.12474524583861,
                -0.737969624950919
              ],
              [
                -47.12075761583872,
                -0.7450497042740727
              ],
              [
                -47.119292772859524,
                -0.7505835628314593
              ],
              [
                -47.11522376206288,
                -0.7418759222297059
              ],
              [
                -47.11571204301788,
                -0.7365048198014909
              ],
              [
                -47.1179093090374,
                -0.7306454489910916
              ],
              [
                -47.119292773141616,
                -0.7198219036286608
              ],
              [
                -47.11782792891317,
                -0.7131486770765176
              ],
              [
                -47.10993404895971,
                -0.7028134001022633
              ],
              [
                -47.105620897932376,
                -0.6958960769154439
              ],
              [
                -47.10289466088351,
                -0.6749813512357117
              ],
              [
                -47.098988411137896,
                -0.665622686143505
              ],
              [
                -47.0882462229354,
                -0.6617163888732547
              ],
              [
                -47.077544725968416,
                -0.6657040266538694
              ],
              [
                -47.07306881401727,
                -0.6752255229801664
              ],
              [
                -47.07359778603617,
                -0.6864559962007278
              ],
              [
                -47.078358527932394,
                -0.6958960769154439
              ],
              [
                -47.07551022006019,
                -0.6976864694248387
              ],
              [
                -47.07371985609932,
                -0.6973609571697905
              ],
              [
                -47.07258053286112,
                -0.6979305660627974
              ],
              [
                -47.07152259013809,
                -0.7027320595918097
              ],
              [
                -47.079701301163105,
                -0.7096493827800032
              ],
              [
                -47.07966061091404,
                -0.7359351358011738
              ],
              [
                -47.08454342385963,
                -0.7505835628314593
              ],
              [
                -47.0783585280988,
                -0.757256789391134
              ],
              [
                -47.07152259000589,
                -0.7437476552520605
              ],
              [
                -47.06598873615273,
                -0.7596982064150781
              ],
              [
                -47.06468665294088,
                -0.7770321471199376
              ],
              [
                -47.059885219964734,
                -0.7896460850158464
              ],
              [
                -47.04356848910873,
                -0.7914364775303429
              ],
              [
                -47.05426998611225,
                -0.8028297069184207
              ],
              [
                -47.07347571495419,
                -0.8153622292075576
              ],
              [
                -47.07835852802741,
                -0.8262671902201175
              ],
              [
                -47.07656816297453,
                -0.8366024672345105
              ],
              [
                -47.0626114568673,
                -0.8558895566300595
              ],
              [
                -47.05719967388929,
                -0.8671200299146391
              ],
              [
                -47.05418860618099,
                -0.8565406562500997
              ],
              [
                -47.051014778180736,
                -0.8194312826241036
              ],
              [
                -47.04775956900457,
                -0.8107235668965672
              ],
              [
                -47.04234778601091,
                -0.8007138021471712
              ],
              [
                -47.03600012888455,
                -0.7916805741690139
              ],
              [
                -47.029896614172706,
                -0.7852515944540307
              ],
              [
                -47.026112433845896,
                -0.787692936373476
              ],
              [
                -47.01622473910867,
                -0.7914364775303429
              ],
              [
                -47.01659094991091,
                -0.770114823917648
              ],
              [
                -47.015248176110134,
                -0.760023718670737
              ],
              [
                -47.00841223909868,
                -0.757256789391134
              ],
              [
                -46.99266516809863,
                -0.757256789391134
              ],
              [
                -46.98460852785708,
                -0.7492000981920268
              ],
              [
                -46.977365688875395,
                -0.7305640333739256
              ],
              [
                -46.969105597932575,
                -0.6958960769154439
              ],
              [
                -46.95685787710535,
                -0.7101376511627345
              ],
              [
                -46.957020636973645,
                -0.7354468674180608
              ],
              [
                -46.9691055981725,
                -0.7852515944540307
              ],
              [
                -46.961659309172425,
                -0.7852515944540307
              ],
              [
                -46.95482337117539,
                -0.7709286796637175
              ],
              [
                -46.946278450066,
                -0.7760556103524522
              ],
              [
                -46.94249426998277,
                -0.7824032495549081
              ],
              [
                -46.94286048090124,
                -0.7901343533998119
              ],
              [
                -46.947377081870876,
                -0.7989234096321405
              ],
              [
                -46.92808997287092,
                -0.7989234096321405
              ],
              [
                -46.931507941823654,
                -0.8049455365831614
              ],
              [
                -46.93785559804894,
                -0.8204078193929759
              ],
              [
                -46.94115149602733,
                -0.8262671902201175
              ],
              [
                -46.93309485608126,
                -0.8230119925500609
              ],
              [
                -46.93130449103214,
                -0.8219540401637301
              ],
              [
                -46.928089973180306,
                -0.8194312826241036
              ],
              [
                -46.92223059805864,
                -0.8345679780783151
              ],
              [
                -46.930327929095895,
                -0.8428687659388916
              ],
              [
                -46.943959113997316,
                -0.8478329405115331
              ],
              [
                -46.95482337119403,
                -0.8536109708333356
              ],
              [
                -46.963002082193285,
                -0.8650042002454075
              ],
              [
                -46.968373176141185,
                -0.8796526273381464
              ],
              [
                -46.964995897805196,
                -0.893324442560555
              ],
              [
                -46.947377081886984,
                -0.90129971818121
              ],
              [
                -46.94863847581747,
                -0.8846981424281751
              ],
              [
                -46.951649543053634,
                -0.8716773517237507
              ],
              [
                -46.94912675708092,
                -0.8615048308251075
              ],
              [
                -46.934315559193934,
                -0.8536109708333356
              ],
              [
                -46.9117732408831,
                -0.8600399505631148
              ],
              [
                -46.90078691306453,
                -0.8573544368918613
              ],
              [
                -46.90021725219703,
                -0.8392880560105171
              ],
              [
                -46.89273027294692,
                -0.8467749881242863
              ],
              [
                -46.8913468089163,
                -0.8341610502044343
              ],
              [
                -46.8927302731722,
                -0.7852515944540307
              ],
              [
                -46.884022589920846,
                -0.7899715972718107
              ],
              [
                -46.877674933923814,
                -0.7956682119650608
              ],
              [
                -46.87393144390515,
                -0.802911047429116
              ],
              [
                -46.872873501947915,
                -0.8125952999230185
              ],
              [
                -46.865386522947915,
                -0.8125952999230185
              ],
              [
                -46.86168372305415,
                -0.8060849045862765
              ],
              [
                -46.85899817615122,
                -0.8025041946623293
              ],
              [
                -46.854644335030564,
                -0.800551046019132
              ],
              [
                -46.84557044187115,
                -0.7989234096321405
              ],
              [
                -46.849842903127715,
                -0.7912737214023544
              ],
              [
                -46.85594641812841,
                -0.7855771067099313
              ],
              [
                -46.863636847936135,
                -0.781345297169964
              ],
              [
                -46.87287350194424,
                -0.7784156117605788
              ],
              [
                -46.858631965113865,
                -0.7657203333585421
              ],
              [
                -46.832915818934644,
                -0.7300757649908762
              ],
              [
                -46.818226692071114,
                -0.7232398574157267
              ],
              [
                -46.81822669186602,
                -0.7164038747352897
              ],
              [
                -46.831288215000654,
                -0.7095679671628754
              ],
              [
                -46.81920325409056,
                -0.7116838719281454
              ],
              [
                -46.809193489112054,
                -0.7172177304800106
              ],
              [
                -46.80150305893947,
                -0.7257626149476817
              ],
              [
                -46.79653886614402,
                -0.7369117476740994
              ],
              [
                -46.80809485611413,
                -0.7400041892074402
              ],
              [
                -46.81086178299357,
                -0.7466773406582907
              ],
              [
                -46.806385870965656,
                -0.7554663968785713
              ],
              [
                -46.79653886587091,
                -0.764743721484764
              ],
              [
                -46.81143144402406,
                -0.770684507918563
              ],
              [
                -46.818226692174896,
                -0.7709286796637175
              ],
              [
                -46.8182266919443,
                -0.7784156117605788
              ],
              [
                -46.81191972603776,
                -0.7848446665807987
              ],
              [
                -46.81334387881359,
                -0.7907853779117403
              ],
              [
                -46.82046464792392,
                -0.7956682119650608
              ],
              [
                -46.831288214871165,
                -0.7989234096321405
              ],
              [
                -46.83128821518815,
                -0.8051083678178876
              ],
              [
                -46.82127845001778,
                -0.8077938814843704
              ],
              [
                -46.817860480931174,
                -0.8141415206933655
              ],
              [
                -46.81944739489522,
                -0.8229305769326659
              ],
              [
                -46.82445227786696,
                -0.8331030978176837
              ],
              [
                -46.81297766792181,
                -0.829847900146889
              ],
              [
                -46.80443274617941,
                -0.8251278973228879
              ],
              [
                -46.79893958210214,
                -0.8171526217235807
              ],
              [
                -46.796538866188016,
                -0.8051083678178876
              ],
              [
                -46.79035397018802,
                -0.8051083678178876
              ],
              [
                -46.797596808814674,
                -0.8605282189482252
              ],
              [
                -46.79930579294319,
                -0.862481367595392
              ],
              [
                -46.799672004171484,
                -0.865166956373803
              ],
              [
                -46.79653886604492,
                -0.8746070371423723
              ],
              [
                -46.78555253813059,
                -0.8939755421814731
              ],
              [
                -46.782866990887364,
                -0.90129971818121
              ],
              [
                -46.77863522006944,
                -0.8858375104344198
              ],
              [
                -46.78335527306625,
                -0.8744442810139258
              ],
              [
                -46.7863663401108,
                -0.8627255393412843
              ],
              [
                -46.776682094947056,
                -0.8467749881242863
              ],
              [
                -46.769886847947056,
                -0.8467749881242863
              ],
              [
                -46.76988684788998,
                -0.8671200299146391
              ],
              [
                -46.75963294208059,
                -0.8615048308251075
              ],
              [
                -46.75560462086519,
                -0.8501929419252829
              ],
              [
                -46.755523241179624,
                -0.8194312826241036
              ],
              [
                -46.7451065748065,
                -0.82927821614488
              ],
              [
                -46.71963456880902,
                -0.8648413690103505
              ],
              [
                -46.71458899600927,
                -0.8776994786897838
              ],
              [
                -46.71873938703762,
                -0.8946265666957424
              ],
              [
                -46.74937903605759,
                -0.9429664137375733
              ],
              [
                -46.73326575415653,
                -0.930922159777709
              ],
              [
                -46.70929928311337,
                -0.8898251482433798
              ],
              [
                -46.69786536397352,
                -0.8807919202375388
              ],
              [
                -46.69904537711518,
                -0.8684221540485924
              ],
              [
                -46.69762122296108,
                -0.8438453027085144
              ],
              [
                -46.68871009009303,
                -0.8257789218355797
              ],
              [
                -46.667388475867426,
                -0.8331030978176837
              ],
              [
                -46.66063391801107,
                -0.8449032550956596
              ],
              [
                -46.65990149586841,
                -0.8558895566300595
              ],
              [
                -46.65697180914068,
                -0.8639462478575118
              ],
              [
                -46.64321855389025,
                -0.8671200299146391
              ],
              [
                -46.63267981704194,
                -0.8632138077264583
              ],
              [
                -46.63516191283035,
                -0.8532853834700229
              ],
              [
                -46.65673278691428,
                -0.8139729813525838
              ],
              [
                -46.65591340902859,
                -0.8018204236472085
              ],
              [
                -46.63808736012404,
                -0.8018533954701054
              ],
              [
                -46.6137962329192,
                -0.813235659289985
              ],
              [
                -46.59854081889035,
                -0.8671200299146391
              ],
              [
                -46.62246660095198,
                -0.8980445205025787
              ],
              [
                -46.62645423104794,
                -0.9087867254182687
              ],
              [
                -46.61900794204797,
                -0.9087867254182687
              ],
              [
                -46.61139889192813,
                -0.903903891345763
              ],
              [
                -46.60875403613326,
                -0.9110653863261958
              ],
              [
                -46.61131751211887,
                -0.9240048365384104
              ],
              [
                -46.61900794189146,
                -0.9354794064908967
              ],
              [
                -46.63263912698295,
                -0.9434546821241722
              ],
              [
                -46.646229621122956,
                -0.9454078307773183
              ],
              [
                -46.65656490798846,
                -0.9391415320495664
              ],
              [
                -46.66002356713751,
                -0.9224586157620329
              ],
              [
                -46.66738847613752,
                -0.9224586157620329
              ],
              [
                -46.673085090155574,
                -0.9366187744993042
              ],
              [
                -46.6822810539157,
                -0.9467098798084014
              ],
              [
                -46.7235408190671,
                -0.9728329520216219
              ],
              [
                -46.737456834827384,
                -0.984307521995965
              ],
              [
                -46.74705970020231,
                -0.9991187803912143
              ],
              [
                -46.74937903579982,
                -1.0186499665463844
              ],
              [
                -46.73814856680163,
                -1.0015601223297683
              ],
              [
                -46.72069251188132,
                -0.9839820097377108
              ],
              [
                -46.70042884008245,
                -0.9699032665921229
              ],
              [
                -46.681060350968124,
                -0.9634742117293726
              ],
              [
                -46.677235481087614,
                -0.9655901165130389
              ],
              [
                -46.653664335894945,
                -0.96702532965071
              ],
              [
                -46.62611677811339,
                -0.9622032568540644
              ],
              [
                -46.60505468511661,
                -0.9565639485072448
              ],
              [
                -46.58159082614727,
                -0.9703558593164573
              ],
              [
                -46.56456228493301,
                -0.9509504017455512
              ],
              [
                -46.5612946338854,
                -0.9282895962936573
              ],
              [
                -46.545893490833926,
                -0.9137396340039157
              ],
              [
                -46.518351755014024,
                -0.9008239175006824
              ],
              [
                -46.50294811204357,
                -0.8838435788701767
              ],
              [
                -46.48755809814094,
                -0.8790056585837746
              ],
              [
                -46.475422040148196,
                -0.8838773017597519
              ],
              [
                -46.46569628992152,
                -0.8766023957324582
              ],
              [
                -46.447068005806706,
                -0.8725758526764446
              ],
              [
                -46.42762913002484,
                -0.8685499855809057
              ],
              [
                -46.41630916490673,
                -0.8807080261002518
              ],
              [
                -46.42118662600425,
                -0.8944660637669237
              ],
              [
                -46.438201798911386,
                -0.9025419823101065
              ],
              [
                -46.4608781820055,
                -0.9065619159845799
              ],
              [
                -46.480326845111286,
                -0.9194909263690944
              ],
              [
                -46.47306314498271,
                -0.936498754059135
              ],
              [
                -46.47713306208361,
                -0.9526822110767342
              ],
              [
                -46.48929239098829,
                -0.9648067540647072
              ],
              [
                -46.488497126141226,
                -0.9761392222374065
              ],
              [
                -46.47150699310416,
                -0.9858764249869689
              ],
              [
                -46.475581301937154,
                -1.0069172549702332
              ],
              [
                -46.48009192615611,
                -1.0222307516058597
              ],
              [
                -46.46678626176981,
                -1.0231258727641561
              ],
              [
                -46.462717252009114,
                -1.0316708324319717
              ],
              [
                -46.47500566310906,
                -1.0453427228428582
              ],
              [
                -46.46458899602085,
                -1.0458309912314927
              ],
              [
                -46.45319576692439,
                -1.0435523303113012
              ],
              [
                -46.444081184180334,
                -1.0377743750537063
              ],
              [
                -46.44029700409946,
                -1.028252878607146
              ],
              [
                -46.435658331884994,
                -1.0238583128997643
              ],
              [
                -46.42511959501906,
                -1.0287411469954244
              ],
              [
                -46.413726366225426,
                -1.0360653981407784
              ],
              [
                -46.40672766819106,
                -1.039157839707744
              ],
              [
                -46.392689581812846,
                -1.0271135105945404
              ],
              [
                -46.38451087084487,
                -1.0098609102426077
              ],
              [
                -46.36489824108169,
                -1.0083961050789563
              ],
              [
                -46.367054817090754,
                -1.0254859493004322
              ],
              [
                -46.365793424108816,
                -1.0453427228428582
              ],
              [
                -46.36119544175674,
                -1.0673153260881025
              ],
              [
                -46.356516079859084,
                -1.0752906017646464
              ],
              [
                -46.35293535094464,
                -1.069105718621517
              ],
              [
                -46.351470507210074,
                -1.0490048484178507
              ],
              [
                -46.346180793104494,
                -1.0339494933509925
              ],
              [
                -46.33446204293024,
                -1.0221493359878542
              ],
              [
                -46.32266191300591,
                -1.0202776029466833
              ],
              [
                -46.317372200108736,
                -1.0353329580048138
              ],
              [
                -46.31737220019979,
                -1.0733375282076785
              ],
              [
                -46.31899980377276,
                -1.0814754849094423
              ],
              [
                -46.324330207248266,
                -1.0973446957636788
              ],
              [
                -46.32481848924262,
                -1.1073544606289105
              ],
              [
                -46.30955969999645,
                -1.0958798154878318
              ],
              [
                -46.30125891817339,
                -1.0791968990923884
              ],
              [
                -46.29767818894199,
                -1.0577124891180232
              ],
              [
                -46.29686438700904,
                -1.0316708324319717
              ],
              [
                -46.29002845000903,
                -1.0316708324319717
              ],
              [
                -46.2806290359857,
                -1.0489234327997305
              ],
              [
                -46.256255663041685,
                -1.0770809942986714
              ],
              [
                -46.248443163135605,
                -1.0936825701809387
              ],
              [
                -46.254017706990375,
                -1.077406506558185
              ],
              [
                -46.2711075511479,
                -1.0536435107709898
              ],
              [
                -46.276356575190505,
                -1.039157839707744
              ],
              [
                -46.279042121144144,
                -1.0365536665292345
              ],
              [
                -46.283314581914155,
                -1.0293921715131413
              ],
              [
                -46.283314582179884,
                -1.0220679954764973
              ],
              [
                -46.26414954312558,
                -1.0166968929941365
              ],
              [
                -46.27465078987972,
                -1.0055389726775037
              ],
              [
                -46.281479030872774,
                -0.9974484834102283
              ],
              [
                -46.278978511847605,
                -0.9862609710788994
              ],
              [
                -46.26776936422515,
                -0.9713537263817034
              ],
              [
                -46.26214681399758,
                -0.9502200645985507
              ],
              [
                -46.25030825998937,
                -0.930954831174138
              ],
              [
                -46.23424231708724,
                -0.9170875133009055
              ],
              [
                -46.20030676979336,
                -0.9076473574110443
              ],
              [
                -46.171783006928415,
                -0.9209937354967705
              ],
              [
                -46.17393958214871,
                -0.9566383040991613
              ],
              [
                -46.180165168148704,
                -0.9566383040991613
              ],
              [
                -46.190012173974104,
                -0.9591610616513573
              ],
              [
                -46.203480598190104,
                -0.9763323214565525
              ],
              [
                -46.215565559029905,
                -0.997328387863105
              ],
              [
                -46.22118079309603,
                -1.0111630343836984
              ],
              [
                -46.20571855391005,
                -1.00660571255016
              ],
              [
                -46.19859778620506,
                -1.0105120098664646
              ],
              [
                -46.2012426421054,
                -1.0182431137763153
              ],
              [
                -46.21495520719465,
                -1.0248349247828041
              ],
              [
                -46.213286913049856,
                -1.0285783908659982
              ],
              [
                -46.21231035097803,
                -1.0318335885614103
              ],
              [
                -46.2108048169122,
                -1.0350887862572804
              ],
              [
                -46.20750891819024,
                -1.039157839707744
              ],
              [
                -46.21178137881865,
                -1.0442033548294254
              ],
              [
                -46.217030402866264,
                -1.0538876074120653
              ],
              [
                -46.221180793210316,
                -1.0590146132617344
              ],
              [
                -46.21149654894294,
                -1.0748023333753884
              ],
              [
                -46.262115037935665,
                -1.1832007701092162
              ],
              [
                -46.230539517171344,
                -1.1477190323962199
              ],
              [
                -46.221180793253154,
                -1.1415341492328113
              ],
              [
                -46.2088516919547,
                -1.1431617105352905
              ],
              [
                -46.196034308864235,
                -1.1493465936991953
              ],
              [
                -46.182118293197576,
                -1.15325289104013
              ],
              [
                -46.16649329304846,
                -1.1483700569174227
              ],
              [
                -46.15542558519873,
                -1.1261532818437316
              ],
              [
                -46.14708411403614,
                -1.1141903683027337
              ],
              [
                -46.1392309241553,
                -1.1135393437825993
              ],
              [
                -46.136301235953276,
                -1.1260718662253315
              ],
              [
                -46.14452063675017,
                -1.1613908477716386
              ],
              [
                -46.146066861146366,
                -1.1763648624132819
              ],
              [
                -46.13280188679371,
                -1.1639950209647782
              ],
              [
                -46.126820441943856,
                -1.1460913959867354
              ],
              [
                -46.125599738835504,
                -1.1039364316861264
              ],
              [
                -46.12262936084876,
                -1.0953101314798557
              ],
              [
                -46.115712043146175,
                -1.0850562699786246
              ],
              [
                -46.107736783099305,
                -1.0767554820391194
              ],
              [
                -46.1016739571989,
                -1.0733375282076785
              ],
              [
                -46.09390214801164,
                -1.075860285772126
              ],
              [
                -46.09048417910475,
                -1.0824520967949247
              ],
              [
                -46.08836829306091,
                -1.091241153126105
              ],
              [
                -46.084584113931555,
                -1.100518477850538
              ],
              [
                -46.06847083219293,
                -1.1304664319525093
              ],
              [
                -46.064686652921345,
                -1.1476376167777815
              ],
              [
                -46.07408606683514,
                -1.1552059646042223
              ],
              [
                -46.08556067615862,
                -1.1620419473998973
              ],
              [
                -46.09410559777734,
                -1.1783179359795113
              ],
              [
                -46.095326301111676,
                -1.1965471483531813
              ],
              [
                -46.084584114191095,
                -1.2103817949981979
              ],
              [
                -46.072377082238134,
                -1.20159273861791
              ],
              [
                -46.06358802006531,
                -1.1896298250341908
              ],
              [
                -46.05044511603479,
                -1.1626929719215073
              ],
              [
                -46.040598110824,
                -1.1752254943930809
              ],
              [
                -46.039702928735444,
                -1.1871069923497997
              ],
              [
                -46.04426021973728,
                -1.1985002219213066
              ],
              [
                -46.05044511619094,
                -1.2103817949981979
              ],
              [
                -46.03221594984575,
                -1.200778882857706
              ],
              [
                -46.03010006419719,
                -1.1846656503910045
              ],
              [
                -46.03453528598932,
                -1.1657854135060806
              ],
              [
                -46.036203580048365,
                -1.1483700569174227
              ],
              [
                -46.03132076677461,
                -1.138441632545088
              ],
              [
                -46.02330481720295,
                -1.1275367465031763
              ],
              [
                -46.01667233021427,
                -1.1132138315225386
              ],
              [
                -46.01573645713494,
                -1.0936825701809387
              ],
              [
                -46.008900520134915,
                -1.0936825701809387
              ],
              [
                -46.00885982983159,
                -1.098239816924876
              ],
              [
                -46.00739498582074,
                -1.1011695023702905
              ],
              [
                -46.005116339862035,
                -1.103773675556166
              ],
              [
                -46.00267493424092,
                -1.1073544606289105
              ],
              [
                -45.990834113777,
                -1.1042619439460726
              ],
              [
                -45.99313394992627,
                -1.0790903978501132
              ],
              [
                -45.9925834109929,
                -1.0676180059232163
              ],
              [
                -45.97945403192135,
                -1.0550836058466944
              ],
              [
                -45.96415000211922,
                -1.0638607953152228
              ],
              [
                -45.9647014550677,
                -1.072598929324494
              ],
              [
                -45.96108964794607,
                -1.086195562887406
              ],
              [
                -45.96962706922122,
                -1.0867901823059214
              ],
              [
                -45.97443600206081,
                -1.091241153126105
              ],
              [
                -45.9610896482407,
                -1.1073544606289105
              ],
              [
                -45.97191321507943,
                -1.1110979267255776
              ],
              [
                -45.97671464812746,
                -1.1193987146778812
              ],
              [
                -45.981597460251855,
                -1.1415341492328113
              ],
              [
                -45.97191321504407,
                -1.1369768273731797
              ],
              [
                -45.96275794206621,
                -1.1354306065829096
              ],
              [
                -45.95470130079748,
                -1.1368954117547287
              ],
              [
                -45.94806881425169,
                -1.1415341492328113
              ],
              [
                -45.96080481694405,
                -1.1460913959867354
              ],
              [
                -45.99889075394217,
                -1.1517880107605298
              ],
              [
                -46.00267493373293,
                -1.1928036071347772
              ],
              [
                -45.9979548822659,
                -1.2014299824871988
              ],
              [
                -45.9866430327632,
                -1.2040340805787153
              ],
              [
                -45.97297115780349,
                -1.2052547891125758
              ],
              [
                -45.96108964819058,
                -1.2103817949981979
              ],
              [
                -45.95571855399282,
                -1.2199846320365957
              ],
              [
                -45.95596269417817,
                -1.2404110897698413
              ],
              [
                -45.948068813980996,
                -1.2513973914905328
              ],
              [
                -45.93903561114826,
                -1.246270460701
              ],
              [
                -45.93447831897663,
                -1.2400041618889506
              ],
              [
                -45.93492591077299,
                -1.2325171545433207
              ],
              [
                -45.940663214880686,
                -1.2234025858915853
              ],
              [
                -45.93610592401008,
                -1.2227515613680415
              ],
              [
                -45.93301347577054,
                -1.2211239249526415
              ],
              [
                -45.93024654917882,
                -1.219008095251439
              ],
              [
                -45.926380988975666,
                -1.2172177027055058
              ],
              [
                -45.93053137881068,
                -1.200941638988417
              ],
              [
                -45.92332923097199,
                -1.173028249078071
              ],
              [
                -45.91012489392443,
                -1.1409418581192365
              ],
              [
                -45.88988956285855,
                -1.0907451487506268
              ],
              [
                -45.86748691389674,
                -1.0634705411159773
              ],
              [
                -45.85384242195011,
                -1.067859849364677
              ],
              [
                -45.853868819953696,
                -1.1011721311033655
              ],
              [
                -45.885243292851555,
                -1.1408830496051758
              ],
              [
                -45.8900040359926,
                -1.1543921839524867
              ],
              [
                -45.900217252191595,
                -1.167575806047548
              ],
              [
                -45.90587317606174,
                -1.172539980686625
              ],
              [
                -45.907215949921124,
                -1.1975236851372184
              ],
              [
                -45.90587317619036,
                -1.2103817949981979
              ],
              [
                -45.898019985963934,
                -1.183038013978645
              ],
              [
                -45.89183509015131,
                -1.1720517122951788
              ],
              [
                -45.879221158034674,
                -1.1626929719215073
              ],
              [
                -45.88280188722484,
                -1.178806279477759
              ],
              [
                -45.885365363936195,
                -1.1832007701092162
              ],
              [
                -45.87279212111006,
                -1.2022437631407668
              ],
              [
                -45.88060462082322,
                -1.2194149480252612
              ],
              [
                -45.89427649599561,
                -1.2370744764241093
              ],
              [
                -45.89964758988378,
                -1.2575822746873118
              ],
              [
                -45.8738500637539,
                -1.2354468400075131
              ],
              [
                -45.86485755109085,
                -1.2308895932337804
              ],
              [
                -45.864857550995644,
                -1.2370744764241093
              ],
              [
                -45.86847897027396,
                -1.2442359715093476
              ],
              [
                -45.86485755098102,
                -1.2513973914905328
              ],
              [
                -45.86485755088391,
                -1.2575822746873118
              ],
              [
                -45.87092037658899,
                -1.263360230004663
              ],
              [
                -45.881459113873646,
                -1.2776018045781388
              ],
              [
                -45.88536536385452,
                -1.284844640190713
              ],
              [
                -45.862538214917976,
                -1.2731258983068698
              ],
              [
                -45.84666907471728,
                -1.2570125906748957
              ],
              [
                -45.83836829297827,
                -1.2343075470906404
              ],
              [
                -45.83820553298296,
                -1.202894787663649
              ],
              [
                -45.827381965271066,
                -1.2185198268589115
              ],
              [
                -45.820952929190305,
                -1.2417945544369702
              ],
              [
                -45.820546027985465,
                -1.2627906210987558
              ],
              [
                -45.82762610645033,
                -1.2719052648754852
              ],
              [
                -45.84056555847789,
                -1.279554878154279
              ],
              [
                -45.834584114546765,
                -1.2971331412020304
              ],
              [
                -45.82095292925899,
                -1.3156877908428108
              ],
              [
                -45.81090247339686,
                -1.326429995962616
              ],
              [
                -45.81948808458129,
                -1.296156454199696
              ],
              [
                -45.8098038395238,
                -1.2750789718825648
              ],
              [
                -45.79369055915424,
                -1.2676734552490705
              ],
              [
                -45.78294837108022,
                -1.2780087324598182
              ],
              [
                -45.77432206926125,
                -1.2642555013863839
              ],
              [
                -45.768422003943876,
                -1.2287736884249114
              ],
              [
                -45.76244055918974,
                -1.2103817949981979
              ],
              [
                -45.74791419176443,
                -1.2040340805787153
              ],
              [
                -45.721587694152554,
                -1.1349423381923285
              ],
              [
                -45.701039191941135,
                -1.1346981664437137
              ],
              [
                -45.69603430890252,
                -1.1605770671196864
              ],
              [
                -45.72736568899131,
                -1.2256812468307965
              ],
              [
                -45.73452714798104,
                -1.2513973914905328
              ],
              [
                -45.72834225198106,
                -1.2513973914905328
              ],
              [
                -45.726918097720585,
                -1.2470028257375163
              ],
              [
                -45.72150631399567,
                -1.2370744764241093
              ],
              [
                -45.702951954869505,
                -1.2223557492731247
              ],
              [
                -45.68856755682346,
                -1.2021884846395279
              ],
              [
                -45.67965000601887,
                -1.2099554895998057
              ],
              [
                -45.6754049889493,
                -1.2293593701549483
              ],
              [
                -45.67269832691066,
                -1.2441011550555967
              ],
              [
                -45.675047980103365,
                -1.2592300396904794
              ],
              [
                -45.66458851799416,
                -1.2685508512460104
              ],
              [
                -45.65411822454256,
                -1.2743798790951841
              ],
              [
                -45.659571263213685,
                -1.2929922106282083
              ],
              [
                -45.65180882872446,
                -1.2999859925631672
              ],
              [
                -45.651054049457336,
                -1.3174413811346233
              ],
              [
                -45.65610577535139,
                -1.3333479201836882
              ],
              [
                -45.66348406216669,
                -1.3465402547719467
              ],
              [
                -45.67008578404273,
                -1.3539104713065975
              ],
              [
                -45.67553544316413,
                -1.3663164391800784
              ],
              [
                -45.64073645712487,
                -1.370538034323255
              ],
              [
                -45.632313605886736,
                -1.3673641770864788
              ],
              [
                -45.62157141853355,
                -1.3571917310646575
              ],
              [
                -45.61636308469396,
                -1.348321183890888
              ],
              [
                -45.611724412886716,
                -1.3345679527658014
              ],
              [
                -45.610463019933036,
                -1.3200822815049922
              ],
              [
                -45.6151016924171,
                -1.309177395363949
              ],
              [
                -45.62295488219495,
                -1.2959937731748574
              ],
              [
                -45.61998450425567,
                -1.284275031284157
              ],
              [
                -45.61025956926715,
                -1.2756487310021767
              ],
              [
                -45.5980118484481,
                -1.2719052648754852
              ],
              [
                -45.583241340525504,
                -1.2743466819516411
              ],
              [
                -45.579213020237006,
                -1.281508101943971
              ],
              [
                -45.58462480442701,
                -1.2891578654399551
              ],
              [
                -45.59801184776106,
                -1.2924129880689714
              ],
              [
                -45.59410559770615,
                -1.294121965002764
              ],
              [
                -45.59129798119483,
                -1.2959937731748574
              ],
              [
                -45.58824622258821,
                -1.2975399188708068
              ],
              [
                -45.583729621557225,
                -1.2985166058732047
              ],
              [
                -45.58800208226944,
                -1.3070614905464797
              ],
              [
                -45.58946692596505,
                -1.3142229105512135
              ],
              [
                -45.58812415280328,
                -1.3207333060318438
              ],
              [
                -45.58372962139486,
                -1.326429995962616
              ],
              [
                -45.559803839909904,
                -1.2831356632577604
              ],
              [
                -45.543853318630475,
                -1.2702775533493271
              ],
              [
                -45.52969316285564,
                -1.284844640190713
              ],
              [
                -45.54214433458233,
                -1.284763224571677
              ],
              [
                -45.549387174018,
                -1.289727474346651
              ],
              [
                -45.55186927007781,
                -1.2994117270432437
              ],
              [
                -45.55020097609655,
                -1.3121884213523096
              ],
              [
                -45.54515540266343,
                -1.3099911009153462
              ],
              [
                -45.53551184772683,
                -1.308282123980129
              ],
              [
                -45.529693162918335,
                -1.3059221225187088
              ],
              [
                -45.53673255064814,
                -1.3186174012130514
              ],
              [
                -45.54515540319555,
                -1.3274065327531925
              ],
              [
                -45.5510147784723,
                -1.3374977133523547
              ],
              [
                -45.5502009754445,
                -1.3537736269722616
              ],
              [
                -45.54637610599878,
                -1.3511695288603516
              ],
              [
                -45.53652910110645,
                -1.3463681103075342
              ],
              [
                -45.53571529840834,
                -1.3368465386116075
              ],
              [
                -45.525217251826824,
                -1.3248837000509521
              ],
              [
                -45.52285722609649,
                -1.3121884213523096
              ],
              [
                -45.51545162709649,
                -1.3121884213523096
              ],
              [
                -45.51178951736626,
                -1.3536923615662304
              ],
              [
                -45.51231848941946,
                -1.3606096849444302
              ],
              [
                -45.52342688693547,
                -1.385674730153637
              ],
              [
                -45.52928626250491,
                -1.404473626743889
              ],
              [
                -45.529693163216216,
                -1.4157854408276276
              ],
              [
                -45.5139867824745,
                -1.4034969397357786
              ],
              [
                -45.47134355420081,
                -1.3501929920684776
              ],
              [
                -45.4689835278729,
                -1.3431942530749947
              ],
              [
                -45.46849524637705,
                -1.3336728315940576
              ],
              [
                -45.46678626251192,
                -1.3230120420892555
              ],
              [
                -45.46080481709636,
                -1.3121884213523096
              ],
              [
                -45.45327714826863,
                -1.3070614905464797
              ],
              [
                -45.41982988176197,
                -1.2924129880689714
              ],
              [
                -45.447132941761836,
                -1.2924129880689714
              ],
              [
                -45.42837480346164,
                -1.2867977137676165
              ],
              [
                -45.4156794911391,
                -1.287692985150406
              ],
              [
                -45.40851803245005,
                -1.2968074787256951
              ],
              [
                -45.406158007188395,
                -1.3160133031061538
              ],
              [
                -45.407215950319014,
                -1.3253720435528509
              ],
              [
                -45.41197669257156,
                -1.3427060597859355
              ],
              [
                -45.41299394420056,
                -1.3501929920684776
              ],
              [
                -45.41730709466173,
                -1.354180554855595
              ],
              [
                -45.43602454314981,
                -1.353285433682897
              ],
              [
                -45.44029700453145,
                -1.3571917310646575
              ],
              [
                -45.46304277280573,
                -1.3649227599980458
              ],
              [
                -45.46825110617584,
                -1.3674455927058584
              ],
              [
                -45.473052537944085,
                -1.3756649651469468
              ],
              [
                -45.47394772035691,
                -1.3837216565661994
              ],
              [
                -45.47350012876646,
                -1.3921851256600297
              ],
              [
                -45.47447669219693,
                -1.4016252817659016
              ],
              [
                -45.48452714757723,
                -1.4301082809270032
              ],
              [
                -45.486724413218504,
                -1.4471982006170623
              ],
              [
                -45.481312628729164,
                -1.4636369455789058
              ],
              [
                -45.50422115853265,
                -1.4586728459687193
              ],
              [
                -45.5182999345002,
                -1.464532216970626
              ],
              [
                -45.542713996000074,
                -1.4909807270180373
              ],
              [
                -45.53107662729753,
                -1.4896786779516502
              ],
              [
                -45.522206184255,
                -1.4841448192073488
              ],
              [
                -45.51683508934818,
                -1.4752742719683523
              ],
              [
                -45.515451626728954,
                -1.4636369455789058
              ],
              [
                -45.50177975223442,
                -1.4699846600884872
              ],
              [
                -45.49616451669791,
                -1.4808895463296161
              ],
              [
                -45.49864661378492,
                -1.4933407285044693
              ],
              [
                -45.50926673148816,
                -1.5045712772412714
              ],
              [
                -45.49840247302784,
                -1.505140886154977
              ],
              [
                -45.491322394775516,
                -1.5033504935805209
              ],
              [
                -45.48619544252133,
                -1.498711906225141
              ],
              [
                -45.481312629000115,
                -1.4909807270180373
              ],
              [
                -45.46450761575508,
                -1.5005835642058194
              ],
              [
                -45.46141516842025,
                -1.516290019279842
              ],
              [
                -45.46312415315432,
                -1.533135692198566
              ],
              [
                -45.460804816776765,
                -1.5461564833288413
              ],
              [
                -45.44912675767069,
                -1.5280901769470925
              ],
              [
                -45.448231574713276,
                -1.505059470534936
              ],
              [
                -45.45457923153836,
                -1.4600563106525015
              ],
              [
                -45.45103919203544,
                -1.4537085961466858
              ],
              [
                -45.4424942704862,
                -1.443129222188963
              ],
              [
                -45.43211829282398,
                -1.433282138175191
              ],
              [
                -45.423329231164054,
                -1.4288876474850463
              ],
              [
                -45.41808020637544,
                -1.4338517470864798
              ],
              [
                -45.42031816275456,
                -1.4450008801633691
              ],
              [
                -45.42642167898089,
                -1.4568010377794889
              ],
              [
                -45.43293209472946,
                -1.4636369455789058
              ],
              [
                -45.423491990473266,
                -1.4590796236412233
              ],
              [
                -45.40851803327791,
                -1.4454892236686012
              ],
              [
                -45.40274003766077,
                -1.4425594630640586
              ],
              [
                -45.40127519437865,
                -1.437920875725663
              ],
              [
                -45.38573157475586,
                -1.4122046556979764
              ],
              [
                -45.37954667935855,
                -1.3937314215774694
              ],
              [
                -45.35558020733982,
                -1.3495419675406082
              ],
              [
                -45.354644335113335,
                -1.3363583453227137
              ],
              [
                -45.36021887949143,
                -1.3202451127433825
              ],
              [
                -45.346831834609524,
                -1.3117000778507544
              ],
              [
                -45.32616126223742,
                -1.3129208614980192
              ],
              [
                -45.3099666013925,
                -1.326429995962616
              ],
              [
                -45.30728105418229,
                -1.3360328330590272
              ],
              [
                -45.2962947262151,
                -1.4157854408276276
              ],
              [
                -45.30614173155784,
                -1.4113909501419355
              ],
              [
                -45.30996660065091,
                -1.4083797739236366
              ],
              [
                -45.32237708199732,
                -1.4367815076895338
              ],
              [
                -45.34186764218446,
                -1.453057571614936
              ],
              [
                -45.36587480450485,
                -1.4659156816548917
              ],
              [
                -45.39195716125428,
                -1.4841448192073488
              ],
              [
                -45.38573157500006,
                -1.4909807270180373
              ],
              [
                -45.37783769337508,
                -1.4794246660241643
              ],
              [
                -45.3692520825539,
                -1.4728330050779501
              ],
              [
                -45.3601781894721,
                -1.4717750526593176
              ],
              [
                -45.35094153566448,
                -1.4767391522734097
              ],
              [
                -45.35850989537257,
                -1.4893531656850756
              ],
              [
                -45.36510169232656,
                -1.5038388370874831
              ],
              [
                -45.36969967397836,
                -1.5196265575714683
              ],
              [
                -45.371449348642926,
                -1.5353330126640525
              ],
              [
                -45.37873287736727,
                -1.5407854558056406
              ],
              [
                -45.39256751234829,
                -1.5480282915283767
              ],
              [
                -45.40094967452346,
                -1.5601539614872006
              ],
              [
                -45.39195716078587,
                -1.5803361727571161
              ],
              [
                -45.38621985550687,
                -1.564385620971944
              ],
              [
                -45.38499915284708,
                -1.5558407361699584
              ],
              [
                -45.3857315747771,
                -1.5461564833288413
              ],
              [
                -45.351063605874806,
                -1.5599911302465332
              ],
              [
                -45.34019934813599,
                -1.5831845177661714
              ],
              [
                -45.34337317652259,
                -1.6115862518386739
              ],
              [
                -45.355376756862405,
                -1.6542294106445354
              ],
              [
                -45.36139889265541,
                -1.668226888902319
              ],
              [
                -45.36558997345487,
                -1.684747049717911
              ],
              [
                -45.36461341057432,
                -1.7038713087211352
              ],
              [
                -45.358876105611,
                -1.7194149327630204
              ],
              [
                -45.350168423437346,
                -1.7300757225316685
              ],
              [
                -45.338368293384725,
                -1.7378883174821425
              ],
              [
                -45.32363847644161,
                -1.7448056410287465
              ],
              [
                -45.284413214625495,
                -1.7321916274047722
              ],
              [
                -45.27122962115099,
                -1.7216122532557578
              ],
              [
                -45.27647864457515,
                -1.7038713087211352
              ],
              [
                -45.26207434742107,
                -1.6958960327605044
              ],
              [
                -45.22789466152122,
                -1.6830380727434582
              ],
              [
                -45.22126217349533,
                -1.672784060687745
              ],
              [
                -45.22630774528769,
                -1.6565079965348821
              ],
              [
                -45.24941972646707,
                -1.6246884586556294
              ],
              [
                -45.25536048074614,
                -1.6075985387760727
              ],
              [
                -45.2474666007002,
                -1.5792782203313973
              ],
              [
                -45.22728430846314,
                -1.5474585323998085
              ],
              [
                -45.20417233001175,
                -1.525160416327843
              ],
              [
                -45.17967688756701,
                -1.525648759835454
              ],
              [
                -45.175852017456634,
                -1.5004208831790726
              ],
              [
                -45.1631973955553,
                -1.4828427701415086
              ],
              [
                -45.148671027548986,
                -1.4815405708624345
              ],
              [
                -45.1386612624842,
                -1.5045712772412714
              ],
              [
                -45.131825325484115,
                -1.5045712772412714
              ],
              [
                -45.127674934582735,
                -1.486993164199229
              ],
              [
                -45.11583411375584,
                -1.4777971046923475
              ],
              [
                -45.10342363164089,
                -1.472588758218272
              ],
              [
                -45.09772701660158,
                -1.4670548994796828
              ],
              [
                -45.09137936126562,
                -1.4641252890846848
              ],
              [
                -45.0814102858576,
                -1.4716122214195533
              ],
              [
                -45.081206835614545,
                -1.4811337931894215
              ],
              [
                -45.1045629552527,
                -1.4841448192073488
              ],
              [
                -45.078928188412725,
                -1.4835750600810322
              ],
              [
                -45.071848111462835,
                -1.4703915879745812
              ],
              [
                -45.07066809816298,
                -1.4502906422486441
              ],
              [
                -45.06297766816275,
                -1.4288876474850463
              ],
              [
                -45.061512824751425,
                -1.4664038749474115
              ],
              [
                -45.05675208166665,
                -1.4767391522734097
              ],
              [
                -45.04971269339902,
                -1.4821915953952909
              ],
              [
                -45.03868567613081,
                -1.4875627731123369
              ],
              [
                -45.02721106653389,
                -1.4901668712448697
              ],
              [
                -45.01891028613073,
                -1.4875627731123369
              ],
              [
                -45.0067439440758,
                -1.4906552147514374
              ],
              [
                -44.99644934851073,
                -1.508721671304513
              ],
              [
                -44.99803626161348,
                -1.5240210482856962
              ],
              [
                -45.02196204296362,
                -1.5182430928826607
              ],
              [
                -45.009673631450745,
                -1.5332983732256307
              ],
              [
                -44.99522864461794,
                -1.5354142780709363
              ],
              [
                -44.9804581364625,
                -1.5360653026059554
              ],
              [
                -44.96735592377919,
                -1.5461564833288413
              ],
              [
                -44.967355923984236,
                -1.5524227822504542
              ],
              [
                -44.98497473960406,
                -1.5612119139116092
              ],
              [
                -45.00536048077552,
                -1.5675594782462634
              ],
              [
                -45.02037512917711,
                -1.578708611415007
              ],
              [
                -45.02196204335594,
                -1.6008440465355287
              ],
              [
                -45.01573645735592,
                -1.6008440465355287
              ],
              [
                -45.00894120956337,
                -1.582696174256779
              ],
              [
                -44.995838995397776,
                -1.581963734099378
              ],
              [
                -44.96735592462209,
                -1.5940081386774625
              ],
              [
                -44.97175045502687,
                -1.579359635951833
              ],
              [
                -44.967274543468605,
                -1.5646298678330344
              ],
              [
                -44.959462043429625,
                -1.5490862439519708
              ],
              [
                -44.9537247384369,
                -1.531914908535653
              ],
              [
                -44.953846809150235,
                -1.5017229322462997
              ],
              [
                -44.94713294223912,
                -1.492771119591145
              ],
              [
                -44.92638098900009,
                -1.4909807270180373
              ],
              [
                -44.92638098925169,
                -1.4841448192073488
              ],
              [
                -44.93382727825169,
                -1.4841448192073488
              ],
              [
                -44.93382727766753,
                -1.4767391522734097
              ],
              [
                -44.91563880152091,
                -1.4686826110237665
              ],
              [
                -44.89509029943071,
                -1.456231428867424
              ],
              [
                -44.878244594650894,
                -1.441175998381714
              ],
              [
                -44.87120520728718,
                -1.4254696935920044
              ],
              [
                -44.86803137925295,
                -1.4213192995494617
              ],
              [
                -44.861195442589015,
                -1.4269345738927235
              ],
              [
                -44.8543595039243,
                -1.4371070199550777
              ],
              [
                -44.851307746427224,
                -1.4462216638198195
              ],
              [
                -44.84951738242795,
                -1.4762509589805846
              ],
              [
                -44.85130774625125,
                -1.4841448192073488
              ],
              [
                -44.856678840368424,
                -1.4893531656850756
              ],
              [
                -44.87572180859493,
                -1.4984676593650812
              ],
              [
                -44.88536536448151,
                -1.5045712772412714
              ],
              [
                -44.89146887938716,
                -1.5121396252146537
              ],
              [
                -44.89704342434762,
                -1.5280087613269366
              ],
              [
                -44.913075325025936,
                -1.5479468759081065
              ],
              [
                -44.91950436089736,
                -1.562758059631527
              ],
              [
                -44.91978919178811,
                -1.5803361727571161
              ],
              [
                -44.91209876235507,
                -1.6008440465355287
              ],
              [
                -44.92625891827474,
                -1.6011695588043933
              ],
              [
                -44.943918424165496,
                -1.5973446769855892
              ],
              [
                -44.95372473935542,
                -1.6008440465355287
              ],
              [
                -44.939320441617014,
                -1.6110164927077903
              ],
              [
                -44.92174231766397,
                -1.6295712929104824
              ],
              [
                -44.915272589475514,
                -1.6472306715206118
              ],
              [
                -44.93382727862974,
                -1.6554501943171684
              ],
              [
                -44.91812089848045,
                -1.6574846835584756
              ],
              [
                -44.91193600202939,
                -1.6535783861045037
              ],
              [
                -44.90306555946348,
                -1.6246884586556294
              ],
              [
                -44.9037166015636,
                -1.6171201106277193
              ],
              [
                -44.900298632261524,
                -1.6097958592520807
              ],
              [
                -44.88536536435488,
                -1.6008440465355287
              ],
              [
                -44.87315833220308,
                -1.6128883009151498
              ],
              [
                -44.86115475217608,
                -1.630140901828743
              ],
              [
                -44.847401496593015,
                -1.641290035043274
              ],
              [
                -44.830189582041776,
                -1.6349423204646618
              ],
              [
                -44.847401495754866,
                -1.6290015337788863
              ],
              [
                -44.85069739440229,
                -1.6161434236067724
              ],
              [
                -44.84544837069896,
                -1.6006812152944285
              ],
              [
                -44.837025519997134,
                -1.586602471692431
              ],
              [
                -44.8444718089971,
                -1.586602471692431
              ],
              [
                -44.84239661419842,
                -1.581475540803334
              ],
              [
                -44.84007727849345,
                -1.5774065623414446
              ],
              [
                -44.83804277321164,
                -1.5728492403715622
              ],
              [
                -44.837025519448865,
                -1.566094597932911
              ],
              [
                -44.822906053840356,
                -1.5758602664067534
              ],
              [
                -44.81407630159715,
                -1.5912412092868709
              ],
              [
                -44.809966601341614,
                -1.6094703469830252
              ],
              [
                -44.81037350232281,
                -1.6281064125911888
              ],
              [
                -44.80361894368349,
                -1.6093075157418233
              ],
              [
                -44.80288652335421,
                -1.6008440465355287
              ],
              [
                -44.7918188142478,
                -1.6184221597046533
              ],
              [
                -44.7957250638431,
                -1.6300594862080529
              ],
              [
                -44.805083787916374,
                -1.6397437391020817
              ],
              [
                -44.810373501349126,
                -1.6520320901620138
              ],
              [
                -44.80638587099212,
                -1.6594377571792198
              ],
              [
                -44.78795325452116,
                -1.6730283075505785
              ],
              [
                -44.782378709499454,
                -1.6827938258804722
              ],
              [
                -44.7853897775058,
                -1.68417729058419
              ],
              [
                -44.80288652257958,
                -1.7038713087211352
              ],
              [
                -44.79552161380227,
                -1.7101376077085604
              ],
              [
                -44.77749589840564,
                -1.7206357164411619
              ],
              [
                -44.77318274583369,
                -1.724297767049539
              ],
              [
                -44.78636633967633,
                -1.7377254862395286
              ],
              [
                -44.79499264259198,
                -1.7427711517750732
              ],
              [
                -44.80288652314874,
                -1.7516415489573318
              ],
              [
                -44.807687954857315,
                -1.748467691643421
              ],
              [
                -44.8107804026769,
                -1.7477352514777376
              ],
              [
                -44.82404537714884,
                -1.7516415489573318
              ],
              [
                -44.82315019330543,
                -1.7562801363908134
              ],
              [
                -44.82192949103045,
                -1.7592098970555448
              ],
              [
                -44.816517706557285,
                -1.7653133648246297
              ],
              [
                -44.77399654940441,
                -1.7406552469003669
              ],
              [
                -44.76781165250738,
                -1.7269832808438672
              ],
              [
                -44.77554277257985,
                -1.7038713087211352
              ],
              [
                -44.74205481696458,
                -1.7194963483842318
              ],
              [
                -44.72496497342941,
                -1.7234026458559895
              ],
              [
                -44.70787512911838,
                -1.7174618591342101
              ],
              [
                -44.72061113230456,
                -1.7496070597026792
              ],
              [
                -44.75084387951014,
                -1.7731259597948104
              ],
              [
                -44.810373501803696,
                -1.8057593537957946
              ],
              [
                -44.810373502501335,
                -1.813165020893672
              ],
              [
                -44.79515540308586,
                -1.807549746406929
              ],
              [
                -44.756825324320445,
                -1.8018530563008317
              ],
              [
                -44.74449622272358,
                -1.7960751007887796
              ],
              [
                -44.730458137170274,
                -1.7858212388641659
              ],
              [
                -44.72305253785914,
                -1.7912736820986896
              ],
              [
                -44.71735592441635,
                -1.8034807678813647
              ],
              [
                -44.70787512950019,
                -1.813165020893672
              ],
              [
                -44.6793513666601,
                -1.8111305316298976
              ],
              [
                -44.66258704289876,
                -1.7854143109695477
              ],
              [
                -44.654652472511806,
                -1.7497697407321102
              ],
              [
                -44.65269934811824,
                -1.7174618591342101
              ],
              [
                -44.59801184843454,
                -1.7448056410287465
              ],
              [
                -44.614247199982174,
                -1.7536760382123027
              ],
              [
                -44.62523352807156,
                -1.7633602911894204
              ],
              [
                -44.632883266461874,
                -1.775648642355443
              ],
              [
                -44.639027472876656,
                -1.7926571468130814
              ],
              [
                -44.64073645691795,
                -1.8082007709540597
              ],
              [
                -44.640614386311356,
                -1.8218725868778443
              ],
              [
                -44.64476477866166,
                -1.831150062220701
              ],
              [
                -44.659535285227726,
                -1.8335913291702488
              ],
              [
                -44.65953528664998,
                -1.8397763628079766
              ],
              [
                -44.64899654962379,
                -1.8370094333696894
              ],
              [
                -44.63267981772523,
                -1.828057620510127
              ],
              [
                -44.62100175670868,
                -1.8261043966526127
              ],
              [
                -44.612375455653385,
                -1.8297665975023654
              ],
              [
                -44.60680091071777,
                -1.8374976266744352
              ],
              [
                -44.602650520053494,
                -1.8448218781678944
              ],
              [
                -44.598011848169335,
                -1.8472632953332968
              ],
              [
                -44.59186764246883,
                -1.8404273873566723
              ],
              [
                -44.589222785733554,
                -1.8288713260886353
              ],
              [
                -44.58482825436391,
                -1.8179664395915227
              ],
              [
                -44.57323157549864,
                -1.813165020893672
              ],
              [
                -44.56501217346722,
                -1.8184546328955815
              ],
              [
                -44.564442512383756,
                -1.830743134324709
              ],
              [
                -44.56899980377502,
                -1.844414950271508
              ],
              [
                -44.57632402285759,
                -1.8540992033134582
              ],
              [
                -44.570139126554494,
                -1.8609351112971435
              ],
              [
                -44.56236731701367,
                -1.8506812493229259
              ],
              [
                -44.55382239477509,
                -1.844414950271508
              ],
              [
                -44.5465388656281,
                -1.837823138948732
              ],
              [
                -44.54283606670919,
                -1.8261043966526127
              ],
              [
                -44.535755989375886,
                -1.8293596696064243
              ],
              [
                -44.53018144395275,
                -1.8337541604140077
              ],
              [
                -44.52570553364804,
                -1.8397763628079766
              ],
              [
                -44.52171790316903,
                -1.8472632953332968
              ],
              [
                -44.53766842442216,
                -1.8649228244314981
              ],
              [
                -44.57823645650513,
                -1.8868140131344386
              ],
              [
                -44.59064693910051,
                -1.9017880284565425
              ],
              [
                -44.57115637824322,
                -1.9005672447620272
              ],
              [
                -44.536610481483365,
                -1.8918596787258084
              ],
              [
                -44.521717902571055,
                -1.8951148014825814
              ],
              [
                -44.51309160112649,
                -1.9045549579085441
              ],
              [
                -44.506662564173105,
                -1.9200985821816048
              ],
              [
                -44.50259355367787,
                -1.9375952801343006
              ],
              [
                -44.50121008924096,
                -1.9533830011024298
              ],
              [
                -44.49913489517931,
                -1.9615211084620308
              ],
              [
                -44.49022376156122,
                -1.977959854016119
              ],
              [
                -44.48814856753012,
                -1.9874814261270188
              ],
              [
                -44.4902237623165,
                -1.9953752866403
              ],
              [
                -44.49469967377599,
                -2.000095289783425
              ],
              [
                -44.49913489451274,
                -2.003838756092744
              ],
              [
                -44.50121008984656,
                -2.008396078206502
              ],
              [
                -44.50959225142611,
                -2.0155574985525093
              ],
              [
                -44.52855384003448,
                -2.017754819094953
              ],
              [
                -44.54938717412364,
                -2.0160458420774607
              ],
              [
                -44.56330318957085,
                -2.0116513512068894
              ],
              [
                -44.57457434829399,
                -2.0240211182323344
              ],
              [
                -44.588124152168504,
                -2.0306941950620163
              ],
              [
                -44.61729895624917,
                -2.0389949835060466
              ],
              [
                -44.61143958185666,
                -2.039808839311465
              ],
              [
                -44.606800910856656,
                -2.039808839311465
              ],
              [
                -44.602650519864966,
                -2.0411923040527897
              ],
              [
                -44.59801184860889,
                -2.0458310418038654
              ],
              [
                -44.5809626945053,
                -2.034763323873471
              ],
              [
                -44.561350064350314,
                -2.0295549771913235
              ],
              [
                -44.54100501244796,
                -2.02922946491209
              ],
              [
                -44.521717903378224,
                -2.0323219066717595
              ],
              [
                -44.504505989475994,
                -2.0319963943924626
              ],
              [
                -44.49624589742045,
                -2.0355770294652613
              ],
              [
                -44.49437415360746,
                -2.0458310418038654
              ],
              [
                -44.50055904959539,
                -2.0544573425383117
              ],
              [
                -44.53538977865894,
                -2.0800107324986374
              ],
              [
                -44.55406653622864,
                -2.0871721528876077
              ],
              [
                -44.578846808971306,
                -2.122328380548103
              ],
              [
                -44.60789954297577,
                -2.1537411419576995
              ],
              [
                -44.63902747272252,
                -2.1488583075050918
              ],
              [
                -44.64525305836829,
                -2.1556942156540138
              ],
              [
                -44.63219153677657,
                -2.1597633445090674
              ],
              [
                -44.61644446545733,
                -2.1593564166021597
              ],
              [
                -44.603382941799126,
                -2.157159096033127
              ],
              [
                -44.59801184736899,
                -2.1556942156540138
              ],
              [
                -44.588612433887945,
                -2.165459884567256
              ],
              [
                -44.59430904972225,
                -2.1742490166390587
              ],
              [
                -44.61729895640855,
                -2.1898739066740545
              ],
              [
                -44.655425585376136,
                -2.2311337528673842
              ],
              [
                -44.676258918799526,
                -2.2398414693665356
              ],
              [
                -44.70787512869609,
                -2.2375627331569916
              ],
              [
                -44.701039191330054,
                -2.2443986413604025
              ],
              [
                -44.69749915315915,
                -2.250420843960917
              ],
              [
                -44.693592902886046,
                -2.2655575407816726
              ],
              [
                -44.733265753206375,
                -2.253350454531049
              ],
              [
                -44.75137285063546,
                -2.252048405388672
              ],
              [
                -44.76968339793105,
                -2.259698169422322
              ],
              [
                -44.784738735547066,
                -2.2751603785423486
              ],
              [
                -44.80117753876568,
                -2.2857399033846315
              ],
              [
                -44.82404537615609,
                -2.2792293572281492
              ],
              [
                -44.80431067584379,
                -2.291436443508149
              ],
              [
                -44.759429490655535,
                -2.2748348662560804
              ],
              [
                -44.71784420488602,
                -2.2655575407816726
              ],
              [
                -44.707875128926666,
                -2.2997372321438645
              ],
              [
                -44.700510219926706,
                -2.2997372321438645
              ],
              [
                -44.69322669287216,
                -2.285414391098045
              ],
              [
                -44.6792699859801,
                -2.273858329397351
              ],
              [
                -44.66563880192548,
                -2.270928718821672
              ],
              [
                -44.659535286839045,
                -2.2826474615558046
              ],
              [
                -44.6618546201268,
                -2.296481959060859
              ],
              [
                -44.667469855990376,
                -2.305271091237938
              ],
              [
                -44.674183723076666,
                -2.3121884151095817
              ],
              [
                -44.68000240849978,
                -2.3208961316744565
              ],
              [
                -44.688099738197415,
                -2.343438345813022
              ],
              [
                -44.69212805903414,
                -2.348077083689972
              ],
              [
                -44.7042130200311,
                -2.3580868494399065
              ],
              [
                -44.71084550647265,
                -2.3683407118630275
              ],
              [
                -44.71519934740603,
                -2.3928361500573576
              ],
              [
                -44.72093665216524,
                -2.402113475644459
              ],
              [
                -44.71410071574297,
                -2.4089495341680722
              ],
              [
                -44.71129309894489,
                -2.3969052790022305
              ],
              [
                -44.707183397922975,
                -2.3884416590376314
              ],
              [
                -44.701405402276094,
                -2.3817684317792014
              ],
              [
                -44.67430579283133,
                -2.360121338798614
              ],
              [
                -44.66397050702109,
                -2.3567033846591428
              ],
              [
                -44.65953528632941,
                -2.3643531487683758
              ],
              [
                -44.66470292899959,
                -2.4039852839734177
              ],
              [
                -44.663482226188016,
                -2.420586861431357
              ],
              [
                -44.65269934759643,
                -2.429457259126652
              ],
              [
                -44.65558834483727,
                -2.420179933514526
              ],
              [
                -44.6562393872692,
                -2.4074846537545325
              ],
              [
                -44.654164192797175,
                -2.3944638617204452
              ],
              [
                -44.644032356672675,
                -2.3747698424490724
              ],
              [
                -44.64598548158515,
                -2.366469053753931
              ],
              [
                -44.650257942263316,
                -2.358819289643146
              ],
              [
                -44.65269934840923,
                -2.35125094116347
              ],
              [
                -44.65225175612865,
                -2.327894720968314
              ],
              [
                -44.649769661250474,
                -2.308770460985784
              ],
              [
                -44.643544075048915,
                -2.2907854189346577
              ],
              [
                -44.631581183733225,
                -2.2717424244303954
              ],
              [
                -44.58482825469342,
                -2.2301572160125733
              ],
              [
                -44.57323157443935,
                -2.22405359779871
              ],
              [
                -44.56224524616723,
                -2.221775011805784
              ],
              [
                -44.55402584415091,
                -2.2164038337900203
              ],
              [
                -44.54283606750815,
                -2.2035458732392517
              ],
              [
                -44.54515540244101,
                -2.204034066558806
              ],
              [
                -44.54283606640954,
                -2.1898739066740545
              ],
              [
                -44.53978430835938,
                -2.1857235123972063
              ],
              [
                -44.53327389236734,
                -2.181084924803349
              ],
              [
                -44.5291641921111,
                -2.1762020903388968
              ],
              [
                -44.49730384001941,
                -2.1478817706574818
              ],
              [
                -44.46165930826752,
                -2.144626497619411
              ],
              [
                -44.42711341096181,
                -2.162367442772245
              ],
              [
                -44.39879309865355,
                -2.1973609896290895
              ],
              [
                -44.3897598953461,
                -2.2183570577105987
              ],
              [
                -44.38560950402505,
                -2.2379696610667748
              ],
              [
                -44.384510870882366,
                -2.275567306453506
              ],
              [
                -44.38182532468937,
                -2.277601795796298
              ],
              [
                -44.368967251413565,
                -2.292738492655284
              ],
              [
                -44.36465410092722,
                -2.2997372321438645
              ],
              [
                -44.36245683427463,
                -2.310316606797213
              ],
              [
                -44.36359615798255,
                -2.333916923615913
              ],
              [
                -44.37340247280552,
                -2.3773739407642074
              ],
              [
                -44.38231360668054,
                -2.3947893740104287
              ],
              [
                -44.39537512817134,
                -2.402113475644459
              ],
              [
                -44.430734830939556,
                -2.4069150447996828
              ],
              [
                -44.453439908268024,
                -2.4074846537545325
              ],
              [
                -44.473947719169885,
                -2.402113475644459
              ],
              [
                -44.480213995117914,
                -2.396579616498848
              ],
              [
                -44.490712043771026,
                -2.3830706311508933
              ],
              [
                -44.497792120726054,
                -2.3804663826209724
              ],
              [
                -44.50011145715954,
                -2.3791643334629216
              ],
              [
                -44.50381425712652,
                -2.376397403895949
              ],
              [
                -44.50719153574963,
                -2.3732235464147666
              ],
              [
                -44.508656378962314,
                -2.371189057053489
              ],
              [
                -44.510650194361304,
                -2.367120078332117
              ],
              [
                -44.51545162727314,
                -2.3688290554034492
              ],
              [
                -44.52098548188303,
                -2.3727353530874895
              ],
              [
                -44.538075325961316,
                -2.379652677003852
              ],
              [
                -44.55142167805199,
                -2.391045757356252
              ],
              [
                -44.562977668235085,
                -2.4047177241798883
              ],
              [
                -44.57013912714365,
                -2.416436467064334
              ],
              [
                -44.523345507370934,
                -2.3871396098785755
              ],
              [
                -44.507435675946255,
                -2.3898251238226567
              ],
              [
                -44.50121009006396,
                -2.4195289089329433
              ],
              [
                -44.51085364543635,
                -2.4699846660508453
              ],
              [
                -44.521595832924454,
                -2.5000953793193164
              ],
              [
                -44.53538977807749,
                -2.518243102780981
              ],
              [
                -44.54710852645599,
                -2.5214168100949332
              ],
              [
                -44.55626380098487,
                -2.519952079878114
              ],
              [
                -44.56517493507036,
                -2.521172863641011
              ],
              [
                -44.57632402159033,
                -2.532484528528428
              ],
              [
                -44.588042771706675,
                -2.5621883140678476
              ],
              [
                -44.59434973919611,
                -2.5665829553782737
              ],
              [
                -44.61294511745485,
                -2.570245156471822
              ],
              [
                -44.637074349090426,
                -2.5798479945224253
              ],
              [
                -44.655995244345284,
                -2.5931941488859507
              ],
              [
                -44.6595352872233,
                -2.608168315393711
              ],
              [
                -44.64476477951554,
                -2.5930316180576543
              ],
              [
                -44.59902909960688,
                -2.5739070571401497
              ],
              [
                -44.58006751071737,
                -2.5635717788771983
              ],
              [
                -44.57127845170477,
                -2.5523415295803575
              ],
              [
                -44.567453579185276,
                -2.54225019779517
              ],
              [
                -44.5614314426248,
                -2.5352514581387706
              ],
              [
                -44.54625403459129,
                -2.532484528528428
              ],
              [
                -44.540394661089486,
                -2.5382626346309403
              ],
              [
                -44.545033331276336,
                -2.5505509866370493
              ],
              [
                -44.55284583214901,
                -2.5624325609494845
              ],
              [
                -44.55650794219594,
                -2.5665829553782737
              ],
              [
                -44.60753333378964,
                -2.6696917920947514
              ],
              [
                -44.631581183666114,
                -2.696954010498173
              ],
              [
                -44.625233527790684,
                -2.7066382643085323
              ],
              [
                -44.62694251044081,
                -2.7188452009084987
              ],
              [
                -44.63902747406111,
                -2.7448056706790744
              ],
              [
                -44.6462296218744,
                -2.768243157304693
              ],
              [
                -44.647694464075215,
                -2.7872860025738047
              ],
              [
                -44.64525305789041,
                -2.8307430218030216
              ],
              [
                -44.650135872848146,
                -2.854669002438368
              ],
              [
                -44.68614661516675,
                -2.9166806742087257
              ],
              [
                -44.6873266290808,
                -2.924411854411114
              ],
              [
                -44.68614661464638,
                -2.9538713943643495
              ],
              [
                -44.687367316459564,
                -2.96542730669369
              ],
              [
                -44.69249426865655,
                -2.9846329836667875
              ],
              [
                -44.69359290099175,
                -2.9948868467932055
              ],
              [
                -44.68431556025063,
                -3.0126279437503265
              ],
              [
                -44.66295325205435,
                -3.0176733094847514
              ],
              [
                -44.63975989717215,
                -3.0189756591612644
              ],
              [
                -44.6247452441651,
                -3.025974098776005
              ],
              [
                -44.62222245964022,
                -3.051039297964591
              ],
              [
                -44.63975989491387,
                -3.0690243415144463
              ],
              [
                -44.661732549190816,
                -3.0832657681604254
              ],
              [
                -44.672515428240786,
                -3.0979142729932745
              ],
              [
                -44.67674719945971,
                -3.1117489219558974
              ],
              [
                -44.68683834488241,
                -3.1207821516109195
              ],
              [
                -44.6984757161055,
                -3.1278623073744813
              ],
              [
                -44.70787512798184,
                -3.1358374342502375
              ],
              [
                -44.71182207010168,
                -3.1451149108313348
              ],
              [
                -44.71715247135305,
                -3.168877760696895
              ],
              [
                -44.72093665404899,
                -3.1768531880414965
              ],
              [
                -44.74058997220982,
                -3.186944220150306
              ],
              [
                -44.763050912281805,
                -3.1906878371445857
              ],
              [
                -44.78156490967238,
                -3.196954137065771
              ],
              [
                -44.78921464764823,
                -3.2146135184179583
              ],
              [
                -44.787098762239204,
                -3.2333310026223097
              ],
              [
                -44.781158005510285,
                -3.251722824337451
              ],
              [
                -44.77232825601006,
                -3.2694639218783053
              ],
              [
                -44.76130123828395,
                -3.2860655010082116
              ],
              [
                -44.79600989489066,
                -3.3002255124223936
              ],
              [
                -44.76158606580125,
                -3.305596540882204
              ],
              [
                -44.75373287643068,
                -3.2898088176249662
              ],
              [
                -44.761301236616525,
                -3.2382138376583196
              ],
              [
                -44.75519771974046,
                -3.220147378083539
              ],
              [
                -44.74278723682121,
                -3.207451946941394
              ],
              [
                -44.72541256627888,
                -3.1998024825249765
              ],
              [
                -44.679554817468706,
                -3.1940243759743616
              ],
              [
                -44.65998287475212,
                -3.18466548370133
              ],
              [
                -44.64435787622191,
                -3.169691616600262
              ],
              [
                -44.63158118206481,
                -3.1495092520143033
              ],
              [
                -44.61359615913854,
                -3.111993168853106
              ],
              [
                -44.60008704205452,
                -3.104099157207284
              ],
              [
                -44.57323157626242,
                -3.101657889944693
              ],
              [
                -44.529164189982545,
                -3.03215898293424
              ],
              [
                -44.481922979726924,
                -3.0074194463296573
              ],
              [
                -44.47394772216728,
                -3.001723055977989
              ],
              [
                -44.46861731487962,
                -2.9865860575336813
              ],
              [
                -44.43297278578381,
                -2.9502906087429466
              ],
              [
                -44.42418372335014,
                -2.9345028862015625
              ],
              [
                -44.41543535265271,
                -2.9139951601111886
              ],
              [
                -44.408843552961585,
                -2.8921850844141854
              ],
              [
                -44.406239384885424,
                -2.8720027205202516
              ],
              [
                -44.40807044368261,
                -2.8263486807912557
              ],
              [
                -44.40428626311946,
                -2.8048642678353115
              ],
              [
                -44.39195716221181,
                -2.793145524465933
              ],
              [
                -44.39533443683543,
                -2.7891576607659645
              ],
              [
                -44.39708411382247,
                -2.785332928752864
              ],
              [
                -44.39997311103558,
                -2.7819149744605602
              ],
              [
                -44.40623938546487,
                -2.778903797888622
              ],
              [
                -44.370961068512365,
                -2.6675758870431676
              ],
              [
                -44.364654101010615,
                -2.6286760407731546
              ],
              [
                -44.36107337014619,
                -2.6368139984352803
              ],
              [
                -44.358550585472756,
                -2.6446265940195373
              ],
              [
                -44.35732988159164,
                -2.6527645516956957
              ],
              [
                -44.35781816469043,
                -2.6627744679715
              ],
              [
                -44.35098222769016,
                -2.6627744679715
              ],
              [
                -44.36807207066023,
                -2.549574599965079
              ],
              [
                -44.35749264016243,
                -2.5365535073172403
              ],
              [
                -44.35265051878403,
                -2.5290665743300655
              ],
              [
                -44.3452042309381,
                -2.5258114513867085
              ],
              [
                -44.326486782694374,
                -2.525079011171268
              ],
              [
                -44.31224524529677,
                -2.5319149195663777
              ],
              [
                -44.30186927068589,
                -2.5480283039035476
              ],
              [
                -44.28892981640436,
                -2.5802547722325744
              ],
              [
                -44.288238085486896,
                -2.5514462581086526
              ],
              [
                -44.291981576057324,
                -2.539808930690882
              ],
              [
                -44.302601690599,
                -2.532484528528428
              ],
              [
                -44.29979407652665,
                -2.5212542792678714
              ],
              [
                -44.301096157488146,
                -2.508477433538462
              ],
              [
                -44.30064856726208,
                -2.49480561678599
              ],
              [
                -44.29263261655941,
                -2.481052384426098
              ],
              [
                -44.278960741489946,
                -2.4755185252369003
              ],
              [
                -44.22008216178672,
                -2.4703915939697247
              ],
              [
                -44.111480273353145,
                -2.4157854424829805
              ],
              [
                -44.08287512914208,
                -2.416436467064334
              ],
              [
                -44.07298743405511,
                -2.399509377323014
              ],
              [
                -44.0530492838536,
                -2.399997720864899
              ],
              [
                -44.03441321410602,
                -2.41521568331435
              ],
              [
                -44.0289200513414,
                -2.4430478103759836
              ],
              [
                -44.04637610685775,
                -2.4386533193344766
              ],
              [
                -44.071400519588096,
                -2.4380835601645354
              ],
              [
                -44.09215247369095,
                -2.4434547382937812
              ],
              [
                -44.097157355583875,
                -2.456719627056791
              ],
              [
                -44.069732225627675,
                -2.4608700214405053
              ],
              [
                -44.06362870988838,
                -2.462985926446213
              ],
              [
                -44.060617641862805,
                -2.4716122275130776
              ],
              [
                -44.0601293617301,
                -2.494887032412647
              ],
              [
                -44.056223111158246,
                -2.5051408949752676
              ],
              [
                -44.055653449436626,
                -2.4943172732394747
              ],
              [
                -44.05435136662564,
                -2.4865862436183743
              ],
              [
                -44.04938717478371,
                -2.4703915939697247
              ],
              [
                -44.041900194783544,
                -2.4703915939697247
              ],
              [
                -44.03433183478091,
                -2.4933407363598428
              ],
              [
                -44.032704230318124,
                -2.51327885253171
              ],
              [
                -44.03746497113255,
                -2.532403112901466
              ],
              [
                -44.04938717497342,
                -2.552911138543591
              ],
              [
                -44.0655411450064,
                -2.5513648424815254
              ],
              [
                -44.08287512887775,
                -2.560316655922175
              ],
              [
                -44.09715735540693,
                -2.5802547722325744
              ],
              [
                -44.10334225384457,
                -2.583428779993706
              ],
              [
                -44.11025957038667,
                -2.584730829178766
              ],
              [
                -44.11758378942374,
                -2.5874977588042607
              ],
              [
                -44.124419727994784,
                -2.594496498499005
              ],
              [
                -44.10655676920341,
                -2.6023087936211464
              ],
              [
                -44.11107337238042,
                -2.6220029635637907
              ],
              [
                -44.13719641854947,
                -2.6701799854369765
              ],
              [
                -44.15103105196824,
                -2.6801081856768696
              ],
              [
                -44.167144334533205,
                -2.687269756698144
              ],
              [
                -44.179676887069824,
                -2.690118101982584
              ],
              [
                -44.19107011704387,
                -2.6888974684110387
              ],
              [
                -44.1978246732661,
                -2.685153851642502
              ],
              [
                -44.21385657701631,
                -2.669040767496248
              ],
              [
                -44.210316534777505,
                -2.6864559008418234
              ],
              [
                -44.20669511683817,
                -2.6923154226677326
              ],
              [
                -44.20018469966934,
                -2.696954010498173
              ],
              [
                -44.212228972047114,
                -2.707696367052163
              ],
              [
                -44.239857552649575,
                -2.7145322755810084
              ],
              [
                -44.251698370733735,
                -2.7211239372292604
              ],
              [
                -44.27993730535259,
                -2.7483050405858593
              ],
              [
                -44.28551184788842,
                -2.752211188211813
              ],
              [
                -44.313099740551216,
                -2.7621396889688707
              ],
              [
                -44.33849036560643,
                -2.784926151033542
              ],
              [
                -44.34850012917429,
                -2.8102352959626393
              ],
              [
                -44.32994544111432,
                -2.8273250674929327
              ],
              [
                -44.3283585288521,
                -2.804131827597595
              ],
              [
                -44.3227432912912,
                -2.7850886818652603
              ],
              [
                -44.31248938877625,
                -2.7787412670570184
              ],
              [
                -44.29637610720916,
                -2.793145524465933
              ],
              [
                -44.30553137917411,
                -2.8102352959626393
              ],
              [
                -44.310047980187164,
                -2.81422285924558
              ],
              [
                -44.310047980530825,
                -2.8204891588767618
              ],
              [
                -44.29637610468283,
                -2.8341609761144717
              ],
              [
                -44.288929817373074,
                -2.8068173416606164
              ],
              [
                -44.284047005381765,
                -2.8055967080730917
              ],
              [
                -44.27717037789093,
                -2.806898757290021
              ],
              [
                -44.27106686009882,
                -2.807305535010348
              ],
              [
                -44.268462694585985,
                -2.8033993873599417
              ],
              [
                -44.2678116531521,
                -2.790215763519379
              ],
              [
                -44.26549231702327,
                -2.780531509618196
              ],
              [
                -44.26146399413285,
                -2.7726374982872226
              ],
              [
                -44.25544186081852,
                -2.7653133963664462
              ],
              [
                -44.24616451514492,
                -2.7740209631283785
              ],
              [
                -44.22008216220711,
                -2.793145524465933
              ],
              [
                -44.226144985208975,
                -2.7769507240695384
              ],
              [
                -44.2183731781246,
                -2.7677549639571364
              ],
              [
                -44.18651282448137,
                -2.759047096774716
              ],
              [
                -44.18854733202133,
                -2.7780902424506273
              ],
              [
                -44.17471269592246,
                -2.8070615885488177
              ],
              [
                -44.18309485533217,
                -2.823907113184179
              ],
              [
                -44.19115149695582,
                -2.829685219471342
              ],
              [
                -44.20702063778239,
                -2.8358701034840603
              ],
              [
                -44.21385657326707,
                -2.840996884741456
              ],
              [
                -44.21886145743343,
                -2.8482398715227792
              ],
              [
                -44.218495246741725,
                -2.8517392414710008
              ],
              [
                -44.21410071574163,
                -2.8517392414710008
              ],
              [
                -44.20702063847943,
                -2.8484027027823524
              ],
              [
                -44.20494544043322,
                -2.853448068417391
              ],
              [
                -44.20246334297444,
                -2.857517047350181
              ],
              [
                -44.20055091163437,
                -2.862074520064424
              ],
              [
                -44.200184700202314,
                -2.8689104287136598
              ],
              [
                -44.16665605558251,
                -2.838067424205429
              ],
              [
                -44.15925045411772,
                -2.8273250674929327
              ],
              [
                -44.15587317591551,
                -2.8295223882121254
              ],
              [
                -44.15477454447483,
                -2.829766635100963
              ],
              [
                -44.15396074274126,
                -2.8304990753408297
              ],
              [
                -44.151763474687144,
                -2.8341609761144717
              ],
              [
                -44.1414688780289,
                -2.8204077432472427
              ],
              [
                -44.13272050911713,
                -2.8036436342480413
              ],
              [
                -44.12669837007421,
                -2.7859025377305877
              ],
              [
                -44.12441972712575,
                -2.7689755975394323
              ],
              [
                -44.11807206896515,
                -2.757745047564873
              ],
              [
                -44.10602779986626,
                -2.7496070897943157
              ],
              [
                -44.09813391759117,
                -2.748711818303476
              ],
              [
                -44.10460364448237,
                -2.759047096774716
              ],
              [
                -44.10460364481912,
                -2.7653133963664462
              ],
              [
                -44.09264075250181,
                -2.7616511951949745
              ],
              [
                -44.08897864448255,
                -2.759047096774716
              ],
              [
                -44.08287512888894,
                -2.752211188211813
              ],
              [
                -44.07664954248267,
                -2.759047096774716
              ],
              [
                -44.0794571625952,
                -2.766290083487988
              ],
              [
                -44.079660609848936,
                -2.7693009596289166
              ],
              [
                -44.078358527397086,
                -2.7721493049394503
              ],
              [
                -44.076649541476264,
                -2.778903797888622
              ],
              [
                -44.074208135886586,
                -2.772067889310364
              ],
              [
                -44.07262122412445,
                -2.7689755975394323
              ],
              [
                -44.06981360581923,
                -2.7653133963664462
              ],
              [
                -44.06867428248521,
                -2.779066629146897
              ],
              [
                -44.0719294908888,
                -2.7894833232828966
              ],
              [
                -44.08287512937134,
                -2.8068173416606164
              ],
              [
                -44.0681046219794,
                -2.79518001391792
              ],
              [
                -44.062855597723036,
                -2.777032139698663
              ],
              [
                -44.063628708912795,
                -2.734795754312624
              ],
              [
                -44.06037350192888,
                -2.7177059829616637
              ],
              [
                -44.052479621475065,
                -2.7019182608447054
              ],
              [
                -44.03571529987702,
                -2.6764462849668007
              ],
              [
                -44.022938607009685,
                -2.648858404112641
              ],
              [
                -44.0141495418778,
                -2.6346980933912536
              ],
              [
                -43.98399817560633,
                -2.615492417187863
              ],
              [
                -43.98045813800438,
                -2.6115862696204823
              ],
              [
                -43.975900846464974,
                -2.610284220431733
              ],
              [
                -43.946359830010536,
                -2.6286760407731546
              ],
              [
                -43.94635983112581,
                -2.6212705233409337
              ],
              [
                -43.9577530607386,
                -2.612400125470225
              ],
              [
                -43.958363412825946,
                -2.6006813823501767
              ],
              [
                -43.94635982909391,
                -2.5739884727674553
              ],
              [
                -43.93260657696128,
                -2.5558408994141297
              ],
              [
                -43.92324785260724,
                -2.546807670350602
              ],
              [
                -43.91905677164345,
                -2.549574599965079
              ],
              [
                -43.89175371085615,
                -2.600518551095095
              ],
              [
                -43.87804114533271,
                -2.6349423402747605
              ],
              [
                -43.87437903400581,
                -2.622816518987766
              ],
              [
                -43.87726803207595,
                -2.611260607109937
              ],
              [
                -43.88223222754993,
                -2.598565477314305
              ],
              [
                -43.884877081223124,
                -2.5836727264492314
              ],
              [
                -43.879465298060815,
                -2.571221543145917
              ],
              [
                -43.853260869217145,
                -2.5593399688225285
              ],
              [
                -43.84631565079615,
                -2.5563384059771614
              ],
              [
                -43.838531054309065,
                -2.556247677123274
              ],
              [
                -43.83405514276083,
                -2.554945627942119
              ],
              [
                -43.827618414241606,
                -2.551052699173136
              ],
              [
                -43.821384265610746,
                -2.5510539008798085
              ],
              [
                -43.81574459595709,
                -2.55152767373578
              ],
              [
                -43.80492102775273,
                -2.549248937456671
              ],
              [
                -43.78184973761546,
                -2.532484528528428
              ],
              [
                -43.76695715976664,
                -2.5262996447214787
              ],
              [
                -43.752797005543606,
                -2.524021208875008
              ],
              [
                -43.74640865774312,
                -2.529229405583926
              ],
              [
                -43.738564181115194,
                -2.5172073818455076
              ],
              [
                -43.740101692507636,
                -2.4869117559113474
              ],
              [
                -43.72411048139421,
                -2.4772275023265653
              ],
              [
                -43.71251380095266,
                -2.4885393173764037
              ],
              [
                -43.70653235660099,
                -2.5138486117059635
              ],
              [
                -43.708566861571,
                -2.539727515063869
              ],
              [
                -43.721058723966166,
                -2.552911138543591
              ],
              [
                -43.72105872287875,
                -2.560316655922175
              ],
              [
                -43.71361243387874,
                -2.560316655922175
              ],
              [
                -43.71361243496598,
                -2.552911138543591
              ],
              [
                -43.70669511696585,
                -2.552911138543591
              ],
              [
                -43.70669511587879,
                -2.560316655922175
              ],
              [
                -43.699289516878814,
                -2.560316655922175
              ],
              [
                -43.699126758208486,
                -2.553643578761143
              ],
              [
                -43.69762122133232,
                -2.5490046905753525
              ],
              [
                -43.69310461922295,
                -2.539320436928766
              ],
              [
                -43.68464108179314,
                -2.5433897161471504
              ],
              [
                -43.67674719853129,
                -2.545586736371125
              ],
              [
                -43.6583145838283,
                -2.546156645760648
              ],
              [
                -43.68097897161271,
                -2.5295550680916596
              ],
              [
                -43.682443813337215,
                -2.5046525514282427
              ],
              [
                -43.66844641777191,
                -2.4833309704758797
              ],
              [
                -43.64464270739352,
                -2.4772275023265653
              ],
              [
                -43.6519669260323,
                -2.48544687548637
              ],
              [
                -43.657338019090446,
                -2.4939103453196285
              ],
              [
                -43.66576087076825,
                -2.5119768033563568
              ],
              [
                -43.65241451688429,
                -2.5016415251598407
              ],
              [
                -43.63573157553029,
                -2.498304986598987
              ],
              [
                -43.62197831811005,
                -2.5053035760153977
              ],
              [
                -43.61733964769923,
                -2.525079011171268
              ],
              [
                -43.597482877280754,
                -2.5162086133902006
              ],
              [
                -43.558176237163146,
                -2.5308571172693664
              ],
              [
                -43.54222571469973,
                -2.525079011171268
              ],
              [
                -43.548451301075815,
                -2.518243102780981
              ],
              [
                -43.56045488220069,
                -2.5193010552899664
              ],
              [
                -43.56305904862094,
                -2.509535386046379
              ],
              [
                -43.55825761593042,
                -2.495782153665775
              ],
              [
                -43.548451300333355,
                -2.4846330196474034
              ],
              [
                -43.548451301156426,
                -2.5051408949752676
              ],
              [
                -43.53913326605995,
                -2.491143415721029
              ],
              [
                -43.536732551067345,
                -2.4782040392045945
              ],
              [
                -43.54210364560473,
                -2.4665667118743144
              ],
              [
                -43.55589758958899,
                -2.456719627056791
              ],
              [
                -43.537342902350694,
                -2.435967655164121
              ],
              [
                -43.52367102799299,
                -2.4426408824582366
              ],
              [
                -43.51748613122921,
                -2.4649390001995606
              ],
              [
                -43.52183997391299,
                -2.4914690782274773
              ],
              [
                -43.50841223887344,
                -2.491631759267379
              ],
              [
                -43.49982662529624,
                -2.5248347642905986
              ],
              [
                -43.48704993262477,
                -2.532484528528428
              ],
              [
                -43.49449622482144,
                -2.546156645760648
              ],
              [
                -43.48420162668596,
                -2.543715078228696
              ],
              [
                -43.47695878877329,
                -2.5376930256685593
              ],
              [
                -43.47154700583347,
                -2.5289040435028762
              ],
              [
                -43.46654212107564,
                -2.518243102780981
              ],
              [
                -43.45836341267601,
                -2.5350889273114667
              ],
              [
                -43.45287024696022,
                -2.552911138543591
              ],
              [
                -43.44562740629895,
                -2.544854296154209
              ],
              [
                -43.4442032551601,
                -2.5308571172693664
              ],
              [
                -43.44806881426918,
                -2.5148251485876436
              ],
              [
                -43.46540279835762,
                -2.486016484445685
              ],
              [
                -43.4525040365829,
                -2.483819314021848
              ],
              [
                -43.41877193991085,
                -2.4914690782274773
              ],
              [
                -43.41877193833534,
                -2.4846330196474034
              ],
              [
                -43.43504798053755,
                -2.48259853026362
              ],
              [
                -43.44725501186468,
                -2.4716122275130776
              ],
              [
                -43.45547441303439,
                -2.4568010426831295
              ],
              [
                -43.459787564337,
                -2.4430478103759836
              ],
              [
                -43.452870246336914,
                -2.4430478103759836
              ],
              [
                -43.44810950375768,
                -2.451918208091125
              ],
              [
                -43.43862870959009,
                -2.456719627056791
              ],
              [
                -43.42609615805741,
                -2.458184507477519
              ],
              [
                -43.41193600159036,
                -2.456719627056791
              ],
              [
                -43.4280899733137,
                -2.4416643455837064
              ],
              [
                -43.47402910069861,
                -2.417738516227143
              ],
              [
                -43.48704993356379,
                -2.3952775673387485
              ],
              [
                -43.482736782710134,
                -2.379082917837232
              ],
              [
                -43.47529216541007,
                -2.365923478934391
              ],
              [
                -43.46736941529121,
                -2.3536855988351126
              ],
              [
                -43.467372921113395,
                -2.3457672532977707
              ],
              [
                -43.45440102096589,
                -2.341448770243548
              ],
              [
                -43.44142936158507,
                -2.339290054463779
              ],
              [
                -43.42629773058915,
                -2.3378496588330995
              ],
              [
                -43.40756544539801,
                -2.337129686337814
              ],
              [
                -43.385232647553984,
                -2.3400058209859456
              ],
              [
                -43.36362079153329,
                -2.3428830071281777
              ],
              [
                -43.34057294717338,
                -2.3450375169354256
              ],
              [
                -43.31176641050063,
                -2.3464673976339445
              ],
              [
                -43.251263657860584,
                -2.367306042436387
              ],
              [
                -43.19939548345784,
                -2.379511025832177
              ],
              [
                -43.118658941882096,
                -2.416888609193991
              ],
              [
                -43.01402747337609,
                -2.457207970601462
              ],
              [
                -42.94310641238521,
                -2.481628152131806
              ],
              [
                -42.91630469585304,
                -2.492436752520267
              ],
              [
                -42.882845325604265,
                -2.5103291133006955
              ],
              [
                -42.8579078580471,
                -2.52217178231015
              ],
              [
                -42.82384192683095,
                -2.543226884893061
              ],
              [
                -42.81916256579318,
                -2.546156645760648
              ],
              [
                -42.8106583326628,
                -2.5480283039035476
              ],
              [
                -42.77505449088136,
                -2.560316655922175
              ],
              [
                -42.7659805995155,
                -2.561293343021885
              ],
              [
                -42.70995032488151,
                -2.560316655922175
              ],
              [
                -42.700021937771474,
                -2.5635717788771983
              ],
              [
                -42.693104619395314,
                -2.5704076872997237
              ],
              [
                -42.6878149099413,
                -2.577243896153844
              ],
              [
                -42.68228105342595,
                -2.5802547722325744
              ],
              [
                -42.67284094884392,
                -2.5891251700729656
              ],
              [
                -42.63048255023532,
                -2.6423478577178843
              ],
              [
                -42.58088131336242,
                -2.6720516436046586
              ],
              [
                -42.565581835847716,
                -2.6764462849668007
              ],
              [
                -42.5555720703388,
                -2.677911165421319
              ],
              [
                -42.53929602846469,
                -2.683282193472148
              ],
              [
                -42.52745520746459,
                -2.683282193472148
              ],
              [
                -42.51634680871429,
                -2.6810848727891368
              ],
              [
                -42.48713131593762,
                -2.669040767496248
              ],
              [
                -42.4862361327461,
                -2.686781563355015
              ],
              [
                -42.48949133923577,
                -2.699639524528791
              ],
              [
                -42.498280404682596,
                -2.7041969971611923
              ],
              [
                -42.51439368368196,
                -2.696954010498173
              ],
              [
                -42.50763912699261,
                -2.721856377460094
              ],
              [
                -42.49351965918057,
                -2.731214968782414
              ],
              [
                -42.474436000013306,
                -2.7373998527257837
              ],
              [
                -42.45299231689304,
                -2.752211188211813
              ],
              [
                -42.446034310759146,
                -2.747002991377594
              ],
              [
                -42.42739824288204,
                -2.7380511777558687
              ],
              [
                -42.4181208997937,
                -2.7311338535803804
              ],
              [
                -42.41197669268429,
                -2.7385393711017962
              ],
              [
                -42.40733802010642,
                -2.75017669876975
              ],
              [
                -42.37840735546626,
                -2.7562801670973403
              ],
              [
                -42.264271613503965,
                -2.759047096774716
              ],
              [
                -42.25450598786066,
                -2.7665340299483603
              ],
              [
                -42.25397701802762,
                -2.783461270561518
              ],
              [
                -42.25934811154746,
                -2.80201592251418
              ],
              [
                -42.26740475122465,
                -2.81422285924558
              ],
              [
                -42.2386368485849,
                -2.8047828522059324
              ],
              [
                -42.234201625935434,
                -2.810723489312562
              ],
              [
                -42.239409958744,
                -2.8341609761144717
              ],
              [
                -42.23326575274421,
                -2.8341609761144717
              ],
              [
                -42.22935950554884,
                -2.822198286243641
              ],
              [
                -42.22223873692569,
                -2.812432616677507
              ],
              [
                -42.213693815557846,
                -2.8049456834646906
              ],
              [
                -42.20592200476146,
                -2.7999814330606028
              ],
              [
                -42.19310461893739,
                -2.809177193206795
              ],
              [
                -42.17613684916565,
                -2.811781592068597
              ],
              [
                -42.15953528589915,
                -2.8095028557244777
              ],
              [
                -42.147572395557916,
                -2.8033993873599417
              ],
              [
                -42.08238684875924,
                -2.7999814330606028
              ],
              [
                -42.08446204283893,
                -2.803968996338849
              ],
              [
                -42.085519985598765,
                -2.8046200209471865
              ],
              [
                -42.08682206859873,
                -2.8046200209471865
              ],
              [
                -42.089833137354496,
                -2.8068173416606164
              ],
              [
                -42.08372961933858,
                -2.8209773522272696
              ],
              [
                -42.08238684715921,
                -2.8273250674929327
              ],
              [
                -42.06773841178349,
                -2.8200009655262925
              ],
              [
                -42.04718990928905,
                -2.821465846004461
              ],
              [
                -42.028879362580085,
                -2.8249652159418175
              ],
              [
                -42.02090410036487,
                -2.823907113184179
              ],
              [
                -42.01593990622229,
                -2.8112930982919653
              ],
              [
                -42.00401770890521,
                -2.812595447936418
              ],
              [
                -41.968983527982736,
                -2.8336727827632515
              ],
              [
                -41.95543372206757,
                -2.839043810908429
              ],
              [
                -41.94391842304246,
                -2.8376603460569805
              ],
              [
                -41.939035610366126,
                -2.823907113184179
              ],
              [
                -41.936756964380955,
                -2.7880184428101096
              ],
              [
                -41.94041907540973,
                -2.773695601038678
              ],
              [
                -41.952707484549734,
                -2.778903797888622
              ],
              [
                -41.9588923805495,
                -2.778903797888622
              ],
              [
                -41.970611132822,
                -2.768243157304693
              ],
              [
                -42.001616992778416,
                -2.749769921052069
              ],
              [
                -42.01531402244862,
                -2.74113415628915
              ],
              [
                -42.01040398719948,
                -2.7271886504960468
              ],
              [
                -41.9956232199516,
                -2.721434578410005
              ],
              [
                -41.90027410759289,
                -2.725440768106633
              ],
              [
                -41.838564526190304,
                -2.729480305165889
              ],
              [
                -41.82126538137943,
                -2.7335670092148336
              ],
              [
                -41.84284420482839,
                -2.7653133963664462
              ],
              [
                -41.8426814433446,
                -2.7652319807374233
              ],
              [
                -41.83210201630894,
                -2.7624650510581263
              ],
              [
                -41.82396399405044,
                -2.757419385049099
              ],
              [
                -41.80870520799383,
                -2.7448056706790744
              ],
              [
                -41.77867591247592,
                -2.782159221348062
              ],
              [
                -41.694056181495675,
                -2.8328814588942786
              ],
              [
                -41.66506138525618,
                -2.8559067603535113
              ],
              [
                -41.65782630119071,
                -2.8689104287136598
              ],
              [
                -41.66372636589928,
                -2.8654110587584034
              ],
              [
                -41.67931067801758,
                -2.8581683723892226
              ],
              [
                -41.68517005272544,
                -2.854669002438368
              ],
              [
                -41.682850716028675,
                -2.858005541129459
              ],
              [
                -41.6783341141908,
                -2.8689104287136598
              ],
              [
                -41.68834388013195,
                -2.8649228654053895
              ],
              [
                -41.698841926598476,
                -2.862074520064424
              ],
              [
                -41.69884192619091,
                -2.8689104287136598
              ],
              [
                -41.68614661477574,
                -2.875909168628486
              ],
              [
                -41.675038217063296,
                -2.8795713698482004
              ],
              [
                -41.663929817062275,
                -2.877862242469897
              ],
              [
                -41.650990364190676,
                -2.8689104287136598
              ],
              [
                -41.639881966145296,
                -2.884942398022219
              ],
              [
                -41.62328040182055,
                -2.8956030387502403
              ],
              [
                -41.60155188688018,
                -2.901299729455605
              ],
              [
                -41.516957161954565,
                -2.90699642016485
              ],
              [
                -41.48961341215806,
                -2.9035784658241766
              ],
              [
                -41.46544348823545,
                -2.8887671300795295
              ],
              [
                -41.45494544183077,
                -2.8971493348716173
              ],
              [
                -41.44855709371954,
                -2.905938317397021
              ],
              [
                -41.4488826155979,
                -2.9164364273173944
              ],
              [
                -41.45860755202155,
                -2.92978288261377
              ],
              [
                -41.45579993377438,
                -2.9302710759705244
              ],
              [
                -41.4455460290212,
                -2.92978288261377
              ],
              [
                -41.44762122157883,
                -2.933526199060861
              ],
              [
                -41.44945227984503,
                -2.936130597960728
              ],
              [
                -41.450917122884995,
                -2.9388975276960534
              ],
              [
                -41.45177161421208,
                -2.943454700027606
              ],
              [
                -41.44469153795176,
                -2.943047922300766
              ],
              [
                -41.44005286592448,
                -2.941664457432308
              ],
              [
                -41.43187415361003,
                -2.9366187913178767
              ],
              [
                -41.44005286281754,
                -2.9142391065757596
              ],
              [
                -41.42210852724157,
                -2.9087866627527315
              ],
              [
                -41.34308834316686,
                -2.9203425750194785
              ],
              [
                -41.33568274741294,
                -2.9229469739152485
              ],
              [
                -41.3290095680572,
                -2.9322241498245685
              ],
              [
                -41.32787024393771,
                -2.941013132386816
              ],
              [
                -41.332102016258396,
                -2.947442263373102
              ],
              [
                -41.341908331798855,
                -2.9502906087429466
              ],
              [
                -41.337513801352685,
                -2.9545224189841752
              ],
              [
                -41.327544724442056,
                -2.9611140808160212
              ],
              [
                -41.32201086897593,
                -2.963799594928761
              ],
              [
                -41.31647701819217,
                -2.960870134350064
              ],
              [
                -41.31065833222384,
                -2.9634742328318215
              ],
              [
                -41.30528723806075,
                -2.9694962856807527
              ],
              [
                -41.300933396164645,
                -2.9776342436608703
              ],
              [
                -41.294748500164935,
                -2.9776342436608703
              ],
              [
                -41.294748499977295,
                -2.963799594928761
              ],
              [
                -41.27391516845841,
                -2.980075811312513
              ],
              [
                -41.25645911378348,
                -3.0048153478339303
              ],
              [
                -41.24811764391211,
                -3.0120583347572847
              ],
              [
                -41.244536913189464,
                -3.0152320422485595
              ],
              [
                -41.24010169055146,
                -2.988050938040831
              ],
              [
                -41.24327552211163,
                -2.97275170921318
              ],
              [
                -41.25690670603276,
                -2.949802415385009
              ],
              [
                -41.264027473990254,
                -2.9283994177475003
              ],
              [
                -41.28237870934491,
                -2.9157039870701236
              ],
              [
                -41.28726152487587,
                -2.9030088568386536
              ],
              [
                -41.296294727928334,
                -2.907159251425555
              ],
              [
                -41.30288652101052,
                -2.907891391245404
              ],
              [
                -41.30858313819178,
                -2.906345395548752
              ],
              [
                -41.31525631587718,
                -2.9030088568386536
              ],
              [
                -41.299712695544194,
                -2.8967425571470287
              ],
              [
                -41.273426888790894,
                -2.8788389296041226
              ],
              [
                -41.25690670551586,
                -2.8751767283847007
              ],
              [
                -41.19855709551513,
                -2.8751767283847007
              ],
              [
                -41.167958138786304,
                -2.8788389296041226
              ],
              [
                -41.13776607822125,
                -2.885837369100445
              ],
              [
                -41.11070716011259,
                -2.897718943856746
              ],
              [
                -41.08926347707282,
                -2.9166806742087257
              ],
              [
                -41.08250891907263,
                -2.9166806742087257
              ],
              [
                -41.084624802464404,
                -2.905205877150679
              ],
              [
                -41.089955207287026,
                -2.8944638207803015
              ],
              [
                -41.1030167315139,
                -2.8751767283847007
              ],
              [
                -41.08926347491754,
                -2.882500830398451
              ],
              [
                -41.082508916917696,
                -2.882500830398451
              ],
              [
                -40.93846595018739,
                -2.8689104287136598
              ],
              [
                -40.92813066441092,
                -2.8698057002168524
              ],
              [
                -40.90855872181324,
                -2.8742000412509077
              ],
              [
                -40.900013801511385,
                -2.8751767283847007
              ],
              [
                -40.89195716173696,
                -2.8731422389138594
              ],
              [
                -40.88792883988952,
                -2.864027593902706
              ],
              [
                -40.879505989586704,
                -2.862074520064424
              ],
              [
                -40.84898841154897,
                -2.859307590354314
              ],
              [
                -40.841379360652795,
                -2.864678618515547
              ],
              [
                -40.83543860492421,
                -2.882500830398451
              ],
              [
                -40.8286026669244,
                -2.882500830398451
              ],
              [
                -40.81834876222398,
                -2.871677358426887
              ],
              [
                -40.769195115905745,
                -2.846774991040069
              ],
              [
                -40.75291907340271,
                -2.840996884741456
              ],
              [
                -40.58161373518922,
                -2.8273250674929327
              ],
              [
                -40.527414517536464,
                -2.8033993873599417
              ],
              [
                -40.50987708273086,
                -2.7999814330606028
              ],
              [
                -40.50674394493664,
                -2.797946943607522
              ],
              [
                -40.499623177492275,
                -2.786309615876619
              ],
              [
                -40.49315344986237,
                -2.786716393595979
              ],
              [
                -40.488107878057264,
                -2.788995129934157
              ],
              [
                -40.48371334562195,
                -2.791680643992548
              ],
              [
                -40.47911536510499,
                -2.793145524465933
              ],
              [
                -40.40306555816661,
                -2.805922070163963
              ],
              [
                -40.27375240833924,
                -2.8068173416606164
              ],
              [
                -40.188059048574495,
                -2.8204891588767618
              ],
              [
                -40.175038214634384,
                -2.8246395534235624
              ],
              [
                -40.1547745440384,
                -2.84351986798309
              ],
              [
                -40.14342200534345,
                -2.8484027027823524
              ],
              [
                -40.13243567587128,
                -2.844008061334895
              ],
              [
                -40.126861133158364,
                -2.8345680542627547
              ],
              [
                -40.120920378315084,
                -2.8283831702509907
              ],
              [
                -40.10863196380735,
                -2.8341609761144717
              ],
              [
                -40.096343553003464,
                -2.8307430218030216
              ],
              [
                -40.08218339754667,
                -2.836358296835408
              ],
              [
                -40.066761846246294,
                -2.8444148390569777
              ],
              [
                -40.05060787834035,
                -2.8484027027823524
              ],
              [
                -40.00104733130178,
                -2.8456357730766566
              ],
              [
                -39.985707162338166,
                -2.8484027027823524
              ],
              [
                -39.90306555770695,
                -2.9017879228107306
              ],
              [
                -39.87242591243372,
                -2.9098447655209037
              ],
              [
                -39.8609106103675,
                -2.9157039870701236
              ],
              [
                -39.80748450379285,
                -2.9675432118179175
              ],
              [
                -39.79588782633987,
                -2.974704783077262
              ],
              [
                -39.78335527123208,
                -2.9776342436608703
              ],
              [
                -39.767323371517605,
                -2.9856096708135063
              ],
              [
                -39.74303138023492,
                -3.0036761298489667
              ],
              [
                -39.72594153773299,
                -3.0223936135497347
              ],
              [
                -39.73184159919989,
                -3.03215898293424
              ],
              [
                -39.72549394469042,
                -3.0353329908601245
              ],
              [
                -39.71910559946333,
                -3.037530311634138
              ],
              [
                -39.7122289719696,
                -3.0389951921504856
              ],
              [
                -39.7045792327288,
                -3.039646216777092
              ],
              [
                -39.71202551836711,
                -3.025974098776005
              ],
              [
                -39.69790605347813,
                -3.0171851161227936
              ],
              [
                -39.68154863029443,
                -3.0204402392475567
              ],
              [
                -39.64313717572614,
                -3.039646216777092
              ],
              [
                -39.63768469930125,
                -3.0406226035037554
              ],
              [
                -39.61888587272508,
                -3.039646216777092
              ],
              [
                -39.61489824179237,
                -3.0422503152840275
              ],
              [
                -39.61074785122554,
                -3.0552711082581845
              ],
              [
                -39.60830644454428,
                -3.0601539431822644
              ],
              [
                -39.57111568773986,
                -3.090915532888862
              ],
              [
                -39.49714107978213,
                -3.131117430544561
              ],
              [
                -39.4854630207417,
                -3.1457659354666814
              ],
              [
                -39.39671790251164,
                -3.1835262656904635
              ],
              [
                -39.38394120955166,
                -3.1862931955114733
              ],
              [
                -39.375396286537494,
                -3.186130364245107
              ],
              [
                -39.36782793027812,
                -3.1845029528616857
              ],
              [
                -39.35826575351215,
                -3.1835262656904635
              ],
              [
                -39.352772588305356,
                -3.186781388883914
              ],
              [
                -39.347523565903956,
                -3.1937801290745575
              ],
              [
                -39.340891080012874,
                -3.2008602849049366
              ],
              [
                -39.32046464708877,
                -3.207614778208244
              ],
              [
                -39.28685462170793,
                -3.232028953336808
              ],
              [
                -39.27794348816116,
                -3.2304012415168932
              ],
              [
                -39.2725723957077,
                -3.232028953336808
              ],
              [
                -39.26740474998368,
                -3.236423294569622
              ],
              [
                -39.264068161048584,
                -3.241957154251131
              ],
              [
                -39.26158606615374,
                -3.247653845204401
              ],
              [
                -39.25890051972057,
                -3.25188565560523
              ],
              [
                -39.19371497311485,
                -3.296807557911217
              ],
              [
                -39.16527258894509,
                -3.3228491447435733
              ],
              [
                -39.156483526240415,
                -3.327569148568775
              ],
              [
                -39.14565995905633,
                -3.3297664694263855
              ],
              [
                -39.125803188323786,
                -3.330498909712396
              ],
              [
                -39.115549280831175,
                -3.3344050576212285
              ],
              [
                -39.101307746096,
                -3.348565369554967
              ],
              [
                -39.09243730251016,
                -3.3641902616682007
              ],
              [
                -39.08055579431673,
                -3.377048524348789
              ],
              [
                -39.05719967330094,
                -3.3822567215943433
              ],
              [
                -39.015492318940815,
                -3.384047264718371
              ],
              [
                -38.999663864094785,
                -3.388278774770834
              ],
              [
                -38.98517818746199,
                -3.3959285398084327
              ],
              [
                -38.96035722531337,
                -3.418145394675116
              ],
              [
                -38.94273841177632,
                -3.4445940601232587
              ],
              [
                -38.91633053205669,
                -3.5050594404078725
              ],
              [
                -38.89720618324495,
                -3.5002580208290084
              ],
              [
                -38.88329017001659,
                -3.5075824238670434
              ],
              [
                -38.87059485796724,
                -3.5206846332912773
              ],
              [
                -38.85545813808622,
                -3.5329729867962927
              ],
              [
                -38.80748450398439,
                -3.5472958299734785
              ],
              [
                -38.78954017001821,
                -3.573825911547574
              ],
              [
                -38.7630509101666,
                -3.5982397874938523
              ],
              [
                -38.73200436187383,
                -3.6198870339654765
              ],
              [
                -38.70710201530665,
                -3.629164210741167
              ],
              [
                -38.69440670723222,
                -3.6366514451936043
              ],
              [
                -38.671131966951805,
                -3.669040749260323
              ],
              [
                -38.65965735670705,
                -3.6764462676918868
              ],
              [
                -38.594715949032235,
                -3.6906876955337036
              ],
              [
                -38.52619381595262,
                -3.7180316336391726
              ],
              [
                -38.49437415362265,
                -3.7212867570783272
              ],
              [
                -38.47740637704079,
                -3.697442189303738
              ],
              [
                -38.46654212219018,
                -3.705499032880116
              ],
              [
                -38.45734615803734,
                -3.7184384114089637
              ],
              [
                -38.43594316258883,
                -3.7583960656790536
              ],
              [
                -38.40977942728207,
                -3.7931455226310216
              ],
              [
                -38.403309698784405,
                -3.8093400248173497
              ],
              [
                -38.395822720152275,
                -3.840590111621078
              ],
              [
                -38.38927161468845,
                -3.855157202387027
              ],
              [
                -38.37804114621163,
                -3.8697242931864477
              ],
              [
                -38.320790168731,
                -3.922784158624339
              ],
              [
                -38.31021074129311,
                -3.9296200682806783
              ],
              [
                -38.26349850154982,
                -3.951592678002206
              ],
              [
                -38.25133215986552,
                -3.9618465425371268
              ],
              [
                -38.1885473322265,
                -4.052016019522763
              ],
              [
                -38.10667883955475,
                -4.157891507090962
              ],
              [
                -38.029611783764885,
                -4.237400043786572
              ],
              [
                -37.93455970095332,
                -4.307793934634135
              ],
              [
                -37.9194229809003,
                -4.314548429086564
              ],
              [
                -37.85423743360112,
                -4.375909089485976
              ],
              [
                -37.83507239508296,
                -4.3849423208917155
              ],
              [
                -37.81371009111401,
                -4.391290037621642
              ],
              [
                -37.79124915239189,
                -4.395196186185122
              ],
              [
                -37.76862545321918,
                -4.396416820058451
              ],
              [
                -37.710804817619525,
                -4.515394825994928
              ],
              [
                -37.68374589809675,
                -4.548435159604501
              ],
              [
                -37.64940345011485,
                -4.578789978634313
              ],
              [
                -37.60724850457438,
                -4.608086995218811
              ],
              [
                -37.56436112949476,
                -4.629489697986103
              ],
              [
                -37.53734290313877,
                -4.638116151980386
              ],
              [
                -37.52529863201826,
                -4.632582291054669
              ],
              [
                -37.513824024374685,
                -4.623793306192435
              ],
              [
                -37.488026497196046,
                -4.629978191897921
              ],
              [
                -37.42711341254562,
                -4.661065451839143
              ],
              [
                -37.324818487006226,
                -4.696465638584738
              ],
              [
                -37.2925512347745,
                -4.717950057792928
              ],
              [
                -37.274403450838264,
                -4.742364238916442
              ],
              [
                -37.23110917737055,
                -4.842054853821236
              ],
              [
                -37.18293209240321,
                -4.910902456014334
              ],
              [
                -37.13491777431921,
                -4.931410489101884
              ],
              [
                -37.115142379661854,
                -4.92197017847347
              ],
              [
                -37.09813391562224,
                -4.9205867131647345
              ],
              [
                -37.08242753916445,
                -4.924493162548905
              ],
              [
                -37.04938717233583,
                -4.937920737380133
              ],
              [
                -37.03746497229838,
                -4.938734593522194
              ],
              [
                -37.011382617314844,
                -4.931410489101884
              ],
              [
                -36.982980923411745,
                -4.929782776820293
              ],
              [
                -36.89875240884986,
                -4.938246400007647
              ],
              [
                -36.881011523148445,
                -4.9485002663840065
              ],
              [
                -36.84764563862972,
                -4.985935245724429
              ],
              [
                -36.843495247784304,
                -4.992852572363626
              ],
              [
                -36.833119269067375,
                -4.997328330556487
              ],
              [
                -36.82070878800207,
                -5.007745050120665
              ],
              [
                -36.810292120999364,
                -5.020114841969003
              ],
              [
                -36.80597896998615,
                -5.030043226225715
              ],
              [
                -36.790882942006576,
                -5.0512020813713345
              ],
              [
                -36.75658118403079,
                -5.066827082727844
              ],
              [
                -36.71955318903173,
                -5.075372004777674
              ],
              [
                -36.69611568899713,
                -5.07545338284184
              ],
              [
                -36.695708787943836,
                -5.089613536863863
              ],
              [
                -36.682240364072044,
                -5.092217710031215
              ],
              [
                -36.641468879053974,
                -5.089043881024902
              ],
              [
                -36.60692298095687,
                -5.096368094589712
              ],
              [
                -36.589995898039135,
                -5.10295989619485
              ],
              [
                -36.56114661406158,
                -5.123223569447116
              ],
              [
                -36.54442298101086,
                -5.1276180976121974
              ],
              [
                -36.53091386596921,
                -5.122735282281212
              ],
              [
                -36.525380011999566,
                -5.105564059980304
              ],
              [
                -36.533680792952055,
                -5.101006766315336
              ],
              [
                -36.57054602796189,
                -5.091729422868071
              ],
              [
                -36.57998613197726,
                -5.080987236726826
              ],
              [
                -36.54507402294406,
                -5.089613536863863
              ],
              [
                -36.42235266797733,
                -5.080987236726826
              ],
              [
                -36.33975175705351,
                -5.089043881024902
              ],
              [
                -36.300038215050094,
                -5.101169531832779
              ],
              [
                -36.281361456947515,
                -5.104587495039986
              ],
              [
                -36.25723222591823,
                -5.1021460873841376
              ],
              [
                -36.25723222601434,
                -5.0958798168145485
              ],
              [
                -36.291981575014326,
                -5.0958798168145485
              ],
              [
                -36.29198157505342,
                -5.089043881024902
              ],
              [
                -36.131214973014295,
                -5.0958798168145485
              ],
              [
                -36.11359615803057,
                -5.0915666667392685
              ],
              [
                -36.07909095002806,
                -5.072360936603797
              ],
              [
                -36.042836067027196,
                -5.064873957555715
              ],
              [
                -36.01598059799207,
                -5.051039320549611
              ],
              [
                -35.997181769963696,
                -5.047539969924913
              ],
              [
                -35.91759192602948,
                -5.058282160691944
              ],
              [
                -35.768422004068924,
                -5.086846616957418
              ],
              [
                -35.65941321499503,
                -5.111260674719748
              ],
              [
                -35.58193925707561,
                -5.1189104193503105
              ],
              [
                -35.54881751199946,
                -5.128350518973373
              ],
              [
                -35.510568813982005,
                -5.143731376968507
              ],
              [
                -35.49290930892483,
                -5.1574032486904535
              ],
              [
                -35.4549047519422,
                -5.196954030695951
              ],
              [
                -35.438588020099225,
                -5.205173440678119
              ],
              [
                -35.42052161411921,
                -5.211521098820702
              ],
              [
                -35.4037979811279,
                -5.226495057311154
              ],
              [
                -35.39004472602573,
                -5.2445614574709465
              ],
              [
                -35.37120520689527,
                -5.279066659048065
              ],
              [
                -35.3624161450546,
                -5.300876563101753
              ],
              [
                -35.35602779915317,
                -5.3235002666746984
              ],
              [
                -35.353505011743124,
                -5.345798420494263
              ],
              [
                -35.34862219979733,
                -5.355645429567258
              ],
              [
                -35.318755663260475,
                -5.383233345673948
              ],
              [
                -35.26227779919306,
                -5.483330998778278
              ],
              [
                -35.25389563683715,
                -5.524102462952391
              ],
              [
                -35.245269335227675,
                -5.546156520633496
              ],
              [
                -35.23412024601542,
                -5.566582941858758
              ],
              [
                -35.2231339178677,
                -5.582614834689684
              ],
              [
                -35.2306208983215,
                -5.588799755764592
              ],
              [
                -35.226063605754824,
                -5.598565349472588
              ],
              [
                -35.20677649665887,
                -5.668145477119076
              ],
              [
                -35.205799934350836,
                -5.6788062672130435
              ],
              [
                -35.19566809732051,
                -5.689548397831626
              ],
              [
                -35.1952205067913,
                -5.760023684672599
              ],
              [
                -35.18773352818362,
                -5.773532819962232
              ],
              [
                -35.17870032451871,
                -5.7834611699278184
              ],
              [
                -35.17113196521545,
                -5.796319280664366
              ],
              [
                -35.16795813758924,
                -5.818454716820095
              ],
              [
                -35.17121334501568,
                -5.833916925847656
              ],
              [
                -35.171538866508286,
                -5.844333619369795
              ],
              [
                -35.16795813730071,
                -5.856215118175201
              ],
              [
                -35.150135870609404,
                -5.874769769031246
              ],
              [
                -35.14745032505291,
                -5.876722917845405
              ],
              [
                -35.1458227193285,
                -5.886814023988914
              ],
              [
                -35.147450325052255,
                -5.921075130795873
              ],
              [
                -35.14533443857435,
                -5.932061433285101
              ],
              [
                -35.135975714883365,
                -5.945733324787185
              ],
              [
                -35.133778450112516,
                -5.955254821997155
              ],
              [
                -35.12999426936035,
                -5.959649312951795
              ],
              [
                -35.112212694151154,
                -5.976657818039564
              ],
              [
                -35.10651608047264,
                -5.986016559109065
              ],
              [
                -35.10505123670324,
                -5.995538056321324
              ],
              [
                -35.10651608040797,
                -6.027601842575828
              ],
              [
                -35.111683723685985,
                -6.048516570190012
              ],
              [
                -35.11119544233452,
                -6.0577938956325506
              ],
              [
                -35.10277258981315,
                -6.061700118158926
              ],
              [
                -35.09935462122105,
                -6.066582952646634
              ],
              [
                -35.09284420495727,
                -6.185804943780884
              ],
              [
                -35.1207169257712,
                -6.164727460087247
              ],
              [
                -35.124989386316706,
                -6.182793842494227
              ],
              [
                -35.149769660456144,
                -6.206801011833399
              ],
              [
                -35.15086829287851,
                -6.215996996718641
              ],
              [
                -35.13426673102442,
                -6.224297785267451
              ],
              [
                -35.120106574844684,
                -6.21461353196023
              ],
              [
                -35.10757402234551,
                -6.199883688037707
              ],
              [
                -35.095936653404316,
                -6.192071243012767
              ],
              [
                -35.08706621057577,
                -6.197442345909337
              ],
              [
                -35.07787024629293,
                -6.220879831184581
              ],
              [
                -35.0689591137963,
                -6.226169518450373
              ],
              [
                -35.048939581979205,
                -6.22722747092469
              ],
              [
                -35.04124915362135,
                -6.2302385722057245
              ],
              [
                -35.03819739461996,
                -6.23650479631891
              ],
              [
                -35.036000128318655,
                -6.258558816795859
              ],
              [
                -35.02619381461066,
                -6.298923466426442
              ],
              [
                -35.023915166872015,
                -6.318047726076311
              ],
              [
                -35.02594967278833,
                -6.333916862888914
              ],
              [
                -35.02424068759305,
                -6.3428686759442074
              ],
              [
                -35.01707923171982,
                -6.355889617825472
              ],
              [
                -35.010609502590995,
                -6.362888206969272
              ],
              [
                -34.996327278281946,
                -6.371026314411249
              ],
              [
                -34.989165819564946,
                -6.377618125856667
              ],
              [
                -34.98228919211119,
                -6.3913713576740205
              ],
              [
                -34.97227942507871,
                -6.433363493213879
              ],
              [
                -34.958973760730075,
                -6.5368791012137235
              ],
              [
                -34.958485481212335,
                -6.582614852616894
              ],
              [
                -34.96996008851074,
                -6.617282735876615
              ],
              [
                -34.96080481692547,
                -6.638848562300917
              ],
              [
                -34.95714270713411,
                -6.651299744656006
              ],
              [
                -34.9532771478177,
                -6.674737228982605
              ],
              [
                -34.94774329354143,
                -6.684828409770399
              ],
              [
                -34.94098873598039,
                -6.694431247033713
              ],
              [
                -34.93517005242087,
                -6.705987308108589
              ],
              [
                -34.93492591184802,
                -6.7242164457606854
              ],
              [
                -34.940052864655506,
                -6.744561488203777
              ],
              [
                -34.94273841074783,
                -6.766208579646185
              ],
              [
                -34.93517004985499,
                -6.787855671015185
              ],
              [
                -34.935170050116525,
                -6.781670787774514
              ],
              [
                -34.91673743320466,
                -6.864190324420568
              ],
              [
                -34.904164191043506,
                -6.887302295703113
              ],
              [
                -34.893625454888024,
                -6.89430103458478
              ],
              [
                -34.8657120436475,
                -6.907159144312672
              ],
              [
                -34.86009680867806,
                -6.914646076447992
              ],
              [
                -34.86009680891642,
                -6.962660410986298
              ],
              [
                -34.86286373485013,
                -6.976006713819591
              ],
              [
                -34.869252081881676,
                -6.982679940329598
              ],
              [
                -34.87621009142843,
                -6.986993165446008
              ],
              [
                -34.88060462050854,
                -6.993340729475685
              ],
              [
                -34.88109290416481,
                -7.00457127769884
              ],
              [
                -34.87816321580931,
                -7.028008760603705
              ],
              [
                -34.88060462239089,
                -7.041192382240436
              ],
              [
                -34.896351690894,
                -7.081312705590893
              ],
              [
                -34.89419511565815,
                -7.082777585805126
              ],
              [
                -34.901844854477034,
                -7.090590029917401
              ],
              [
                -34.90758216119216,
                -7.093194278094026
              ],
              [
                -34.91348222689845,
                -7.090508764516013
              ],
              [
                -34.921498175657895,
                -7.082777585805126
              ],
              [
                -34.91222083087158,
                -7.092705934619365
              ],
              [
                -34.90782630062396,
                -7.104180579233286
              ],
              [
                -34.90851803190171,
                -7.116875857177717
              ],
              [
                -34.91466223980718,
                -7.130547822026445
              ],
              [
                -34.89606686195893,
                -7.11744561626392
              ],
              [
                -34.87564042942323,
                -7.095635695039893
              ],
              [
                -34.85936438740771,
                -7.071465772366672
              ],
              [
                -34.85265051951735,
                -7.051690340025973
              ],
              [
                -34.848784958800046,
                -7.03020593073684
              ],
              [
                -34.83617102914356,
                -6.991794583830561
              ],
              [
                -34.83958899498626,
                -6.972914272304774
              ],
              [
                -34.82579505147553,
                -6.984470332827175
              ],
              [
                -34.82420813647997,
                -7.003350494095556
              ],
              [
                -34.83275306038898,
                -7.041192382240436
              ],
              [
                -34.83275305948164,
                -7.099786088823488
              ],
              [
                -34.82795162648235,
                -7.130059478555932
              ],
              [
                -34.825306770155215,
                -7.137383729327966
              ],
              [
                -34.81875566252541,
                -7.144219636618621
              ],
              [
                -34.8021134121645,
                -7.154066719893129
              ],
              [
                -34.79735266830229,
                -7.15846121024784
              ],
              [
                -34.79360918053208,
                -7.176202153060231
              ],
              [
                -34.79674231710371,
                -7.192966408870529
              ],
              [
                -34.80207271920815,
                -7.208754127902997
              ],
              [
                -34.804798956819184,
                -7.223321213545048
              ],
              [
                -34.8047989569966,
                -7.370782158845997
              ],
              [
                -34.8144425103812,
                -7.444512554144899
              ],
              [
                -34.81460527408093,
                -7.483819318106717
              ],
              [
                -34.80479895697194,
                -7.514092704731837
              ],
              [
                -34.81550045655209,
                -7.542575849047869
              ],
              [
                -34.81916256719235,
                -7.548272537965851
              ],
              [
                -34.82428951589886,
                -7.54851648435321
              ],
              [
                -34.83397376160638,
                -7.543064042250048
              ],
              [
                -34.84162350236417,
                -7.541761993426401
              ],
              [
                -34.880604619783895,
                -7.541599162216763
              ],
              [
                -34.89338131202429,
                -7.542901211040474
              ],
              [
                -34.89732825516518,
                -7.54322687345961
              ],
              [
                -34.91266842247338,
                -7.5477840443379165
              ],
              [
                -34.92894446713477,
                -7.555759468892357
              ],
              [
                -34.865467902347675,
                -7.553399317641964
              ],
              [
                -34.835386111036975,
                -7.562727262663838
              ],
              [
                -34.83140028464077,
                -7.5824382507806005
              ],
              [
                -34.820488722554025,
                -7.599686942519267
              ],
              [
                -34.808949349381976,
                -7.613702142891779
              ],
              [
                -34.805303872172644,
                -7.6227161419567535
              ],
              [
                -34.813003782250384,
                -7.638517378220834
              ],
              [
                -34.819930600380715,
                -7.653544715543954
              ],
              [
                -34.830304218089786,
                -7.680888040146926
              ],
              [
                -34.837295029246256,
                -7.679756934102137
              ],
              [
                -34.83726966430668,
                -7.667087645090471
              ],
              [
                -34.83958899836873,
                -7.655938514493142
              ],
              [
                -34.839588994633274,
                -7.643812697055115
              ],
              [
                -34.84373938412165,
                -7.650567187756919
              ],
              [
                -34.84544837020172,
                -7.6569963164629256
              ],
              [
                -34.845814584181966,
                -7.671807646985928
              ],
              [
                -34.86782793103939,
                -7.632419619989538
              ],
              [
                -34.87376868463725,
                -7.61777112047595
              ],
              [
                -34.87604733249311,
                -7.637302453144848
              ],
              [
                -34.86017027719967,
                -7.6859865795004705
              ],
              [
                -34.864368438683364,
                -7.705229502209667
              ],
              [
                -34.87679655392494,
                -7.702963985446386
              ],
              [
                -34.88725716386064,
                -7.70838247905734
              ],
              [
                -34.89999799122444,
                -7.718044798366276
              ],
              [
                -34.90721595061603,
                -7.733819296148929
              ],
              [
                -34.88792884167601,
                -7.723565436981677
              ],
              [
                -34.87753100432536,
                -7.714503369975883
              ],
              [
                -34.869380398827,
                -7.714475730731562
              ],
              [
                -34.86587616628394,
                -7.717540382157928
              ],
              [
                -34.86933293208995,
                -7.7275502949742565
              ],
              [
                -34.87589913030651,
                -7.736416784243582
              ],
              [
                -34.884402946087775,
                -7.745289882869411
              ],
              [
                -34.892095730678065,
                -7.762618186686674
              ],
              [
                -34.893524817763705,
                -7.804926658463618
              ],
              [
                -34.88494418401049,
                -7.81566300238086
              ],
              [
                -34.84803774304603,
                -7.82283778942453
              ],
              [
                -34.847226670799984,
                -7.834375671320942
              ],
              [
                -34.84407961958972,
                -7.848216322705835
              ],
              [
                -34.84581458535476,
                -7.884698320626878
              ],
              [
                -34.83275305836137,
                -7.857354397186985
              ],
              [
                -34.82648678373336,
                -7.869235966908263
              ],
              [
                -34.8177790987714,
                -7.893812661283134
              ],
              [
                -34.81163489576181,
                -7.905857062026461
              ],
              [
                -34.817005988630605,
                -7.91334399200534
              ],
              [
                -34.818837044321086,
                -7.919040680175714
              ],
              [
                -34.81696530201333,
                -7.924737368333339
              ],
              [
                -34.81163489319997,
                -7.9325496602042795
              ],
              [
                -34.82144121171202,
                -7.952243821814723
              ],
              [
                -34.84577388975689,
                -8.041680501316037
              ],
              [
                -34.84581458200975,
                -8.059177342418094
              ],
              [
                -34.851185673619796,
                -8.068617344787505
              ],
              [
                -34.86367753980915,
                -8.070407886891388
              ],
              [
                -34.88060462229856,
                -8.062758126212257
              ],
              [
                -34.900868293680155,
                -8.04265718796814
              ],
              [
                -34.91266842127082,
                -8.03541420472399
              ],
              [
                -34.928944464333284,
                -8.034926011609771
              ],
              [
                -34.91344153752508,
                -8.045505531905834
              ],
              [
                -34.906849736039824,
                -8.052666799103374
              ],
              [
                -34.901031055299335,
                -8.062758126212257
              ],
              [
                -34.89769446393671,
                -8.074965056880858
              ],
              [
                -34.897572396526655,
                -8.08489355271771
              ],
              [
                -34.89574134122498,
                -8.093845361881927
              ],
              [
                -34.887359175719965,
                -8.10377355721215
              ],
              [
                -34.88353430649924,
                -8.096937652095379
              ],
              [
                -34.88060462051081,
                -8.08953213826735
              ],
              [
                -34.88133704224634,
                -8.105401268113763
              ],
              [
                -34.89419511560638,
                -8.1413713354198
              ],
              [
                -34.900380014080405,
                -8.179620137262434
              ],
              [
                -34.90416419501898,
                -8.189385801476776
              ],
              [
                -34.9207657517642,
                -8.214450685642769
              ],
              [
                -34.9321182910029,
                -8.242119966894492
              ],
              [
                -34.938872851381,
                -8.272067982802515
              ],
              [
                -34.94261634200504,
                -8.310235366789485
              ],
              [
                -34.9422501325024,
                -8.337335038180205
              ],
              [
                -34.93858801713685,
                -8.347100401255164
              ],
              [
                -34.939930792322734,
                -8.350762600163023
              ],
              [
                -34.94591223536136,
                -8.356703233554102
              ],
              [
                -34.95250403628091,
                -8.364678655527587
              ],
              [
                -34.9556778652176,
                -8.374444318900379
              ],
              [
                -34.95734615670436,
                -8.382500855956168
              ],
              [
                -35.02623450037376,
                -8.575860138973184
              ],
              [
                -35.06969153316687,
                -8.662367333913616
              ],
              [
                -35.068959113896696,
                -8.672295826919497
              ],
              [
                -35.080230270678946,
                -8.681084802391576
              ],
              [
                -35.08421790211043,
                -8.70126714997467
              ],
              [
                -35.0860082657793,
                -8.740655158145916
              ],
              [
                -35.096506313721775,
                -8.761488529122696
              ],
              [
                -35.12734941056784,
                -8.806247559453494
              ],
              [
                -35.13377844668714,
                -8.826918098536153
              ],
              [
                -35.138050909558466,
                -8.871351765382666
              ],
              [
                -35.147450328177946,
                -8.911879287039861
              ],
              [
                -35.18887285328422,
                -8.990655292856564
              ],
              [
                -35.232248500931156,
                -9.04778407266635
              ],
              [
                -35.26048743089678,
                -9.114027485840046
              ],
              [
                -35.289418096183674,
                -9.153578315362152
              ],
              [
                -35.305083786498,
                -9.1930477283357
              ],
              [
                -35.39216060837552,
                -9.305759277169914
              ],
              [
                -35.414947070625516,
                -9.323418937204249
              ],
              [
                -35.414947071625846,
                -9.316583036708403
              ],
              [
                -35.437814911043205,
                -9.3283831817037
              ],
              [
                -35.46231034855591,
                -9.346612149333344
              ],
              [
                -35.48204505426405,
                -9.367852590076499
              ],
              [
                -35.49010169069805,
                -9.388929899024635
              ],
              [
                -35.49323482758346,
                -9.404066577959656
              ],
              [
                -35.573638476905785,
                -9.52271904013292
              ],
              [
                -35.582590297302346,
                -9.532891473863703
              ],
              [
                -35.630360482945285,
                -9.56365332158958
              ],
              [
                -35.65754146674842,
                -9.577080873614145
              ],
              [
                -35.67511959691442,
                -9.608656575083424
              ],
              [
                -35.69615637953776,
                -9.672946891702095
              ],
              [
                -35.70933997657049,
                -9.674574601094585
              ],
              [
                -35.71910559899172,
                -9.677829719447358
              ],
              [
                -35.74331620943672,
                -9.679782790455201
              ],
              [
                -35.752308724417794,
                -9.682712547174695
              ],
              [
                -35.76085364075312,
                -9.68710688181558
              ],
              [
                -35.77806556168577,
                -9.700127955908254
              ],
              [
                -35.763050911501765,
                -9.675713817412404
              ],
              [
                -35.749094206243925,
                -9.659844702256198
              ],
              [
                -35.74624589846798,
                -9.641778269308778
              ],
              [
                -35.76504472838157,
                -9.610772477224074
              ],
              [
                -35.77342688901619,
                -9.600355797521114
              ],
              [
                -35.78604082065083,
                -9.588555654795664
              ],
              [
                -35.79991614216085,
                -9.584730627603795
              ],
              [
                -35.81216386247409,
                -9.597832817780011
              ],
              [
                -35.80988522297284,
                -9.604587601825061
              ],
              [
                -35.79523678160006,
                -9.629164272221603
              ],
              [
                -35.79173743090934,
                -9.64218504645345
              ],
              [
                -35.79173743001528,
                -9.66912186474976
              ],
              [
                -35.794911261936036,
                -9.679131766786234
              ],
              [
                -35.801991343437656,
                -9.684258841043617
              ],
              [
                -35.808990040375406,
                -9.686944351218944
              ],
              [
                -35.853179492727214,
                -9.731215161421739
              ],
              [
                -35.858143684120414,
                -9.734551695143328
              ],
              [
                -35.86839759142406,
                -9.718031557043307
              ],
              [
                -35.87710527064381,
                -9.696953952694807
              ],
              [
                -35.87734941129712,
                -9.686618689173141
              ],
              [
                -35.90843665046333,
                -9.63876709698512
              ],
              [
                -35.905425589240856,
                -9.624769937390354
              ],
              [
                -35.91958574444483,
                -9.608086966896183
              ],
              [
                -35.94188392154245,
                -9.599786189330386
              ],
              [
                -35.96304277539474,
                -9.610772477224074
              ],
              [
                -35.951568159578756,
                -9.627617978288969
              ],
              [
                -35.92320715938242,
                -9.645765826940993
              ],
              [
                -35.90843665577547,
                -9.659275094090647
              ],
              [
                -35.90217038115562,
                -9.671156651709051
              ],
              [
                -35.87897701844679,
                -9.74920017764045
              ],
              [
                -35.873646615862626,
                -9.755466467873577
              ],
              [
                -35.8609106091708,
                -9.76002363328498
              ],
              [
                -35.85741126179177,
                -9.755303636859175
              ],
              [
                -35.85692298091874,
                -9.747002860212419
              ],
              [
                -35.85317948689842,
                -9.74114334705295
              ],
              [
                -35.81956946871364,
                -9.735528380818733
              ],
              [
                -35.80557206866332,
                -9.731052330404307
              ],
              [
                -35.79857337032273,
                -9.72063565164059
              ],
              [
                -35.81061764042343,
                -9.744805542780698
              ],
              [
                -35.86204993314632,
                -9.79404059384243
              ],
              [
                -35.882679815541394,
                -9.855645391540916
              ],
              [
                -35.90392005435541,
                -9.878187871436694
              ],
              [
                -35.94937089698772,
                -9.913181213954338
              ],
              [
                -35.97329667686347,
                -9.96575279159739
              ],
              [
                -35.980376761037064,
                -9.974542059769288
              ],
              [
                -35.99201413037015,
                -9.980726933393614
              ],
              [
                -36.00218665073462,
                -9.995537943597714
              ],
              [
                -36.03628496000427,
                -10.06414153414291
              ],
              [
                -36.05011959499087,
                -10.078545830700943
              ],
              [
                -36.09032141787306,
                -10.093438404832389
              ],
              [
                -36.14118404886825,
                -10.15943775370989
              ],
              [
                -36.25104733021456,
                -10.248223572903106
              ],
              [
                -36.28050696470745,
                -10.279961837632568
              ],
              [
                -36.28897050718105,
                -10.297051696788873
              ],
              [
                -36.2919815752936,
                -10.320245059363383
              ],
              [
                -36.29092363166673,
                -10.332289310390724
              ],
              [
                -36.28917395699302,
                -10.338962497779477
              ],
              [
                -36.28880774649405,
                -10.344008086715052
              ],
              [
                -36.291981574740454,
                -10.351983322756045
              ],
              [
                -36.40807044230178,
                -10.50212982540748
              ],
              [
                -36.42076575347478,
                -10.50872159664893
              ],
              [
                -36.4579158192886,
                -10.520440371966993
              ],
              [
                -36.48607337120615,
                -10.52337005639925
              ],
              [
                -36.50499427006579,
                -10.527764583041023
              ],
              [
                -36.52013098870794,
                -10.533786707957367
              ],
              [
                -36.53844153571594,
                -10.54363371321904
              ],
              [
                -36.576568162903044,
                -10.550469656009545
              ],
              [
                -36.581939256435426,
                -10.553806230585511
              ],
              [
                -36.59178626148801,
                -10.567803628235978
              ],
              [
                -36.59675045539867,
                -10.570977484272642
              ],
              [
                -36.6109106114463,
                -10.57512787672725
              ],
              [
                -36.76838131401131,
                -10.6726213523438
              ],
              [
                -36.903065559731104,
                -10.772881790847514
              ],
              [
                -36.95270748517316,
                -10.836358306493555
              ],
              [
                -36.96336829251041,
                -10.8654110515396
              ],
              [
                -36.97887122246795,
                -10.886488524325637
              ],
              [
                -37.02936764270004,
                -10.935642205493119
              ],
              [
                -37.03966224015397,
                -10.949151333724263
              ],
              [
                -37.04442298098485,
                -10.96445077856039
              ],
              [
                -37.045521612849136,
                -10.985284079502653
              ],
              [
                -37.05044511717252,
                -10.999607063075985
              ],
              [
                -37.124012825460426,
                -11.115329698196202
              ],
              [
                -37.138295052022954,
                -11.125909142270894
              ],
              [
                -37.1476130859846,
                -11.121758750179037
              ],
              [
                -37.147043423629476,
                -11.111993086386857
              ],
              [
                -37.14281165403254,
                -11.100681277620534
              ],
              [
                -37.141713018924314,
                -11.09172939411659
              ],
              [
                -37.14663652277947,
                -11.085219001666749
              ],
              [
                -37.1521703769158,
                -11.08367278158241
              ],
              [
                -37.157582162082605,
                -11.080987269106929
              ],
              [
                -37.16222083159602,
                -11.071384361384178
              ],
              [
                -37.16966712059592,
                -11.071384361384178
              ],
              [
                -37.17568925629739,
                -11.08570726983445
              ],
              [
                -37.185210740632414,
                -11.0741512894404
              ],
              [
                -37.20006262857351,
                -11.043389568713689
              ],
              [
                -37.20685787790752,
                -11.03915783615518
              ],
              [
                -37.24852454320647,
                -11.021661071956517
              ],
              [
                -37.258412239650504,
                -11.019789339760381
              ],
              [
                -37.261545376687344,
                -11.015232019981621
              ],
              [
                -37.26838131523018,
                -11.01637138747969
              ],
              [
                -37.27513587155077,
                -11.022719023873131
              ],
              [
                -37.27822831873608,
                -11.033379808405925
              ],
              [
                -37.276112435083284,
                -11.041762008155294
              ],
              [
                -37.27086341174996,
                -11.0533179885461
              ],
              [
                -37.26431230489785,
                -11.064385700769472
              ],
              [
                -37.25841223859497,
                -11.071384361384178
              ],
              [
                -37.25157630169894,
                -11.073011997049374
              ],
              [
                -37.24461829304232,
                -11.07089609321663
              ],
              [
                -37.236887175280906,
                -11.069594044769802
              ],
              [
                -37.22740637801249,
                -11.074802313663865
              ],
              [
                -37.21930904994693,
                -11.081150025162808
              ],
              [
                -37.21129309715918,
                -11.085870025890367
              ],
              [
                -37.19635982892273,
                -11.09172939411659
              ],
              [
                -37.19635983037644,
                -11.098565373786263
              ],
              [
                -37.214222784922214,
                -11.09172939411659
              ],
              [
                -37.22069251144341,
                -11.096774982064069
              ],
              [
                -37.21678626186559,
                -11.106133718156357
              ],
              [
                -37.203765429700006,
                -11.112237258024253
              ],
              [
                -37.194447396009274,
                -11.110528281882406
              ],
              [
                -37.190337693864684,
                -11.104750254126968
              ],
              [
                -37.18781490748071,
                -11.099541910122085
              ],
              [
                -37.1826879553763,
                -11.098565373786263
              ],
              [
                -37.17267818775966,
                -11.103122618460347
              ],
              [
                -37.165638802282665,
                -11.108819305740662
              ],
              [
                -37.16392981777258,
                -11.116387650114076
              ],
              [
                -37.16966712202378,
                -11.125909142270894
              ],
              [
                -37.163319464304365,
                -11.136162999132765
              ],
              [
                -37.1640518858149,
                -11.170342672272987
              ],
              [
                -37.15538489619596,
                -11.187432583987855
              ],
              [
                -37.15538489410335,
                -11.181247628504625
              ],
              [
                -37.14915931019574,
                -11.187432583987855
              ],
              [
                -37.17247473823033,
                -11.203545809176354
              ],
              [
                -37.199452276753874,
                -11.215264545734804
              ],
              [
                -37.22179114611344,
                -11.22958752944841
              ],
              [
                -37.23110917930551,
                -11.252862246607622
              ],
              [
                -37.23542232806993,
                -11.260837443685942
              ],
              [
                -37.2453507125148,
                -11.267022324128156
              ],
              [
                -37.25658118190767,
                -11.272230668223356
              ],
              [
                -37.264637823301506,
                -11.277439012323198
              ],
              [
                -37.26976477860204,
                -11.284844675887047
              ],
              [
                -37.285755990968184,
                -11.31707127699478
              ],
              [
                -37.31602942572135,
                -11.40642668329321
              ],
              [
                -37.33006751290482,
                -11.420668251985942
              ],
              [
                -37.374867315780584,
                -11.429864157403257
              ],
              [
                -37.38809160264187,
                -11.426934548237531
              ],
              [
                -37.38988196747858,
                -11.419040691342321
              ],
              [
                -37.38442948918955,
                -11.409437708027136
              ],
              [
                -37.38442949099569,
                -11.40195077888291
              ],
              [
                -37.40245520920843,
                -11.399672193993904
              ],
              [
                -37.374379033514614,
                -11.362399929045162
              ],
              [
                -37.368275521513674,
                -11.351250951053137
              ],
              [
                -37.36217200258306,
                -11.32480230252304
              ],
              [
                -37.35830644309937,
                -11.315850493883056
              ],
              [
                -37.34715735493716,
                -11.303399317312442
              ],
              [
                -37.30557206908543,
                -11.269952083399449
              ],
              [
                -37.294992642560324,
                -11.258233346749297
              ],
              [
                -37.29051672993775,
                -11.254327051133101
              ],
              [
                -37.272084114897936,
                -11.249444294276156
              ],
              [
                -37.285878059739964,
                -11.236993117849314
              ],
              [
                -37.28844153481325,
                -11.208184469469854
              ],
              [
                -37.29938717356752,
                -11.19475675676816
              ],
              [
                -37.303334113736184,
                -11.219821865559542
              ],
              [
                -37.30308997257501,
                -11.231215090026742
              ],
              [
                -37.29938717341415,
                -11.242608314511944
              ],
              [
                -37.30557206841405,
                -11.242608314511944
              ],
              [
                -37.32412675675785,
                -11.208591397166591
              ],
              [
                -37.336781379925924,
                -11.19052502417764
              ],
              [
                -37.34410559821976,
                -11.184258728217289
              ],
              [
                -37.34788977925823,
                -11.204196908512104
              ],
              [
                -37.31997636658309,
                -11.249769806392734
              ],
              [
                -37.31920325408549,
                -11.269952083399449
              ],
              [
                -37.325591602236955,
                -11.263116178719672
              ],
              [
                -37.34715735689973,
                -11.249444294276156
              ],
              [
                -37.34618079360051,
                -11.261000274851154
              ],
              [
                -37.34129798326708,
                -11.267673498576407
              ],
              [
                -37.33604895962819,
                -11.272881842672179
              ],
              [
                -37.33348548311274,
                -11.280450187182586
              ],
              [
                -37.33629310023653,
                -11.290134435581562
              ],
              [
                -37.343129035732936,
                -11.292738532532596
              ],
              [
                -37.35204016713334,
                -11.293389556770551
              ],
              [
                -37.36082923112846,
                -11.296563412591661
              ],
              [
                -37.37144934952651,
                -11.306329076603097
              ],
              [
                -37.37975012686023,
                -11.317152542364946
              ],
              [
                -37.395578580789206,
                -11.344984654924396
              ],
              [
                -37.40819251126417,
                -11.395684482674971
              ],
              [
                -37.41539466072059,
                -11.40642668329321
              ],
              [
                -37.42955481671709,
                -11.405043219198301
              ],
              [
                -37.43626868317547,
                -11.388767162225516
              ],
              [
                -37.44334876351668,
                -11.351250951053137
              ],
              [
                -37.44566810033273,
                -11.364434567586008
              ],
              [
                -37.45177161449064,
                -11.370538032574778
              ],
              [
                -37.46043860805876,
                -11.368910471952887
              ],
              [
                -37.47008215942926,
                -11.358656464516484
              ],
              [
                -37.46035722360643,
                -11.391778186945116
              ],
              [
                -37.45372473742277,
                -11.40357833951877
              ],
              [
                -37.443348760554876,
                -11.413262588190385
              ],
              [
                -37.40172278574624,
                -11.428887621014399
              ],
              [
                -37.39557857826253,
                -11.437432502192994
              ],
              [
                -37.405995247640675,
                -11.470472959982082
              ],
              [
                -37.43138587138625,
                -11.492852482559803
              ],
              [
                -37.46296139327522,
                -11.5074195637769
              ],
              [
                -37.49185136546046,
                -11.516289957313225
              ],
              [
                -37.474842902838574,
                -11.520114837607384
              ],
              [
                -37.45384680850289,
                -11.517673421457037
              ],
              [
                -37.43276933534708,
                -11.511163028471017
              ],
              [
                -37.415394660918494,
                -11.503187755775048
              ],
              [
                -37.4019669241037,
                -11.490980675117417
              ],
              [
                -37.38975989283297,
                -11.474379105589554
              ],
              [
                -37.37677974997023,
                -11.460218952252788
              ],
              [
                -37.360829231435,
                -11.454847926961536
              ],
              [
                -37.36823482977789,
                -11.47380949690813
              ],
              [
                -37.434722461291166,
                -11.569268523016403
              ],
              [
                -37.509185348542744,
                -11.723809437534348
              ],
              [
                -37.51341712258395,
                -11.76067478004031
              ],
              [
                -37.5228165362625,
                -11.77613698395579
              ],
              [
                -37.545765752868384,
                -11.804375879126471
              ],
              [
                -37.60423743595283,
                -11.949965152726696
              ],
              [
                -37.63174394168677,
                -11.995293818232657
              ],
              [
                -37.65465247457692,
                -12.049737278499295
              ],
              [
                -37.71764075582777,
                -12.136407205458655
              ],
              [
                -37.786709731992886,
                -12.264634107773901
              ],
              [
                -37.871175350748885,
                -12.382262572205036
              ],
              [
                -37.933390111823414,
                -12.475376228999222
              ],
              [
                -37.99852453823504,
                -12.562188293746713
              ],
              [
                -38.050892706410444,
                -12.641045816870433
              ],
              [
                -38.063465949009874,
                -12.647230703292358
              ],
              [
                -38.073963990955185,
                -12.653903783308778
              ],
              [
                -38.14549720341447,
                -12.735040052893963
              ],
              [
                -38.213246216862416,
                -12.820000765049977
              ],
              [
                -38.29137122657966,
                -12.894952164180463
              ],
              [
                -38.320423953628435,
                -12.935235206021547
              ],
              [
                -38.339995892674175,
                -12.950290500065163
              ],
              [
                -38.36139889673187,
                -12.961846722044262
              ],
              [
                -38.37193763326268,
                -12.965264679173034
              ],
              [
                -38.39427649514061,
                -12.968438389227085
              ],
              [
                -38.40611731079558,
                -12.96884516728698
              ],
              [
                -38.41624914864969,
                -12.973076981002889
              ],
              [
                -38.437001101583704,
                -12.992364089729964
              ],
              [
                -38.46495520957544,
                -13.00237401496001
              ],
              [
                -38.48643957854371,
                -13.013767106008832
              ],
              [
                -38.50967362991571,
                -13.021416877429434
              ],
              [
                -38.5327042277225,
                -13.016534038205384
              ],
              [
                -38.53831945920931,
                -13.004001427710943
              ],
              [
                -38.51838130993853,
                -12.966892091833296
              ],
              [
                -38.507923954091794,
                -12.931817249044029
              ],
              [
                -38.49779212478914,
                -12.918389668378188
              ],
              [
                -38.48619543870255,
                -12.915948098922712
              ],
              [
                -38.4774063756146,
                -12.935235206021547
              ],
              [
                -38.47907467070316,
                -12.915948098922712
              ],
              [
                -38.48704993329384,
                -12.898858314682922
              ],
              [
                -38.4912003314775,
                -12.882012777923388
              ],
              [
                -38.47565671085934,
                -12.851657946070075
              ],
              [
                -38.48009192283239,
                -12.842217632382388
              ],
              [
                -38.48766028459468,
                -12.834730694323017
              ],
              [
                -38.4917699872795,
                -12.829359662765931
              ],
              [
                -38.492298957780704,
                -12.822442334174765
              ],
              [
                -38.494130013246895,
                -12.817640912040007
              ],
              [
                -38.50226802679835,
                -12.808282014474582
              ],
              [
                -38.504058404385184,
                -12.804131917858774
              ],
              [
                -38.50226803686572,
                -12.800551130157618
              ],
              [
                -38.49974523978917,
                -12.796563264086572
              ],
              [
                -38.49913489143647,
                -12.791192232809935
              ],
              [
                -38.5089005159268,
                -12.722914225301086
              ],
              [
                -38.526966924962636,
                -12.723077056640095
              ],
              [
                -38.54238847333545,
                -12.721612175444088
              ],
              [
                -38.557484503238044,
                -12.71550870410861
              ],
              [
                -38.574289518422006,
                -12.701836880423228
              ],
              [
                -38.60594642089928,
                -12.713637045011149
              ],
              [
                -38.62621008921883,
                -12.70240648966752
              ],
              [
                -38.6376033131602,
                -12.68075923568793
              ],
              [
                -38.64858964875265,
                -12.638360301767573
              ],
              [
                -38.6561580111974,
                -12.633721712104155
              ],
              [
                -38.667144332513764,
                -12.634047074318673
              ],
              [
                -38.683461069313175,
                -12.626722969615395
              ],
              [
                -38.69456946214355,
                -12.614027534496412
              ],
              [
                -38.695179823254655,
                -12.602797280975361
              ],
              [
                -38.69180253308655,
                -12.589776183599641
              ],
              [
                -38.69098873683116,
                -12.571465772727475
              ],
              [
                -38.697132942831274,
                -12.571465772727475
              ],
              [
                -38.7158096974058,
                -12.605075717674286
              ],
              [
                -38.72207597658846,
                -12.622491157887245
              ],
              [
                -38.724476698261014,
                -12.643487385425074
              ],
              [
                -38.72447669838774,
                -12.671075278004004
              ],
              [
                -38.72630774381245,
                -12.678887576673558
              ],
              [
                -38.730336065769315,
                -12.682386948137696
              ],
              [
                -38.73497473862276,
                -12.684502854156715
              ],
              [
                -38.73814857287719,
                -12.687595447743469
              ],
              [
                -38.75096595058837,
                -12.712823188753328
              ],
              [
                -38.750396288549894,
                -12.72454193783885
              ],
              [
                -38.738148560713086,
                -12.736586049359673
              ],
              [
                -38.77721107288647,
                -12.80754987422004
              ],
              [
                -38.7899470741102,
                -12.818536184091272
              ],
              [
                -38.79548091938665,
                -12.821465646438497
              ],
              [
                -38.80663001827582,
                -12.835137772731597
              ],
              [
                -38.8138321629482,
                -12.83904392290459
              ],
              [
                -38.82445227603968,
                -12.838148650828007
              ],
              [
                -38.83556067183766,
                -12.828382975020352
              ],
              [
                -38.844878711791054,
                -12.825941706302443
              ],
              [
                -38.85582434690211,
                -12.816827055669531
              ],
              [
                -38.86400306406864,
                -12.795098683174672
              ],
              [
                -38.8827205005556,
                -12.722100369033507
              ],
              [
                -38.8811742854019,
                -12.705336251989678
              ],
              [
                -38.86986243333117,
                -12.69207120638709
              ],
              [
                -38.848011853844696,
                -12.674493233769185
              ],
              [
                -38.861683720851104,
                -12.654066614633487
              ],
              [
                -38.86847896785074,
                -12.654066614633487
              ],
              [
                -38.86339270351604,
                -12.669854343470385
              ],
              [
                -38.86986243780171,
                -12.6778297738843
              ],
              [
                -38.88243568241849,
                -12.684177491921702
              ],
              [
                -38.89582272255821,
                -12.69500096867051
              ],
              [
                -38.90318763015169,
                -12.709405232821258
              ],
              [
                -38.90583248637756,
                -12.721775006782806
              ],
              [
                -38.910511854266495,
                -12.731052487597553
              ],
              [
                -38.92369543568298,
                -12.736586049359673
              ],
              [
                -38.914662235729566,
                -12.74846763015273
              ],
              [
                -38.90367591686079,
                -12.772393623647835
              ],
              [
                -38.895822717502604,
                -12.784356320254775
              ],
              [
                -38.888010215593226,
                -12.790459792145528
              ],
              [
                -38.88149980961853,
                -12.791680726871189
              ],
              [
                -38.875355592350616,
                -12.794528773433939
              ],
              [
                -38.8684789642453,
                -12.804864058109906
              ],
              [
                -38.86921138654815,
                -12.809014455156737
              ],
              [
                -38.86913001650227,
                -12.820570674810481
              ],
              [
                -38.86701412403128,
                -12.834649278641312
              ],
              [
                -38.86168372386809,
                -12.845879835971793
              ],
              [
                -38.85399329120198,
                -12.851250867652132
              ],
              [
                -38.83429928877573,
                -12.860609765774383
              ],
              [
                -38.82750403142754,
                -12.866957184935506
              ],
              [
                -38.8121231812519,
                -12.853692436882717
              ],
              [
                -38.803618946612445,
                -12.848728183173472
              ],
              [
                -38.79710852837021,
                -12.849297792529796
              ],
              [
                -38.792795374048666,
                -12.856703315056974
              ],
              [
                -38.78880774833109,
                -12.866631822621004
              ],
              [
                -38.78368079810043,
                -12.872979542262906
              ],
              [
                -38.775990365794534,
                -12.870049779278533
              ],
              [
                -38.76545163149417,
                -12.86467874745652
              ],
              [
                -38.752308722887086,
                -12.864434500401263
              ],
              [
                -38.738026496900254,
                -12.867933872733653
              ],
              [
                -38.72447668865118,
                -12.873223488894252
              ],
              [
                -38.73371334441729,
                -12.879571208595339
              ],
              [
                -38.73631750627104,
                -12.882744918253882
              ],
              [
                -38.74217689307517,
                -12.897149486495492
              ],
              [
                -38.74693763176888,
                -12.904555009525069
              ],
              [
                -38.75080319083722,
                -12.912774389113068
              ],
              [
                -38.75243079112778,
                -12.924981335140108
              ],
              [
                -38.751332159961315,
                -12.946384349270778
              ],
              [
                -38.75210526969678,
                -12.95728924561494
              ],
              [
                -38.7558487562171,
                -12.965427210140028
              ],
              [
                -38.76744543574168,
                -12.97918045453094
              ],
              [
                -38.786854627155606,
                -13.008070710673234
              ],
              [
                -38.80089270197722,
                -13.024020978249968
              ],
              [
                -38.81554114573144,
                -13.03671642053955
              ],
              [
                -38.83511309077342,
                -13.050062888309908
              ],
              [
                -38.85708573827228,
                -13.060642123533057
              ],
              [
                -38.87901770619339,
                -13.064873937841973
              ],
              [
                -38.88927161437472,
                -13.069756777431126
              ],
              [
                -38.89500892248042,
                -13.080987338670841
              ],
              [
                -38.89688066553094,
                -13.094659169790935
              ],
              [
                -38.89582272596804,
                -13.10654075676311
              ],
              [
                -38.893381320575045,
                -13.113458088279318
              ],
              [
                -38.8897598910043,
                -13.118422043533593
              ],
              [
                -38.884144666038395,
                -13.122328495789894
              ],
              [
                -38.87535560180113,
                -13.126397479078262
              ],
              [
                -38.806996217358325,
                -13.143812631717948
              ],
              [
                -38.810658327234755,
                -13.15349689644481
              ],
              [
                -38.819569468438885,
                -13.156670907858237
              ],
              [
                -38.83092200279598,
                -13.157810127103108
              ],
              [
                -38.84178626031032,
                -13.16122808527752
              ],
              [
                -38.85179602779749,
                -13.168877858485276
              ],
              [
                -38.87535559161702,
                -13.195407668079582
              ],
              [
                -38.931752084026705,
                -13.23300551183696
              ],
              [
                -38.94762122481573,
                -13.246758762100463
              ],
              [
                -38.957508923268286,
                -13.264825244118345
              ],
              [
                -38.96349036390494,
                -13.305840750914687
              ],
              [
                -38.97085526935423,
                -13.325616064138739
              ],
              [
                -38.95685787432206,
                -13.356621944490705
              ],
              [
                -38.9545792292572,
                -13.372491105978687
              ],
              [
                -38.96471107018765,
                -13.380303713477353
              ],
              [
                -38.98961341721994,
                -13.363946357691784
              ],
              [
                -38.998850069022474,
                -13.360446982578633
              ],
              [
                -39.00959225374575,
                -13.360284151079222
              ],
              [
                -39.039784313900675,
                -13.366631875747254
              ],
              [
                -39.0376684182147,
                -13.357842579875154
              ],
              [
                -39.03697669830753,
                -13.350193104615398
              ],
              [
                -39.03770910725835,
                -13.341973418803494
              ],
              [
                -39.03978430449071,
                -13.33245198246116
              ],
              [
                -39.06248938513717,
                -13.39999761357819
              ],
              [
                -39.06822669079256,
                -13.440606351904135
              ],
              [
                -39.06029212254701,
                -13.47031018735067
              ],
              [
                -39.0710343133841,
                -13.480075873396554
              ],
              [
                -39.07994544826949,
                -13.495294012765264
              ],
              [
                -39.08600826411027,
                -13.514092644005592
              ],
              [
                -39.088205535133646,
                -13.534275043685714
              ],
              [
                -39.08421790184346,
                -13.578789947339754
              ],
              [
                -39.09142004519755,
                -13.59368242646676
              ],
              [
                -39.115549281263114,
                -13.59937912806527
              ],
              [
                -39.115549278864314,
                -13.606133634109879
              ],
              [
                -39.08665930209572,
                -13.603936309133971
              ],
              [
                -39.07738196864678,
                -13.59002051869633
              ],
              [
                -39.08079993538518,
                -13.541110964647093
              ],
              [
                -39.07502194475429,
                -13.517266657449381
              ],
              [
                -39.05968176633355,
                -13.494805518145606
              ],
              [
                -39.03766842152297,
                -13.484551637645128
              ],
              [
                -39.011830206055,
                -13.497002842656059
              ],
              [
                -39.00706946913445,
                -13.504815451958429
              ],
              [
                -39.00316321645829,
                -13.522556279329
              ],
              [
                -38.99543209712859,
                -13.534275043685714
              ],
              [
                -38.99299069038211,
                -13.541110964647093
              ],
              [
                -38.996937625340955,
                -13.547051612566579
              ],
              [
                -39.0026749353178,
                -13.553480755228717
              ],
              [
                -39.005686004412674,
                -13.56178155963519
              ],
              [
                -39.00194251786144,
                -13.588067441144165
              ],
              [
                -38.99278723840038,
                -13.607679933220213
              ],
              [
                -38.9814347035383,
                -13.625746427316507
              ],
              [
                -38.97085527627618,
                -13.647719077611441
              ],
              [
                -38.96784421196446,
                -13.674004963623652
              ],
              [
                -38.97573807796121,
                -13.692559354093792
              ],
              [
                -38.98656165606418,
                -13.710219072700115
              ],
              [
                -38.99201412001344,
                -13.733086699821492
              ],
              [
                -38.994211393575675,
                -13.794610317001577
              ],
              [
                -38.99201412455915,
                -13.812269738961598
              ],
              [
                -38.98184160269361,
                -13.827569304374068
              ],
              [
                -38.97996985904014,
                -13.83587011345182
              ],
              [
                -38.98859615148403,
                -13.83953202308473
              ],
              [
                -39.0016983683796,
                -13.83766036035135
              ],
              [
                -39.011219859350604,
                -13.832452150897517
              ],
              [
                -39.029896618812415,
                -13.815362338503878
              ],
              [
                -39.037342899478524,
                -13.805352398404281
              ],
              [
                -39.04076087500068,
                -13.794040706695792
              ],
              [
                -39.04287676001663,
                -13.782321936174974
              ],
              [
                -39.046620247289816,
                -13.771254192037965
              ],
              [
                -39.05357825457441,
                -13.760918890051219
              ],
              [
                -39.06017004565176,
                -13.755140770763436
              ],
              [
                -39.06696529545883,
                -13.750420756666315
              ],
              [
                -39.074533664324385,
                -13.74334088582188
              ],
              [
                -39.07957923107667,
                -13.740980728612145
              ],
              [
                -39.083973768090864,
                -13.74195741790411
              ],
              [
                -39.08702552343972,
                -13.74114356023187
              ],
              [
                -39.09162349868148,
                -13.712660345136717
              ],
              [
                -39.099680146544166,
                -13.708917020681982
              ],
              [
                -39.110951304604015,
                -13.708184578869915
              ],
              [
                -39.132557743027725,
                -13.709242383472537
              ],
              [
                -39.14110267155671,
                -13.719170905740105
              ],
              [
                -39.148752409129926,
                -13.73691174070047
              ],
              [
                -39.14403235402928,
                -13.744317274691321
              ],
              [
                -39.11554927792352,
                -13.723565256301766
              ],
              [
                -39.11001543611056,
                -13.731703532360685
              ],
              [
                -39.10826575649509,
                -13.740411118370787
              ],
              [
                -39.11009680692749,
                -13.749118704539294
              ],
              [
                -39.115549285570474,
                -13.757582343855876
              ],
              [
                -39.07160397258533,
                -13.7795550001164
              ],
              [
                -39.060292120428635,
                -13.791761965052169
              ],
              [
                -39.0432022828839,
                -13.82634866785808
              ],
              [
                -39.03213457026753,
                -13.840590128408632
              ],
              [
                -38.99771074575359,
                -13.851739290019957
              ],
              [
                -38.994455538828696,
                -13.863458062292054
              ],
              [
                -38.999989393921915,
                -13.87517683486414
              ],
              [
                -39.0087784544524,
                -13.88054787647122
              ],
              [
                -39.03490149603475,
                -13.879652602723151
              ],
              [
                -39.048939575424,
                -13.87590897650917
              ],
              [
                -39.06712806210508,
                -13.867445635472091
              ],
              [
                -39.0745336613455,
                -13.894219728276495
              ],
              [
                -39.07115638127156,
                -13.903090149003484
              ],
              [
                -39.063710087608484,
                -13.935804896658384
              ],
              [
                -39.05748450285271,
                -13.937920807330162
              ],
              [
                -39.04124915945651,
                -13.947198308152315
              ],
              [
                -39.02159582878358,
                -13.955661650688986
              ],
              [
                -39.00739498867931,
                -13.969659168188047
              ],
              [
                -38.99669349543204,
                -13.98560976532509
              ],
              [
                -38.992014132947695,
                -13.997247125242927
              ],
              [
                -38.99282792333788,
                -14.009047016758537
              ],
              [
                -38.9955948607904,
                -14.01913837724879
              ],
              [
                -38.99567623661226,
                -14.029229437546284
              ],
              [
                -38.982818168488244,
                -14.05071391226841
              ],
              [
                -38.97956294860732,
                -14.06113033634814
              ],
              [
                -38.980824344947166,
                -14.069512565658094
              ],
              [
                -38.988596154719275,
                -14.072930530038494
              ],
              [
                -39.02790279326197,
                -14.078301574059143
              ],
              [
                -39.03986568871763,
                -14.07512785724626
              ],
              [
                -39.054066533582635,
                -14.059258672681102
              ],
              [
                -39.07103430548571,
                -14.076348494446297
              ],
              [
                -39.07286535885851,
                -14.08586994541095
              ],
              [
                -39.06029211855804,
                -14.099704635373977
              ],
              [
                -39.06680254537948,
                -14.105645590866242
              ],
              [
                -39.072906059791265,
                -14.115167042490581
              ],
              [
                -39.07624264499372,
                -14.127374016661753
              ],
              [
                -39.07453366449016,
                -14.140557681354682
              ],
              [
                -39.06672116293309,
                -14.15007913377346
              ],
              [
                -39.055897583687376,
                -14.15504309935123
              ],
              [
                -39.04564368160746,
                -14.16139083463678
              ],
              [
                -39.03978431295589,
                -14.175388358878298
              ],
              [
                -39.03359941695528,
                -14.175388358878298
              ],
              [
                -39.0570369163444,
                -14.133558919762265
              ],
              [
                -39.06338456591296,
                -14.109958529328164
              ],
              [
                -39.0432022755591,
                -14.099704635373977
              ],
              [
                -39.02428137425579,
                -14.09685628147078
              ],
              [
                -39.00283769392836,
                -14.089532157541761
              ],
              [
                -38.95726477517728,
                -14.066094601305087
              ],
              [
                -38.959095831812014,
                -14.057305593155403
              ],
              [
                -38.95836341818255,
                -14.045993895083683
              ],
              [
                -38.959706187630836,
                -14.036228197418112
              ],
              [
                -38.967844204379176,
                -14.031914959274557
              ],
              [
                -38.972279429593584,
                -14.026625331695703
              ],
              [
                -38.97069251254912,
                -14.014825139275537
              ],
              [
                -38.964711072943516,
                -13.997247125242927
              ],
              [
                -38.96532141351232,
                -13.99195719765829
              ],
              [
                -38.96910559301083,
                -13.989190260322635
              ],
              [
                -38.97142493967039,
                -13.986260791724971
              ],
              [
                -38.96784420623496,
                -13.980564085438145
              ],
              [
                -38.96304276949866,
                -13.9782853428586
              ],
              [
                -38.95295162501489,
                -13.976983290083457
              ],
              [
                -38.95103919022786,
                -13.973565326460106
              ],
              [
                -38.95287024403935,
                -13.962578993534013
              ],
              [
                -38.95807858368426,
                -13.955987314080444
              ],
              [
                -38.96666418558609,
                -13.952080855536199
              ],
              [
                -38.97834224683319,
                -13.949395334297426
              ],
              [
                -38.97565670949054,
                -13.945733423776606
              ],
              [
                -38.97085527061418,
                -13.935804896658384
              ],
              [
                -38.987538211628156,
                -13.939873886322061
              ],
              [
                -38.98997961520637,
                -13.930840633182141
              ],
              [
                -38.98375404135287,
                -13.91627380687369
              ],
              [
                -38.974598764478245,
                -13.904473617401212
              ],
              [
                -38.963856580484354,
                -13.897068080859036
              ],
              [
                -38.94888260932431,
                -13.890313270270488
              ],
              [
                -38.9356583250699,
                -13.888929801916067
              ],
              [
                -38.929921031046106,
                -13.89763769129222
              ],
              [
                -38.92906653425413,
                -13.983168191013545
              ],
              [
                -38.92369544743766,
                -14.004083052885532
              ],
              [
                -38.94668534558557,
                -14.102308741669988
              ],
              [
                -38.9592992771154,
                -14.122165503347814
              ],
              [
                -38.964711073820915,
                -14.133721751525307
              ],
              [
                -38.96686764605414,
                -14.145928726238216
              ],
              [
                -38.968373182354696,
                -14.170017313612933
              ],
              [
                -38.970855277337805,
                -14.181573262694638
              ],
              [
                -38.98924720284773,
                -14.212334951381077
              ],
              [
                -38.99201412851751,
                -14.226657840535243
              ],
              [
                -38.99201413030951,
                -14.267836262340428
              ],
              [
                -38.984201631968084,
                -14.299411816318443
              ],
              [
                -38.985178182797824,
                -14.312595186166346
              ],
              [
                -38.992095501789805,
                -14.32496499810943
              ],
              [
                -39.00072181418554,
                -14.33570739327735
              ],
              [
                -39.004994264445706,
                -14.34685626750659
              ],
              [
                -38.99885006773166,
                -14.360284187157095
              ],
              [
                -39.00694739308211,
                -14.370293839931119
              ],
              [
                -39.007639123660816,
                -14.3832332647986
              ],
              [
                -39.00560461580763,
                -14.398207187193446
              ],
              [
                -39.00568600437566,
                -14.414971659966591
              ],
              [
                -39.02611243117092,
                -14.463311400348115
              ],
              [
                -39.03359940865936,
                -14.539157725216846
              ],
              [
                -39.05142167858072,
                -14.591973557854697
              ],
              [
                -39.056263805176805,
                -14.622247083924442
              ],
              [
                -39.06558183539225,
                -14.654880474576785
              ],
              [
                -39.067128065987,
                -14.674981512687912
              ],
              [
                -39.05406654014358,
                -14.75408302033275
              ],
              [
                -39.050852023711016,
                -14.765801819362306
              ],
              [
                -39.036732558116164,
                -14.779473701993073
              ],
              [
                -39.03359941568892,
                -14.792250309332173
              ],
              [
                -39.04564368042999,
                -14.796075059895427
              ],
              [
                -39.05296789545224,
                -14.801364698106125
              ],
              [
                -39.05406654200057,
                -14.812188523285322
              ],
              [
                -39.04824784781172,
                -14.818617385304998
              ],
              [
                -39.03921465192643,
                -14.817559577774333
              ],
              [
                -39.02969316228785,
                -14.81462980243236
              ],
              [
                -39.02269446095954,
                -14.815850442012406
              ],
              [
                -39.0261124390933,
                -14.857191761683158
              ],
              [
                -39.022938598743494,
                -14.900323037780009
              ],
              [
                -39.00890052000748,
                -14.97087981614159
              ],
              [
                -39.00182044167573,
                -15.232028898041685
              ],
              [
                -38.979644334176385,
                -15.323663003971019
              ],
              [
                -38.97325598916828,
                -15.409356381051143
              ],
              [
                -38.943267382023954,
                -15.56536223843044
              ],
              [
                -38.92389889302151,
                -15.715590120108425
              ],
              [
                -38.904896615621695,
                -15.75750093767407
              ],
              [
                -38.892404751898994,
                -15.77499765221668
              ],
              [
                -38.88857988080607,
                -15.782891512921838
              ],
              [
                -38.882720507322034,
                -15.812676696675648
              ],
              [
                -38.87791907683839,
                -15.822360967376103
              ],
              [
                -38.864369268968005,
                -15.843357010848312
              ],
              [
                -38.86168372442482,
                -15.85426200204609
              ],
              [
                -38.86701412654156,
                -15.869724208952412
              ],
              [
                -38.89049231788866,
                -15.904392200554943
              ],
              [
                -38.895822719920446,
                -15.918877861609987
              ],
              [
                -38.89875240925611,
                -15.940036738927331
              ],
              [
                -38.923695441462186,
                -16.00514087366097
              ],
              [
                -38.92418372419108,
                -16.02361421166039
              ],
              [
                -38.92955481493091,
                -16.038343972153122
              ],
              [
                -38.944203252958715,
                -16.066582923000965
              ],
              [
                -38.94786536384461,
                -16.081475516317873
              ],
              [
                -38.952748176004135,
                -16.167087498071997
              ],
              [
                -38.95726477763499,
                -16.183282152741928
              ],
              [
                -38.998036261833946,
                -16.252862235169527
              ],
              [
                -39.00536048336419,
                -16.275079074258077
              ],
              [
                -39.00767981548693,
                -16.299248930277507
              ],
              [
                -39.005686000088346,
                -16.326592673554728
              ],
              [
                -39.00690670175719,
                -16.359307495073217
              ],
              [
                -39.018381313818324,
                -16.383070567928712
              ],
              [
                -39.054066536019924,
                -16.436455988336387
              ],
              [
                -39.049631316823145,
                -16.44703546251471
              ],
              [
                -39.050648566863785,
                -16.45671965670986
              ],
              [
                -39.060292123940656,
                -16.47812270338847
              ],
              [
                -39.09227454277859,
                -16.65781015032393
              ],
              [
                -39.13597571573118,
                -16.800225531037213
              ],
              [
                -39.13597571872176,
                -16.844659174121496
              ],
              [
                -39.13377845106466,
                -16.855726838476098
              ],
              [
                -39.12169349313086,
                -16.87851334674372
              ],
              [
                -39.12157142132573,
                -16.892022448502303
              ],
              [
                -39.12360592101326,
                -16.897881720072476
              ],
              [
                -39.14964758976917,
                -16.95045337923256
              ],
              [
                -39.16881263330192,
                -17.07594173476458
              ],
              [
                -39.183745902614646,
                -17.114922858666244
              ],
              [
                -39.202056443323585,
                -17.144219648077065
              ],
              [
                -39.20860755078767,
                -17.162204681575503
              ],
              [
                -39.217355921576846,
                -17.295098527156583
              ],
              [
                -39.20905514182474,
                -17.382094005201427
              ],
              [
                -39.19001217206356,
                -17.430271061122564
              ],
              [
                -39.18626868375821,
                -17.452080984149088
              ],
              [
                -39.188384563247475,
                -17.578382979837592
              ],
              [
                -39.18374589230135,
                -17.600843917763836
              ],
              [
                -39.16673744065219,
                -17.633965858243066
              ],
              [
                -39.14696205071674,
                -17.657159235033497
              ],
              [
                -39.13711504526896,
                -17.67962016487898
              ],
              [
                -39.14964759012488,
                -17.7107072919717
              ],
              [
                -39.25890052697342,
                -17.82073344027371
              ],
              [
                -39.268218563558484,
                -17.836521241658474
              ],
              [
                -39.271351688298076,
                -17.846286659065477
              ],
              [
                -39.27257239138626,
                -17.85857507147257
              ],
              [
                -39.27505449046701,
                -17.866875900666706
              ],
              [
                -39.28136145796772,
                -17.87102631512804
              ],
              [
                -39.289296019917515,
                -17.874118621695906
              ],
              [
                -39.3141983767491,
                -17.890313498732944
              ],
              [
                -39.38239499068091,
                -17.903252935899513
              ],
              [
                -39.41783607118593,
                -17.92099381309107
              ],
              [
                -39.450184695372826,
                -17.94801190517814
              ],
              [
                -39.499094205827504,
                -18.005629177803826
              ],
              [
                -39.62498939029931,
                -18.1926409335705
              ],
              [
                -39.659413219010936,
                -18.273614252269688
              ],
              [
                -39.672596816504665,
                -18.32317485242748
              ],
              [
                -39.724680134954305,
                -18.51873127130952
              ],
              [
                -39.74486243195476,
                -18.681735904177216
              ],
              [
                -39.741078258413026,
                -18.90211360617556
              ],
              [
                -39.71922767391924,
                -19.090508810468265
              ],
              [
                -39.69806880481836,
                -19.23992264707498
              ],
              [
                -39.70140540884189,
                -19.376153339921217
              ],
              [
                -39.70978757004727,
                -19.416111024902985
              ],
              [
                -39.786203575890845,
                -19.601983270182643
              ],
              [
                -39.80699622923714,
                -19.63616311122791
              ],
              [
                -39.834868945745086,
                -19.657159138780692
              ],
              [
                -39.95099850468988,
                -19.70517347460062
              ],
              [
                -40.00942949796419,
                -19.74700296533124
              ],
              [
                -40.02684485552138,
                -19.764418219972956
              ],
              [
                -40.08364824004529,
                -19.895440349018237
              ],
              [
                -40.088124148661734,
                -19.914483267480005
              ],
              [
                -40.09740150585248,
                -19.93059675720997
              ],
              [
                -40.14167232099376,
                -19.945570439339274
              ],
              [
                -40.15705319608183,
                -19.95891702847908
              ],
              [
                -40.13442949807782,
                -19.95891702847908
              ],
              [
                -40.13198807571078,
                -19.971856242197067
              ],
              [
                -40.14647376202901,
                -20.023044529424727
              ],
              [
                -40.15387936101391,
                -20.027601821203653
              ],
              [
                -40.162668423920486,
                -20.029554944839624
              ],
              [
                -40.17003333207846,
                -20.03394947814629
              ],
              [
                -40.17861894402149,
                -20.04338958131427
              ],
              [
                -40.17747962110982,
                -20.058526301603766
              ],
              [
                -40.17540442615213,
                -20.067315365220644
              ],
              [
                -40.166086391812314,
                -20.08652108926142
              ],
              [
                -40.16388912721997,
                -20.096123959210825
              ],
              [
                -40.16592363203577,
                -20.10588958152291
              ],
              [
                -40.17540442592583,
                -20.125258069918818
              ],
              [
                -40.190988735603646,
                -20.189873950225593
              ],
              [
                -40.1948949863527,
                -20.198500263138573
              ],
              [
                -40.20254472656305,
                -20.20769623020056
              ],
              [
                -40.222767706801235,
                -20.251560151109157
              ],
              [
                -40.23277747343955,
                -20.266778259392677
              ],
              [
                -40.241525845236914,
                -20.275567319444594
              ],
              [
                -40.244374153623916,
                -20.27752045007027
              ],
              [
                -40.24722246015497,
                -20.27353281225356
              ],
              [
                -40.2560929024664,
                -20.26376717724595
              ],
              [
                -40.266184049493475,
                -20.260511984171462
              ],
              [
                -40.27354895644971,
                -20.26751066700659
              ],
              [
                -40.27993730384871,
                -20.276950776803954
              ],
              [
                -40.286732551071125,
                -20.28101979103351
              ],
              [
                -40.298085089608634,
                -20.273695565319603
              ],
              [
                -40.29320227850951,
                -20.245049745401428
              ],
              [
                -40.300404425956074,
                -20.23267994536265
              ],
              [
                -40.31639563728408,
                -20.22795989812556
              ],
              [
                -40.33604895700593,
                -20.22763437308687
              ],
              [
                -40.36929277295599,
                -20.23267994536265
              ],
              [
                -40.35619055837182,
                -20.24334074389164
              ],
              [
                -40.35090084491544,
                -20.256524345774302
              ],
              [
                -40.35655677040876,
                -20.266371357926825
              ],
              [
                -40.376128710441115,
                -20.266778259392677
              ],
              [
                -40.37612870939897,
                -20.274183843292725
              ],
              [
                -40.37173417923766,
                -20.275567319444594
              ],
              [
                -40.3687231108484,
                -20.276950776803954
              ],
              [
                -40.36188717407126,
                -20.28101979103351
              ],
              [
                -40.370472785689174,
                -20.301039316498315
              ],
              [
                -40.36597077780766,
                -20.323231200698597
              ],
              [
                -40.34787808540403,
                -20.326205517365704
              ],
              [
                -40.32394785236926,
                -20.32483815185648
              ],
              [
                -40.325391554613866,
                -20.337532434403727
              ],
              [
                -40.31469990333781,
                -20.33426821189961
              ],
              [
                -40.30064856729748,
                -20.31943125231653
              ],
              [
                -40.28246008979104,
                -20.314222911968137
              ],
              [
                -40.25951087010217,
                -20.32146573996298
              ],
              [
                -40.27505448977965,
                -20.333916907289172
              ],
              [
                -40.2906388013003,
                -20.35068125235633
              ],
              [
                -40.302479622191164,
                -20.370863557268503
              ],
              [
                -40.312652146779,
                -20.417250240317998
              ],
              [
                -40.33653723913091,
                -20.455661718894405
              ],
              [
                -40.34874426961115,
                -20.500095304382114
              ],
              [
                -40.39659583084277,
                -20.56902433031964
              ],
              [
                -40.418324348593316,
                -20.615329693541227
              ],
              [
                -40.433216926880846,
                -20.62867605267203
              ],
              [
                -40.45128333271353,
                -20.616875919262704
              ],
              [
                -40.4753311835142,
                -20.63779061602127
              ],
              [
                -40.48363196660378,
                -20.648207313034195
              ],
              [
                -40.524484832028854,
                -20.7157528920679
              ],
              [
                -40.53441321439978,
                -20.726739182405918
              ],
              [
                -40.55606034909973,
                -20.743584866813737
              ],
              [
                -40.56517493195635,
                -20.753024968775144
              ],
              [
                -40.58342363824695,
                -20.801972266970253
              ],
              [
                -40.60939918917469,
                -20.80728932695851
              ],
              [
                -40.61956450172404,
                -20.83390128806702
              ],
              [
                -40.62843837621545,
                -20.83921759657086
              ],
              [
                -40.633900517979605,
                -20.82952236520725
              ],
              [
                -40.63683020912813,
                -20.818942997335224
              ],
              [
                -40.64159095157751,
                -20.808200801490198
              ],
              [
                -40.65208899809856,
                -20.808038048910422
              ],
              [
                -40.66246497555711,
                -20.812595346432463
              ],
              [
                -40.66722571288873,
                -20.81552496792718
              ],
              [
                -40.701378349183194,
                -20.835956386607062
              ],
              [
                -40.73172478627781,
                -20.84383798194932
              ],
              [
                -40.74630356885924,
                -20.85288152679707
              ],
              [
                -40.75846325753197,
                -20.864194068944865
              ],
              [
                -40.76093271836695,
                -20.882329450207486
              ],
              [
                -40.77308460454729,
                -20.889107677127118
              ],
              [
                -40.779186535029666,
                -20.902699805597003
              ],
              [
                -40.788930995200765,
                -20.91628472367836
              ],
              [
                -40.80110878461578,
                -20.930996141404233
              ],
              [
                -40.80847962089885,
                -20.962725375427222
              ],
              [
                -40.80736325905158,
                -20.997874889990108
              ],
              [
                -40.81138185733647,
                -21.01884750963128
              ],
              [
                -40.814613232694164,
                -21.03661156857239
              ],
              [
                -40.830677864315454,
                -21.049248960449404
              ],
              [
                -40.839588994734974,
                -21.068291907175258
              ],
              [
                -40.84166419291858,
                -21.079278265939923
              ],
              [
                -40.84654700319245,
                -21.094496340631927
              ],
              [
                -40.92234945048779,
                -21.190463855847778
              ],
              [
                -40.95180979428297,
                -21.238104387976655
              ],
              [
                -40.965117969053225,
                -21.27402110670454
              ],
              [
                -40.96519935162794,
                -21.274834944645395
              ],
              [
                -40.960072393011764,
                -21.28736741825366
              ],
              [
                -40.95921790217944,
                -21.30339933555538
              ],
              [
                -40.96129310098284,
                -21.320245091581793
              ],
              [
                -40.96519934374735,
                -21.335625849754873
              ],
              [
                -40.96350250906723,
                -21.3645025323446
              ],
              [
                -40.98325178547542,
                -21.39130676920437
              ],
              [
                -41.01816398372107,
                -21.441723736684956
              ],
              [
                -41.049549931582185,
                -21.469333558543248
              ],
              [
                -41.05724036067982,
                -21.48381922308862
              ],
              [
                -41.07186755100704,
                -21.523338463082506
              ],
              [
                -41.059345882995196,
                -21.56104482408584
              ],
              [
                -41.01854407951081,
                -21.60808690914486
              ],
              [
                -41.01353919640976,
                -21.65154393865631
              ],
              [
                -41.02472895455335,
                -21.719190101730423
              ],
              [
                -41.006743941980105,
                -21.823418850408995
              ],
              [
                -40.96727454397107,
                -21.947523709206415
              ],
              [
                -40.97264563814084,
                -21.986748971485742
              ],
              [
                -40.995269330619784,
                -22.01425540765599
              ],
              [
                -41.141265433952995,
                -22.096775064609847
              ],
              [
                -41.243694881469374,
                -22.145212826817065
              ],
              [
                -41.345692506930426,
                -22.172051623407725
              ],
              [
                -41.46572831739501,
                -22.202569247695262
              ],
              [
                -41.55516517020335,
                -22.232354454143564
              ],
              [
                -41.66649329064851,
                -22.28183356105941
              ],
              [
                -41.74136308745003,
                -22.32903414510376
              ],
              [
                -41.77082271824918,
                -22.354180574105435
              ],
              [
                -41.77594967868376,
                -22.362562819214666
              ],
              [
                -41.77896074426496,
                -22.380303686629325
              ],
              [
                -41.784494590788874,
                -22.38860437004963
              ],
              [
                -41.80260169684836,
                -22.402032222194503
              ],
              [
                -41.83482825029821,
                -22.41952885583309
              ],
              [
                -41.849680138885034,
                -22.433037978512168
              ],
              [
                -41.86847896727683,
                -22.468519754687968
              ],
              [
                -41.87352454211928,
                -22.47389087158502
              ],
              [
                -41.88255775104622,
                -22.47584407338993
              ],
              [
                -41.89268958005391,
                -22.480238514795282
              ],
              [
                -41.90086829826,
                -22.48577246209386
              ],
              [
                -41.9042862648046,
                -22.490655242295198
              ],
              [
                -41.91197669425576,
                -22.507989220159637
              ],
              [
                -41.93004310159906,
                -22.51970798747349
              ],
              [
                -41.96629798935736,
                -22.535414428729247
              ],
              [
                -41.98607337195682,
                -22.564873968308795
              ],
              [
                -41.99620520692217,
                -22.609307549002224
              ],
              [
                -41.998117641100784,
                -22.657891522497437
              ],
              [
                -41.99303137138891,
                -22.69988362485846
              ],
              [
                -41.98289954220098,
                -22.716241133810257
              ],
              [
                -41.946888806017974,
                -22.75359472291696
              ],
              [
                -41.939035601181615,
                -22.765069143999614
              ],
              [
                -41.934559695572084,
                -22.768731321634068
              ],
              [
                -41.92491614359488,
                -22.761814042102333
              ],
              [
                -41.91104081996798,
                -22.747165635345638
              ],
              [
                -41.90160071345091,
                -22.743584874236706
              ],
              [
                -41.880034964801226,
                -22.738864903306748
              ],
              [
                -41.87010658351052,
                -22.734063517726298
              ],
              [
                -41.86978105683982,
                -22.752129852242813
              ],
              [
                -41.87657629514746,
                -22.762383647367127
              ],
              [
                -41.885324685402814,
                -22.770603268312612
              ],
              [
                -41.89061439489521,
                -22.782403353531013
              ],
              [
                -41.90957597796869,
                -22.776625283065506
              ],
              [
                -41.92227128157372,
                -22.783379734241173
              ],
              [
                -41.94522051679969,
                -22.8097471274171
              ],
              [
                -41.97524979829527,
                -22.821872581678036
              ],
              [
                -41.983062303326236,
                -22.823418869461463
              ],
              [
                -41.9896134148493,
                -22.826348614771454
              ],
              [
                -41.991200316656744,
                -22.83367267834222
              ],
              [
                -41.99132239059047,
                -22.84286869218944
              ],
              [
                -41.99478105559277,
                -22.859795851138333
              ],
              [
                -41.995025204306344,
                -22.868422263236226
              ],
              [
                -41.99689694458769,
                -22.87525814157661
              ],
              [
                -42.00357012085336,
                -22.87802505928202
              ],
              [
                -42.014149551845236,
                -22.87883891165216
              ],
              [
                -42.01992753502158,
                -22.881280168415625
              ],
              [
                -42.02367103223288,
                -22.88567479139753
              ],
              [
                -42.02782140944713,
                -22.892266426163086
              ],
              [
                -42.033070435812455,
                -22.912530128091525
              ],
              [
                -42.030262831463325,
                -22.933770522282824
              ],
              [
                -42.022694458434174,
                -22.9445125454698
              ],
              [
                -42.013539181751796,
                -22.93328203006605
              ],
              [
                -42.00731359575329,
                -22.93328203006605
              ],
              [
                -42.002919081998144,
                -22.947686543990528
              ],
              [
                -42.00373287242481,
                -22.959161008517412
              ],
              [
                -42.01353919888242,
                -22.98170346933163
              ],
              [
                -42.02717038727435,
                -22.97625103788087
              ],
              [
                -42.04600989064875,
                -22.95777754738131
              ],
              [
                -42.05821692783357,
                -22.953789995015736
              ],
              [
                -42.17414302684122,
                -22.95077882689368
              ],
              [
                -42.376128698894334,
                -22.937432411509004
              ],
              [
                -42.53172766451629,
                -22.934177298708118
              ],
              [
                -42.62425695492034,
                -22.939548310051812
              ],
              [
                -42.65623938293101,
                -22.94597742161899
              ],
              [
                -42.66860918480756,
                -22.946954105884803
              ],
              [
                -42.674549923602385,
                -22.949964973344635
              ],
              [
                -42.68708249221701,
                -22.963637053840404
              ],
              [
                -42.69566809667329,
                -22.966892168609814
              ],
              [
                -42.7693578839971,
                -22.968519876289715
              ],
              [
                -42.86270097196137,
                -22.977227422331186
              ],
              [
                -42.93224037491973,
                -22.972100653123256
              ],
              [
                -43.031402138547904,
                -22.974297668187763
              ],
              [
                -43.05650795113635,
                -22.9533018030248
              ],
              [
                -43.07396400361733,
                -22.944919622410055
              ],
              [
                -43.089751758878535,
                -22.953789995015736
              ],
              [
                -43.10163325475967,
                -22.94296625397931
              ],
              [
                -43.121449342386505,
                -22.929945502176416
              ],
              [
                -43.130767379918915,
                -22.919610258475114
              ],
              [
                -43.1163630883607,
                -22.921156549231494
              ],
              [
                -43.11058510160551,
                -22.922784255387818
              ],
              [
                -43.103423625625496,
                -22.926446143797065
              ],
              [
                -43.09190833904483,
                -22.917087584500415
              ],
              [
                -43.09129797273074,
                -22.90829833341121
              ],
              [
                -43.099354622889635,
                -22.90162528122056
              ],
              [
                -43.11363685908246,
                -22.89910260815695
              ],
              [
                -43.129465307000814,
                -22.894138377290172
              ],
              [
                -43.126535599007234,
                -22.882419381555533
              ],
              [
                -43.11025957470154,
                -22.86060970321696
              ],
              [
                -43.101714641272785,
                -22.836521009016618
              ],
              [
                -43.081206827706744,
                -22.814141443871257
              ],
              [
                -43.03453527559109,
                -22.775567186934822
              ],
              [
                -43.052967895972735,
                -22.7777644939144
              ],
              [
                -43.061146617206596,
                -22.773858370740538
              ],
              [
                -43.06143143500776,
                -22.7658015795066
              ],
              [
                -43.05626381113187,
                -22.755141008718542
              ],
              [
                -43.03490149027889,
                -22.746270369940245
              ],
              [
                -43.02839107804528,
                -22.74146898371096
              ],
              [
                -43.02513588185282,
                -22.735528387916464
              ],
              [
                -43.0214737654196,
                -22.713555639569304
              ],
              [
                -43.02122961657014,
                -22.704196817826535
              ],
              [
                -43.025135869138055,
                -22.678968984778674
              ],
              [
                -43.02839107469533,
                -22.672539905821136
              ],
              [
                -43.040923638437754,
                -22.669366224307474
              ],
              [
                -43.06578527409608,
                -22.671644641612573
              ],
              [
                -43.07555091254183,
                -22.665704053222637
              ],
              [
                -43.083566854703506,
                -22.67180747154476
              ],
              [
                -43.09479732340274,
                -22.687269707891314
              ],
              [
                -43.10342362617312,
                -22.69361737352073
              ],
              [
                -43.11485754014125,
                -22.697686320997022
              ],
              [
                -43.12218176649284,
                -22.697198131403155
              ],
              [
                -43.12954667245523,
                -22.695000827646663
              ],
              [
                -43.14134680316797,
                -22.69361737352073
              ],
              [
                -43.151844858835304,
                -22.695977507224843
              ],
              [
                -43.176096155935454,
                -22.707777576384
              ],
              [
                -43.21670489078424,
                -22.734063517726298
              ],
              [
                -43.23619545078823,
                -22.734063517726298
              ],
              [
                -43.25560461257081,
                -22.737074372782157
              ],
              [
                -43.27017167432028,
                -22.747002805193638
              ],
              [
                -43.27538001194336,
                -22.768161716302327
              ],
              [
                -43.271066854926126,
                -22.788994975158065
              ],
              [
                -43.24058998102836,
                -22.843926789673276
              ],
              [
                -43.233794734027086,
                -22.843926789673276
              ],
              [
                -43.23062088914473,
                -22.838555488104845
              ],
              [
                -43.227040164624206,
                -22.835218966476095
              ],
              [
                -43.22345944507132,
                -22.832696296699904
              ],
              [
                -43.22012284952355,
                -22.829685135830555
              ],
              [
                -43.21922766891722,
                -22.83953217028266
              ],
              [
                -43.21544348029311,
                -22.84693765094557
              ],
              [
                -43.20885169006003,
                -22.852715729152592
              ],
              [
                -43.19961504047486,
                -22.857028934422903
              ],
              [
                -43.20445715894295,
                -22.85759854071822
              ],
              [
                -43.207142715956756,
                -22.85930766006747
              ],
              [
                -43.20946203973557,
                -22.861748915893653
              ],
              [
                -43.213286906047905,
                -22.864434417607228
              ],
              [
                -43.17332923215835,
                -22.886976835222963
              ],
              [
                -43.16209875090626,
                -22.895684366830835
              ],
              [
                -43.16063392115714,
                -22.908623994724113
              ],
              [
                -43.163197398565025,
                -22.92742282767414
              ],
              [
                -43.162464968491584,
                -22.939711140811006
              ],
              [
                -43.15123449347428,
                -22.93328203006605
              ],
              [
                -43.15221107218859,
                -22.951104488487434
              ],
              [
                -43.17076575803571,
                -22.96982192230278
              ],
              [
                -43.19676674054142,
                -22.98593527037705
              ],
              [
                -43.22012284812217,
                -22.995293842939514
              ],
              [
                -43.447580530143696,
                -23.018161682433018
              ],
              [
                -43.49600176838704,
                -23.03101992754454
              ],
              [
                -43.54222571612864,
                -23.049411730603858
              ],
              [
                -43.5483292264299,
                -23.05478275494748
              ],
              [
                -43.554351354316225,
                -23.062188268337945
              ],
              [
                -43.56037350665346,
                -23.067478178997806
              ],
              [
                -43.56651769545213,
                -23.066338661049194
              ],
              [
                -43.5772192017595,
                -23.05136480298149
              ],
              [
                -43.58006751312964,
                -23.049411730603858
              ],
              [
                -43.62075762004766,
                -23.04257582771719
              ],
              [
                -43.871896951183935,
                -23.069756914553416
              ],
              [
                -43.914051899195606,
                -23.069756914553416
              ],
              [
                -43.934722453144275,
                -23.072686374232422
              ],
              [
                -43.95006261818652,
                -23.080173306134316
              ],
              [
                -43.968983521105905,
                -23.092705905943518
              ],
              [
                -43.98875890711772,
                -23.09742591057097
              ],
              [
                -44.00373288636295,
                -23.091078494367217
              ],
              [
                -44.008412251221834,
                -23.069756914553416
              ],
              [
                -44.00145422626002,
                -23.049248899469486
              ],
              [
                -43.98713131065244,
                -23.04168055704365
              ],
              [
                -43.950062633078225,
                -23.04257582771719
              ],
              [
                -43.9400121617975,
                -23.04558670122976
              ],
              [
                -43.916330537241215,
                -23.05641046565887
              ],
              [
                -43.90538489477362,
                -23.05559661029601
              ],
              [
                -43.90046139172561,
                -23.05006275472057
              ],
              [
                -43.891713009640874,
                -23.021416800926524
              ],
              [
                -43.86900794012217,
                -23.03964606952348
              ],
              [
                -43.83202064847795,
                -23.047621489436665
              ],
              [
                -43.75112871113409,
                -23.049411730603858
              ],
              [
                -43.66930092096032,
                -23.037204804787244
              ],
              [
                -43.62547767665748,
                -23.02402119631007
              ],
              [
                -43.60374914921591,
                -23.007745004339647
              ],
              [
                -43.62360591884361,
                -23.00562910280022
              ],
              [
                -43.646066853400576,
                -22.998630375337434
              ],
              [
                -43.66441809857364,
                -22.988457947921248
              ],
              [
                -43.67198645425724,
                -22.977959860894938
              ],
              [
                -43.676665827816585,
                -22.97966898439584
              ],
              [
                -43.687489388567656,
                -22.9787737149151
              ],
              [
                -43.69912675738636,
                -22.97665781466175
              ],
              [
                -43.70669510639957,
                -22.974297668187763
              ],
              [
                -43.71637936850157,
                -22.965752953522056
              ],
              [
                -43.72883052589872,
                -22.945896006228917
              ],
              [
                -43.734038855657914,
                -22.939548310051812
              ],
              [
                -43.74889075627199,
                -22.93434012944945
              ],
              [
                -43.79352780392708,
                -22.928155265488222
              ],
              [
                -43.80296789436783,
                -22.929864086812955
              ],
              [
                -43.808990032164,
                -22.90976320848488
              ],
              [
                -43.82412675014722,
                -22.90764731121736
              ],
              [
                -43.84410559637392,
                -22.91057706136948
              ],
              [
                -43.864369276765096,
                -22.905938490658517
              ],
              [
                -43.850168435271776,
                -22.89910260815695
              ],
              [
                -43.85016841507631,
                -22.892266426163086
              ],
              [
                -43.86436927618309,
                -22.89617285867771
              ],
              [
                -43.892730277499076,
                -22.909356432260356
              ],
              [
                -43.90196693281663,
                -22.912204767178654
              ],
              [
                -43.9537654268792,
                -22.919610258475114
              ],
              [
                -43.96642006128958,
                -22.9234352777802
              ],
              [
                -43.99583900815316,
                -22.9367002739825
              ],
              [
                -44.00470942859393,
                -22.939548310051812
              ],
              [
                -44.01244057107218,
                -22.94573347587493
              ],
              [
                -44.01976477320521,
                -22.959161008517412
              ],
              [
                -44.03075111582305,
                -22.971368214648713
              ],
              [
                -44.04938716432432,
                -22.974297668187763
              ],
              [
                -44.04287676258163,
                -22.958754231883944
              ],
              [
                -44.03917396049811,
                -22.944105768958718
              ],
              [
                -44.04230709994123,
                -22.93580500529443
              ],
              [
                -44.05622310058176,
                -22.939548310051812
              ],
              [
                -44.06232663568636,
                -22.94841898210725
              ],
              [
                -44.079741997598404,
                -22.987237316862338
              ],
              [
                -44.08910070924751,
                -22.99382896529218
              ],
              [
                -44.115101691893514,
                -23.022393486731698
              ],
              [
                -44.127919085157956,
                -23.028904024958013
              ],
              [
                -44.151763486163475,
                -23.028904024958013
              ],
              [
                -44.15729732075853,
                -23.031833482050274
              ],
              [
                -44.172922334098914,
                -23.04257582771719
              ],
              [
                -44.180043093143226,
                -23.045098508295116
              ],
              [
                -44.18639076555148,
                -23.049004953195453
              ],
              [
                -44.19098873865211,
                -23.048760706496278
              ],
              [
                -44.192738416609146,
                -23.039157876651277
              ],
              [
                -44.196929496640095,
                -23.033624023036005
              ],
              [
                -44.206369603563495,
                -23.037855828732816
              ],
              [
                -44.22008216214626,
                -23.049411730603858
              ],
              [
                -44.23729406277267,
                -23.04697016492781
              ],
              [
                -44.242990693105426,
                -23.04257582771719
              ],
              [
                -44.240467893155184,
                -23.008965635925293
              ],
              [
                -44.2418106652565,
                -22.999932422169607
              ],
              [
                -44.2504776724314,
                -22.996189112729763
              ],
              [
                -44.27155513905219,
                -22.995293842939514
              ],
              [
                -44.289621559864166,
                -23.010919007039394
              ],
              [
                -44.298736138300335,
                -23.01287207780811
              ],
              [
                -44.30260168905011,
                -22.995293842939514
              ],
              [
                -44.317128053938134,
                -23.002862177885714
              ],
              [
                -44.32384192813375,
                -23.007907835329558
              ],
              [
                -44.3299454332983,
                -23.01523192576838
              ],
              [
                -44.35265051079538,
                -22.99928139874907
              ],
              [
                -44.35448157733178,
                -22.986423462698365
              ],
              [
                -44.34154212568185,
                -22.97747166865985
              ],
              [
                -44.31997635626487,
                -22.974297668187763
              ],
              [
                -44.3118383357238,
                -22.970147283598564
              ],
              [
                -44.311634885441265,
                -22.961114077172166
              ],
              [
                -44.31688392403191,
                -22.946954105884803
              ],
              [
                -44.320952920728075,
                -22.943780107411666
              ],
              [
                -44.327626116127206,
                -22.9401182177113
              ],
              [
                -44.32896887382094,
                -22.934828321251015
              ],
              [
                -44.31688391144603,
                -22.926446143797065
              ],
              [
                -44.325917116885606,
                -22.9216447409025
              ],
              [
                -44.335926875974074,
                -22.91936601243622
              ],
              [
                -44.34658768461993,
                -22.91871499009735
              ],
              [
                -44.357818160859715,
                -22.919610258475114
              ],
              [
                -44.35155189946024,
                -22.935316813483183
              ],
              [
                -44.35570226809809,
                -22.944431130082155
              ],
              [
                -44.36432857190481,
                -22.95142984965755
              ],
              [
                -44.371490031406346,
                -22.96119549258772
              ],
              [
                -44.37511146166082,
                -22.955254871443813
              ],
              [
                -44.38219153176641,
                -22.94597742161899
              ],
              [
                -44.38451086050409,
                -22.939548310051812
              ],
              [
                -44.391753712371106,
                -22.941989870218958
              ],
              [
                -44.39488685315105,
                -22.94345474629258
              ],
              [
                -44.398793104043065,
                -22.946954105884803
              ],
              [
                -44.41136632836093,
                -22.937432411509004
              ],
              [
                -44.42324784197779,
                -22.947930489744348
              ],
              [
                -44.439768040279866,
                -22.98170346933163
              ],
              [
                -44.43565833188449,
                -22.99675872063195
              ],
              [
                -44.457386856020186,
                -23.009454128909343
              ],
              [
                -44.486643033079986,
                -23.018243097945884
              ],
              [
                -44.53404700983327,
                -23.025323243842923
              ],
              [
                -44.604237433769995,
                -23.05559661029601
              ],
              [
                -44.60252843921688,
                -23.050469532138262
              ],
              [
                -44.600575326154924,
                -23.04111094859727
              ],
              [
                -44.598011855118585,
                -23.035739925836403
              ],
              [
                -44.63036048966001,
                -23.035088901920396
              ],
              [
                -44.6551000635901,
                -23.043145436181547
              ],
              [
                -44.673207171469805,
                -23.059340224913473
              ],
              [
                -44.70051023128621,
                -23.107680078010915
              ],
              [
                -44.69847572420712,
                -23.114515990650855
              ],
              [
                -44.69489499762621,
                -23.120782294890876
              ],
              [
                -44.69318600254854,
                -23.12737396240967
              ],
              [
                -44.702463347141766,
                -23.144626584991467
              ],
              [
                -44.71214759594643,
                -23.17498144723549
              ],
              [
                -44.71410071948932,
                -23.186618800228466
              ],
              [
                -44.70799719938092,
                -23.21461353281095
              ],
              [
                -44.689320435703436,
                -23.211032736823967
              ],
              [
                -44.665760864309576,
                -23.195244972125668
              ],
              [
                -44.64525306348239,
                -23.186618800228466
              ],
              [
                -44.62677974531544,
                -23.195244972125668
              ],
              [
                -44.67320715652952,
                -23.22958744609062
              ],
              [
                -44.680002398655446,
                -23.248630358646224
              ],
              [
                -44.670155400355554,
                -23.23853929031017
              ],
              [
                -44.65599524640073,
                -23.23040130465569
              ],
              [
                -44.640004041562314,
                -23.227797197644513
              ],
              [
                -44.62474523742092,
                -23.234958492309833
              ],
              [
                -44.63988197166996,
                -23.250420908402408
              ],
              [
                -44.64875241808586,
                -23.262139697928415
              ],
              [
                -44.65269934877331,
                -23.272149355959183
              ],
              [
                -44.65135658780404,
                -23.284763427210304
              ],
              [
                -44.64704341449705,
                -23.282810043977168
              ],
              [
                -44.62816320664795,
                -23.258233234103926
              ],
              [
                -44.613636838335964,
                -23.243828921739556
              ],
              [
                -44.60057531772999,
                -23.234307465472092
              ],
              [
                -44.583363417018425,
                -23.22918066702778
              ],
              [
                -44.55650793522083,
                -23.227471534065504
              ],
              [
                -44.564035599677325,
                -23.23967851228977
              ],
              [
                -44.56847084380147,
                -23.244398833224633
              ],
              [
                -44.5763240136771,
                -23.248630358646224
              ],
              [
                -44.558257620520585,
                -23.26336033651114
              ],
              [
                -44.53302973981996,
                -23.26702225247324
              ],
              [
                -44.51056880925275,
                -23.273369994834724
              ],
              [
                -44.5012100811227,
                -23.29648192597825
              ],
              [
                -44.52379310301519,
                -23.29070409219587
              ],
              [
                -44.54141192430515,
                -23.30315533702275
              ],
              [
                -44.56330317801992,
                -23.337334767099286
              ],
              [
                -44.58381099921471,
                -23.353204001858888
              ],
              [
                -44.60098223812111,
                -23.3501931068503
              ],
              [
                -44.61644446780499,
                -23.342461879369527
              ],
              [
                -44.63158117292136,
                -23.344821745220706
              ],
              [
                -44.647043436783555,
                -23.338637124455428
              ],
              [
                -44.67442785494983,
                -23.338067211669504
              ],
              [
                -44.70425371281052,
                -23.342461879369527
              ],
              [
                -44.727162230165426,
                -23.35100666736321
              ],
              [
                -44.72756914571469,
                -23.352064776740324
              ],
              [
                -44.732899554415404,
                -23.365818098181432
              ],
              [
                -44.74779211729743,
                -23.370863497481384
              ],
              [
                -44.766184048292885,
                -23.37297941688471
              ],
              [
                -44.78237870572643,
                -23.379001510988846
              ],
              [
                -44.79979408697661,
                -23.371270578374475
              ],
              [
                -44.81330319107964,
                -23.377129839837618
              ],
              [
                -44.82697507186255,
                -23.38543068704401
              ],
              [
                -44.84447180746432,
                -23.385186438420615
              ],
              [
                -44.85045324971995,
                -23.379001510988846
              ],
              [
                -44.85399330094553,
                -23.36980568803619
              ],
              [
                -44.85855058745021,
                -23.36150484408685
              ],
              [
                -44.86803137143101,
                -23.35784261923663
              ],
              [
                -44.87743079796,
                -23.35816828384469
              ],
              [
                -44.88434811374449,
                -23.359470341446183
              ],
              [
                -44.89850826073583,
                -23.364678572275608
              ],
              [
                -44.89199784987379,
                -23.340996990083067
              ],
              [
                -44.919300922383066,
                -23.348809633416163
              ],
              [
                -44.952626100422776,
                -23.36809654923327
              ],
              [
                -44.964222781709076,
                -23.379001510988846
              ],
              [
                -44.96922767926383,
                -23.381443095623187
              ],
              [
                -44.9756974014794,
                -23.39421973291459
              ],
              [
                -44.9810277936557,
                -23.39934655206374
              ],
              [
                -44.98814856061757,
                -23.402032086251758
              ],
              [
                -45.001535618242535,
                -23.403741226519006
              ],
              [
                -45.00837154677715,
                -23.40553148268105
              ],
              [
                -45.02830968722737,
                -23.41611078968381
              ],
              [
                -45.03624426459249,
                -23.41562259248684
              ],
              [
                -45.04308020477543,
                -23.40553148268105
              ],
              [
                -45.05077064460688,
                -23.428155292431914
              ],
              [
                -45.03966223338681,
                -23.438653189252566
              ],
              [
                -45.02163653171062,
                -23.446465851912535
              ],
              [
                -45.00837153899568,
                -23.46086993647754
              ],
              [
                -45.03473874733626,
                -23.462090881551426
              ],
              [
                -45.050160287121784,
                -23.473321234707434
              ],
              [
                -45.070423967284384,
                -23.51539490610183
              ],
              [
                -45.08018958414652,
                -23.49765392825736
              ],
              [
                -45.091786249223254,
                -23.491875764595726
              ],
              [
                -45.09764564551139,
                -23.497816761146165
              ],
              [
                -45.090240048288884,
                -23.51539490610183
              ],
              [
                -45.101918085329736,
                -23.512790480038895
              ],
              [
                -45.11339270808516,
                -23.507745062245775
              ],
              [
                -45.12458247383255,
                -23.50066483466548
              ],
              [
                -45.135243280210936,
                -23.491875764595726
              ],
              [
                -45.147775841999376,
                -23.48739996411847
              ],
              [
                -45.152170370851415,
                -23.498793157634395
              ],
              [
                -45.150624162454406,
                -23.516045937538333
              ],
              [
                -45.14549719144234,
                -23.529066568645298
              ],
              [
                -45.16421464061477,
                -23.533135591904323
              ],
              [
                -45.18321692835091,
                -23.525974243454385
              ],
              [
                -45.20034745214731,
                -23.52369548265704
              ],
              [
                -45.213734503699705,
                -23.54273853662785
              ],
              [
                -45.20323646927418,
                -23.56121198471593
              ],
              [
                -45.200672969362785,
                -23.57203528452408
              ],
              [
                -45.210682741649585,
                -23.576918178251272
              ],
              [
                -45.22288978418946,
                -23.579196942328224
              ],
              [
                -45.25194251754179,
                -23.590590163984324
              ],
              [
                -45.264149532199276,
                -23.587497533204303
              ],
              [
                -45.27879798071735,
                -23.573663015837624
              ],
              [
                -45.289540158823485,
                -23.570082187301317
              ],
              [
                -45.30174719240728,
                -23.57415121507366
              ],
              [
                -45.312408007490106,
                -23.5837541704778
              ],
              [
                -45.321115677471994,
                -23.593519661286646
              ],
              [
                -45.327056453915304,
                -23.59807719165805
              ],
              [
                -45.34837805449579,
                -23.604424687778902
              ],
              [
                -45.367787240345066,
                -23.616631783978722
              ],
              [
                -45.38829504331488,
                -23.624444183508537
              ],
              [
                -45.412993940560355,
                -23.617852433739646
              ],
              [
                -45.41706294537997,
                -23.629082834086613
              ],
              [
                -45.42845617702491,
                -23.641859555571827
              ],
              [
                -45.43293208978419,
                -23.652601763150887
              ],
              [
                -45.433501755823855,
                -23.664727458967317
              ],
              [
                -45.42821204366788,
                -23.68613047439144
              ],
              [
                -45.42666582932967,
                -23.69703552922044
              ],
              [
                -45.42308508408468,
                -23.71062584365142
              ],
              [
                -45.41490637939686,
                -23.71477630438437
              ],
              [
                -45.40575109854106,
                -23.71591554059849
              ],
              [
                -45.39940345497895,
                -23.72087987099377
              ],
              [
                -45.39830482037849,
                -23.734144827281394
              ],
              [
                -45.40611732228482,
                -23.756117504214174
              ],
              [
                -45.402740039348906,
                -23.765313423850387
              ],
              [
                -45.39305580425108,
                -23.783461319722974
              ],
              [
                -45.39484616198204,
                -23.80315524972399
              ],
              [
                -45.406605604142904,
                -23.820407877347982
              ],
              [
                -45.4266658151264,
                -23.830743054583667
              ],
              [
                -45.43887286029,
                -23.831719760693986
              ],
              [
                -45.44806882144529,
                -23.82903419450026
              ],
              [
                -45.455962696755336,
                -23.825616174164157
              ],
              [
                -45.46450760274579,
                -23.823907013911388
              ],
              [
                -45.47850501771432,
                -23.82634862852326
              ],
              [
                -45.498768693894945,
                -23.83635843913675
              ],
              [
                -45.50926673673554,
                -23.837579096661102
              ],
              [
                -45.528879361302934,
                -23.829522397310487
              ],
              [
                -45.551991341084886,
                -23.802422795872697
              ],
              [
                -45.574086075517094,
                -23.79664488319662
              ],
              [
                -45.60802161800072,
                -23.80315524972399
              ],
              [
                -45.618478963803526,
                -23.80291099829436
              ],
              [
                -45.62303626105622,
                -23.80038826868778
              ],
              [
                -45.62710527763265,
                -23.79257582964839
              ],
              [
                -45.63215084476961,
                -23.789808849481513
              ],
              [
                -45.65135657527714,
                -23.789157813030048
              ],
              [
                -45.65265865776951,
                -23.789808849481513
              ],
              [
                -45.71751869135164,
                -23.770765963343646
              ],
              [
                -45.78294837650303,
                -23.768731438063856
              ],
              [
                -45.79426021741524,
                -23.765883042790144
              ],
              [
                -45.815541142507804,
                -23.757256741796088
              ],
              [
                -45.82388260503096,
                -23.755059383266218
              ],
              [
                -45.86436926127964,
                -23.756442871905758
              ],
              [
                -45.95563716946536,
                -23.777113490723234
              ],
              [
                -45.989003058767786,
                -23.789808849481513
              ],
              [
                -46.00763912212882,
                -23.800957888217972
              ],
              [
                -46.01797440867703,
                -23.81023523720079
              ],
              [
                -46.026926223072515,
                -23.828545691264697
              ],
              [
                -46.037464980541834,
                -23.82903419450026
              ],
              [
                -46.06065831857201,
                -23.823907013911388
              ],
              [
                -46.07974200288148,
                -23.82781353728975
              ],
              [
                -46.09894773304824,
                -23.837090893732494
              ],
              [
                -46.13630122640882,
                -23.851739087750076
              ],
              [
                -46.13780677914605,
                -23.849542023471834
              ],
              [
                -46.1392309117175,
                -23.844414839714517
              ],
              [
                -46.146066848715684,
                -23.844414839714517
              ],
              [
                -46.15953529061536,
                -23.870538068591568
              ],
              [
                -46.179595512466804,
                -23.890313467628374
              ],
              [
                -46.2052302651076,
                -23.90447348149625
              ],
              [
                -46.23542233627441,
                -23.912693034095966
              ],
              [
                -46.23542231932209,
                -23.92017983188013
              ],
              [
                -46.213531064700646,
                -23.919366258425196
              ],
              [
                -46.197377076616604,
                -23.91570397639886
              ],
              [
                -46.18301347047837,
                -23.907159053863854
              ],
              [
                -46.145497187075065,
                -23.870782020086086
              ],
              [
                -46.13190669516569,
                -23.86492267822595
              ],
              [
                -46.11192785416993,
                -23.86492267822595
              ],
              [
                -46.149973120254266,
                -23.905531607197215
              ],
              [
                -46.15973872533957,
                -23.92017983188013
              ],
              [
                -46.16445880011552,
                -23.935154033539227
              ],
              [
                -46.16832435414211,
                -23.954685219570013
              ],
              [
                -46.16954505623466,
                -23.97234471480677
              ],
              [
                -46.16649330329101,
                -23.981622112642892
              ],
              [
                -46.17503820239026,
                -23.990899212773765
              ],
              [
                -46.186634906398645,
                -23.995375379264395
              ],
              [
                -46.196888805503356,
                -23.99391046290396
              ],
              [
                -46.2012833204444,
                -23.985039849009745
              ],
              [
                -46.20750891097051,
                -23.979912944164457
              ],
              [
                -46.22109942683569,
                -23.98170353023311
              ],
              [
                -46.234120248423835,
                -23.98601655977833
              ],
              [
                -46.253041149197394,
                -23.995863584588378
              ],
              [
                -46.267730261110714,
                -24.010511850883887
              ],
              [
                -46.28766842172345,
                -24.021172759881658
              ],
              [
                -46.317372187481475,
                -24.01637121941065
              ],
              [
                -46.30992590733071,
                -24.001560115087244
              ],
              [
                -46.28482010302853,
                -23.992852334271006
              ],
              [
                -46.276356585315504,
                -23.981622112642892
              ],
              [
                -46.2772517527519,
                -23.967543181801158
              ],
              [
                -46.28457598173497,
                -23.9559872990639
              ],
              [
                -46.29295813861053,
                -23.946058869158673
              ],
              [
                -46.29686437383337,
                -23.93718826864807
              ],
              [
                -46.299468555612876,
                -23.925062775208314
              ],
              [
                -46.30699622831385,
                -23.91529718972527
              ],
              [
                -46.31883705437454,
                -23.908868218450106
              ],
              [
                -46.346180806009116,
                -23.904961985861586
              ],
              [
                -46.35777747727078,
                -23.90081150158999
              ],
              [
                -46.363758921694576,
                -23.894219698453668
              ],
              [
                -46.35830643394346,
                -23.88600015053259
              ],
              [
                -46.3583064551259,
                -23.878594777961936
              ],
              [
                -46.38540604311846,
                -23.873467589675943
              ],
              [
                -46.389271621329485,
                -23.88640723727175
              ],
              [
                -46.38735917839719,
                -23.903985277571493
              ],
              [
                -46.396799289296325,
                -23.912693034095966
              ],
              [
                -46.40929115003854,
                -23.915948228665453
              ],
              [
                -46.41038978727737,
                -23.923272492756414
              ],
              [
                -46.4080297656768,
                -23.930596758514216
              ],
              [
                -46.4098201285882,
                -23.93385195489457
              ],
              [
                -46.43268796131069,
                -23.931736002101413
              ],
              [
                -46.453928193603446,
                -23.92644627094544
              ],
              [
                -46.44957435904902,
                -23.9384092303823
              ],
              [
                -46.440419084044755,
                -23.944919625061814
              ],
              [
                -46.4313044989941,
                -23.948174822898988
              ],
              [
                -46.42723549182203,
                -23.95086039891885
              ],
              [
                -46.425607886171925,
                -23.956719756356808
              ],
              [
                -46.416981575853335,
                -23.976169538047046
              ],
              [
                -46.41295326434599,
                -23.981622112642892
              ],
              [
                -46.40192624225599,
                -23.984144856301903
              ],
              [
                -46.38829505025562,
                -23.983982021109068
              ],
              [
                -46.376820433946484,
                -23.985121266608793
              ],
              [
                -46.37193764094265,
                -23.992120176575078
              ],
              [
                -46.37205969102857,
                -24.01580159608763
              ],
              [
                -46.37604733097409,
                -24.024509383298174
              ],
              [
                -46.38630122242594,
                -24.030043083593398
              ],
              [
                -46.3880915880321,
                -24.02157954791454
              ],
              [
                -46.391753718745804,
                -24.016208684484617
              ],
              [
                -46.39781652385996,
                -24.012464973603898
              ],
              [
                -46.40672767401185,
                -24.00896581658852
              ],
              [
                -46.46898352107618,
                -24.039971540037566
              ],
              [
                -46.593413865329005,
                -24.089532151975195
              ],
              [
                -46.74307206662528,
                -24.176853098383482
              ],
              [
                -46.85496985756147,
                -24.228448191083846
              ],
              [
                -46.93663489711534,
                -24.273370071673632
              ],
              [
                -46.96646074864134,
                -24.29908627408309
              ],
              [
                -46.98892169306166,
                -24.33115014125504
              ],
              [
                -46.999908020159594,
                -24.366794662653028
              ],
              [
                -47.00633703214238,
                -24.372002752788834
              ],
              [
                -47.00999916236883,
                -24.376885770055935
              ],
              [
                -46.99950109447085,
                -24.400567199223087
              ],
              [
                -46.99950111321587,
                -24.409844732035285
              ],
              [
                -47.01537024362117,
                -24.422946848957373
              ],
              [
                -47.03502356026419,
                -24.431084825993047
              ],
              [
                -47.049794064084665,
                -24.427829574800718
              ],
              [
                -47.05101479184017,
                -24.406182689970095
              ],
              [
                -47.072092261266626,
                -24.448500351355154
              ],
              [
                -47.08141028031594,
                -24.453871294773915
              ],
              [
                -47.09691320218719,
                -24.459405077102772
              ],
              [
                -47.1227107556635,
                -24.483331135150312
              ],
              [
                -47.13634192644747,
                -24.488702085487684
              ],
              [
                -47.18138587234923,
                -24.53337982946855
              ],
              [
                -47.44204666764731,
                -24.680433740661798
              ],
              [
                -47.4548233586167,
                -24.676690241549345
              ],
              [
                -47.46906492078638,
                -24.680922258323303
              ],
              [
                -47.49669348142672,
                -24.69353599189389
              ],
              [
                -47.51846269275378,
                -24.688083579806
              ],
              [
                -47.531320769804964,
                -24.688164999440108
              ],
              [
                -47.54076086010417,
                -24.703382964568146
              ],
              [
                -47.55992589957388,
                -24.712660303519517
              ],
              [
                -47.58470619299032,
                -24.731622090531758
              ],
              [
                -47.63385983548369,
                -24.75562921822817
              ],
              [
                -47.825550912837436,
                -24.894138296557113
              ],
              [
                -47.84178625692355,
                -24.909844610577235
              ],
              [
                -47.86660723953245,
                -24.94060650667842
              ],
              [
                -47.87340248367183,
                -24.94540791142108
              ],
              [
                -47.8798721904724,
                -24.94866292849218
              ],
              [
                -47.88630123418173,
                -24.953057532736473
              ],
              [
                -47.89329994119194,
                -24.96111425922933
              ],
              [
                -47.93374589800054,
                -25.033461196005796
              ],
              [
                -47.960560676123606,
                -25.049899999162527
              ],
              [
                -48.00999915282415,
                -25.044203381348428
              ],
              [
                -48.00169837098122,
                -25.027927341823947
              ],
              [
                -47.98810787693902,
                -25.02581145542619
              ],
              [
                -47.973500128885775,
                -25.027601819924758
              ],
              [
                -47.962147589992405,
                -25.023125908929057
              ],
              [
                -47.961171028052334,
                -25.013116144494433
              ],
              [
                -47.97272701700533,
                -25.009372654050647
              ],
              [
                -48.01691647006121,
                -25.010837498577033
              ],
              [
                -48.023589647989596,
                -25.015069268902707
              ],
              [
                -48.024403450097296,
                -25.022393488916485
              ],
              [
                -48.02358964798087,
                -25.033623955820797
              ],
              [
                -48.02700761593405,
                -25.045179945381143
              ],
              [
                -48.03490149575248,
                -25.048760672677037
              ],
              [
                -48.04417883980493,
                -25.045505465169207
              ],
              [
                -48.05158443889298,
                -25.03679778299493
              ],
              [
                -48.0516251287515,
                -25.052829682669255
              ],
              [
                -48.03246009022635,
                -25.063246354123166
              ],
              [
                -48.00645911424886,
                -25.06910572933408
              ],
              [
                -47.98607337091008,
                -25.070977471157256
              ],
              [
                -47.963002081775436,
                -25.078220307894462
              ],
              [
                -47.94969641762765,
                -25.08001067150843
              ],
              [
                -47.93830318900499,
                -25.074639581047332
              ],
              [
                -47.927723761992745,
                -25.065606377932664
              ],
              [
                -47.91535396993491,
                -25.059502862388428
              ],
              [
                -47.90168209482934,
                -25.05657317339484
              ],
              [
                -47.887074347977034,
                -25.057305596784367
              ],
              [
                -47.92198645633921,
                -25.158623949840734
              ],
              [
                -47.951771614933975,
                -25.20134857466982
              ],
              [
                -48.00316321556819,
                -25.214288024263325
              ],
              [
                -48.02000891831591,
                -25.226332292922734
              ],
              [
                -48.068348761092714,
                -25.280043218655447
              ],
              [
                -48.07628333152227,
                -25.29322681661193
              ],
              [
                -48.08210201624652,
                -25.307305590087683
              ],
              [
                -48.08336341006261,
                -25.310316656402854
              ],
              [
                -48.09154211933937,
                -25.325290607791512
              ],
              [
                -48.16828365704239,
                -25.369235926276176
              ],
              [
                -48.173451300501995,
                -25.38103606146839
              ],
              [
                -48.19652258816546,
                -25.41692472136346
              ],
              [
                -48.20905514183375,
                -25.457614840498113
              ],
              [
                -48.225087042940366,
                -25.45973072646204
              ],
              [
                -48.24160722409354,
                -25.44817472077224
              ],
              [
                -48.25015214739966,
                -25.427829679567324
              ],
              [
                -48.247303840715674,
                -25.410902608487465
              ],
              [
                -48.22288977621295,
                -25.352146075715126
              ],
              [
                -48.22199459394503,
                -25.343357019378885
              ],
              [
                -48.222157356290644,
                -25.339125260652363
              ],
              [
                -48.21922766781054,
                -25.334567965271546
              ],
              [
                -48.20921790334247,
                -25.32415130313002
              ],
              [
                -48.20152747428834,
                -25.318291936779953
              ],
              [
                -48.18126380168638,
                -25.306817322284882
              ],
              [
                -48.13711503888701,
                -25.289646100141244
              ],
              [
                -48.12730872368299,
                -25.27996185327499
              ],
              [
                -48.14028886546388,
                -25.269626555072186
              ],
              [
                -48.152577277197324,
                -25.281996344631786
              ],
              [
                -48.17422441300191,
                -25.29062265401804
              ],
              [
                -48.198719856631214,
                -25.29534271178362
              ],
              [
                -48.21914628824641,
                -25.296807552256627
              ],
              [
                -48.22960364601566,
                -25.300388288295437
              ],
              [
                -48.24254309974972,
                -25.315362253988955
              ],
              [
                -48.25015214800199,
                -25.31804778401883
              ],
              [
                -48.259429491761885,
                -25.313653259960926
              ],
              [
                -48.274322067978154,
                -25.29656339965448
              ],
              [
                -48.284331835557026,
                -25.289971618096903
              ],
              [
                -48.283070442540165,
                -25.30641041993602
              ],
              [
                -48.28368079425019,
                -25.316013290414045
              ],
              [
                -48.28628496142224,
                -25.322849229976516
              ],
              [
                -48.29743404855537,
                -25.341241139950867
              ],
              [
                -48.30675208212792,
                -25.351006770164354
              ],
              [
                -48.318714973219585,
                -25.357679947996672
              ],
              [
                -48.332753058694465,
                -25.358330985224
              ],
              [
                -48.31908118434325,
                -25.32415130313002
              ],
              [
                -48.32530677034331,
                -25.32415130313002
              ],
              [
                -48.33372962285798,
                -25.32968517092614
              ],
              [
                -48.33551998492965,
                -25.318617436241347
              ],
              [
                -48.331369595351866,
                -25.270196225221937
              ],
              [
                -48.325754361147204,
                -25.243829035351364
              ],
              [
                -48.325306769761056,
                -25.228610932804866
              ],
              [
                -48.33800208250386,
                -25.236748960626134
              ],
              [
                -48.35122636668234,
                -25.250664978255656
              ],
              [
                -48.36099199043205,
                -25.26376717980092
              ],
              [
                -48.36314856646139,
                -25.269626555072186
              ],
              [
                -48.3726293604977,
                -25.271579680405925
              ],
              [
                -48.372670051966836,
                -25.2761369858406
              ],
              [
                -48.36628170591228,
                -25.28386810533728
              ],
              [
                -48.364084439796095,
                -25.28346120327607
              ],
              [
                -48.359364386784165,
                -25.285577079028382
              ],
              [
                -48.35472571576683,
                -25.289239198006804
              ],
              [
                -48.352609830437494,
                -25.293389584996415
              ],
              [
                -48.35374915211073,
                -25.296970301880982
              ],
              [
                -48.35887610624709,
                -25.296807552256627
              ],
              [
                -48.3600968090959,
                -25.30022551987594
              ],
              [
                -48.36742102806468,
                -25.30478281059083
              ],
              [
                -48.38369706805594,
                -25.298109624386655
              ],
              [
                -48.40721595091302,
                -25.28386810533728
              ],
              [
                -48.41413326654697,
                -25.273532805860782
              ],
              [
                -48.4239395825181,
                -25.252211200742003
              ],
              [
                -48.43455970035911,
                -25.242282813289382
              ],
              [
                -48.434559700410276,
                -25.262790626751578
              ],
              [
                -48.442005989410376,
                -25.262790626751578
              ],
              [
                -48.445057746891266,
                -25.25660573515101
              ],
              [
                -48.4479874339142,
                -25.253676039215996
              ],
              [
                -48.45128333200069,
                -25.251722915006827
              ],
              [
                -48.45567786356366,
                -25.24846770200842
              ],
              [
                -48.45197506440041,
                -25.26474375165892
              ],
              [
                -48.428334114344054,
                -25.32415130313002
              ],
              [
                -48.44660396798155,
                -25.32447680264818
              ],
              [
                -48.4789119132278,
                -25.331638281069196
              ],
              [
                -48.496571418227866,
                -25.331638281069196
              ],
              [
                -48.49657141874763,
                -25.33847422378329
              ],
              [
                -48.46263587133657,
                -25.342868751055157
              ],
              [
                -48.44566809882983,
                -25.3474260475311
              ],
              [
                -48.43455969969382,
                -25.358330985224
              ],
              [
                -48.45221920675746,
                -25.368259388919103
              ],
              [
                -48.457427537978525,
                -25.37965260180636
              ],
              [
                -48.45128333302007,
                -25.38567474722666
              ],
              [
                -48.43455969900714,
                -25.37948983301278
              ],
              [
                -48.43028724071455,
                -25.389418242510157
              ],
              [
                -48.416859504536525,
                -25.404392189849048
              ],
              [
                -48.41405188715515,
                -25.410088801402342
              ],
              [
                -48.417836065006014,
                -25.428317949017195
              ],
              [
                -48.42690996055599,
                -25.432305602012313
              ],
              [
                -48.43814042755267,
                -25.43124764095598
              ],
              [
                -48.44815019212235,
                -25.43401456408505
              ],
              [
                -48.45425371132086,
                -25.445896103886714
              ],
              [
                -48.456166143924385,
                -25.45956795733262
              ],
              [
                -48.46019446460361,
                -25.47087981244153
              ],
              [
                -48.47272701615615,
                -25.475681240428447
              ],
              [
                -48.48814856800616,
                -25.473890892027303
              ],
              [
                -48.49791419103378,
                -25.46868254132987
              ],
              [
                -48.517079230700965,
                -25.447035412313472
              ],
              [
                -48.526844854863135,
                -25.453220299791735
              ],
              [
                -48.53742428116549,
                -25.454522377532133
              ],
              [
                -48.54808509136921,
                -25.452243760291758
              ],
              [
                -48.558013475700726,
                -25.447035412313472
              ],
              [
                -48.56273352692199,
                -25.45956795733262
              ],
              [
                -48.57506262996738,
                -25.462009381672463
              ],
              [
                -48.62364661248747,
                -25.4496395674412
              ],
              [
                -48.635365366054536,
                -25.44459402642216
              ],
              [
                -48.683827277060125,
                -25.412774338559434
              ],
              [
                -48.69139563666341,
                -25.405694265976347
              ],
              [
                -48.73094641674771,
                -25.359633059714533
              ],
              [
                -48.74303137719371,
                -25.352146075715126
              ],
              [
                -48.7402237633071,
                -25.367445582771023
              ],
              [
                -48.72313391921162,
                -25.406670841879272
              ],
              [
                -48.71882076507902,
                -25.42262133477417
              ],
              [
                -48.715687628393894,
                -25.427829679567324
              ],
              [
                -48.71011308567513,
                -25.433038025050557
              ],
              [
                -48.698963997640234,
                -25.43816498669624
              ],
              [
                -48.69522050775664,
                -25.440850525778508
              ],
              [
                -48.68358313763455,
                -25.46266042067607
              ],
              [
                -48.68871009172801,
                -25.473321237440768
              ],
              [
                -48.70555579266717,
                -25.47437916202807
              ],
              [
                -48.729359504268096,
                -25.468194271394978
              ],
              [
                -48.710845505321196,
                -25.4963518060358
              ],
              [
                -48.68333899609352,
                -25.49871184783444
              ],
              [
                -48.65143795674682,
                -25.492771107595196
              ],
              [
                -48.620106576603725,
                -25.496189074323162
              ],
              [
                -48.622385221705144,
                -25.503106393219056
              ],
              [
                -48.62413489352351,
                -25.506036052826232
              ],
              [
                -48.6269425119494,
                -25.509698174549342
              ],
              [
                -48.635650195184795,
                -25.5030250085721
              ],
              [
                -48.64305579445232,
                -25.502373968958157
              ],
              [
                -48.64928137934856,
                -25.507012631108747
              ],
              [
                -48.654286261759054,
                -25.51653411085401
              ],
              [
                -48.64224198916507,
                -25.521742429655365
              ],
              [
                -48.628285284388724,
                -25.52450935864681
              ],
              [
                -48.615386521363895,
                -25.529961832428373
              ],
              [
                -48.606434700354306,
                -25.543877866153334
              ],
              [
                -48.59544837267704,
                -25.527764595946284
              ],
              [
                -48.57819576650424,
                -25.52605559258007
              ],
              [
                -48.55866451563244,
                -25.52727628780303
              ],
              [
                -48.52403724095413,
                -25.514825145459803
              ],
              [
                -48.5050349587475,
                -25.523207278813352
              ],
              [
                -48.48607337246431,
                -25.535902615070974
              ],
              [
                -48.46930904935334,
                -25.543877866153334
              ],
              [
                -48.47935950278366,
                -25.555108320159068
              ],
              [
                -48.48289954424002,
                -25.55820079004937
              ],
              [
                -48.47614498683364,
                -25.550713807433763
              ],
              [
                -48.49034583198219,
                -25.56406015384181
              ],
              [
                -48.4969376274837,
                -25.56853605250559
              ],
              [
                -48.50340735442187,
                -25.571872639961175
              ],
              [
                -48.482492639957236,
                -25.57984789683158
              ],
              [
                -48.47134355482621,
                -25.57293060435508
              ],
              [
                -48.46434485574701,
                -25.559991141746004
              ],
              [
                -48.45567786483327,
                -25.550713807433763
              ],
              [
                -48.440419076025705,
                -25.550062767154067
              ],
              [
                -48.424061650909856,
                -25.554294510348747
              ],
              [
                -48.406320765785495,
                -25.555108320159068
              ],
              [
                -48.386708137352706,
                -25.543877866153334
              ],
              [
                -48.3611954431959,
                -25.570977482671672
              ],
              [
                -48.38890540272827,
                -25.595472912582427
              ],
              [
                -48.432728643814244,
                -25.622491133480207
              ],
              [
                -48.5175675082924,
                -25.77019618955789
              ],
              [
                -48.51707923365922,
                -25.797133094219234
              ],
              [
                -48.53502356600497,
                -25.839450770345415
              ],
              [
                -48.54100500916948,
                -25.84547289039512
              ],
              [
                -48.55850175367395,
                -25.840996974087457
              ],
              [
                -48.57241777003019,
                -25.821547107150934
              ],
              [
                -48.58600826690371,
                -25.817559502162272
              ],
              [
                -48.580677864371026,
                -25.801853126234636
              ],
              [
                -48.57852129066261,
                -25.797133094219234
              ],
              [
                -48.591786264466535,
                -25.79900483750046
              ],
              [
                -48.60350501457255,
                -25.802178666413337
              ],
              [
                -48.61314856645433,
                -25.808038014249725
              ],
              [
                -48.620106574903595,
                -25.817559502162272
              ],
              [
                -48.608265756799575,
                -25.818617470356124
              ],
              [
                -48.599354618242245,
                -25.822849193012612
              ],
              [
                -48.59219316553584,
                -25.82927827504991
              ],
              [
                -48.58600826939002,
                -25.838067336769786
              ],
              [
                -48.579904753905026,
                -25.85116954553969
              ],
              [
                -48.58324133576163,
                -25.854668841216185
              ],
              [
                -48.65123450314411,
                -25.84449634457637
              ],
              [
                -48.743031380451285,
                -25.851739203557816
              ],
              [
                -48.75304114791317,
                -25.855075804194662
              ],
              [
                -48.762684700894745,
                -25.85979583873443
              ],
              [
                -48.769439253859055,
                -25.86736416387241
              ],
              [
                -48.77033443874723,
                -25.87965259981945
              ],
              [
                -48.76577714427775,
                -25.88665126789935
              ],
              [
                -48.75865638209881,
                -25.883884399734995
              ],
              [
                -48.750477668124134,
                -25.877211197072164
              ],
              [
                -48.74303138331606,
                -25.872816702281675
              ],
              [
                -48.57852129230149,
                -25.872816702281675
              ],
              [
                -48.57115637475069,
                -25.86907313815479
              ],
              [
                -48.567005991641736,
                -25.864434525917535
              ],
              [
                -48.563465949169355,
                -25.86581795979519
              ],
              [
                -48.55801347574831,
                -25.87965259981945
              ],
              [
                -48.556507943899334,
                -25.891208608445236
              ],
              [
                -48.55858313441258,
                -25.901787996618577
              ],
              [
                -48.578521290762275,
                -25.961602495770958
              ],
              [
                -48.58600826617481,
                -25.995782151919805
              ],
              [
                -48.60456295230366,
                -26.023370026924084
              ],
              [
                -48.61266028286532,
                -26.040622627214084
              ],
              [
                -48.609852670352595,
                -26.054375929083182
              ],
              [
                -48.600087046327396,
                -26.071221641372084
              ],
              [
                -48.58263098705088,
                -26.157159096487966
              ],
              [
                -48.582915821153456,
                -26.172621370221815
              ],
              [
                -48.592518686452905,
                -26.18385184173312
              ],
              [
                -48.616688608178706,
                -26.188164990400114
              ],
              [
                -48.634917776118314,
                -26.194512654312135
              ],
              [
                -48.64614823699827,
                -26.209079651281414
              ],
              [
                -48.655425585242675,
                -26.22527434904235
              ],
              [
                -48.66787675371899,
                -26.236016506425138
              ],
              [
                -48.68716387039568,
                -26.23772555592466
              ],
              [
                -48.7122289671039,
                -26.233575103677467
              ],
              [
                -48.73379472669819,
                -26.224704690865835
              ],
              [
                -48.74303138313551,
                -26.212090787769345
              ],
              [
                -48.74522864532756,
                -26.1891415367593
              ],
              [
                -48.7506404291965,
                -26.173597916657283
              ],
              [
                -48.76414954491523,
                -26.14714936317833
              ],
              [
                -48.76903235355459,
                -26.1298153423182
              ],
              [
                -48.77033444050498,
                -26.109307562749446
              ],
              [
                -48.772531706758166,
                -26.100681262903606
              ],
              [
                -48.78184973788454,
                -26.09099699353971
              ],
              [
                -48.78864498653373,
                -26.06340911753651
              ],
              [
                -48.79645748734922,
                -26.068454696460968
              ],
              [
                -48.79800371442098,
                -26.088067353493408
              ],
              [
                -48.78400631567109,
                -26.113051054148443
              ],
              [
                -48.7905167279132,
                -26.124769763894587
              ],
              [
                -48.791127083717555,
                -26.13534923151393
              ],
              [
                -48.788197395638626,
                -26.145114847393042
              ],
              [
                -48.784006311629426,
                -26.153985263995256
              ],
              [
                -48.78001868478688,
                -26.15691497864015
              ],
              [
                -48.773304821059526,
                -26.159844693250232
              ],
              [
                -48.76695716362515,
                -26.163995072144136
              ],
              [
                -48.76414954743955,
                -26.171075165430395
              ],
              [
                -48.76439368258648,
                -26.18206144409371
              ],
              [
                -48.76349850616079,
                -26.18718844403584
              ],
              [
                -48.760650193903885,
                -26.191582940191374
              ],
              [
                -48.756092903958354,
                -26.203545839061082
              ],
              [
                -48.764149546401654,
                -26.228204062551097
              ],
              [
                -48.76065019447954,
                -26.239678648021957
              ],
              [
                -48.756214971723765,
                -26.24944425830497
              ],
              [
                -48.759755011745874,
                -26.25709400587248
              ],
              [
                -48.76793372173793,
                -26.26197681043655
              ],
              [
                -48.7777400460955,
                -26.263278971741034
              ],
              [
                -48.757313611399915,
                -26.291192361105676
              ],
              [
                -48.77037513296492,
                -26.289727505113973
              ],
              [
                -48.782093887202244,
                -26.290948243479527
              ],
              [
                -48.791615355818415,
                -26.295586778731913
              ],
              [
                -48.79824784596947,
                -26.30486414906111
              ],
              [
                -48.75731359841747,
                -26.311455924764765
              ],
              [
                -48.73770097792806,
                -26.319105743076644
              ],
              [
                -48.729359503365885,
                -26.33521900271883
              ],
              [
                -48.721791149347474,
                -26.344821909189132
              ],
              [
                -48.659779424011035,
                -26.370700762456494
              ],
              [
                -48.65078691624602,
                -26.376560180993202
              ],
              [
                -48.643625453557,
                -26.384860923006887
              ],
              [
                -48.64061438775252,
                -26.396742452249768
              ],
              [
                -48.63955644683839,
                -26.408623979550246
              ],
              [
                -48.635853654001934,
                -26.418552416636313
              ],
              [
                -48.62857010830804,
                -26.425225455249162
              ],
              [
                -48.61668859847854,
                -26.427829622659836
              ],
              [
                -48.60789954755314,
                -26.436700165719685
              ],
              [
                -48.61424719478249,
                -26.45680099685062
              ],
              [
                -48.66445879058355,
                -26.556084915182307
              ],
              [
                -48.6754451130142,
                -26.594659088598497
              ],
              [
                -48.68333900026584,
                -26.662367480678313
              ],
              [
                -48.682199667001484,
                -26.719170774352442
              ],
              [
                -48.678944468865396,
                -26.73105237326219
              ],
              [
                -48.67113196185017,
                -26.739434477538524
              ],
              [
                -48.6269425165082,
                -26.770928680389748
              ],
              [
                -48.6148982331235,
                -26.770440299405102
              ],
              [
                -48.59215248023358,
                -26.763930004460825
              ],
              [
                -48.58226477048282,
                -26.767510614252245
              ],
              [
                -48.57795163399934,
                -26.776543934530356
              ],
              [
                -48.57921302861355,
                -26.786553713512962
              ],
              [
                -48.58372961575274,
                -26.7948543826851
              ],
              [
                -48.59772702416739,
                -26.804457347742055
              ],
              [
                -48.60948646242737,
                -26.819431291664294
              ],
              [
                -48.62047277747198,
                -26.837172064498745
              ],
              [
                -48.626942510062776,
                -26.85230883645957
              ],
              [
                -48.62877357410534,
                -26.86484146094592
              ],
              [
                -48.62694252058343,
                -26.897068035628514
              ],
              [
                -48.62482662170973,
                -26.90276453871881
              ],
              [
                -48.6153865241992,
                -26.912041934580177
              ],
              [
                -48.61327064263016,
                -26.917738584958855
              ],
              [
                -48.61436927345523,
                -26.92392346257796
              ],
              [
                -48.61904863071015,
                -26.93303800871371
              ],
              [
                -48.620106582561846,
                -26.93792089128424
              ],
              [
                -48.62132728112319,
                -26.974379189830735
              ],
              [
                -48.62010657118757,
                -26.982598535709013
              ],
              [
                -48.611195438212235,
                -26.993910384924483
              ],
              [
                -48.601958781326076,
                -26.997735231012744
              ],
              [
                -48.59483802531548,
                -26.997328425210412
              ],
              [
                -48.59219315778747,
                -26.996270399602583
              ],
              [
                -48.575184692714046,
                -27.01620853420135
              ],
              [
                -48.57713782078956,
                -27.03297288164222
              ],
              [
                -48.58653724519832,
                -27.049574526038292
              ],
              [
                -48.59630287001486,
                -27.08611423844842
              ],
              [
                -48.603749152611236,
                -27.094414968936256
              ],
              [
                -48.607167126888065,
                -27.10442478437512
              ],
              [
                -48.5880427703506,
                -27.150648675196603
              ],
              [
                -48.57949784625869,
                -27.158461158785336
              ],
              [
                -48.56517494280246,
                -27.161390952097786
              ],
              [
                -48.55138098278282,
                -27.158135626171443
              ],
              [
                -48.544748506607824,
                -27.150160451215967
              ],
              [
                -48.540598106644346,
                -27.14006923473838
              ],
              [
                -48.53441321302258,
                -27.130466388433053
              ],
              [
                -48.51622473370626,
                -27.120782117279067
              ],
              [
                -48.50690669839817,
                -27.132500857004636
              ],
              [
                -48.4968155539488,
                -27.14910243225802
              ],
              [
                -48.476144984564996,
                -27.153985272709075
              ],
              [
                -48.48387609736834,
                -27.16594810715342
              ],
              [
                -48.48888099228736,
                -27.17066825282833
              ],
              [
                -48.49657141251283,
                -27.175062714910126
              ],
              [
                -48.48696855704039,
                -27.198500281840182
              ],
              [
                -48.485910619115884,
                -27.210707353581103
              ],
              [
                -48.492909306364446,
                -27.21599698236442
              ],
              [
                -48.50536047544262,
                -27.21868250650643
              ],
              [
                -48.51598059369257,
                -27.22234462530506
              ],
              [
                -48.524566215504784,
                -27.22128676005777
              ],
              [
                -48.53136146324223,
                -27.20916111486235
              ],
              [
                -48.5162247377822,
                -27.206312748462995
              ],
              [
                -48.51260332050789,
                -27.198174749817692
              ],
              [
                -48.51829993227678,
                -27.188734619487928
              ],
              [
                -48.53136146303996,
                -27.18189874337391
              ],
              [
                -48.54185950268116,
                -27.18238696665897
              ],
              [
                -48.560373499831506,
                -27.192966387016035
              ],
              [
                -48.56891842810144,
                -27.195489223112567
              ],
              [
                -48.57335364343715,
                -27.19963956876906
              ],
              [
                -48.60643470495956,
                -27.223402640721826
              ],
              [
                -48.61440995332208,
                -27.232028851904946
              ],
              [
                -48.618478966079735,
                -27.23845791043456
              ],
              [
                -48.61998450040594,
                -27.246677313995807
              ],
              [
                -48.62010657058666,
                -27.2606747036476
              ],
              [
                -48.6129044239643,
                -27.299493081197234
              ],
              [
                -48.60985266876371,
                -27.30535247792714
              ],
              [
                -48.60659746449952,
                -27.306329068917297
              ],
              [
                -48.572336399036935,
                -27.312188463623023
              ],
              [
                -48.560943163734756,
                -27.324965107699885
              ],
              [
                -48.55483964836024,
                -27.342461849791682
              ],
              [
                -48.55186926149679,
                -27.387302276328317
              ],
              [
                -48.56261144964436,
                -27.37281660814393
              ],
              [
                -48.565541148870714,
                -27.367445600929475
              ],
              [
                -48.57144121055443,
                -27.376641538283973
              ],
              [
                -48.5755102184436,
                -27.384942303983703
              ],
              [
                -48.57778885898679,
                -27.393812703890372
              ],
              [
                -48.578521286080594,
                -27.40471769120331
              ],
              [
                -48.58193924788285,
                -27.41668052678011
              ],
              [
                -48.59048417015715,
                -27.42164472192931
              ],
              [
                -48.60179603108927,
                -27.424004839771907
              ],
              [
                -48.61327063823396,
                -27.428317976490423
              ],
              [
                -48.62612871649502,
                -27.43678155790689
              ],
              [
                -48.636952279315366,
                -27.44695404409797
              ],
              [
                -48.644602017031424,
                -27.460625909241248
              ],
              [
                -48.6474503213554,
                -27.479587470095055
              ],
              [
                -48.60985264855273,
                -27.558688911829627
              ],
              [
                -48.59015867290082,
                -27.563653366536975
              ],
              [
                -48.5790909691471,
                -27.576348711792185
              ],
              [
                -48.57750405192963,
                -27.59400819214368
              ],
              [
                -48.58600825481748,
                -27.613213707497057
              ],
              [
                -48.59455317742516,
                -27.601169441050907
              ],
              [
                -48.6142472162304,
                -27.612400121175735
              ],
              [
                -48.63512122924404,
                -27.632582337298707
              ],
              [
                -48.6474503409479,
                -27.647393608646905
              ],
              [
                -48.63805091896417,
                -27.66130956320142
              ],
              [
                -48.631703256844666,
                -27.67978283147759
              ],
              [
                -48.62808182613019,
                -27.700127796125305
              ],
              [
                -48.626942517261426,
                -27.719659152615794
              ],
              [
                -48.62389074778312,
                -27.725274300206927
              ],
              [
                -48.61009682590084,
                -27.741143615102985
              ],
              [
                -48.60643469076706,
                -27.75042076160492
              ],
              [
                -48.611968565531924,
                -27.752699563651554
              ],
              [
                -48.62246661970356,
                -27.759942456437027
              ],
              [
                -48.62922116356088,
                -27.76751071672622
              ],
              [
                -48.62352455918355,
                -27.77092876541833
              ],
              [
                -48.61803139119013,
                -27.778008813421835
              ],
              [
                -48.58193924220196,
                -27.812757960211023
              ],
              [
                -48.57233639378613,
                -27.825453396363304
              ],
              [
                -48.57408607573436,
                -27.83342870930768
              ],
              [
                -48.58112547227149,
                -27.836846742090373
              ],
              [
                -48.588693805217694,
                -27.839043812380158
              ],
              [
                -48.592193152299124,
                -27.842950048072847
              ],
              [
                -48.58824622144078,
                -27.85361092336199
              ],
              [
                -48.5794978374241,
                -27.856703281670445
              ],
              [
                -48.570423952971865,
                -27.857517154930594
              ],
              [
                -48.56554114907192,
                -27.86028414339424
              ],
              [
                -48.56969153661559,
                -27.8780250025893
              ],
              [
                -48.59935460118887,
                -27.91676182981431
              ],
              [
                -48.60643469496357,
                -27.932305559628897
              ],
              [
                -48.61656654751937,
                -27.990818052110278
              ],
              [
                -48.61327065607101,
                -28.011163159714844
              ],
              [
                -48.60952715376128,
                -28.017022436495527
              ],
              [
                -48.60480709023854,
                -28.021579649887595
              ],
              [
                -48.60073808419874,
                -28.028415617093945
              ],
              [
                -48.59898842816698,
                -28.04159934343446
              ],
              [
                -48.60228431689811,
                -28.0509579991279
              ],
              [
                -48.609527152909585,
                -28.057712534110976
              ],
              [
                -48.61681066645754,
                -28.06292076085059
              ],
              [
                -48.620106574946234,
                -28.068536065605578
              ],
              [
                -48.621693500293155,
                -28.07691830993112
              ],
              [
                -48.63316808744605,
                -28.106703305676444
              ],
              [
                -48.64061439018234,
                -28.14763765124656
              ],
              [
                -48.65371661220428,
                -28.190199558581735
              ],
              [
                -48.65526280796839,
                -28.212823051186238
              ],
              [
                -48.63589434530711,
                -28.23015723387014
              ],
              [
                -48.651722800878844,
                -28.247165730917352
              ],
              [
                -48.68838456338143,
                -28.278008681365556
              ],
              [
                -48.691558407943575,
                -28.28753027786308
              ],
              [
                -48.694894980040814,
                -28.312269747008923
              ],
              [
                -48.69513912441421,
                -28.336032791376102
              ],
              [
                -48.69640053216293,
                -28.342055033566023
              ],
              [
                -48.72447668278265,
                -28.37135175481205
              ],
              [
                -48.73106848072221,
                -28.38445397461993
              ],
              [
                -48.74303138790733,
                -28.42205175471754
              ],
              [
                -48.75739497859984,
                -28.444593955161007
              ],
              [
                -48.76305089206197,
                -28.456963664906546
              ],
              [
                -48.76065020070482,
                -28.467054993798623
              ],
              [
                -48.75666258051941,
                -28.477634490691262
              ],
              [
                -48.761219876971104,
                -28.48740014729424
              ],
              [
                -48.77061925315116,
                -28.491957170113302
              ],
              [
                -48.78087315939745,
                -28.487481259854878
              ],
              [
                -48.79405677849002,
                -28.47079849546832
              ],
              [
                -48.80345619595678,
                -28.452325213250028
              ],
              [
                -48.807525210186064,
                -28.431736050555813
              ],
              [
                -48.80504307986985,
                -28.40837968635326
              ],
              [
                -48.79466712435847,
                -28.3926734590476
              ],
              [
                -48.7908829326022,
                -28.381524279654837
              ],
              [
                -48.79482986768582,
                -28.370537916355083
              ],
              [
                -48.822132948512355,
                -28.34628676375119
              ],
              [
                -48.83527585313908,
                -28.337660473447475
              ],
              [
                -48.85057531406459,
                -28.323662940422054
              ],
              [
                -48.86461340619099,
                -28.32089605744774
              ],
              [
                -48.874012831519266,
                -28.34628676375119
              ],
              [
                -48.8726700622827,
                -28.358656588844074
              ],
              [
                -48.86229408854805,
                -28.380466500952323
              ],
              [
                -48.85973060562571,
                -28.391290026533664
              ],
              [
                -48.86192785930588,
                -28.400567282454315
              ],
              [
                -48.871734198332625,
                -28.40976341704478
              ],
              [
                -48.87401282032602,
                -28.418877829648427
              ],
              [
                -48.86925206193847,
                -28.426690219908973
              ],
              [
                -48.8585099123188,
                -28.42734152755057
              ],
              [
                -48.84683181981618,
                -28.42603921264537
              ],
              [
                -48.83922276550938,
                -28.428887481780563
              ],
              [
                -48.83844966499915,
                -28.437188344805982
              ],
              [
                -48.84300698045123,
                -28.445733441124826
              ],
              [
                -48.84911049162743,
                -28.454522469689945
              ],
              [
                -48.85289464217473,
                -28.463636843018623
              ],
              [
                -48.8545629489128,
                -28.471286673700977
              ],
              [
                -48.85488848528816,
                -28.475274413050442
              ],
              [
                -48.85179601019717,
                -28.47926185042708
              ],
              [
                -48.843006948376285,
                -28.487481259854878
              ],
              [
                -48.80846108663712,
                -28.504571361499647
              ],
              [
                -48.79869546244145,
                -28.514336992146607
              ],
              [
                -48.789173952872375,
                -28.52141689570021
              ],
              [
                -48.77774002822537,
                -28.525078964615453
              ],
              [
                -48.76927649286252,
                -28.517673412714288
              ],
              [
                -48.760894352926435,
                -28.512790750400654
              ],
              [
                -48.74986729935662,
                -28.51140703357172
              ],
              [
                -48.75609291131336,
                -28.528415682025653
              ],
              [
                -48.76528888081399,
                -28.543633827052172
              ],
              [
                -48.79596918667471,
                -28.579522264444442
              ],
              [
                -48.807118274570605,
                -28.600192836919604
              ],
              [
                -48.81533769002017,
                -28.61044684493352
              ],
              [
                -48.82591711342201,
                -28.615004111586344
              ],
              [
                -48.870513491543726,
                -28.620049847424564
              ],
              [
                -48.88410399030113,
                -28.623223708845103
              ],
              [
                -48.9124649903208,
                -28.63787212468429
              ],
              [
                -48.940581841558,
                -28.645440409022495
              ],
              [
                -48.955393047232434,
                -28.655694368780324
              ],
              [
                -48.976389141225404,
                -28.675225618557807
              ],
              [
                -49.05703692442319,
                -28.718519869583947
              ],
              [
                -49.342762828176426,
                -28.923516555704293
              ],
              [
                -49.55231687881194,
                -29.127374075578523
              ],
              [
                -49.71353103881039,
                -29.324476720650075
              ],
              [
                -49.8106583533473,
                -29.443129304685517
              ],
              [
                -49.860259584693765,
                -29.528578485030234
              ],
              [
                -49.9335831243366,
                -29.6343725723444
              ],
              [
                -49.99742589733357,
                -29.764580900711152
              ],
              [
                -50.045318148239915,
                -29.814548341111635
              ],
              [
                -50.206898566206064,
                -30.20110442008562
              ],
              [
                -50.25137284814688,
                -30.322849199484075
              ],
              [
                -50.315663215766506,
                -30.461521096661507
              ],
              [
                -50.58763586536093,
                -30.851006735657766
              ],
              [
                -50.59333248981721,
                -30.871514603541797
              ],
              [
                -50.599517383073064,
                -30.881442973332593
              ],
              [
                -50.72142493364105,
                -31.04452890190673
              ],
              [
                -50.82843990922315,
                -31.142673442081307
              ],
              [
                -50.88365637451265,
                -31.21990322716065
              ],
              [
                -51.034575971560656,
                -31.378024972731435
              ],
              [
                -51.1518448495567,
                -31.481540586612226
              ],
              [
                -51.32396398832177,
                -31.603936413063813
              ],
              [
                -51.56334388281387,
                -31.777439081036267
              ],
              [
                -51.86351477405846,
                -31.93173591355748
              ],
              [
                -51.88927160669576,
                -31.953789932327716
              ],
              [
                -52.032622847723104,
                -32.10898201139021
              ],
              [
                -52.068592894812156,
                -32.16236740214672
              ],
              [
                -52.07738195176383,
                -32.16725018713735
              ],
              [
                -52.084462051362884,
                -32.14690525081265
              ],
              [
                -52.07689367780626,
                -32.123793193768066
              ],
              [
                -52.05313065908121,
                -32.08782315392639
              ],
              [
                -52.046701632993376,
                -32.07431409225649
              ],
              [
                -52.03892982484523,
                -32.051853165277436
              ],
              [
                -52.03575598949919,
                -32.02792734469367
              ],
              [
                -52.04287676076589,
                -32.009535435336346
              ],
              [
                -52.05663001802727,
                -31.988376592574422
              ],
              [
                -52.045033338444625,
                -31.97682060585805
              ],
              [
                -52.02472898151023,
                -31.966973628312456
              ],
              [
                -52.01219641754229,
                -31.950616141519866
              ],
              [
                -52.02586829017767,
                -31.9196916496846
              ],
              [
                -52.08796139196408,
                -31.858575127804855
              ],
              [
                -52.087269674039156,
                -31.82781348001072
              ],
              [
                -52.048451289110155,
                -31.80828209413519
              ],
              [
                -52.00182043467321,
                -31.821547093020477
              ],
              [
                -51.9227595759549,
                -31.868747691916067
              ],
              [
                -51.87999427145268,
                -31.871270448925202
              ],
              [
                -51.83633378704949,
                -31.85491301380609
              ],
              [
                -51.813710092287096,
                -31.82838308352121
              ],
              [
                -51.83409583987124,
                -31.80046970213689
              ],
              [
                -51.786040831322396,
                -31.792087565622708
              ],
              [
                -51.743723120875586,
                -31.794854479231493
              ],
              [
                -51.7044978546159,
                -31.79273855987418
              ],
              [
                -51.66616777615037,
                -31.769707958348956
              ],
              [
                -51.560210741632936,
                -31.667575782511733
              ],
              [
                -51.54539955259543,
                -31.6397438013267
              ],
              [
                -51.512562627606364,
                -31.615980719240536
              ],
              [
                -51.505116347467656,
                -31.598077122625494
              ],
              [
                -51.49868730225256,
                -31.57488371224679
              ],
              [
                -51.48412025441879,
                -31.582940409983998
              ],
              [
                -51.457264791190035,
                -31.615492519523077
              ],
              [
                -51.44762122034874,
                -31.612725504216925
              ],
              [
                -51.450998494350486,
                -31.59531011131038
              ],
              [
                -51.46349036061916,
                -31.557224198099206
              ],
              [
                -51.4590958253947,
                -31.539320534033966
              ],
              [
                -51.44835363833706,
                -31.516859595658957
              ],
              [
                -51.43496659648518,
                -31.496514555663776
              ],
              [
                -51.42251542567721,
                -31.485121333337393
              ],
              [
                -51.41348221563387,
                -31.51783613786887
              ],
              [
                -51.37779699620388,
                -31.5269507352718
              ],
              [
                -51.334543419788794,
                -31.51921963534988
              ],
              [
                -51.30304927838533,
                -31.50221117004458
              ],
              [
                -51.287831187511514,
                -31.490004184770015
              ],
              [
                -51.25670325372774,
                -31.47258879846513
              ],
              [
                -51.244984493528044,
                -31.464043818912486
              ],
              [
                -51.21027583935014,
                -31.41619228401726
              ],
              [
                -51.17959550880479,
                -31.358982039254716
              ],
              [
                -51.1585587210088,
                -31.286390871637412
              ],
              [
                -51.15477454673246,
                -31.21209077438836
              ],
              [
                -51.1761368418894,
                -31.14934657787824
              ],
              [
                -51.17015539808635,
                -31.135349188732974
              ],
              [
                -51.16283118955037,
                -31.09295016001074
              ],
              [
                -51.16185461716089,
                -31.077732006840293
              ],
              [
                -51.15339108284278,
                -31.06715261842172
              ],
              [
                -51.13390052033766,
                -31.069594009951192
              ],
              [
                -51.09727942300037,
                -31.080987220667023
              ],
              [
                -51.07799231636024,
                -31.07789478630148
              ],
              [
                -51.04784095520913,
                -31.064060184158848
              ],
              [
                -51.03278561203495,
                -31.060642190994926
              ],
              [
                -51.01398678777653,
                -31.062758098674486
              ],
              [
                -51.006418429332484,
                -31.070489221886792
              ],
              [
                -51.00576738459725,
                -31.12420014299923
              ],
              [
                -51.0031632125958,
                -31.132907796122343
              ],
              [
                -50.99425208405224,
                -31.13632579084662
              ],
              [
                -50.98350989651586,
                -31.135023704752815
              ],
              [
                -50.97594153289526,
                -31.130954667066796
              ],
              [
                -50.97150631136487,
                -31.123304930771425
              ],
              [
                -50.97004146682944,
                -31.11174893766489
              ],
              [
                -50.96467038187358,
                -31.101250937203595
              ],
              [
                -50.95287025057864,
                -31.09547294151157
              ],
              [
                -50.94107011315658,
                -31.09189216852935
              ],
              [
                -50.93590247858753,
                -31.0878232073775
              ],
              [
                -50.93993078874302,
                -31.076429921319367
              ],
              [
                -50.948719857719105,
                -31.07480235196665
              ],
              [
                -50.95958411951132,
                -31.076267216941687
              ],
              [
                -50.97004147494741,
                -31.07431408867057
              ],
              [
                -50.9876602810388,
                -31.045586818213724
              ],
              [
                -50.97744706293274,
                -31.008965717716727
              ],
              [
                -50.96011308366488,
                -30.966973558215027
              ],
              [
                -50.95641029226275,
                -30.922784149613165
              ],
              [
                -50.9718318342491,
                -30.904066660607118
              ],
              [
                -50.97842363126781,
                -30.893324472714493
              ],
              [
                -50.97374427587259,
                -30.888604459387093
              ],
              [
                -50.963042778074936,
                -30.88982515772066
              ],
              [
                -50.95006262289784,
                -30.894952045265477
              ],
              [
                -50.93932044620075,
                -30.896091428603892
              ],
              [
                -50.91388912626874,
                -30.893324472714493
              ],
              [
                -50.89541581984896,
                -30.885837502979776
              ],
              [
                -50.819569464512895,
                -30.831312755130156
              ],
              [
                -50.779693161731785,
                -30.823825771518447
              ],
              [
                -50.76012122094059,
                -30.81511808483987
              ],
              [
                -50.74388586662242,
                -30.80388760212688
              ],
              [
                -50.73106848903678,
                -30.79241301921787
              ],
              [
                -50.69261634549008,
                -30.726495082627128
              ],
              [
                -50.67943275157438,
                -30.641696906300066
              ],
              [
                -50.68952389066491,
                -30.464043869942692
              ],
              [
                -50.694691533894094,
                -30.446058839278535
              ],
              [
                -50.713368294443754,
                -30.40837982473856
              ],
              [
                -50.7210994134053,
                -30.379082943457274
              ],
              [
                -50.72663326584525,
                -30.37037525099724
              ],
              [
                -50.725656704780725,
                -30.363051038669816
              ],
              [
                -50.70995032280993,
                -30.35418058370151
              ],
              [
                -50.69717362950269,
                -30.350762612828873
              ],
              [
                -50.68993079081426,
                -30.353204020721712
              ],
              [
                -50.67585201417813,
                -30.367852454867155
              ],
              [
                -50.64513098753105,
                -30.392185145089126
              ],
              [
                -50.64264889489238,
                -30.398370067540817
              ],
              [
                -50.64631100243708,
                -30.404554948649654
              ],
              [
                -50.65184485702457,
                -30.41139088920797
              ],
              [
                -50.654693160468874,
                -30.41936612867339
              ],
              [
                -50.64989172882,
                -30.438571859813635
              ],
              [
                -50.63805090845973,
                -30.457207925647605
              ],
              [
                -50.622629359006666,
                -30.47372811096115
              ],
              [
                -50.607533330842465,
                -30.48512134501167
              ],
              [
                -50.572173629302824,
                -30.461114174681857
              ],
              [
                -50.56501217618849,
                -30.450127876251653
              ],
              [
                -50.56672115721594,
                -30.434258717248447
              ],
              [
                -50.57282467672325,
                -30.409437774527078
              ],
              [
                -50.56867428021705,
                -30.397637611097895
              ],
              [
                -50.555165168551554,
                -30.378838803355013
              ],
              [
                -50.53726152481522,
                -30.320407821083222
              ],
              [
                -50.536773240122315,
                -30.294040617633105
              ],
              [
                -50.53986568956575,
                -30.26751067846524
              ],
              [
                -50.54552161538695,
                -30.25115326150254
              ],
              [
                -50.583363411621896,
                -30.23202890781423
              ],
              [
                -50.58771725322771,
                -30.226820578531115
              ],
              [
                -50.59837805806965,
                -30.202406502286376
              ],
              [
                -50.603871224139795,
                -30.19378021300375
              ],
              [
                -50.61481686203158,
                -30.186211853340286
              ],
              [
                -50.625599738598964,
                -30.183363537535644
              ],
              [
                -50.63662675700254,
                -30.184991144015918
              ],
              [
                -50.64854895627456,
                -30.1903622335458
              ],
              [
                -50.67247473958832,
                -30.217054949605295
              ],
              [
                -50.67585201722931,
                -30.217705989405182
              ],
              [
                -50.67829342361585,
                -30.2282040316483
              ],
              [
                -50.67617753662752,
                -30.23162199459861
              ],
              [
                -50.669585740082596,
                -30.233982023384502
              ],
              [
                -50.6584366516224,
                -30.241468999569488
              ],
              [
                -50.65343177015834,
                -30.251560154968924
              ],
              [
                -50.65526282467198,
                -30.261651297995446
              ],
              [
                -50.66218014098677,
                -30.275485928812508
              ],
              [
                -50.67198645823605,
                -30.288995057541293
              ],
              [
                -50.69517981852258,
                -30.29436615328206
              ],
              [
                -50.76105709621566,
                -30.291436463402622
              ],
              [
                -50.77912350117851,
                -30.29322681600042
              ],
              [
                -50.79352779902089,
                -30.30250416512725
              ],
              [
                -50.79938717575412,
                -30.323500268652772
              ],
              [
                -50.85716712243957,
                -30.317071230736232
              ],
              [
                -50.87441972540526,
                -30.320082286393113
              ],
              [
                -50.897531704288596,
                -30.310479420684928
              ],
              [
                -50.9129939410033,
                -30.316664302834745
              ],
              [
                -50.922922328623336,
                -30.33318449466507
              ],
              [
                -50.929066533800494,
                -30.35418058370151
              ],
              [
                -50.93285071690137,
                -30.38062917647762
              ],
              [
                -50.93028724168025,
                -30.39861420716241
              ],
              [
                -50.91539466396334,
                -30.436211864834693
              ],
              [
                -50.93639075655134,
                -30.431573190352992
              ],
              [
                -50.984364385734814,
                -30.395196214377812
              ],
              [
                -51.00389563974126,
                -30.388116160516997
              ],
              [
                -51.02147376054665,
                -30.3837216042445
              ],
              [
                -51.034087695571465,
                -30.375664981470116
              ],
              [
                -51.03892981490042,
                -30.35759855333564
              ],
              [
                -51.040272588042534,
                -30.343519778183225
              ],
              [
                -51.03868567479407,
                -30.338962490717922
              ],
              [
                -51.03278560853085,
                -30.32691821207694
              ],
              [
                -51.02627519596107,
                -30.317803655860818
              ],
              [
                -51.01939856596199,
                -30.311293220719143
              ],
              [
                -51.01390540237345,
                -30.30494556720728
              ],
              [
                -51.011626756550264,
                -30.296156505275984
              ],
              [
                -51.01480058652645,
                -30.27857839225618
              ],
              [
                -51.02310136743077,
                -30.26376719368238
              ],
              [
                -51.034169074139854,
                -30.257419523780232
              ],
              [
                -51.045765752965316,
                -30.265394783725167
              ],
              [
                -51.052601690965176,
                -30.265394783725167
              ],
              [
                -51.057606575541634,
                -30.2418759122893
              ],
              [
                -51.079457159826624,
                -30.23788827187699
              ],
              [
                -51.103382943416904,
                -30.243259381595408
              ],
              [
                -51.11465410044695,
                -30.24814218164729
              ],
              [
                -51.122547979491465,
                -30.256036056860022
              ],
              [
                -51.140777148051384,
                -30.247491144311745
              ],
              [
                -51.17613684764439,
                -30.22454192284366
              ],
              [
                -51.17145748497282,
                -30.209405199764753
              ],
              [
                -51.18049068907315,
                -30.20037200344444
              ],
              [
                -51.21027584426651,
                -30.1903622335458
              ],
              [
                -51.219227668683004,
                -30.188897398147887
              ],
              [
                -51.22687740889174,
                -30.19019948241402
              ],
              [
                -51.23302161488428,
                -30.18987396136826
              ],
              [
                -51.237538216249106,
                -30.18352630758529
              ],
              [
                -51.23558509118872,
                -30.178155213221192
              ],
              [
                -51.221262172983565,
                -30.164971606819268
              ],
              [
                -51.21711178338208,
                -30.156345312325186
              ],
              [
                -51.22036699087043,
                -30.136407158210993
              ],
              [
                -51.23159745930764,
                -30.124769785780625
              ],
              [
                -51.24404863148902,
                -30.116875905885248
              ],
              [
                -51.251210090477656,
                -30.107842708913683
              ],
              [
                -51.250477667307464,
                -30.091566660772546
              ],
              [
                -51.238880988720105,
                -30.058526298287596
              ],
              [
                -51.237538214795045,
                -30.039646090744952
              ],
              [
                -51.25934811068035,
                -30.046807548043677
              ],
              [
                -51.26280677012313,
                -30.0329729157544
              ],
              [
                -51.26207434809221,
                -30.013767185565825
              ],
              [
                -51.27171790300682,
                -30.0048153630424
              ],
              [
                -51.28351803302137,
                -30.00741952913139
              ],
              [
                -51.285267707060314,
                -30.01262786336996
              ],
              [
                -51.28380286391156,
                -30.02076588245837
              ],
              [
                -51.28595943910256,
                -30.032159113628193
              ],
              [
                -51.30361894406107,
                -30.063409113373524
              ],
              [
                -51.306467252214354,
                -30.070245051309207
              ],
              [
                -51.30426998609667,
                -30.07626718559036
              ],
              [
                -51.2993057930838,
                -30.07887135251202
              ],
              [
                -51.29434160056996,
                -30.080743094375528
              ],
              [
                -51.29214433425234,
                -30.083916920437463
              ],
              [
                -51.29332434851313,
                -30.090101824130624
              ],
              [
                -51.29845130175869,
                -30.09970468962556
              ],
              [
                -51.29963131352557,
                -30.104668875108903
              ],
              [
                -51.30003821485989,
                -30.127048434147866
              ],
              [
                -51.30308997350202,
                -30.136325782053593
              ],
              [
                -51.31017005107294,
                -30.14568450344358
              ],
              [
                -51.313954231279645,
                -30.154554947698987
              ],
              [
                -51.312163866702974,
                -30.165134377267552
              ],
              [
                -51.30850175743474,
                -30.17620208363775
              ],
              [
                -51.306467252384635,
                -30.186944271332237
              ],
              [
                -51.30890865914274,
                -30.197360941923733
              ],
              [
                -51.32697506364335,
                -30.22454192284366
              ],
              [
                -51.31651770659238,
                -30.223321219534892
              ],
              [
                -51.298654753373334,
                -30.218845318311736
              ],
              [
                -51.28905188723205,
                -30.217705989405182
              ],
              [
                -51.282460090720164,
                -30.221368101359612
              ],
              [
                -51.2648819647816,
                -30.244886975679837
              ],
              [
                -51.29214433613289,
                -30.271661072835467
              ],
              [
                -51.280629037202516,
                -30.28736745325026
              ],
              [
                -51.247181768948984,
                -30.297539965663436
              ],
              [
                -51.237538215583314,
                -30.313246355514675
              ],
              [
                -51.22813880037242,
                -30.307061452217223
              ],
              [
                -51.20864824200045,
                -30.28875091504008
              ],
              [
                -51.2040909495144,
                -30.28533293806813
              ],
              [
                -51.19717363285268,
                -30.294691670147323
              ],
              [
                -51.19530188815126,
                -30.30901458794392
              ],
              [
                -51.19660397237219,
                -30.337172147282693
              ],
              [
                -51.18773352802817,
                -30.360121352169884
              ],
              [
                -51.16612707983658,
                -30.362969645987146
              ],
              [
                -51.11465409796543,
                -30.3473446407117
              ],
              [
                -51.09341386452898,
                -30.344984624129847
              ],
              [
                -51.090646936653336,
                -30.351983316854515
              ],
              [
                -51.096302861350054,
                -30.366143472041955
              ],
              [
                -51.10041256600013,
                -30.385349229030496
              ],
              [
                -51.10472571492896,
                -30.39324309657344
              ],
              [
                -51.11481686200759,
                -30.401055603053184
              ],
              [
                -51.12637284951913,
                -30.406996343109277
              ],
              [
                -51.13512122575354,
                -30.409437774527078
              ],
              [
                -51.14110266794105,
                -30.407810153646675
              ],
              [
                -51.15330970269197,
                -30.39861420716241
              ],
              [
                -51.1618546197304,
                -30.395196214377812
              ],
              [
                -51.2004288418642,
                -30.39983490518166
              ],
              [
                -51.229481575975335,
                -30.425876565838
              ],
              [
                -51.250477669513195,
                -30.462334903033778
              ],
              [
                -51.27794348885049,
                -30.54013437211241
              ],
              [
                -51.286976690855205,
                -30.58163827221894
              ],
              [
                -51.29019120938327,
                -30.62444426535642
              ],
              [
                -51.285959444728334,
                -30.669610317760043
              ],
              [
                -51.26756750585594,
                -30.73495855591438
              ],
              [
                -51.26488196004419,
                -30.7555477549263
              ],
              [
                -51.26968339475892,
                -30.78183357301648
              ],
              [
                -51.28172766497121,
                -30.796563391279104
              ],
              [
                -51.29767818613958,
                -30.79534268926805
              ],
              [
                -51.313954226271335,
                -30.773207262313502
              ],
              [
                -51.28945878825295,
                -30.767347916482645
              ],
              [
                -51.29116777007165,
                -30.73992276681402
              ],
              [
                -51.313954225323315,
                -30.68377040759075
              ],
              [
                -51.32249915671603,
                -30.642185175920133
              ],
              [
                -51.332834442582495,
                -30.63640718013506
              ],
              [
                -51.35798091864807,
                -30.635430565440384
              ],
              [
                -51.377105278549934,
                -30.642266566702663
              ],
              [
                -51.383290168571335,
                -30.65886810036335
              ],
              [
                -51.38158118008261,
                -30.776299715097863
              ],
              [
                -51.37877356429449,
                -30.794121987198224
              ],
              [
                -51.36546789689704,
                -30.83228928542329
              ],
              [
                -51.36107337469155,
                -30.85458751949474
              ],
              [
                -51.361887180009,
                -30.879164355938663
              ],
              [
                -51.370716927229914,
                -30.886488547147202
              ],
              [
                -51.4125870400837,
                -30.882500892064012
              ],
              [
                -51.43712317555404,
                -30.883884370411803
              ],
              [
                -51.45543371976311,
                -30.889418208225038
              ],
              [
                -51.46861731816415,
                -30.901625264746496
              ],
              [
                -51.4777725963268,
                -30.922784149613165
              ],
              [
                -51.48570716134512,
                -30.967054947992196
              ],
              [
                -51.48420162378849,
                -31.012953364511922
              ],
              [
                -51.470814577543806,
                -31.05331794139771
              ],
              [
                -51.443023237980064,
                -31.080987220667023
              ],
              [
                -51.569691535405,
                -31.119561452600937
              ],
              [
                -51.59068762582373,
                -31.12200284486326
              ],
              [
                -51.62360591904283,
                -31.135349188732974
              ],
              [
                -51.642974417773594,
                -31.167087525162962
              ],
              [
                -51.65086829119306,
                -31.205498945741958
              ],
              [
                -51.64903723249679,
                -31.238702044145768
              ],
              [
                -51.63760331790374,
                -31.25025806479023
              ],
              [
                -51.63752193799591,
                -31.25652434131424
              ],
              [
                -51.65282142086348,
                -31.25920991020869
              ],
              [
                -51.663400846236506,
                -31.257256775998556
              ],
              [
                -51.6743057979096,
                -31.253676067787335
              ],
              [
                -51.68472245869743,
                -31.252129808629018
              ],
              [
                -51.69375565975545,
                -31.25579190664608
              ],
              [
                -51.71255450292855,
                -31.265883138417504
              ],
              [
                -51.73501543058593,
                -31.269138287958175
              ],
              [
                -51.77940832088195,
                -31.2660457682454
              ],
              [
                -51.795887834610646,
                -31.26702244822671
              ],
              [
                -51.818959101728574,
                -31.27223065781156
              ],
              [
                -51.839466912993764,
                -31.282159039737316
              ],
              [
                -51.85692298069024,
                -31.311211845258885
              ],
              [
                -51.877552863690134,
                -31.311211845258885
              ],
              [
                -51.90208900567896,
                -31.30673598938245
              ],
              [
                -51.92275958210591,
                -31.30689876960697
              ],
              [
                -51.92747962592258,
                -31.311456015637713
              ],
              [
                -51.932199672330626,
                -31.318536056632166
              ],
              [
                -51.94001218215594,
                -31.325127908745873
              ],
              [
                -51.953846800895526,
                -31.328057504562928
              ],
              [
                -51.96353105806994,
                -31.33228934380893
              ],
              [
                -51.96369381077186,
                -31.34172940691859
              ],
              [
                -51.95726476815235,
                -31.351169473862623
              ],
              [
                -51.94733639509289,
                -31.35540131731696
              ],
              [
                -51.94286049000543,
                -31.359307600414315
              ],
              [
                -51.951405392138945,
                -31.368096552237354
              ],
              [
                -51.987660283380684,
                -31.39251066037583
              ],
              [
                -51.99351965200854,
                -31.398207239819257
              ],
              [
                -51.99852454379642,
                -31.409356382442137
              ],
              [
                -52.00161698395515,
                -31.42913172975471
              ],
              [
                -51.998524538505016,
                -31.495375233047035
              ],
              [
                -51.999826628448815,
                -31.50701263603808
              ],
              [
                -52.004750117481365,
                -31.527927278174385
              ],
              [
                -52.00475013222048,
                -31.539727489834032
              ],
              [
                -52.00080320087451,
                -31.551202146721497
              ],
              [
                -51.98839271389251,
                -31.56536227612838
              ],
              [
                -51.984852669251985,
                -31.57390716592348
              ],
              [
                -52.00153560393555,
                -31.624281469052452
              ],
              [
                -52.004750138680976,
                -31.6397438013267
              ],
              [
                -52.007923970005976,
                -31.646172855613475
              ],
              [
                -52.01488197027244,
                -31.637465131040805
              ],
              [
                -52.025868306335795,
                -31.615492519523077
              ],
              [
                -52.03018144420105,
                -31.589125259110116
              ],
              [
                -52.03262284623311,
                -31.5813127316754
              ],
              [
                -52.04015051189961,
                -31.57024500524659
              ],
              [
                -52.045969208946275,
                -31.56633882180502
              ],
              [
                -52.05272376404213,
                -31.564060165283905
              ],
              [
                -52.06309973557977,
                -31.557224198099206
              ],
              [
                -52.07323158121026,
                -31.554294563318653
              ],
              [
                -52.083322725578945,
                -31.558689090816646
              ],
              [
                -52.091053846982575,
                -31.56755954154611
              ],
              [
                -52.09410560863023,
                -31.577569327647385
              ],
              [
                -52.08995520032918,
                -31.60613368524989
              ],
              [
                -52.07909096076948,
                -31.61004003133093
              ],
              [
                -52.063791467831315,
                -31.605238528046012
              ],
              [
                -52.04629471439995,
                -31.608086783047177
              ],
              [
                -52.041249158693105,
                -31.622653935366426
              ],
              [
                -52.04914304333718,
                -31.64397557588007
              ],
              [
                -52.06334387836843,
                -31.66545989052994
              ],
              [
                -52.07738195560324,
                -31.680596561422586
              ],
              [
                -52.09577389004855,
                -31.69109464829853
              ],
              [
                -52.20372473593224,
                -31.72730883524346
              ],
              [
                -52.21861732699468,
                -31.740655260540052
              ],
              [
                -52.22447668220862,
                -31.76246504863657
              ],
              [
                -52.222238733824554,
                -31.77434660115068
              ],
              [
                -52.21239171971558,
                -31.794121941586386
              ],
              [
                -52.21019447292832,
                -31.80046970213689
              ],
              [
                -52.21304276203859,
                -31.809258662391834
              ],
              [
                -52.21906490511217,
                -31.81796638830502
              ],
              [
                -52.22419185856066,
                -31.828220296750857
              ],
              [
                -52.22447669730437,
                -31.84140393279135
              ],
              [
                -52.245594849042135,
                -31.840996965248955
              ],
              [
                -52.24844315659513,
                -31.861993062288615
              ],
              [
                -52.235707172354864,
                -31.87965266349775
              ],
              [
                -52.21019447199339,
                -31.868747691916067
              ],
              [
                -52.186675597381374,
                -31.894789388068084
              ],
              [
                -52.18350176947665,
                -31.900079101569876
              ],
              [
                -52.178863071251044,
                -31.902764506543907
              ],
              [
                -52.15680905552286,
                -31.906915007331627
              ],
              [
                -52.14932208270316,
                -31.909763353224086
              ],
              [
                -52.142445442733454,
                -31.9154598979725
              ],
              [
                -52.13609779122497,
                -31.922540000290187
              ],
              [
                -52.133859824833785,
                -31.930840725039154
              ],
              [
                -52.13906816623993,
                -31.940525015525342
              ],
              [
                -52.146962033146096,
                -31.941827027711508
              ],
              [
                -52.16978920183564,
                -31.936456041181803
              ],
              [
                -52.180043101242475,
                -31.940525015525342
              ],
              [
                -52.19725501804213,
                -31.94996513463055
              ],
              [
                -52.21898352199999,
                -31.957207908623147
              ],
              [
                -52.237660278694285,
                -31.96640386460982
              ],
              [
                -52.245594842623724,
                -31.98202883194743
              ],
              [
                -52.24811764327685,
                -32.01913828586486
              ],
              [
                -52.25206457975645,
                -32.038181235951
              ],
              [
                -52.25861567685582,
                -32.05364342283754
              ],
              [
                -52.229237429193724,
                -32.05071377419284
              ],
              [
                -52.21117101487353,
                -32.05673586451416
              ],
              [
                -52.21165930859302,
                -32.06796640181631
              ],
              [
                -52.23810787427462,
                -32.08098722339104
              ],
              [
                -52.213978634194866,
                -32.086114133068214
              ],
              [
                -52.18211830288897,
                -32.079034166071786
              ],
              [
                -52.15440834052265,
                -32.065118142795406
              ],
              [
                -52.142486137689666,
                -32.05022554960297
              ],
              [
                -52.137115049316655,
                -32.03777440791303
              ],
              [
                -52.124094203782214,
                -32.02947355944094
              ],
              [
                -52.108225065759626,
                -32.02556732548252
              ],
              [
                -52.09410560315778,
                -32.026462525801286
              ],
              [
                -52.08141028955189,
                -32.03199637114465
              ],
              [
                -52.081450984401954,
                -32.03769301227308
              ],
              [
                -52.097808403684795,
                -32.05022554960297
              ],
              [
                -52.147450321327035,
                -32.077894770274426
              ],
              [
                -52.168934695292926,
                -32.10068122276003
              ],
              [
                -52.15615801374019,
                -32.122653940111604
              ],
              [
                -52.139719216546375,
                -32.11907323689197
              ],
              [
                -52.10285397578868,
                -32.07968518511275
              ],
              [
                -52.08726966489352,
                -32.06731538394624
              ],
              [
                -52.10057533034562,
                -32.106215130694444
              ],
              [
                -52.101551893733095,
                -32.122653940111604
              ],
              [
                -52.09117590979652,
                -32.153903897554514
              ],
              [
                -52.091175909196814,
                -32.16611092534851
              ],
              [
                -52.127430790899815,
                -32.177504153773135
              ],
              [
                -52.2286270762204,
                -32.251071842275984
              ],
              [
                -52.253407366924556,
                -32.28248469095747
              ],
              [
                -52.37531489627453,
                -32.49871178559221
              ],
              [
                -52.44318599200821,
                -32.68596765420721
              ],
              [
                -52.47085526442027,
                -32.800957896791324
              ],
              [
                -52.62169350246224,
                -33.10198339920972
              ],
              [
                -52.64488686403706,
                -33.13697690209022
              ],
              [
                -52.74404861470407,
                -33.249200041152164
              ],
              [
                -52.81948807465467,
                -33.32252364429793
              ],
              [
                -52.92088780885345,
                -33.403008641748706
              ],
              [
                -53.0916642099002,
                -33.52727638819649
              ],
              [
                -53.19440673293361,
                -33.61972435381251
              ],
              [
                -53.26634679515467,
                -33.67669029544791
              ],
              [
                -53.378814280017494,
                -33.74049255775965
              ],
              [
                -53.37909454617686,
                -33.740675859368174
              ],
              [
                -53.411282944815696,
                -33.74228050026018
              ],
              [
                -53.42363360014456,
                -33.731014981648336
              ],
              [
                -53.43081660494489,
                -33.713444901451304
              ],
              [
                -53.4404284042943,
                -33.697115063676264
              ],
              [
                -53.456706498343316,
                -33.687503334371705
              ],
              [
                -53.47319127627822,
                -33.68739996648809
              ],
              [
                -53.4910713473703,
                -33.69029396834558
              ],
              [
                -53.51153521437699,
                -33.69029396834558
              ],
              [
                -53.53964720017457,
                -33.64926291448731
              ],
              [
                -53.53680495869906,
                -33.55986250410261
              ],
              [
                -53.51401565975948,
                -33.39491136631625
              ],
              [
                -53.53613318459664,
                -33.24463635969247
              ],
              [
                -53.53685664459637,
                -33.17084236513866
              ],
              [
                -53.52066175832638,
                -33.124978983671966
              ],
              [
                -53.51163855336926,
                -33.09942557378949
              ],
              [
                -53.51158687748512,
                -33.09932222735029
              ],
              [
                -53.51153520280247,
                -33.09921888091438
              ],
              [
                -53.483319879054946,
                -33.067282886177004
              ],
              [
                -53.44911004276067,
                -33.04206459575494
              ],
              [
                -53.3273087186324,
                -32.973645130210095
              ],
              [
                -53.31630161950562,
                -32.96268963498615
              ],
              [
                -53.309583709125086,
                -32.94439630597057
              ],
              [
                -53.30699988961532,
                -32.90718928861999
              ],
              [
                -53.29883503126306,
                -32.88910262583085
              ],
              [
                -53.270826387303906,
                -32.863781089262886
              ],
              [
                -53.20385371747794,
                -32.822439867196955
              ],
              [
                -53.18283630973643,
                -32.7999040934922
              ],
              [
                -53.16308103926716,
                -32.77872174763449
              ],
              [
                -53.12685582655231,
                -32.754847063915896
              ],
              [
                -53.114040051493454,
                -32.74058426547855
              ],
              [
                -53.1108361143477,
                -32.722394165709545
              ],
              [
                -53.11977616425662,
                -32.70740813819989
              ],
              [
                -53.18612871079151,
                -32.646740045777435
              ],
              [
                -53.2014766068967,
                -32.637231561835925
              ],
              [
                -53.23372269965785,
                -32.62462250549119
              ],
              [
                -53.266898975761706,
                -32.60736261388312
              ],
              [
                -53.299093400522935,
                -32.60715594859026
              ],
              [
                -53.316043264949954,
                -32.602711746053515
              ],
              [
                -53.359089725952735,
                -32.58028413824015
              ],
              [
                -53.415623738971604,
                -32.56416107185504
              ],
              [
                -53.47463822017921,
                -32.50824715241058
              ],
              [
                -53.53763179991892,
                -32.470213338106646
              ],
              [
                -53.56129958968115,
                -32.449542681762644
              ],
              [
                -53.58197018903223,
                -32.42577165808932
              ],
              [
                -53.59892005770518,
                -32.399933440475714
              ],
              [
                -53.609307005899474,
                -32.38784107933884
              ],
              [
                -53.63478349440291,
                -32.368720832807504
              ],
              [
                -53.643878537077086,
                -32.35559497594988
              ],
              [
                -53.648684456952054,
                -32.33864516197676
              ],
              [
                -53.65183670184811,
                -32.28831222872694
              ],
              [
                -53.65855464242379,
                -32.25430916032529
              ],
              [
                -53.67059526351286,
                -32.226403948912974
              ],
              [
                -53.721444872351825,
                -32.162428525164884
              ],
              [
                -53.75002192748204,
                -32.1040340954907
              ],
              [
                -53.75136550599149,
                -32.06879072419031
              ],
              [
                -53.75730831230349,
                -32.055044873014744
              ],
              [
                -53.77182939013625,
                -32.04708670636061
              ],
              [
                -53.83043045076207,
                -32.0364412916237
              ],
              [
                -53.858077342845675,
                -32.02119674926084
              ],
              [
                -53.87109980079045,
                -32.01148156431177
              ],
              [
                -53.88143508917109,
                -32.00124963849551
              ],
              [
                -53.88727453157941,
                -31.99050097392341
              ],
              [
                -53.88975500176192,
                -31.980372399088537
              ],
              [
                -53.89414750872742,
                -31.97014051815133
              ],
              [
                -53.905826375573106,
                -31.95928842976915
              ],
              [
                -53.934351775423,
                -31.94254531203983
              ],
              [
                -53.94876949446232,
                -31.936964231103076
              ],
              [
                -53.96597773023067,
                -31.932519973240836
              ],
              [
                -53.998895645187815,
                -31.92972958614124
              ],
              [
                -54.00871416190173,
                -31.926525620517182
              ],
              [
                -54.01770585340972,
                -31.919600944594915
              ],
              [
                -54.02664586701489,
                -31.904821435470456
              ],
              [
                -54.03264034611051,
                -31.898103567963435
              ],
              [
                -54.04974523637297,
                -31.88714811302322
              ],
              [
                -54.06881383004591,
                -31.879913364221235
              ],
              [
                -54.08845089747478,
                -31.878156487792168
              ],
              [
                -54.107312779625545,
                -31.883944164905476
              ],
              [
                -54.12550289915804,
                -31.898516995821936
              ],
              [
                -54.135063025437326,
                -31.908955568410175
              ],
              [
                -54.14627681152457,
                -31.90988574486988
              ],
              [
                -54.16958288304987,
                -31.895933109605604
              ],
              [
                -54.21877885585219,
                -31.856659072796408
              ],
              [
                -54.27422764841451,
                -31.823379343979795
              ],
              [
                -54.342957327798835,
                -31.769325922540304
              ],
              [
                -54.373498094753494,
                -31.738940159396236
              ],
              [
                -54.40367711734638,
                -31.714652160858165
              ],
              [
                -54.43649164528525,
                -31.694291620282875
              ],
              [
                -54.463725151520705,
                -31.671864181744205
              ],
              [
                -54.4672206937516,
                -31.664237358664767
              ],
              [
                -54.47736771087611,
                -31.642098457802774
              ],
              [
                -54.47896969397352,
                -31.60148085074262
              ],
              [
                -54.48315547270643,
                -31.583910800085945
              ],
              [
                -54.49504106503095,
                -31.56561741238219
              ],
              [
                -54.509665488773145,
                -31.552284860361485
              ],
              [
                -54.56237545475495,
                -31.515904677698583
              ],
              [
                -54.57384760424042,
                -31.502468707822636
              ],
              [
                -54.591520943230904,
                -31.471049431393087
              ],
              [
                -54.60454341359588,
                -31.459784019970208
              ],
              [
                -54.619684609150774,
                -31.455649912206567
              ],
              [
                -54.65412694399652,
                -31.45575322734623
              ],
              [
                -54.819775742927206,
                -31.435289333658176
              ],
              [
                -54.849903130446975,
                -31.42505754603643
              ],
              [
                -54.86336481825956,
                -31.41761601753701
              ],
              [
                -54.8761547515885,
                -31.40635064082368
              ],
              [
                -54.88780779150164,
                -31.39322485382225
              ],
              [
                -54.900287633876395,
                -31.382062655896064
              ],
              [
                -54.940801967931364,
                -31.365629614673388
              ],
              [
                -54.96963742313996,
                -31.340824954283942
              ],
              [
                -54.99534644401276,
                -31.311782777476704
              ],
              [
                -55.01149531461508,
                -31.28780483611903
              ],
              [
                -55.029375368419636,
                -31.268787950539224
              ],
              [
                -55.04234613790277,
                -31.272611929481542
              ],
              [
                -55.06110470872244,
                -31.304858160388257
              ],
              [
                -55.074256334571324,
                -31.320567656949258
              ],
              [
                -55.08725297607804,
                -31.326768926852797
              ],
              [
                -55.10244585103531,
                -31.324288478771816
              ],
              [
                -55.12223791312734,
                -31.313539723096955
              ],
              [
                -55.16962520457909,
                -31.276436059066583
              ],
              [
                -55.18828038771914,
                -31.266514136147787
              ],
              [
                -55.22755448859455,
                -31.253491739035724
              ],
              [
                -55.24434931881471,
                -31.24460334023943
              ],
              [
                -55.25998144551911,
                -31.228687029451645
              ],
              [
                -55.2687406052484,
                -31.210600303534378
              ],
              [
                -55.28222815248718,
                -31.169052443219847
              ],
              [
                -55.29370032193877,
                -31.15365287826693
              ],
              [
                -55.32692826488781,
                -31.134945994044973
              ],
              [
                -55.33803869409046,
                -31.125644210514427
              ],
              [
                -55.344963337414804,
                -31.108487641556195
              ],
              [
                -55.348425664547065,
                -31.072727589605776
              ],
              [
                -55.3538516838464,
                -31.05629444783831
              ],
              [
                -55.368579466587526,
                -31.037380871449642
              ],
              [
                -55.44258012360309,
                -30.9655506636739
              ],
              [
                -55.48908890775758,
                -30.92968719369954
              ],
              [
                -55.51130977192856,
                -30.906122730873573
              ],
              [
                -55.52748449274636,
                -30.894547198143496
              ],
              [
                -55.56386470472649,
                -30.87646046853027
              ],
              [
                -55.591873333023756,
                -30.84834849650952
              ],
              [
                -55.61290563678559,
                -30.84338753570426
              ],
              [
                -55.6340412966327,
                -30.847624996515474
              ],
              [
                -55.64967342493035,
                -30.860957561113768
              ],
              [
                -55.6545826779119,
                -30.878734205697405
              ],
              [
                -55.65106867948715,
                -30.919971995485724
              ],
              [
                -55.652748174781145,
                -30.938988983917213
              ],
              [
                -55.66582230109998,
                -30.94932421281708
              ],
              [
                -55.688301560878124,
                -30.94777397740029
              ],
              [
                -55.71274450921352,
                -30.943433137822616
              ],
              [
                -55.73189062960426,
                -30.945396854579393
              ],
              [
                -55.74488724855012,
                -30.958625999934373
              ],
              [
                -55.75550675453121,
                -30.99293914550521
              ],
              [
                -55.763594119511886,
                -31.008442090354826
              ],
              [
                -55.77814103183387,
                -31.020431009117864
              ],
              [
                -55.816521848591854,
                -31.042550620931863
              ],
              [
                -55.816727868120786,
                -31.04266932680049
              ],
              [
                -55.832478797491646,
                -31.051746909416725
              ],
              [
                -55.838395745908485,
                -31.058154773748505
              ],
              [
                -55.84214228728295,
                -31.06394252945034
              ],
              [
                -55.84658645927583,
                -31.069316879426136
              ],
              [
                -55.85459631486161,
                -31.07458791555668
              ],
              [
                -55.86425980934284,
                -31.076758333386028
              ],
              [
                -55.88818599575446,
                -31.076965036271336
              ],
              [
                -55.919346878568746,
                -31.082442700324798
              ],
              [
                -55.98515681682333,
                -31.078825362244988
              ],
              [
                -56.009874021790175,
                -31.08194550216585
              ],
              [
                -56.01135677356716,
                -31.08213268353243
              ],
              [
                -56.01701787306164,
                -31.07429629405255
              ],
              [
                -56.02218299001314,
                -31.067146536716912
              ],
              [
                -56.02238968747282,
                -31.045545747935545
              ],
              [
                -56.01634355011032,
                -30.999863806469918
              ],
              [
                -56.015516719760065,
                -30.934338051466554
              ],
              [
                -56.01135677529147,
                -30.91263399483785
              ],
              [
                -55.99386430074989,
                -30.885452177329707
              ],
              [
                -55.989016463056274,
                -30.856161034014352
              ],
              [
                -55.988955038324065,
                -30.855789898731224
              ],
              [
                -55.98900402285902,
                -30.85555886832932
              ],
              [
                -55.99531124076519,
                -30.82581757544322
              ],
              [
                -56.01135677148528,
                -30.798222353599858
              ],
              [
                -56.07685664627202,
                -30.75233366436692
              ],
              [
                -56.09189448657027,
                -30.73610725622205
              ],
              [
                -56.12504492373141,
                -30.68029674131903
              ],
              [
                -56.13168534320354,
                -30.671925145712358
              ],
              [
                -56.14031530349222,
                -30.66479377772419
              ],
              [
                -56.15964230010455,
                -30.653941784885212
              ],
              [
                -56.17080440405452,
                -30.645776881682597
              ],
              [
                -56.17517106435225,
                -30.636061719681436
              ],
              [
                -56.177832400706734,
                -30.62551972860072
              ],
              [
                -56.183516807378744,
                -30.614564318441165
              ],
              [
                -56.215091107702364,
                -30.58190482060461
              ],
              [
                -56.235089883098155,
                -30.565368336716098
              ],
              [
                -56.26795609485502,
                -30.55110564580728
              ],
              [
                -56.3265313296544,
                -30.508317553294354
              ],
              [
                -56.37260086957837,
                -30.485889986295366
              ],
              [
                -56.385985065238565,
                -30.4757614044505
              ],
              [
                -56.400454469215866,
                -30.458914903597435
              ],
              [
                -56.42463904075558,
                -30.423568226541725
              ],
              [
                -56.44127884659576,
                -30.408788738488088
              ],
              [
                -56.49455725320697,
                -30.3793332030114
              ],
              [
                -56.51130041269798,
                -30.366000659465474
              ],
              [
                -56.52375443919382,
                -30.357319047396555
              ],
              [
                -56.56078059799488,
                -30.320525405516918
              ],
              [
                -56.56961726953743,
                -30.30801971793417
              ],
              [
                -56.575017454643636,
                -30.302438652594702
              ],
              [
                -56.58581783235922,
                -30.296547553422936
              ],
              [
                -56.59561051248421,
                -30.2954106567239
              ],
              [
                -56.605196492750565,
                -30.29561736863865
              ],
              [
                -56.61540258898764,
                -30.293343612391922
              ],
              [
                -56.63134476722835,
                -30.284661968247057
              ],
              [
                -56.63242997332341,
                -30.27815073876689
              ],
              [
                -56.62927771008595,
                -30.267712097470426
              ],
              [
                -56.63258500179061,
                -30.24745493385463
              ],
              [
                -56.64178340574657,
                -30.233915703136738
              ],
              [
                -56.65682124911751,
                -30.221306661644483
              ],
              [
                -56.67374527981678,
                -30.21128143199602
              ],
              [
                -56.70477697714329,
                -30.198362320304085
              ],
              [
                -56.76699540044582,
                -30.161361991470894
              ],
              [
                -56.776607219761146,
                -30.15092336417974
              ],
              [
                -56.79515905832922,
                -30.1238449118109
              ],
              [
                -56.83128088524881,
                -30.102037456369164
              ],
              [
                -56.8692113842558,
                -30.10296762690902
              ],
              [
                -56.90636673983267,
                -30.108548685081015
              ],
              [
                -56.95452917439887,
                -30.096869808698976
              ],
              [
                -56.97457963159281,
                -30.09748993225483
              ],
              [
                -57.01126989734251,
                -30.103484391394858
              ],
              [
                -57.018297892553804,
                -30.105758156553776
              ],
              [
                -57.037883260535615,
                -30.11464650245671
              ],
              [
                -57.04852860627051,
                -30.114543153482
              ],
              [
                -57.06723547364806,
                -30.106791685072796
              ],
              [
                -57.07710567231497,
                -30.106068213248363
              ],
              [
                -57.102272095407706,
                -30.12115773823051
              ],
              [
                -57.129557250474036,
                -30.149993181130153
              ],
              [
                -57.150847942650884,
                -30.1823426345442
              ],
              [
                -57.158341022754875,
                -30.207870781232934
              ],
              [
                -57.16381872654991,
                -30.239290062983194
              ],
              [
                -57.18371415186953,
                -30.267505384880888
              ],
              [
                -57.21260127637795,
                -30.28734913223512
              ],
              [
                -57.245054077998624,
                -30.293343612391922
              ],
              [
                -57.25006669060446,
                -30.290449719465585
              ],
              [
                -57.26246903496458,
                -30.278667500809068
              ],
              [
                -57.27037552905276,
                -30.275153503285495
              ],
              [
                -57.276214967456156,
                -30.277737332864852
              ],
              [
                -57.288617310280365,
                -30.29075978751315
              ],
              [
                -57.29647212799948,
                -30.293343612391922
              ],
              [
                -57.31099320516806,
                -30.288279317907012
              ],
              [
                -57.32174190280459,
                -30.279804380945887
              ],
              [
                -57.33429927510163,
                -30.27267302915203
              ],
              [
                -57.35383296948928,
                -30.271949573035723
              ],
              [
                -57.36659704433001,
                -30.277220551994628
              ],
              [
                -57.389386352013254,
                -30.294893895686954
              ],
              [
                -57.399256552594444,
                -30.299131376582608
              ],
              [
                -57.414811157296135,
                -30.29572072459422
              ],
              [
                -57.429797321350726,
                -30.27546355311535
              ],
              [
                -57.44312984336396,
                -30.26946909796153
              ],
              [
                -57.46721105949257,
                -30.269882504267393
              ],
              [
                -57.5109809966735,
                -30.276703789864513
              ],
              [
                -57.53599238999763,
                -30.27443002860971
              ],
              [
                -57.56746333730603,
                -30.25634327288563
              ],
              [
                -57.5868420021303,
                -30.204046738099795
              ],
              [
                -57.60279254791258,
                -30.190516950362447
              ]
            ]
          ],
          [
            [
              [
                -38.94420325478775,
                -13.394626577155949
              ],
              [
                -38.91563879887783,
                -13.383477425703278
              ],
              [
                -38.90623938223231,
                -13.388848462016654
              ],
              [
                -38.8963516882661,
                -13.453545750041751
              ],
              [
                -38.899403445123596,
                -13.471367991457175
              ],
              [
                -38.91633053293953,
                -13.483982027694346
              ],
              [
                -38.90953529058528,
                -13.495212596995291
              ],
              [
                -38.91454016442356,
                -13.508558774895505
              ],
              [
                -38.9238175110857,
                -13.523125889321626
              ],
              [
                -38.92992103305815,
                -13.537855835708326
              ],
              [
                -38.93439694067891,
                -13.556247690015987
              ],
              [
                -38.931962246310384,
                -13.568332976367456
              ],
              [
                -38.91739116256273,
                -13.580965941872194
              ],
              [
                -38.91472879756823,
                -13.592517069154722
              ],
              [
                -38.90504393684692,
                -13.59989255824625
              ],
              [
                -38.906679427029644,
                -13.606185007171346
              ],
              [
                -38.906719995367574,
                -13.6214028498385
              ],
              [
                -38.89595201113394,
                -13.630357685533898
              ],
              [
                -38.89327546053507,
                -13.639286083789276
              ],
              [
                -38.902013197622985,
                -13.671812144757492
              ],
              [
                -38.91281392375039,
                -13.671780900318321
              ],
              [
                -38.918743956334616,
                -13.667042861396263
              ],
              [
                -38.92033601698783,
                -13.655495337520986
              ],
              [
                -38.93759592872391,
                -13.655953489138248
              ],
              [
                -38.94948897198778,
                -13.658024034026186
              ],
              [
                -38.957521830297644,
                -13.632290634622755
              ],
              [
                -38.979055859395935,
                -13.599694877111544
              ],
              [
                -38.9854526201591,
                -13.57342912362725
              ],
              [
                -38.98377952899927,
                -13.558211582826795
              ],
              [
                -38.980539518347676,
                -13.547295859900833
              ],
              [
                -38.97834224538773,
                -13.517347772795583
              ],
              [
                -38.9732152937565,
                -13.508477359123486
              ],
              [
                -38.96788489731783,
                -13.50335056892868
              ],
              [
                -38.967844202592964,
                -13.498304894127187
              ],
              [
                -38.97834225187342,
                -13.490166922271785
              ],
              [
                -39.02676347698393,
                -13.472344680226497
              ],
              [
                -39.0458878316245,
                -13.458184646023094
              ],
              [
                -39.03359941850394,
                -13.442315482046608
              ],
              [
                -39.04255123121186,
                -13.423923331280923
              ],
              [
                -39.0419001871297,
                -13.405938259920564
              ],
              [
                -39.032582160715464,
                -13.392510668818115
              ],
              [
                -39.015533009366024,
                -13.387139632469065
              ],
              [
                -38.99958248704044,
                -13.389825150637039
              ],
              [
                -38.98346920902963,
                -13.394789408665464
              ],
              [
                -38.96564693606867,
                -13.397881705219643
              ],
              [
                -38.94420325478775,
                -13.394626577155949
              ]
            ]
          ],
          [
            [
              [
                -38.61461340913444,
                -12.924981335140108
              ],
              [
                -38.592884899979154,
                -12.964613654024626
              ],
              [
                -38.58747310768547,
                -12.986911641250668
              ],
              [
                -38.60496985500509,
                -12.996677319295957
              ],
              [
                -38.62498938875759,
                -13.001641574073956
              ],
              [
                -38.6424454385297,
                -13.013767106008832
              ],
              [
                -38.67666582427637,
                -13.044529023643262
              ],
              [
                -38.71849523959327,
                -13.072849072281624
              ],
              [
                -38.73737545950004,
                -13.0899391614353
              ],
              [
                -38.75243079870506,
                -13.112725647266513
              ],
              [
                -38.76268470451712,
                -13.116794630492123
              ],
              [
                -38.7704972064654,
                -13.121026445177401
              ],
              [
                -38.775868286586395,
                -13.126560010085814
              ],
              [
                -38.779123504114686,
                -13.133884420415665
              ],
              [
                -38.786529103115065,
                -13.133884420415665
              ],
              [
                -38.78628495601492,
                -13.118422043533593
              ],
              [
                -38.793365035688254,
                -13.075127810894255
              ],
              [
                -38.791249159439815,
                -13.058363685399055
              ],
              [
                -38.78490149544596,
                -13.04973722548024
              ],
              [
                -38.759266724725805,
                -13.037041782935729
              ],
              [
                -38.73192297469632,
                -13.017754672901242
              ],
              [
                -38.66926022476984,
                -12.961846722044262
              ],
              [
                -38.66926022580683,
                -12.955010807838724
              ],
              [
                -38.67878169984136,
                -12.9530574319982
              ],
              [
                -38.68333899756081,
                -12.949965137711565
              ],
              [
                -38.68276933768988,
                -12.944512689576468
              ],
              [
                -38.67666581559707,
                -12.935235206021547
              ],
              [
                -38.67446854925108,
                -12.937920722199674
              ],
              [
                -38.67430579681882,
                -12.939060241485072
              ],
              [
                -38.67341060715644,
                -12.940036628957587
              ],
              [
                -38.669260215547965,
                -12.942071120027904
              ],
              [
                -38.67064368213172,
                -12.924981335140108
              ],
              [
                -38.67894446817942,
                -12.910088873033143
              ],
              [
                -38.6894425179854,
                -12.89576602064007
              ],
              [
                -38.69713294688206,
                -12.880547896410915
              ],
              [
                -38.68346106365471,
                -12.873223488894252
              ],
              [
                -38.64077714912328,
                -12.892754841872366
              ],
              [
                -38.62230384512701,
                -12.905368865995886
              ],
              [
                -38.61461340913444,
                -12.924981335140108
              ]
            ]
          ],
          [
            [
              [
                -44.4977921213748,
                -2.8068173416606164
              ],
              [
                -44.507801887147814,
                -2.8088518311158093
              ],
              [
                -44.513742643777896,
                -2.814629937392947
              ],
              [
                -44.51593990809103,
                -2.823337504203949
              ],
              [
                -44.51488196367632,
                -2.8341609761144717
              ],
              [
                -44.50719153530041,
                -2.822523648335148
              ],
              [
                -44.48078365921425,
                -2.793145524465933
              ],
              [
                -44.48814856488155,
                -2.8720027205202516
              ],
              [
                -44.49233964693223,
                -2.890801619554124
              ],
              [
                -44.50047766924208,
                -2.9035784658241766
              ],
              [
                -44.50568600207643,
                -2.9151343780837866
              ],
              [
                -44.49730383789942,
                -2.9493139216004005
              ],
              [
                -44.51520748430925,
                -2.9597306159445225
              ],
              [
                -44.53819739723677,
                -2.969984779466532
              ],
              [
                -44.557281054554,
                -3.0028622739626605
              ],
              [
                -44.585357223766806,
                -3.0355769373283086
              ],
              [
                -44.58381100350502,
                -3.0464821255729895
              ],
              [
                -44.588531055322846,
                -3.0526670097470006
              ],
              [
                -44.589955208367165,
                -3.0554339395218286
              ],
              [
                -44.590646939612746,
                -3.0601539431822644
              ],
              [
                -44.59801184861284,
                -3.0601539431822644
              ],
              [
                -44.598500128369174,
                -3.0516903225921648
              ],
              [
                -44.600697395935896,
                -3.04501724505528
              ],
              [
                -44.603138798820495,
                -3.039727331982065
              ],
              [
                -44.604237433966546,
                -3.035902599854795
              ],
              [
                -44.604115362165984,
                -3.025974098776005
              ],
              [
                -44.60342363230454,
                -3.0221493666552615
              ],
              [
                -44.59089108187705,
                -2.9996071508449327
              ],
              [
                -44.58385169236975,
                -2.990411090064379
              ],
              [
                -44.578480595793046,
                -2.9810521980320135
              ],
              [
                -44.57428951526644,
                -2.9569636862022506
              ],
              [
                -44.56533769406176,
                -2.9323869810857697
              ],
              [
                -44.56330318834629,
                -2.9198543816633094
              ],
              [
                -44.565663214364555,
                -2.9026017786871012
              ],
              [
                -44.5838110026399,
                -2.862074520064424
              ],
              [
                -44.5856827445727,
                -2.845879719539268
              ],
              [
                -44.5840958319147,
                -2.8295223882121254
              ],
              [
                -44.576324023804204,
                -2.7999814330606028
              ],
              [
                -44.54767818979673,
                -2.744073230446345
              ],
              [
                -44.52660071330594,
                -2.727797014510975
              ],
              [
                -44.48078365651038,
                -2.704359527991447
              ],
              [
                -44.48395748575263,
                -2.761163001847787
              ],
              [
                -44.4977921213748,
                -2.8068173416606164
              ]
            ]
          ],
          [
            [
              [
                -42.04141191159205,
                -2.704359527991447
              ],
              [
                -42.03526770559227,
                -2.704359527991447
              ],
              [
                -42.0359594377175,
                -2.7154272466417795
              ],
              [
                -42.03477942509219,
                -2.725843940703138
              ],
              [
                -42.03197181060542,
                -2.735935272688281
              ],
              [
                -42.027821418999004,
                -2.7448056706790744
              ],
              [
                -42.03530839977984,
                -2.749769921052069
              ],
              [
                -42.043527797242305,
                -2.7540014307676093
              ],
              [
                -42.05235755120363,
                -2.7570940229600214
              ],
              [
                -42.07396399600323,
                -2.760511977242681
              ],
              [
                -42.085194466658784,
                -2.758721734685562
              ],
              [
                -42.094960089433805,
                -2.753513237420855
              ],
              [
                -42.10289466200082,
                -2.7448056706790744
              ],
              [
                -42.08893795449085,
                -2.7390275644477495
              ],
              [
                -42.082386848678986,
                -2.7385393711017962
              ],
              [
                -42.082386849779525,
                -2.7311338535803804
              ],
              [
                -42.09569251040906,
                -2.7291804793451466
              ],
              [
                -42.10533606511744,
                -2.7242976446122307
              ],
              [
                -42.10875403449407,
                -2.7160782712435907
              ],
              [
                -42.10289465958999,
                -2.704359527991447
              ],
              [
                -42.123687303568474,
                -2.70728928890972
              ],
              [
                -42.14415442430959,
                -2.700860158101761
              ],
              [
                -42.18602454384014,
                -2.6764462849668007
              ],
              [
                -42.17088782556074,
                -2.6729469150878904
              ],
              [
                -42.09137936115666,
                -2.6783993587639894
              ],
              [
                -42.07347571452026,
                -2.6845028270429045
              ],
              [
                -42.0593155607869,
                -2.695245183582099
              ],
              [
                -42.04824784990566,
                -2.710625827544833
              ],
              [
                -42.0445450503357,
                -2.7079403135109454
              ],
              [
                -42.04352780070168,
                -2.706963926822462
              ],
              [
                -42.04141191159205,
                -2.704359527991447
              ]
            ]
          ],
          [
            [
              [
                -43.627308722644635,
                -2.252048405388672
              ],
              [
                -43.60702064823339,
                -2.2563288844341263
              ],
              [
                -43.604060736701335,
                -2.265954254186068
              ],
              [
                -43.59999271888995,
                -2.2837222379332833
              ],
              [
                -43.60962695047168,
                -2.301491573629985
              ],
              [
                -43.62629900896679,
                -2.316303509302051
              ],
              [
                -43.629633493987114,
                -2.3329518029649057
              ],
              [
                -43.6307449662287,
                -2.359582223152647
              ],
              [
                -43.63259507469419,
                -2.3762245083513727
              ],
              [
                -43.641108301420125,
                -2.382882113419726
              ],
              [
                -43.6359175325566,
                -2.39286769485702
              ],
              [
                -43.63480545268207,
                -2.399894974945901
              ],
              [
                -43.63924644231747,
                -2.404333929116813
              ],
              [
                -43.655908429150166,
                -2.4002660018756106
              ],
              [
                -43.6755272166203,
                -2.4002675040089416
              ],
              [
                -43.686631530155275,
                -2.401007755308422
              ],
              [
                -43.69292304054621,
                -2.4087749862762946
              ],
              [
                -43.701066025808025,
                -2.4113645139069027
              ],
              [
                -43.70439713241287,
                -2.415433342432534
              ],
              [
                -43.70772814112524,
                -2.4250506008111645
              ],
              [
                -43.7125401860683,
                -2.4265303523471355
              ],
              [
                -43.724755453798636,
                -2.4220921492331566
              ],
              [
                -43.73289990675509,
                -2.4198745498102365
              ],
              [
                -43.74252353847404,
                -2.4117379442503517
              ],
              [
                -43.743262634830046,
                -2.4028612376106713
              ],
              [
                -43.736599729661876,
                -2.3950944572872963
              ],
              [
                -43.73030641517008,
                -2.374755121542585
              ],
              [
                -43.7340123568928,
                -2.3544148845580617
              ],
              [
                -43.736608077914006,
                -2.334070742066759
              ],
              [
                -43.7271622390307,
                -2.3180477864977354
              ],
              [
                -43.71540279817013,
                -2.28923912291273
              ],
              [
                -43.701568163632814,
                -2.2746721852196012
              ],
              [
                -43.684478318230084,
                -2.2633602201915592
              ],
              [
                -43.6688533192355,
                -2.258721632564967
              ],
              [
                -43.656076627549915,
                -2.257745095707688
              ],
              [
                -43.638824022330496,
                -2.253024942245429
              ],
              [
                -43.627308722644635,
                -2.252048405388672
              ]
            ]
          ],
          [
            [
              [
                -49.287953253833976,
                -1.7584774568893013
              ],
              [
                -49.27700761542441,
                -1.7670223418089674
              ],
              [
                -49.281890429187634,
                -1.7858212388641659
              ],
              [
                -49.29332434727793,
                -1.8046199857318799
              ],
              [
                -49.301625129551574,
                -1.813165020893672
              ],
              [
                -49.31021074041049,
                -1.8184546328955815
              ],
              [
                -49.3326309888424,
                -1.8540992033134582
              ],
              [
                -49.359527148762055,
                -1.8839658182773724
              ],
              [
                -49.36742102752437,
                -1.8951148014825814
              ],
              [
                -49.385487433145215,
                -1.8877905499610061
              ],
              [
                -49.42625891807671,
                -1.8776181035878734
              ],
              [
                -49.44249426915582,
                -1.8677710192844166
              ],
              [
                -49.452992316295166,
                -1.850192905804361
              ],
              [
                -49.44762122237938,
                -1.8370906987782523
              ],
              [
                -49.42202714855291,
                -1.813165020893672
              ],
              [
                -49.41885331827609,
                -1.8046199857318799
              ],
              [
                -49.41567949176063,
                -1.7838681652260557
              ],
              [
                -49.41148841167669,
                -1.7755673769472362
              ],
              [
                -49.401926235326385,
                -1.7673478540815724
              ],
              [
                -49.373646614163945,
                -1.7516415489573318
              ],
              [
                -49.352162239745624,
                -1.7224261090412918
              ],
              [
                -49.33812415327356,
                -1.7126604404711803
              ],
              [
                -49.31899980413056,
                -1.7174618591342101
              ],
              [
                -49.3163142564901,
                -1.7311336749681758
              ],
              [
                -49.309803840186895,
                -1.7443987131353116
              ],
              [
                -49.30011959557009,
                -1.7544898939996811
              ],
              [
                -49.287953253833976,
                -1.7584774568893013
              ]
            ]
          ],
          [
            [
              [
                -44.89224199144116,
                -1.2719052648754852
              ],
              [
                -44.87865149552223,
                -1.285088736834473
              ],
              [
                -44.876454230589886,
                -1.296156454199696
              ],
              [
                -44.88536536438884,
                -1.326429995962616
              ],
              [
                -44.89224199138889,
                -1.326429995962616
              ],
              [
                -44.89635169166573,
                -1.3200008658858289
              ],
              [
                -44.90269934769828,
                -1.3141414949320502
              ],
              [
                -44.91071529852866,
                -1.3092586607697765
              ],
              [
                -44.91954505091944,
                -1.3059221225187088
              ],
              [
                -44.91808020717329,
                -1.3146298384336816
              ],
              [
                -44.91405188660257,
                -1.3217098428221403
              ],
              [
                -44.90746009012476,
                -1.3277320450167391
              ],
              [
                -44.89850826756925,
                -1.3326962948031378
              ],
              [
                -44.906890429049064,
                -1.338067322260539
              ],
              [
                -44.914662238468715,
                -1.345147326658043
              ],
              [
                -44.921254035591,
                -1.3531226024442395
              ],
              [
                -44.926380989414056,
                -1.3606096849444302
              ],
              [
                -44.93468176974326,
                -1.366631736938581
              ],
              [
                -44.943226692052846,
                -1.3708635465875776
              ],
              [
                -44.95201575448493,
                -1.3716774023550586
              ],
              [
                -44.96117102817389,
                -1.3674455927058584
              ],
              [
                -44.963856575116566,
                -1.390557564336546
              ],
              [
                -44.98033606715557,
                -1.3960914230503396
              ],
              [
                -45.00169837096888,
                -1.389825124187694
              ],
              [
                -45.01891028581696,
                -1.3776994543529497
              ],
              [
                -45.02696692613037,
                -1.3605282693250507
              ],
              [
                -45.02692623634872,
                -1.340915667228387
              ],
              [
                -45.02196204254612,
                -1.3234188197586043
              ],
              [
                -45.01573645709543,
                -1.3121884213523096
              ],
              [
                -45.00328528646845,
                -1.317478183397904
              ],
              [
                -44.996245898111844,
                -1.3263485803433892
              ],
              [
                -44.99388587154089,
                -1.338555665762794
              ],
              [
                -44.99526933445129,
                -1.3537736269722616
              ],
              [
                -44.980336067142794,
                -1.3204892093876004
              ],
              [
                -44.97793535047678,
                -1.3009578727394857
              ],
              [
                -44.99185136576421,
                -1.2924129880689714
              ],
              [
                -44.98997962058738,
                -1.284763224571677
              ],
              [
                -44.9846085277006,
                -1.2699520410867855
              ],
              [
                -44.97435462090331,
                -1.26034920402405
              ],
              [
                -44.94741777324517,
                -1.27288180166325
              ],
              [
                -44.939198370955275,
                -1.2686499920366316
              ],
              [
                -44.93138587071565,
                -1.2613257408112168
              ],
              [
                -44.92296301988627,
                -1.2575822746873118
              ],
              [
                -44.915679490898576,
                -1.2589657393556364
              ],
              [
                -44.90758216078562,
                -1.2623836932173944
              ],
              [
                -44.89224199144116,
                -1.2719052648754852
              ]
            ]
          ],
          [
            [
              [
                -48.338978644899974,
                -1.0665015454396363
              ],
              [
                -48.32420813701217,
                -1.075860285772126
              ],
              [
                -48.31061764209543,
                -1.1124813913840934
              ],
              [
                -48.29735266803087,
                -1.1285132832840201
              ],
              [
                -48.31533769382714,
                -1.1552059646042223
              ],
              [
                -48.31944739512005,
                -1.1594377742069992
              ],
              [
                -48.318104620754404,
                -1.1812476214358671
              ],
              [
                -48.319081183835166,
                -1.189385653284927
              ],
              [
                -48.334095832134125,
                -1.2050106924697954
              ],
              [
                -48.34874427026244,
                -1.2086728180717337
              ],
              [
                -48.363758917755945,
                -1.2097306953684126
              ],
              [
                -48.37987219997434,
                -1.2172177027055058
              ],
              [
                -48.3880916012436,
                -1.2116025035324147
              ],
              [
                -48.39244544189783,
                -1.2047665207203537
              ],
              [
                -48.3939102859837,
                -1.19719817287586
              ],
              [
                -48.39354407483491,
                -1.189385653284927
              ],
              [
                -48.40233313698198,
                -1.202894787663649
              ],
              [
                -48.41429602782031,
                -1.1980119535292497
              ],
              [
                -48.434559700153585,
                -1.1763648624132819
              ],
              [
                -48.450266080006166,
                -1.1685523428302238
              ],
              [
                -48.46206621024968,
                -1.164483364462695
              ],
              [
                -48.46544348890837,
                -1.1576473816662314
              ],
              [
                -48.4556778642654,
                -1.1415341492328113
              ],
              [
                -48.431955532871235,
                -1.1236304491669231
              ],
              [
                -48.42833411399909,
                -1.117282809880335
              ],
              [
                -48.42149817612061,
                -1.0795224113519657
              ],
              [
                -48.4050186840024,
                -1.0687802063620795
              ],
              [
                -48.38345292909968,
                -1.0653622525318218
              ],
              [
                -48.338978644899974,
                -1.0665015454396363
              ]
            ]
          ],
          [
            [
              [
                -48.19493567618517,
                -0.8194312826241036
              ],
              [
                -48.16274980386113,
                -0.8501929419252829
              ],
              [
                -48.15587317600712,
                -0.8663062492726102
              ],
              [
                -48.18126380088663,
                -0.8671200299146391
              ],
              [
                -48.18126380104624,
                -0.8746070371423723
              ],
              [
                -48.15672766820791,
                -0.8877906590833676
              ],
              [
                -48.16246497294845,
                -0.9208309793680315
              ],
              [
                -48.1949356759022,
                -0.9838192536085774
              ],
              [
                -48.20189368404319,
                -1.0114885466423214
              ],
              [
                -48.207386847933726,
                -1.0178361858996101
              ],
              [
                -48.22288977820309,
                -1.0248349247828041
              ],
              [
                -48.23770097616113,
                -1.027927366348294
              ],
              [
                -48.28770911420337,
                -1.0248349247828041
              ],
              [
                -48.30711829318319,
                -1.020684530823452
              ],
              [
                -48.31627356688897,
                -1.00953539798401
              ],
              [
                -48.318999803980894,
                -0.9933407500376444
              ],
              [
                -48.31908118415935,
                -0.9737281482847605
              ],
              [
                -48.312652147998655,
                -0.953301690795896
              ],
              [
                -48.2845352858496,
                -0.9214820038829497
              ],
              [
                -48.273793097937116,
                -0.8952775912100245
              ],
              [
                -48.25454667906516,
                -0.8630510515980754
              ],
              [
                -48.25015214786088,
                -0.8501929419252829
              ],
              [
                -48.24356035085127,
                -0.8417293979343516
              ],
              [
                -48.19493567618517,
                -0.8194312826241036
              ]
            ]
          ],
          [
            [
              [
                -47.948557095146285,
                -0.6412900067015406
              ],
              [
                -47.93529212087142,
                -0.6366512693078447
              ],
              [
                -47.91462154894289,
                -0.6416968594663935
              ],
              [
                -47.89561927005859,
                -0.6534970166756949
              ],
              [
                -47.887074347901,
                -0.6691219804356683
              ],
              [
                -47.895578579997654,
                -0.6910946584940216
              ],
              [
                -47.916371223122276,
                -0.7085914303974
              ],
              [
                -47.962147590038086,
                -0.7306454489910916
              ],
              [
                -47.96410071502198,
                -0.7151018257143971
              ],
              [
                -47.97777259009737,
                -0.6916643424935881
              ],
              [
                -47.98265540292277,
                -0.6760393036172971
              ],
              [
                -47.97862708193462,
                -0.6731096182170718
              ],
              [
                -47.97105872311917,
                -0.6657854422708827
              ],
              [
                -47.966867642000345,
                -0.6582984350921555
              ],
              [
                -47.97793535108899,
                -0.6517880397854888
              ],
              [
                -47.97642981708255,
                -0.6447079604811131
              ],
              [
                -47.972075976096605,
                -0.6374651250507972
              ],
              [
                -47.969064907862446,
                -0.6338843400379742
              ],
              [
                -47.96149654900418,
                -0.6325822910200332
              ],
              [
                -47.95523027295163,
                -0.6330705594017467
              ],
              [
                -47.95079505096092,
                -0.6358374886715917
              ],
              [
                -47.948557095146285,
                -0.6412900067015406
              ]
            ]
          ],
          [
            [
              [
                -50.81920325395395,
                -0.620212487372015
              ],
              [
                -50.812896288047526,
                -0.6550432374386759
              ],
              [
                -50.813059048894935,
                -0.6691219804356683
              ],
              [
                -50.822255011964444,
                -0.6998837146998245
              ],
              [
                -50.84312903609414,
                -0.7159970219695716
              ],
              [
                -50.87205969983227,
                -0.7222632455431827
              ],
              [
                -50.90550696507731,
                -0.7232398574157267
              ],
              [
                -50.93431555909324,
                -0.7317034013743691
              ],
              [
                -50.976185675950134,
                -0.7697893116618874
              ],
              [
                -51.001088019939324,
                -0.7784156117605788
              ],
              [
                -51.0267227859847,
                -0.7837867141957783
              ],
              [
                -51.05402584499565,
                -0.7965634082224617
              ],
              [
                -51.078033006986814,
                -0.8122697876668125
              ],
              [
                -51.09414628802977,
                -0.8262671902201175
              ],
              [
                -51.100412564029796,
                -0.8262671902201175
              ],
              [
                -51.10973059796695,
                -0.8067359290985611
              ],
              [
                -51.11168372319569,
                -0.782321909044251
              ],
              [
                -51.108021613896184,
                -0.7559546652619897
              ],
              [
                -51.10041256404062,
                -0.7306454489910916
              ],
              [
                -51.081776495991136,
                -0.7011044232097037
              ],
              [
                -51.07677161392669,
                -0.6958960769154439
              ],
              [
                -51.07347571493952,
                -0.6929663915135902
              ],
              [
                -51.06859290316494,
                -0.6797828447616326
              ],
              [
                -51.06627356691785,
                -0.6760393036172971
              ],
              [
                -51.058827278041655,
                -0.6750627668527505
              ],
              [
                -51.045562304149854,
                -0.6813290655256823
              ],
              [
                -51.03892981693887,
                -0.6815731621635264
              ],
              [
                -51.016468878869006,
                -0.667901271926896
              ],
              [
                -50.98013261592644,
                -0.6261532362280566
              ],
              [
                -50.95641028598784,
                -0.6071102811557518
              ],
              [
                -50.90953528594732,
                -0.5832658701312379
              ],
              [
                -50.8608292310067,
                -0.5656063797113804
              ],
              [
                -50.87913977795394,
                -0.6002743360501207
              ],
              [
                -50.8813370430182,
                -0.6139462262625407
              ],
              [
                -50.87441972601821,
                -0.6139462262625407
              ],
              [
                -50.84093176998641,
                -0.5586890565490512
              ],
              [
                -50.83674068896085,
                -0.5617814980677615
              ],
              [
                -50.83503170506434,
                -0.5650367332669893
              ],
              [
                -50.83348548098463,
                -0.5729305931923131
              ],
              [
                -50.828765428927504,
                -0.5834286262582848
              ],
              [
                -50.81920325395395,
                -0.620212487372015
              ]
            ]
          ],
          [
            [
              [
                -47.66051184792884,
                -0.5791968542955026
              ],
              [
                -47.64915930897248,
                -0.591566657930964
              ],
              [
                -47.64077714799112,
                -0.6084937457897265
              ],
              [
                -47.638986783051955,
                -0.6278622506704484
              ],
              [
                -47.6468806630222,
                -0.6481259142609654
              ],
              [
                -47.642811653033554,
                -0.657972922837438
              ],
              [
                -47.641835090157194,
                -0.6754696947246338
              ],
              [
                -47.64342200394361,
                -0.6929663915135902
              ],
              [
                -47.646880663139804,
                -0.7027320595918097
              ],
              [
                -47.65831458205585,
                -0.7076962341424037
              ],
              [
                -47.685658331990226,
                -0.7068010378874454
              ],
              [
                -47.70152747300069,
                -0.7095679671628754
              ],
              [
                -47.69896399616447,
                -0.6939430033852945
              ],
              [
                -47.704213020055995,
                -0.6749000107253217
              ],
              [
                -47.715619934920504,
                -0.6365545319327311
              ],
              [
                -47.75153607106881,
                -0.6222500558881885
              ],
              [
                -47.75089354697191,
                -0.6067629879707602
              ],
              [
                -47.76137901001758,
                -0.5757709016625011
              ],
              [
                -47.755788193015455,
                -0.5664851651583648
              ],
              [
                -47.7452484090207,
                -0.5627825195998762
              ],
              [
                -47.74336543705844,
                -0.5472940622313347
              ],
              [
                -47.73468157104141,
                -0.5417298606140235
              ],
              [
                -47.71547858105284,
                -0.5473334556732019
              ],
              [
                -47.70682192001241,
                -0.5597392353884774
              ],
              [
                -47.70375236301138,
                -0.577713648021215
              ],
              [
                -47.68764824796375,
                -0.5845530855826989
              ],
              [
                -47.66051184792884,
                -0.5791968542955026
              ]
            ]
          ],
          [
            [
              [
                -51.18602454301832,
                -0.6139462262625407
              ],
              [
                -51.162912564079214,
                -0.6205380371797069
              ],
              [
                -51.151600715142045,
                -0.6371396127962833
              ],
              [
                -51.149973110919625,
                -0.6589494596015522
              ],
              [
                -51.15562903593873,
                -0.6815731621635264
              ],
              [
                -51.217640753844236,
                -0.8018530950434849
              ],
              [
                -51.230702278215176,
                -0.8392880560105171
              ],
              [
                -51.2523087232475,
                -0.9618466504394501
              ],
              [
                -51.27114824096347,
                -1.017673429770235
              ],
              [
                -51.275624153154645,
                -1.025160437041618
              ],
              [
                -51.285959439010064,
                -1.0316708324319717
              ],
              [
                -51.310292120933454,
                -1.0021298063354416
              ],
              [
                -51.33145097606827,
                -1.009942325860588
              ],
              [
                -51.41002356725815,
                -1.1530901349098008
              ],
              [
                -51.43480384009322,
                -1.1867001395766392
              ],
              [
                -51.55626380093844,
                -1.2886695219389979
              ],
              [
                -51.59756425710938,
                -1.3121884213523096
              ],
              [
                -51.61021887897529,
                -1.3156063752236475
              ],
              [
                -51.618885871425356,
                -1.3236630666162088
              ],
              [
                -51.62621009025573,
                -1.3329403914475337
              ],
              [
                -51.63483639191376,
                -1.3401018114622927
              ],
              [
                -51.66270911430765,
                -1.3498674798045491
              ],
              [
                -51.66954505036989,
                -1.3537736269722616
              ],
              [
                -51.6712540354759,
                -1.3575985087347824
              ],
              [
                -51.67414303249311,
                -1.370375203084445
              ],
              [
                -51.67577063693022,
                -1.374281500469933
              ],
              [
                -51.68101966127291,
                -1.377129845443493
              ],
              [
                -51.69513912664882,
                -1.3811174082366282
              ],
              [
                -51.70055091158439,
                -1.384454096714797
              ],
              [
                -51.740834114624825,
                -1.4200172504884685
              ],
              [
                -51.7856339182722,
                -1.4499651299828455
              ],
              [
                -51.80671139258946,
                -1.4572893812850516
              ],
              [
                -51.85195878795537,
                -1.4640438734648344
              ],
              [
                -51.89248613167845,
                -1.4836564757009718
              ],
              [
                -51.912709114266775,
                -1.481377889835904
              ],
              [
                -51.93028723831452,
                -1.4707983656473524
              ],
              [
                -51.94391842449835,
                -1.456231428867424
              ],
              [
                -51.95409094928377,
                -1.4224585173712374
              ],
              [
                -51.94188391864046,
                -1.3913714201049303
              ],
              [
                -51.90294348891327,
                -1.3401018114622927
              ],
              [
                -51.89736894340371,
                -1.3251277966952337
              ],
              [
                -51.89305579297556,
                -1.3055966102555565
              ],
              [
                -51.88927161340847,
                -1.268161648536196
              ],
              [
                -51.884266731168104,
                -1.2562802256379977
              ],
              [
                -51.87246660088641,
                -1.2432593596163464
              ],
              [
                -51.8056534500665,
                -1.193942975155945
              ],
              [
                -51.796498175823345,
                -1.189385653284927
              ],
              [
                -51.79531816271556,
                -1.1841773068926171
              ],
              [
                -51.78746497282514,
                -1.1622860440421687
              ],
              [
                -51.785633917945894,
                -1.158868090197344
              ],
              [
                -51.781605598091375,
                -1.1539039155614859
              ],
              [
                -51.77204342400388,
                -1.1514624984998967
              ],
              [
                -51.75145423105435,
                -1.1483700569174227
              ],
              [
                -51.71788489480006,
                -1.1296525761950789
              ],
              [
                -51.68394934807441,
                -1.0969377678855743
              ],
              [
                -51.66836503796344,
                -1.0575497329883807
              ],
              [
                -51.69005286377866,
                -1.0186499665463844
              ],
              [
                -51.686105923853056,
                -0.884372630171155
              ],
              [
                -51.675770636941486,
                -0.8467749881242863
              ],
              [
                -51.623605924088636,
                -0.7902157690171178
              ],
              [
                -51.582142706936885,
                -0.6986630061900088
              ],
              [
                -51.55980383987566,
                -0.6649715865273322
              ],
              [
                -51.53404700409318,
                -0.6346981957808504
              ],
              [
                -51.5051163399877,
                -0.6071102811557518
              ],
              [
                -51.45466061095547,
                -0.5746395700791606
              ],
              [
                -51.43993079306743,
                -0.5621884259384871
              ],
              [
                -51.42479407504737,
                -0.553806260081007
              ],
              [
                -51.37043209500415,
                -0.5342749991075116
              ],
              [
                -51.35484778594794,
                -0.5319963382249399
              ],
              [
                -51.347401495947935,
                -0.5319963382249399
              ],
              [
                -51.35667884002534,
                -0.5440406295931907
              ],
              [
                -51.36302649605566,
                -0.562269804001966
              ],
              [
                -51.366688605968264,
                -0.5816382713075768
              ],
              [
                -51.367909308921035,
                -0.5962866982762614
              ],
              [
                -51.366932745960334,
                -0.6016578006838663
              ],
              [
                -51.365386523001604,
                -0.6055640603947047
              ],
              [
                -51.36510169207557,
                -0.6106096505492333
              ],
              [
                -51.36790930895342,
                -0.620212487372015
              ],
              [
                -51.37303626205479,
                -0.6293270933687799
              ],
              [
                -51.384755011909036,
                -0.6447893009914141
              ],
              [
                -51.3884171210659,
                -0.6548804813113362
              ],
              [
                -51.38158118406588,
                -0.6548804813113362
              ],
              [
                -51.37385006408841,
                -0.6447079604811131
              ],
              [
                -51.35440019391734,
                -0.6262346142916628
              ],
              [
                -51.34740149601838,
                -0.6139462262625407
              ],
              [
                -51.34788977805923,
                -0.6007626419847706
              ],
              [
                -51.35313880104879,
                -0.5894507907257802
              ],
              [
                -51.35366777297371,
                -0.5801734286109882
              ],
              [
                -51.34064693898452,
                -0.5729305931923131
              ],
              [
                -51.34064693898529,
                -0.5928687445008745
              ],
              [
                -51.333119269985296,
                -0.5928687445008745
              ],
              [
                -51.33311926998452,
                -0.5729305931923131
              ],
              [
                -51.32583574093785,
                -0.5804989408650314
              ],
              [
                -51.31798255107534,
                -0.5863583492050726
              ],
              [
                -51.30931555893941,
                -0.5904273274881642
              ],
              [
                -51.299631313985316,
                -0.5928687445008745
              ],
              [
                -51.32164466102485,
                -0.562595316255882
              ],
              [
                -51.326975063954826,
                -0.5518531114512824
              ],
              [
                -51.329213019993034,
                -0.5386695271928118
              ],
              [
                -51.32652747304208,
                -0.5324846441588137
              ],
              [
                -51.322336392012666,
                -0.5284970063911884
              ],
              [
                -51.32013912700774,
                -0.5214169271077406
              ],
              [
                -51.30833899599222,
                -0.5187313759088044
              ],
              [
                -51.253773566995584,
                -0.5315080698443839
              ],
              [
                -51.23753821503371,
                -0.5382626368756205
              ],
              [
                -51.22325598907052,
                -0.5578752759143377
              ],
              [
                -51.20327714794094,
                -0.6046688641421764
              ],
              [
                -51.18602454301832,
                -0.6139462262625407
              ]
            ]
          ],
          [
            [
              [
                -51.16527259000279,
                -0.1403134118371202
              ],
              [
                -51.12083899600279,
                -0.1403134118371202
              ],
              [
                -51.120269334998085,
                -0.1454403612419307
              ],
              [
                -51.121937629001856,
                -0.1467424478030883
              ],
              [
                -51.12474524600183,
                -0.1467424478030883
              ],
              [
                -51.12828528599494,
                -0.14771900333560473
              ],
              [
                -51.13394121000719,
                -0.16082122823400072
              ],
              [
                -51.135853645007465,
                -0.17937591479147938
              ],
              [
                -51.134877082001985,
                -0.19589609344608985
              ],
              [
                -51.13170325400106,
                -0.20305755075838663
              ],
              [
                -51.14419511601138,
                -0.21135833850684227
              ],
              [
                -51.14867102801379,
                -0.23056406835279386
              ],
              [
                -51.148833787988316,
                -0.2638485598686981
              ],
              [
                -51.166737434002236,
                -0.30559661405597455
              ],
              [
                -51.201283331982125,
                -0.3436825427632554
              ],
              [
                -51.278553839949595,
                -0.4010555794410971
              ],
              [
                -51.34219316294913,
                -0.43377042459128445
              ],
              [
                -51.37559973897342,
                -0.4605445209255051
              ],
              [
                -51.39378821495255,
                -0.46648526976046606
              ],
              [
                -51.405100064049904,
                -0.4596493622291319
              ],
              [
                -51.40200761602241,
                -0.4357235732163654
              ],
              [
                -51.39146887901509,
                -0.42441172199650856
              ],
              [
                -51.375599739042904,
                -0.4169247524111235
              ],
              [
                -51.361195442003456,
                -0.40748463420250214
              ],
              [
                -51.35484778604607,
                -0.391208608472241
              ],
              [
                -51.351470507016955,
                -0.3859188841506587
              ],
              [
                -51.33653723904099,
                -0.3755836072517327
              ],
              [
                -51.3304337230027,
                -0.36614348904934524
              ],
              [
                -51.26427161399891,
                -0.219496351353144
              ],
              [
                -51.243234830005264,
                -0.1986630226953376
              ],
              [
                -51.23265540300362,
                -0.17945729285448764
              ],
              [
                -51.22704016800855,
                -0.1750627647922401
              ],
              [
                -51.19782467400594,
                -0.17083099285612355
              ],
              [
                -51.1897680329984,
                -0.16822681973343942
              ],
              [
                -51.18358313700036,
                -0.16318124839088657
              ],
              [
                -51.16616777299608,
                -0.1444637963210784
              ],
              [
                -51.16527259000279,
                -0.1403134118371202
              ]
            ]
          ],
          [
            [
              [
                -48.46251380095294,
                -0.5761044127755456
              ],
              [
                -48.465321417942775,
                -0.5904273274881642
              ],
              [
                -48.48289954292444,
                -0.6276180789262991
              ],
              [
                -48.48436438688783,
                -0.6535783571860467
              ],
              [
                -48.4871720040789,
                -0.6647274898895772
              ],
              [
                -48.49657141792196,
                -0.6760393036172971
              ],
              [
                -48.48582923107394,
                -0.6847470193089696
              ],
              [
                -48.48802649607584,
                -0.7018368633369787
              ],
              [
                -48.49445553294519,
                -0.7228329295432708
              ],
              [
                -48.49657141800606,
                -0.7437476552520605
              ],
              [
                -48.51768958205778,
                -0.7347958429072391
              ],
              [
                -48.537505663077866,
                -0.7189267073733718
              ],
              [
                -48.57233639194184,
                -0.6815731621635264
              ],
              [
                -48.56086178316468,
                -0.7139625328211749
              ],
              [
                -48.5379125640523,
                -0.7448056076357579
              ],
              [
                -48.52354895685503,
                -0.773370021582056
              ],
              [
                -48.537505662866494,
                -0.7989234096321405
              ],
              [
                -48.526234504071475,
                -0.820245063264822
              ],
              [
                -48.52342688679585,
                -0.8463680602502274
              ],
              [
                -48.527658657911324,
                -0.8726538884943659
              ],
              [
                -48.53750566306176,
                -0.8944638105671687
              ],
              [
                -48.560129361077664,
                -0.9143205840064048
              ],
              [
                -48.61294511584953,
                -0.9328752333232776
              ],
              [
                -48.63316809798042,
                -0.9491512968485154
              ],
              [
                -48.62767493380459,
                -0.9587541337756191
              ],
              [
                -48.63072669177068,
                -0.9689266547112839
              ],
              [
                -48.64745032519572,
                -0.990655236352829
              ],
              [
                -48.657541469953784,
                -0.9992001209025074
              ],
              [
                -48.66478430885046,
                -1.0012346100712723
              ],
              [
                -48.665109829772156,
                -1.0031063431109548
              ],
              [
                -48.654286262101074,
                -1.0111630343836984
              ],
              [
                -48.64533443922049,
                -1.0118954745189375
              ],
              [
                -48.63585364508572,
                -1.0083961050789563
              ],
              [
                -48.62877356686283,
                -1.0096981541133216
              ],
              [
                -48.62694251220479,
                -1.0248349247828041
              ],
              [
                -48.63068600196155,
                -1.0290666592542639
              ],
              [
                -48.65428626211415,
                -1.0453427228428582
              ],
              [
                -48.65428626179518,
                -1.0528296550163454
              ],
              [
                -48.62828528618263,
                -1.0477841398927683
              ],
              [
                -48.62877356724251,
                -1.063165007227893
              ],
              [
                -48.642811652899674,
                -1.0835913897035918
              ],
              [
                -48.65733802014267,
                -1.0936825701809387
              ],
              [
                -48.672434048810345,
                -1.1011695023702905
              ],
              [
                -48.71768144406526,
                -1.134047141922956
              ],
              [
                -48.73989824126696,
                -1.1415341492328113
              ],
              [
                -48.75829016816217,
                -1.1506487178483262
              ],
              [
                -48.79613196515424,
                -1.1920712421002326
              ],
              [
                -48.818714972981844,
                -1.202894787663649
              ],
              [
                -48.849598761818704,
                -1.1980119535292497
              ],
              [
                -48.875884568751594,
                -1.1812476214358671
              ],
              [
                -48.897694464813036,
                -1.1581356500573339
              ],
              [
                -48.914947068936996,
                -1.1346981664437137
              ],
              [
                -48.92113196526795,
                -1.1415341492328113
              ],
              [
                -48.91128495976432,
                -1.1612280916412454
              ],
              [
                -48.89484615775151,
                -1.1812476214358671
              ],
              [
                -48.87531490808085,
                -1.1967099044838543
              ],
              [
                -48.85631262898183,
                -1.202894787663649
              ],
              [
                -48.842030403190954,
                -1.2133114804591463
              ],
              [
                -48.83714759004614,
                -1.2339820348286967
              ],
              [
                -48.844553188828925,
                -1.24928148667945
              ],
              [
                -48.86717688675322,
                -1.2439103841405645
              ],
              [
                -48.86717688697974,
                -1.2513973914905328
              ],
              [
                -48.85387122296739,
                -1.254327076957537
              ],
              [
                -48.824818488897066,
                -1.2546525892198241
              ],
              [
                -48.81187903587642,
                -1.2575822746873118
              ],
              [
                -48.79625403659324,
                -1.2684873110120225
              ],
              [
                -48.793080207027735,
                -1.2797177093923129
              ],
              [
                -48.802357550993094,
                -1.3397762991985298
              ],
              [
                -48.83299720023188,
                -1.4157854408276276
              ],
              [
                -48.83922278623194,
                -1.4157854408276276
              ],
              [
                -48.858387825112594,
                -1.3991838646727486
              ],
              [
                -48.94220943861719,
                -1.295830941936709
              ],
              [
                -48.96377519455383,
                -1.2829729822330365
              ],
              [
                -48.990061001743264,
                -1.2924129880689714
              ],
              [
                -48.95738684768975,
                -1.295505429673722
              ],
              [
                -48.94603430885838,
                -1.3090145641256858
              ],
              [
                -48.954986131660064,
                -1.3241512599047591
              ],
              [
                -48.983265754621044,
                -1.3326962948031378
              ],
              [
                -48.983265753918175,
                -1.3401018114622927
              ],
              [
                -48.977202928590565,
                -1.347263231479876
              ],
              [
                -48.97663326749086,
                -1.356133778653124
              ],
              [
                -48.98094641794886,
                -1.3656552001458673
              ],
              [
                -48.99006100193389,
                -1.374281500469933
              ],
              [
                -48.976918097816636,
                -1.369073154027243
              ],
              [
                -48.95311438653482,
                -1.3503556730937867
              ],
              [
                -48.94505774611441,
                -1.3463681103075342
              ],
              [
                -48.93496660092332,
                -1.351495041124318
              ],
              [
                -48.92983964777653,
                -1.3635392953218588
              ],
              [
                -48.92634029949447,
                -1.3775367733273862
              ],
              [
                -48.9211319654206,
                -1.3878720505997857
              ],
              [
                -48.8988337880705,
                -1.39365000595795
              ],
              [
                -48.89757239515407,
                -1.3947079583717352
              ],
              [
                -48.892404751712235,
                -1.398044496639151
              ],
              [
                -48.887196418288916,
                -1.4126929992022796
              ],
              [
                -48.88390052023216,
                -1.4157854408276276
              ],
              [
                -48.874012824384955,
                -1.4193660757446935
              ],
              [
                -48.839222785635116,
                -1.4425594630640586
              ],
              [
                -48.83922278625673,
                -1.4499651299828455
              ],
              [
                -48.85537675639185,
                -1.4535457649070869
              ],
              [
                -48.87193762916259,
                -1.4589169426148711
              ],
              [
                -48.88756262864923,
                -1.4667293872135407
              ],
              [
                -48.901275193638206,
                -1.4767391522734097
              ],
              [
                -48.90461178343771,
                -1.4834937946744031
              ],
              [
                -48.90689042926017,
                -1.492771119591145
              ],
              [
                -48.91063391832896,
                -1.5010719077126797
              ],
              [
                -48.918080207524774,
                -1.5045712772412714
              ],
              [
                -48.935292120768665,
                -1.4933407285044693
              ],
              [
                -48.94444739500011,
                -1.4909807270180373
              ],
              [
                -48.94847571566719,
                -1.501153323332721
              ],
              [
                -48.95616614555566,
                -1.508721671304513
              ],
              [
                -48.97386633993121,
                -1.5140926988169636
              ],
              [
                -49.024891730482246,
                -1.5215796311746812
              ],
              [
                -49.036529100951384,
                -1.528252857974119
              ],
              [
                -49.04808508940146,
                -1.5332983732256307
              ],
              [
                -49.06578528538539,
                -1.531914908535653
              ],
              [
                -49.0721736322887,
                -1.5269508089047419
              ],
              [
                -49.072417773568155,
                -1.5201149010789012
              ],
              [
                -49.07347571568792,
                -1.5139300177900896
              ],
              [
                -49.08250891824934,
                -1.511407185060522
              ],
              [
                -49.090809700664295,
                -1.5111630884135943
              ],
              [
                -49.09691321447754,
                -1.51018640139925
              ],
              [
                -49.101877408383615,
                -1.507989231150534
              ],
              [
                -49.10676022052681,
                -1.5045712772412714
              ],
              [
                -49.11278235670489,
                -1.4952939523178375
              ],
              [
                -49.12498938678877,
                -1.4633114333128272
              ],
              [
                -49.127268033199854,
                -1.453057571614936
              ],
              [
                -49.14952552042586,
                -1.4092750453124439
              ],
              [
                -49.15143795521287,
                -1.4016252817659016
              ],
              [
                -49.18187415321296,
                -1.4016252817659016
              ],
              [
                -49.187245245470116,
                -1.3976375687548126
              ],
              [
                -49.19151770728927,
                -1.3912900044854235
              ],
              [
                -49.197743292643295,
                -1.388360243890079
              ],
              [
                -49.209095832155064,
                -1.3947079583717352
              ],
              [
                -49.191639778583365,
                -1.4086240207823988
              ],
              [
                -49.18439693837746,
                -1.4293758407764974
              ],
              [
                -49.18439693911924,
                -1.453383083880811
              ],
              [
                -49.20409095047251,
                -1.5290667137491825
              ],
              [
                -49.20152747316121,
                -1.5531552224064689
              ],
              [
                -49.18187415239544,
                -1.566094597932911
              ],
              [
                -49.191639777354,
                -1.5719539689738242
              ],
              [
                -49.1954646480686,
                -1.573500264908121
              ],
              [
                -49.19644121055437,
                -1.568780261911937
              ],
              [
                -49.1976212235299,
                -1.5660133325258747
              ],
              [
                -49.20299231765337,
                -1.5598284492191885
              ],
              [
                -49.20791581891099,
                -1.5655249890170297
              ],
              [
                -49.21344967446806,
                -1.5691057741801275
              ],
              [
                -49.220285611579236,
                -1.571547191298483
              ],
              [
                -49.22960364506867,
                -1.573500264908121
              ],
              [
                -49.22203528650393,
                -1.5832659333866324
              ],
              [
                -49.211537239241984,
                -1.5842424701921574
              ],
              [
                -49.20156816299686,
                -1.586602471692431
              ],
              [
                -49.195464648388956,
                -1.6008440465355287
              ],
              [
                -49.188954231051866,
                -1.593519795167714
              ],
              [
                -49.182972786202996,
                -1.5901018412399277
              ],
              [
                -49.16820227799684,
                -1.586602471692431
              ],
              [
                -49.18773352772409,
                -1.6075985387760727
              ],
              [
                -49.22276770729717,
                -1.6211890891001812
              ],
              [
                -49.2562556628268,
                -1.620049721050986
              ],
              [
                -49.2745720663959,
                -1.6215931629370197
              ],
              [
                -49.293729209360045,
                -1.617531094277286
              ],
              [
                -49.31387787546595,
                -1.6043935873358517
              ],
              [
                -49.332003309861435,
                -1.5882343892216815
              ],
              [
                -49.353179491068836,
                -1.573500264908121
              ],
              [
                -49.38902747243222,
                -1.5388322319867638
              ],
              [
                -49.39411373579082,
                -1.5289038825088457
              ],
              [
                -49.391468878762076,
                -1.5147437233511176
              ],
              [
                -49.386463996355495,
                -1.5038388370874831
              ],
              [
                -49.383534309618526,
                -1.49423599989778
              ],
              [
                -49.38731848927669,
                -1.4841448192073488
              ],
              [
                -49.393544075128744,
                -1.4961890734979397
              ],
              [
                -49.4065222601351,
                -1.5175157599811782
              ],
              [
                -49.41463114106777,
                -1.5417023579198974
              ],
              [
                -49.40962243562289,
                -1.5638969770365039
              ],
              [
                -49.37536515034454,
                -1.5861423682874336
              ],
              [
                -49.35423319054978,
                -1.6144078588822126
              ],
              [
                -49.35830571795645,
                -1.637586675792131
              ],
              [
                -49.37243884330245,
                -1.6466353761235306
              ],
              [
                -49.406714149776484,
                -1.6375033073981917
              ],
              [
                -49.42486220233311,
                -1.6324304532879748
              ],
              [
                -49.4430245086457,
                -1.63542255245632
              ],
              [
                -49.468228276659005,
                -1.6232776551328232
              ],
              [
                -49.48333210976409,
                -1.602073692789826
              ],
              [
                -49.48452714837635,
                -1.5680478217551974
              ],
              [
                -49.49030514139402,
                -1.5560848328175731
              ],
              [
                -49.496571417379634,
                -1.49773521921156
              ],
              [
                -49.50487220024922,
                -1.5013974199794962
              ],
              [
                -49.51325436100744,
                -1.5023739567799703
              ],
              [
                -49.521962043674996,
                -1.501153323332721
              ],
              [
                -49.531320766379224,
                -1.49773521921156
              ],
              [
                -49.52489173162225,
                -1.505629229662003
              ],
              [
                -49.51573645675502,
                -1.5133602586627428
              ],
              [
                -49.5075577455684,
                -1.5226375835965071
              ],
              [
                -49.50397701770149,
                -1.5353330126640525
              ],
              [
                -49.50397701699686,
                -1.586602471692431
              ],
              [
                -49.509266730965805,
                -1.5824520776087574
              ],
              [
                -49.51398678242524,
                -1.581638221830895
              ],
              [
                -49.51878821478326,
                -1.581719637451356
              ],
              [
                -49.52440344976637,
                -1.5803361727571161
              ],
              [
                -49.51390540340535,
                -1.5922177460929048
              ],
              [
                -49.514068163359894,
                -1.608086882286279
              ],
              [
                -49.52196204302981,
                -1.6221656259081234
              ],
              [
                -49.53441321535681,
                -1.6281064125911888
              ],
              [
                -49.55125891739196,
                -1.6330705122545541
              ],
              [
                -49.556548632689065,
                -1.6454404291430795
              ],
              [
                -49.553456184372834,
                -1.6609026375015794
              ],
              [
                -49.544911261756276,
                -1.67595791798485
              ],
              [
                -49.55919348875623,
                -1.67595791798485
              ],
              [
                -49.55919348844606,
                -1.6827938258804722
              ],
              [
                -49.545399542950335,
                -1.6867001233422554
              ],
              [
                -49.54426021948481,
                -1.6983374498995591
              ],
              [
                -49.551747199968396,
                -1.7208798130914738
              ],
              [
                -49.558705206429245,
                -1.7242163514283275
              ],
              [
                -49.60326087113132,
                -1.7174618591342101
              ],
              [
                -49.62360592323851,
                -1.7248673759715398
              ],
              [
                -49.65416419262937,
                -1.760023752843254
              ],
              [
                -49.66905676917272,
                -1.772149272763304
              ],
              [
                -49.68834387942218,
                -1.7693010779306517
              ],
              [
                -49.70592200404981,
                -1.7505835965192724
              ],
              [
                -49.718739386409204,
                -1.722832886720742
              ],
              [
                -49.727528449680435,
                -1.6776668949584503
              ],
              [
                -49.745350714467826,
                -1.652764530322812
              ],
              [
                -49.751047329742526,
                -1.6417782283412514
              ],
              [
                -49.75011145705482,
                -1.624932555304338
              ],
              [
                -49.739979620618485,
                -1.5951473565113752
              ],
              [
                -49.744211391765376,
                -1.5803361727571161
              ],
              [
                -49.74803626164219,
                -1.5979142859026538
              ],
              [
                -49.76113847582569,
                -1.6300594862080529
              ],
              [
                -49.764027472584424,
                -1.6451961822807042
              ],
              [
                -49.75975501160515,
                -1.6693661067418806
              ],
              [
                -49.729888476065994,
                -1.730564066045946
              ],
              [
                -49.728505011293784,
                -1.7417944647457042
              ],
              [
                -49.729644334875886,
                -1.7526180857740905
              ],
              [
                -49.732655402385454,
                -1.7628719476739851
              ],
              [
                -49.73672441217158,
                -1.772149272763304
              ],
              [
                -49.74376380163132,
                -1.7800432833589328
              ],
              [
                -49.77643795519455,
                -1.80722423413337
              ],
              [
                -49.80028235659422,
                -1.817315415043921
              ],
              [
                -49.80907141800777,
                -1.8192684886868402
              ],
              [
                -49.82355709538681,
                -1.8165829748745737
              ],
              [
                -49.833078579422924,
                -1.8098283323220459
              ],
              [
                -49.84166419144146,
                -1.8012020317539807
              ],
              [
                -49.853423631862256,
                -1.7926571468130814
              ],
              [
                -49.86339270653165,
                -1.7894832894897053
              ],
              [
                -49.88438880131597,
                -1.7882626560188688
              ],
              [
                -49.89439856718997,
                -1.7858212388641659
              ],
              [
                -49.90599524552278,
                -1.7780900595083267
              ],
              [
                -49.915353969638645,
                -1.7691382466876688
              ],
              [
                -49.92540442615823,
                -1.761651314205515
              ],
              [
                -49.94810950322602,
                -1.7562801363908134
              ],
              [
                -49.96812903542767,
                -1.747002811312105
              ],
              [
                -49.98005123648699,
                -1.7448056410287465
              ],
              [
                -50.002308723688465,
                -1.7455380811942518
              ],
              [
                -50.00739498538641,
                -1.7414689524736973
              ],
              [
                -50.02847245967398,
                -1.7204728851987388
              ],
              [
                -50.03233801944251,
                -1.7155900509135176
              ],
              [
                -50.032338019486644,
                -1.7097306798161305
              ],
              [
                -50.02594967362097,
                -1.6607398062598304
              ],
              [
                -50.0281876297012,
                -1.6554501943171684
              ],
              [
                -50.050282356158114,
                -1.657403267937633
              ],
              [
                -50.05479895750323,
                -1.664727519336617
              ],
              [
                -50.05199133960278,
                -1.679375871932254
              ],
              [
                -50.05207271953037,
                -1.7038713087211352
              ],
              [
                -50.05988522042651,
                -1.717868787026856
              ],
              [
                -50.087066210039396,
                -1.7391903665698905
              ],
              [
                -50.09300696532192,
                -1.7482235949926128
              ],
              [
                -50.15501868452962,
                -1.7789853309186978
              ],
              [
                -50.17003333124398,
                -1.7704402957783174
              ],
              [
                -50.17772376253009,
                -1.7589658004045585
              ],
              [
                -50.1870011056458,
                -1.7491187161877402
              ],
              [
                -50.22451738126094,
                -1.7390275353272382
              ],
              [
                -50.23379472619439,
                -1.7243791826707888
              ],
              [
                -50.23717200392416,
                -1.7053361890479986
              ],
              [
                -50.234608528321694,
                -1.6339657836558799
              ],
              [
                -50.237660286664244,
                -1.6212705047208202
              ],
              [
                -50.248361783703224,
                -1.615411133661091
              ],
              [
                -50.26187089786478,
                -1.614190349991702
              ],
              [
                -50.273589648481284,
                -1.6105282994108179
              ],
              [
                -50.27855384054165,
                -1.597426092606114
              ],
              [
                -50.276234504644414,
                -1.588474279896801
              ],
              [
                -50.27041581881103,
                -1.5858700315348262
              ],
              [
                -50.26366126206871,
                -1.5848934947292121
              ],
              [
                -50.25816809776293,
                -1.5803361727571161
              ],
              [
                -50.24962317579701,
                -1.56308357189959
              ],
              [
                -50.249908007037305,
                -1.5593401057105216
              ],
              [
                -50.25381425672985,
                -1.5433895539467735
              ],
              [
                -50.26219641750464,
                -1.5271134899317431
              ],
              [
                -50.26496334495942,
                -1.5182430928826607
              ],
              [
                -50.26447506364281,
                -1.5109188415533308
              ],
              [
                -50.25942949076242,
                -1.4933407285044693
              ],
              [
                -50.25816809828158,
                -1.4841448192073488
              ],
              [
                -50.275949674644124,
                -1.4970029292714002
              ],
              [
                -50.27684485653351,
                -1.5145810423242438
              ],
              [
                -50.26301022005302,
                -1.5507138052909883
              ],
              [
                -50.26008053253716,
                -1.5526668788980182
              ],
              [
                -50.25788326708404,
                -1.5548641993662147
              ],
              [
                -50.25816809866737,
                -1.5598284492191885
              ],
              [
                -50.261097786085664,
                -1.564873964480789
              ],
              [
                -50.26471920508568,
                -1.564873964480789
              ],
              [
                -50.26842200354222,
                -1.5640601087038681
              ],
              [
                -50.27179928238209,
                -1.566094597932911
              ],
              [
                -50.27855383980382,
                -1.5744768017130353
              ],
              [
                -50.285227017037165,
                -1.5807431006459838
              ],
              [
                -50.29027259018275,
                -1.5873349118500613
              ],
              [
                -50.29222571554179,
                -1.597426092606114
              ],
              [
                -50.28123938639685,
                -1.6130509819430543
              ],
              [
                -50.259266731263175,
                -1.6270484601621624
              ],
              [
                -50.24258378819698,
                -1.64153413169225
              ],
              [
                -50.24762936154536,
                -1.6588681482598144
              ],
              [
                -50.25499426955795,
                -1.675225477822894
              ],
              [
                -50.26024329252478,
                -1.7252743038643894
              ],
              [
                -50.264963345489775,
                -1.7448056410287465
              ],
              [
                -50.271799283489834,
                -1.7448056410287465
              ],
              [
                -50.27472897010947,
                -1.7247046949423888
              ],
              [
                -50.299061653704975,
                -1.6554501943171684
              ],
              [
                -50.306507942705096,
                -1.6554501943171684
              ],
              [
                -50.28722083197029,
                -1.7308895783177112
              ],
              [
                -50.28477942599907,
                -1.7550595029229032
              ],
              [
                -50.294178840269666,
                -1.7727190319005615
              ],
              [
                -50.31655839782331,
                -1.7784969874027283
              ],
              [
                -50.34357662770931,
                -1.7769508416600377
              ],
              [
                -50.366688605161094,
                -1.772149272763304
              ],
              [
                -50.34288489417546,
                -1.7849259674533366
              ],
              [
                -50.31212317596862,
                -1.793715099254334
              ],
              [
                -50.29698645746832,
                -1.8034807678813647
              ],
              [
                -50.31956946500785,
                -1.8192684886868402
              ],
              [
                -50.348744270615825,
                -1.8287086450582757
              ],
              [
                -50.3767797528569,
                -1.8322080146649942
              ],
              [
                -50.40518144391824,
                -1.8309872309769801
              ],
              [
                -50.55972245951445,
                -1.7994930547653685
              ],
              [
                -50.57339433456005,
                -1.7936336836327154
              ],
              [
                -50.59642493420002,
                -1.7758114735985149
              ],
              [
                -50.60387122215717,
                -1.772149272763304
              ],
              [
                -50.60667884049225,
                -1.7648251715224539
              ],
              [
                -50.60008704344249,
                -1.7492815474304941
              ],
              [
                -50.58600826670533,
                -1.7346330445500353
              ],
              [
                -50.5665583980671,
                -1.730564066045946
              ],
              [
                -50.587880011346904,
                -1.6845028028548739
              ],
              [
                -50.74233964868656,
                -1.5311826185939408
              ],
              [
                -50.75792395653006,
                -1.5084774244443007
              ],
              [
                -50.76455644414743,
                -1.4875627731123369
              ],
              [
                -50.768625454555604,
                -1.4784481292250642
              ],
              [
                -50.795969205483885,
                -1.4462216638198195
              ],
              [
                -50.80321204272679,
                -1.4349911151224308
              ],
              [
                -50.80418860573757,
                -1.424981350087345
              ],
              [
                -50.79938717422,
                -1.4016252817659016
              ],
              [
                -50.79743404889019,
                -1.4015438661463437
              ],
              [
                -50.78795325416003,
                -1.3947079583717352
              ],
              [
                -50.78571529916004,
                -1.3947079583717352
              ],
              [
                -50.78795325363179,
                -1.388360243890079
              ],
              [
                -50.79238847576185,
                -1.3849422900050012
              ],
              [
                -50.796945766915776,
                -1.3829078007981714
              ],
              [
                -50.7993871736549,
                -1.3811174082366282
              ],
              [
                -50.81163489530258,
                -1.3498674798045491
              ],
              [
                -50.81305904912701,
                -1.3363583453227137
              ],
              [
                -50.8108617835074,
                -1.3147112540528323
              ],
              [
                -50.779611783065214,
                -1.193942975155945
              ],
              [
                -50.77822831906829,
                -1.172539980686625
              ],
              [
                -50.78563391786841,
                -1.1521135230211759
              ],
              [
                -50.79922441285283,
                -1.1265601346157217
              ],
              [
                -50.80581621013671,
                -1.102308870386573
              ],
              [
                -50.79255123594043,
                -1.086195562887406
              ],
              [
                -50.780140754085764,
                -1.088311467682001
              ],
              [
                -50.73729407517075,
                -1.1135393437825993
              ],
              [
                -50.675852017277585,
                -1.1415341492328113
              ],
              [
                -50.62930253826556,
                -1.150160449457389
              ],
              [
                -50.61375891781888,
                -1.1552059646042223
              ],
              [
                -50.55972245992969,
                -1.1832007701092162
              ],
              [
                -50.57184811070885,
                -1.1586239184484366
              ],
              [
                -50.61668860604555,
                -1.119886983068106
              ],
              [
                -50.58983313672746,
                -1.1115047794973005
              ],
              [
                -50.57652747307137,
                -1.1026343826464684
              ],
              [
                -50.56969153592489,
                -1.100518477850538
              ],
              [
                -50.542307095023865,
                -1.105726824222454
              ],
              [
                -50.539296028264665,
                -1.1073544606289105
              ],
              [
                -50.52208411416552,
                -1.096449499495833
              ],
              [
                -50.522206184136884,
                -1.0866024907653198
              ],
              [
                -50.534169074771235,
                -1.0785457994665977
              ],
              [
                -50.552357551218094,
                -1.0733375282076785
              ],
              [
                -50.544341600904204,
                -1.0521786304979541
              ],
              [
                -50.54552161378725,
                -1.0528296550163454
              ],
              [
                -50.530018684019744,
                -1.038750911830657
              ],
              [
                -50.5153702461303,
                -1.0367164226587116
              ],
              [
                -50.49864661417386,
                -1.0393205958372336
              ],
              [
                -50.47663326720785,
                -1.039157839707744
              ],
              [
                -50.49498450393323,
                -1.0292294153837027
              ],
              [
                -50.512440558874886,
                -1.0238583128997643
              ],
              [
                -50.52847246012565,
                -1.0253231931710187
              ],
              [
                -50.54238847611869,
                -1.0353329580048138
              ],
              [
                -50.55846106709006,
                -1.0512020937204307
              ],
              [
                -50.576771614252245,
                -1.063165007227893
              ],
              [
                -50.59658769420109,
                -1.0705705988956085
              ],
              [
                -50.617502408218385,
                -1.0733375282076785
              ],
              [
                -50.626128710235704,
                -1.0761044575200793
              ],
              [
                -50.64565995986488,
                -1.0894507605909605
              ],
              [
                -50.654693163148515,
                -1.0936825701809387
              ],
              [
                -50.66380774618945,
                -1.094903278708438
              ],
              [
                -50.73517818912642,
                -1.0895321762092078
              ],
              [
                -50.75576738188337,
                -1.0822079250468823
              ],
              [
                -50.764556443784954,
                -1.0699194992700596
              ],
              [
                -50.7682999338273,
                -1.061130442947136
              ],
              [
                -50.78612219995329,
                -1.0333798093445432
              ],
              [
                -50.79255123578252,
                -1.0186499665463844
              ],
              [
                -50.798003709812406,
                -0.984307521995965
              ],
              [
                -50.79816646987511,
                -0.911309482965872
              ],
              [
                -50.79255123604876,
                -0.8746070371423723
              ],
              [
                -50.7864884110699,
                -0.8573544368918613
              ],
              [
                -50.77863522015435,
                -0.8425432536823549
              ],
              [
                -50.7741593089152,
                -0.829847900146889
              ],
              [
                -50.778228319195094,
                -0.8194312826241036
              ],
              [
                -50.76927649608937,
                -0.8073056131001377
              ],
              [
                -50.75763912715938,
                -0.8068173447159179
              ],
              [
                -50.746001757119245,
                -0.8142229363107605
              ],
              [
                -50.737294075029546,
                -0.8262671902201175
              ],
              [
                -50.74058997282428,
                -0.8020158511715243
              ],
              [
                -50.753773566974274,
                -0.7924130142983119
              ],
              [
                -50.77074134011278,
                -0.7857398628378943
              ],
              [
                -50.78571529918974,
                -0.7709286796637175
              ],
              [
                -50.78734290306494,
                -0.7632789163341273
              ],
              [
                -50.78571529883193,
                -0.7336564749066812
              ],
              [
                -50.78355872310068,
                -0.7287737159694747
              ],
              [
                -50.77424068904621,
                -0.7206356842668221
              ],
              [
                -50.772043423854726,
                -0.7164038747352897
              ],
              [
                -50.774159308833326,
                -0.7108700161835391
              ],
              [
                -50.783518032927724,
                -0.7072893062701513
              ],
              [
                -50.785715299149025,
                -0.7027320595918097
              ],
              [
                -50.77989661406876,
                -0.6605770959817627
              ],
              [
                -50.7372940749553,
                -0.5518531114512824
              ],
              [
                -50.72468014206156,
                -0.5636532686344523
              ],
              [
                -50.71129309805452,
                -0.5865211053321197
              ],
              [
                -50.70059160094641,
                -0.6117489434392878
              ],
              [
                -50.69635982990075,
                -0.6306291423865937
              ],
              [
                -50.684071417993025,
                -0.6398251264494331
              ],
              [
                -50.607533331918596,
                -0.6760393036172971
              ],
              [
                -50.587961392148536,
                -0.6813290655256823
              ],
              [
                -50.57738196485682,
                -0.6822241866733556
              ],
              [
                -50.55199133982854,
                -0.679620013527517
              ],
              [
                -50.54845130105209,
                -0.6778296961256869
              ],
              [
                -50.55040442584955,
                -0.6737606427267357
              ],
              [
                -50.55235755116583,
                -0.6654599300161271
              ],
              [
                -50.56037350188062,
                -0.6592749718562442
              ],
              [
                -50.613758918154375,
                -0.6412900067015406
              ],
              [
                -50.673491991018615,
                -0.6310360702579809
              ],
              [
                -50.682687955033934,
                -0.623793234830235
              ],
              [
                -50.68504798106462,
                -0.6078427212811822
              ],
              [
                -50.69074459499494,
                -0.5870907517768034
              ],
              [
                -50.71646074097565,
                -0.521742439361364
              ],
              [
                -50.72154700396404,
                -0.5033505088419531
              ],
              [
                -50.72362220002266,
                -0.47991302574243777
              ],
              [
                -50.72105872295434,
                -0.4650204270674779
              ],
              [
                -50.70319576703605,
                -0.408461208514591
              ],
              [
                -50.69994055902736,
                -0.37151459143249815
              ],
              [
                -50.69635983003081,
                -0.3600399840981257
              ],
              [
                -50.69176184804095,
                -0.35418061333693596
              ],
              [
                -50.67857825396762,
                -0.34107836963587673
              ],
              [
                -50.675852017026,
                -0.3358700609346919
              ],
              [
                -50.67369544199409,
                -0.3192684854159493
              ],
              [
                -50.66832434798717,
                -0.2987606689885355
              ],
              [
                -50.654693162988416,
                -0.2638485598686981
              ],
              [
                -50.64647376200712,
                -0.2556291689558259
              ],
              [
                -50.61359615801094,
                -0.2291806037277756
              ],
              [
                -50.60387122301434,
                -0.22340261103876685
              ],
              [
                -50.59894772000501,
                -0.21933359522707657
              ],
              [
                -50.58336341100908,
                -0.19215260866404582
              ],
              [
                -50.57445227800105,
                -0.18808359285342421
              ],
              [
                -50.5625707670011,
                -0.18808359285342421
              ],
              [
                -50.55003821501111,
                -0.18922292328890877
              ],
              [
                -50.539296028004145,
                -0.18873463613417477
              ],
              [
                -50.521962042997764,
                -0.1803524703242375
              ],
              [
                -50.507801886999935,
                -0.16887786301411362
              ],
              [
                -50.49128170500153,
                -0.15886809839213073
              ],
              [
                -50.46666419200258,
                -0.1545549483934894
              ],
              [
                -50.44371497300663,
                -0.1579729209225335
              ],
              [
                -50.42658443899019,
                -0.16350676064288147
              ],
              [
                -50.41148841100458,
                -0.1644833349521714
              ],
              [
                -50.39464270700259,
                -0.1545549483934894
              ],
              [
                -50.38463294200114,
                -0.13892994721304341
              ],
              [
                -50.377797004002794,
                -0.12070078230039918
              ],
              [
                -50.36815344999684,
                -0.10564543695191678
              ],
              [
                -50.349964973001,
                -0.09937916650154786
              ],
              [
                -50.32738196499866,
                -0.10092538725131042
              ],
              [
                -50.27179928300004,
                -0.11370208111785926
              ],
              [
                -50.095773891998704,
                -0.13225676767009634
              ],
              [
                -50.03844153600256,
                -0.1545549483934894
              ],
              [
                -50.00812740799588,
                -0.15300871825495843
              ],
              [
                -49.79454505099969,
                -0.19882577882137956
              ],
              [
                -49.65347245998546,
                -0.24114347942197942
              ],
              [
                -49.51984615801097,
                -0.23560963969812013
              ],
              [
                -49.481312629001934,
                -0.22584400925984413
              ],
              [
                -49.45958411401402,
                -0.22340261103876685
              ],
              [
                -49.44933020699027,
                -0.22470467882400333
              ],
              [
                -49.42516028598941,
                -0.23040129345005472
              ],
              [
                -49.41795813699391,
                -0.23455168732522397
              ],
              [
                -49.39850826700698,
                -0.25351328298626
              ],
              [
                -49.38731848901569,
                -0.2575822987992989
              ],
              [
                -49.38683020699845,
                -0.2515601531428379
              ],
              [
                -49.39810136600185,
                -0.23650481716828986
              ],
              [
                -49.408436652994524,
                -0.21746184344733702
              ],
              [
                -49.40501868400821,
                -0.19931406597615176
              ],
              [
                -49.38683020699399,
                -0.1847469983866632
              ],
              [
                -49.32648678300254,
                -0.1545549483934894
              ],
              [
                -49.31826738200763,
                -0.16008880689038185
              ],
              [
                -49.31285559800764,
                -0.16008880689038185
              ],
              [
                -49.30724036400503,
                -0.1573218776419102
              ],
              [
                -49.298573371002504,
                -0.1545549483934894
              ],
              [
                -49.28368079300389,
                -0.15520599167408727
              ],
              [
                -49.27464759000458,
                -0.15447357033049386
              ],
              [
                -49.261626756997735,
                -0.14902108989676233
              ],
              [
                -49.236439581995135,
                -0.14771900333560473
              ],
              [
                -49.21540279899729,
                -0.1412085893066411
              ],
              [
                -49.206044075002666,
                -0.1403134118371202
              ],
              [
                -49.19481360599787,
                -0.14153411094692098
              ],
              [
                -49.18171139199842,
                -0.14934661153706763
              ],
              [
                -49.16820227800249,
                -0.1545549483934894
              ],
              [
                -49.15762285099587,
                -0.15406666123886986
              ],
              [
                -49.144764778003456,
                -0.15129974137882313
              ],
              [
                -49.13158118400385,
                -0.15203216272241654
              ],
              [
                -49.120350714991964,
                -0.1620419179556183
              ],
              [
                -49.091379361001124,
                -0.1539039051128788
              ],
              [
                -49.02562415300758,
                -0.16008880689038185
              ],
              [
                -49.01060691099545,
                -0.15988887296911317
              ],
              [
                -48.99271863200069,
                -0.17184838763363244
              ],
              [
                -48.9796045580102,
                -0.18619133695676995
              ],
              [
                -48.96050130700452,
                -0.1826365576510717
              ],
              [
                -48.947359496998324,
                -0.17310486567744307
              ],
              [
                -48.927048843992665,
                -0.15880857636636347
              ],
              [
                -48.89361192800175,
                -0.15288572171558984
              ],
              [
                -48.88048935500873,
                -0.16364715376171116
              ],
              [
                -48.88171072599885,
                -0.1911040821770115
              ],
              [
                -48.89247107200777,
                -0.2054164255395184
              ],
              [
                -48.89195716099949,
                -0.21591562269641673
              ],
              [
                -48.85973059800937,
                -0.20924245253816698
              ],
              [
                -48.81651770698984,
                -0.2076148349476685
              ],
              [
                -48.702015754000776,
                -0.23723723851236672
              ],
              [
                -48.68423417900182,
                -0.23650481716828986
              ],
              [
                -48.64631100201445,
                -0.22625091835170985
              ],
              [
                -48.62352454301375,
                -0.22340261103876685
              ],
              [
                -48.601429816988336,
                -0.22616952151201714
              ],
              [
                -48.54442298101422,
                -0.24407318357513672
              ],
              [
                -48.42723548100515,
                -0.25994231895815667
              ],
              [
                -48.40099036400945,
                -0.2712541701515513
              ],
              [
                -48.393544075009416,
                -0.2712541701515513
              ],
              [
                -48.38438880099977,
                -0.28142669090983025
              ],
              [
                -48.37555904900222,
                -0.2885067701651109
              ],
              [
                -48.368885870993005,
                -0.29794686958086514
              ],
              [
                -48.36628170497372,
                -0.3153622257261917
              ],
              [
                -48.36978105399393,
                -0.3606096305403158
              ],
              [
                -48.373117641973934,
                -0.37371183669178465
              ],
              [
                -48.378895637046945,
                -0.38404715114374877
              ],
              [
                -48.38841712103607,
                -0.39560313654558227
              ],
              [
                -48.39972896999708,
                -0.40471770494611725
              ],
              [
                -48.410633918034385,
                -0.408461208514591
              ],
              [
                -48.42064368397414,
                -0.41497160378669135
              ],
              [
                -48.43150794201667,
                -0.44719818056507576
              ],
              [
                -48.45470130102404,
                -0.485609640389608
              ],
              [
                -48.46157792902179,
                -0.5155575563296303
              ],
              [
                -48.46251380095294,
                -0.5761044127755456
              ]
            ]
          ],
          [
            [
              [
                -50.973744270011096,
                -0.29119232135384393
              ],
              [
                -51.01280676999858,
                -0.27361419031073986
              ],
              [
                -51.03795325399647,
                -0.23593515195030584
              ],
              [
                -51.03868567599778,
                -0.20029062150903715
              ],
              [
                -51.004750129004215,
                -0.18873463613417477
              ],
              [
                -51.004750128995134,
                -0.18254973435543764
              ],
              [
                -51.01252193900663,
                -0.18010833613522545
              ],
              [
                -51.03278561099842,
                -0.16822681973343942
              ],
              [
                -50.98257402300034,
                -0.08554452965221986
              ],
              [
                -50.97240576400027,
                -0.04281351715591483
              ],
              [
                -50.947265908999924,
                -0.011973844773250909
              ],
              [
                -50.92514575099993,
                -0.006148943875551431
              ],
              [
                -50.88976759399992,
                0.0011088790126371857
              ],
              [
                -50.81753522799969,
                0.034742429042713054
              ],
              [
                -50.766003720999535,
                0.04636675677280112
              ],
              [
                -50.73955032400021,
                0.03452468310840115
              ],
              [
                -50.72490564599991,
                0.008007150050472643
              ],
              [
                -50.70230058499993,
                -0.0024960268695898664
              ],
              [
                -50.67585201699994,
                -0.010674737834583935
              ],
              [
                -50.66454016799995,
                -0.015476170291310539
              ],
              [
                -50.655262824999916,
                -0.023776950991288057
              ],
              [
                -50.64769446499987,
                -0.034030856838051626
              ],
              [
                -50.641713020000296,
                -0.044732356113724496
              ],
              [
                -50.640858528000116,
                -0.049574477602120616
              ],
              [
                -50.642323370999655,
                -0.06047942438260166
              ],
              [
                -50.641713020000324,
                -0.0652401678082058
              ],
              [
                -50.62962805900069,
                -0.08159759032680011
              ],
              [
                -50.6274307929973,
                -0.08570728577816004
              ],
              [
                -50.62889563699931,
                -0.10409921620214149
              ],
              [
                -50.638783332003364,
                -0.1210263039406536
              ],
              [
                -50.67585201700261,
                -0.1545549483934894
              ],
              [
                -50.695179817001524,
                -0.16741302032678684
              ],
              [
                -50.75841223898792,
                -0.1955705624173469
              ],
              [
                -50.78123938700586,
                -0.21005625194508673
              ],
              [
                -50.837228970012376,
                -0.267673441492992
              ],
              [
                -50.85594641798277,
                -0.28248462450658895
              ],
              [
                -50.89488684800723,
                -0.30624765733751386
              ],
              [
                -50.92341061100596,
                -0.3304989585543252
              ],
              [
                -50.932036912964215,
                -0.32830167574306923
              ],
              [
                -50.94115149599916,
                -0.32203541466883556
              ],
              [
                -50.96495520699786,
                -0.3142229140659031
              ],
              [
                -50.96898352800364,
                -0.30486419271133786
              ],
              [
                -50.97036699100914,
                -0.29550547135789224
              ],
              [
                -50.973744270011096,
                -0.29119232135384393
              ]
            ]
          ],
          [
            [
              [
                -49.83234615799797,
                -0.10312265128149276
              ],
              [
                -49.82347571500087,
                -0.0703671219055176
              ],
              [
                -49.801014778000535,
                -0.04595305991723518
              ],
              [
                -49.74046790299992,
                -0.0003394509911829644
              ],
              [
                -49.67609615799977,
                0.028062241112183067
              ],
              [
                -49.62808183500002,
                0.05760325719674678
              ],
              [
                -49.52452551999889,
                0.07387929695785957
              ],
              [
                -49.496571418002056,
                0.08559805253371071
              ],
              [
                -49.493763800997954,
                0.07982005046162038
              ],
              [
                -49.48570716099911,
                0.06924062532074492
              ],
              [
                -49.48289954300049,
                0.0637881542774357
              ],
              [
                -49.469797329998805,
                0.06997304666405846
              ],
              [
                -49.456044075000946,
                0.07461172299534104
              ],
              [
                -49.44204667900098,
                0.07566966597884538
              ],
              [
                -49.42821204300053,
                0.07127513322477078
              ],
              [
                -49.39126542900069,
                0.05109284317017494
              ],
              [
                -49.38109290299965,
                0.043931381169193505
              ],
              [
                -49.369862433999906,
                0.028225001932253024
              ],
              [
                -49.36925208199998,
                0.01609935134888468
              ],
              [
                -49.37197831899991,
                0.00698476772214389
              ],
              [
                -49.37051347599993,
                -0.0003394509911829644
              ],
              [
                -49.35912024599992,
                -0.008355402016281058
              ],
              [
                -49.35167395699995,
                -0.008477472044549812
              ],
              [
                -49.347523566999946,
                -0.009698175261248158
              ],
              [
                -49.34630286399983,
                -0.020847263271217113
              ],
              [
                -49.34898841099968,
                -0.030857027887831217
              ],
              [
                -49.354481574999745,
                -0.0371639944097221
              ],
              [
                -49.35928300700028,
                -0.044732356113724496
              ],
              [
                -49.359974739000414,
                -0.05844492117280734
              ],
              [
                -49.364735480999556,
                -0.0565731740889405
              ],
              [
                -49.376332161000754,
                -0.054131771176048886
              ],
              [
                -49.38109290300065,
                -0.05217864602923739
              ],
              [
                -49.385853644998896,
                -0.06963469586803613
              ],
              [
                -49.41999264199774,
                -0.09531015069315264
              ],
              [
                -49.428212042998766,
                -0.11020273052665927
              ],
              [
                -49.43871008999803,
                -0.1205380167861104
              ],
              [
                -49.46336829299788,
                -0.12802499573511208
              ],
              [
                -49.49201412699932,
                -0.13258228931036348
              ],
              [
                -49.68687903599958,
                -0.13543059662141085
              ],
              [
                -49.71621660099508,
                -0.14771900333560473
              ],
              [
                -49.83234615799797,
                -0.10312265128149276
              ]
            ]
          ],
          [
            [
              [
                -50.63426673100054,
                0.07127513322477078
              ],
              [
                -50.63768469999747,
                0.08055247180494664
              ],
              [
                -50.6366267570001,
                0.08820221626692672
              ],
              [
                -50.63442949099919,
                0.09609609491800793
              ],
              [
                -50.634266730998796,
                0.10610585953661943
              ],
              [
                -50.63756262900273,
                0.1176618542938255
              ],
              [
                -50.646717902997565,
                0.13890208264324103
              ],
              [
                -50.64854895700254,
                0.15045807740245723
              ],
              [
                -50.636870897996126,
                0.1652692697890216
              ],
              [
                -50.61058509000915,
                0.18341706603203142
              ],
              [
                -50.5830012960068,
                0.18403196423402962
              ],
              [
                -50.56108574399088,
                0.17625744883393302
              ],
              [
                -50.54432909000101,
                0.17106992590910236
              ],
              [
                -50.51469429201085,
                0.1658506891985079
              ],
              [
                -50.4902243950036,
                0.15936179322607077
              ],
              [
                -50.46964079199833,
                0.14517660543878638
              ],
              [
                -50.446497435000495,
                0.1258511086516775
              ],
              [
                -50.443954598001106,
                0.10914739749934203
              ],
              [
                -50.44400694599946,
                0.08089075218851359
              ],
              [
                -50.44017917900068,
                0.06161771271247452
              ],
              [
                -50.43250787899968,
                0.03591732717368368
              ],
              [
                -50.432546715999905,
                0.01665397176397675
              ],
              [
                -50.437729327999925,
                -3.2628999367997495e-05
              ],
              [
                -50.44749915299988,
                -0.015150648651157903
              ],
              [
                -50.48745683499998,
                -0.01742929543802026
              ],
              [
                -50.49571692599987,
                -0.016615492511193375
              ],
              [
                -50.505726691999925,
                -0.01433684689787936
              ],
              [
                -50.514068162999905,
                -0.01108163871124229
              ],
              [
                -50.51756751199989,
                -0.007256768827876909
              ],
              [
                -50.523060675999936,
                -0.0038388001145569675
              ],
              [
                -50.55972245999993,
                -0.0038388001145569675
              ],
              [
                -50.572173631999924,
                0.0016543640671285358
              ],
              [
                -50.58812415299987,
                0.012111720645449343
              ],
              [
                -50.601714647999756,
                0.02399322999868094
              ],
              [
                -50.60753333199988,
                0.033758855732318606
              ],
              [
                -50.6097305980007,
                0.05341217898861776
              ],
              [
                -50.615467903000344,
                0.05882396100030835
              ],
              [
                -50.62389075399901,
                0.061224674881734
              ],
              [
                -50.63426673100054,
                0.07127513322477078
              ]
            ]
          ],
          [
            [
              [
                -50.09078426598,
                0.30594478974222195
              ],
              [
                -50.107333650986966,
                0.29293068371175646
              ],
              [
                -50.16564774000407,
                0.2617344952353612
              ],
              [
                -50.220460840990214,
                0.24621169542497556
              ],
              [
                -50.21715247298314,
                0.26308827395458984
              ],
              [
                -50.19937089799307,
                0.28851959462681265
              ],
              [
                -50.138539191973095,
                0.3265648342941164
              ],
              [
                -50.1133241690148,
                0.33818214427180904
              ],
              [
                -50.093320561994155,
                0.33901259858114513
              ],
              [
                -50.086403887020296,
                0.32072660605966985
              ],
              [
                -50.09078426598,
                0.30594478974222195
              ]
            ]
          ],
          [
            [
              [
                -50.03688777500614,
                0.2997410549619319
              ],
              [
                -50.00381158898569,
                0.31012252244408733
              ],
              [
                -49.95945083701555,
                0.30830276324599865
              ],
              [
                -49.92162215101583,
                0.29278582174667106
              ],
              [
                -49.85955442400473,
                0.30122358526888726
              ],
              [
                -49.825760286992505,
                0.32220725870058464
              ],
              [
                -49.74591502195671,
                0.3534726204320786
              ],
              [
                -49.65022746603495,
                0.3863733920874054
              ],
              [
                -49.560156608995634,
                0.38575744239075993
              ],
              [
                -49.530356306001856,
                0.35377954378705173
              ],
              [
                -49.52894967799894,
                0.3008146295202993
              ],
              [
                -49.60160336798413,
                0.265985325489173
              ],
              [
                -49.642473965989026,
                0.23269929428609795
              ],
              [
                -49.6923722,
                0.20502350506260722
              ],
              [
                -49.76402747300232,
                0.13336823353537144
              ],
              [
                -49.787342903002624,
                0.09235261013819027
              ],
              [
                -49.80614173100044,
                0.04865143556312812
              ],
              [
                -49.82970130099994,
                0.0112979188921708
              ],
              [
                -49.86705481699993,
                -0.010674737834583935
              ],
              [
                -49.93390865800001,
                -0.028741144268122784
              ],
              [
                -49.96312415299992,
                -0.03276946400310042
              ],
              [
                -49.97500566299972,
                -0.03687916414814484
              ],
              [
                -49.98615475199946,
                -0.04253508738975589
              ],
              [
                -49.9940079419992,
                -0.048435151861567306
              ],
              [
                -50.00450598900015,
                -0.052788995583921486
              ],
              [
                -50.0129288399998,
                -0.045342705668383144
              ],
              [
                -50.02476966099978,
                -0.024265231104426684
              ],
              [
                -50.045074022999934,
                -0.0028622381279699177
              ],
              [
                -50.06944739499987,
                0.01658763146202331
              ],
              [
                -50.09727942599981,
                0.030910548422238115
              ],
              [
                -50.12779700400019,
                0.03717682591265031
              ],
              [
                -50.174672003999916,
                0.029282944915668307
              ],
              [
                -50.18236243399984,
                0.033758855732318606
              ],
              [
                -50.19009355400034,
                0.04132721743628283
              ],
              [
                -50.20669511599979,
                0.039292709532384194
              ],
              [
                -50.22227942599967,
                0.03359609491222321
              ],
              [
                -50.2267960280001,
                0.03034088789907087
              ],
              [
                -50.24885006399999,
                0.024644273278960772
              ],
              [
                -50.272694464999866,
                0.014878647545437607
              ],
              [
                -50.29759680899996,
                0.012030341408956346
              ],
              [
                -50.322621223000155,
                0.026922920065848576
              ],
              [
                -50.34512285100019,
                0.047430731759617435
              ],
              [
                -50.3515518869991,
                0.05890533906326573
              ],
              [
                -50.35309811099933,
                0.07811106889190236
              ],
              [
                -50.3420304029973,
                0.11542389184367596
              ],
              [
                -50.34007727800232,
                0.13336823353537144
              ],
              [
                -50.3503311839999,
                0.12669505399264064
              ],
              [
                -50.357411261996454,
                0.1165225238588371
              ],
              [
                -50.36668860599986,
                0.09178294492075331
              ],
              [
                -50.37999426999849,
                0.11074453117434474
              ],
              [
                -50.383656379000826,
                0.12986888294385338
              ],
              [
                -50.38097083198937,
                0.19464752037769287
              ],
              [
                -50.37779700401105,
                0.20831941049838573
              ],
              [
                -50.366810675991566,
                0.2145042935017615
              ],
              [
                -50.30490264601007,
                0.21684262661238063
              ],
              [
                -50.27964627900153,
                0.22808913500916403
              ],
              [
                -50.25441614999952,
                0.22977054774316064
              ],
              [
                -50.23268400199502,
                0.22450457591265094
              ],
              [
                -50.199636864992954,
                0.2226873515659326
              ],
              [
                -50.12804114499329,
                0.22158437275219503
              ],
              [
                -50.10728919199833,
                0.2221540379701027
              ],
              [
                -50.06218987399549,
                0.2623919225824258
              ],
              [
                -50.03688777500614,
                0.2997410549619319
              ]
            ]
          ],
          [
            [
              [
                -50.37802102101096,
                0.24498952234602428
              ],
              [
                -50.395198074010196,
                0.24034094601340233
              ],
              [
                -50.41397518099494,
                0.22634318688003333
              ],
              [
                -50.420309385998344,
                0.2029726239058084
              ],
              [
                -50.41880199099531,
                0.18894301955441353
              ],
              [
                -50.41513429301098,
                0.17657886777311949
              ],
              [
                -50.41901965799664,
                0.16794411827600159
              ],
              [
                -50.42625891800965,
                0.16840241909779124
              ],
              [
                -50.45018470000107,
                0.1786563179094605
              ],
              [
                -50.45982825399106,
                0.1810977161296599
              ],
              [
                -50.48265540299556,
                0.18235911365959329
              ],
              [
                -50.493153450010446,
                0.18549226296878277
              ],
              [
                -50.50145423099171,
                0.19171783500249223
              ],
              [
                -50.51675370999808,
                0.20864492275050783
              ],
              [
                -50.5180557930039,
                0.21491120259357632
              ],
              [
                -50.51634680900631,
                0.24335358669271073
              ],
              [
                -50.51292883999235,
                0.2564964818563459
              ],
              [
                -50.50597083200604,
                0.26618073423453975
              ],
              [
                -50.49453691299613,
                0.26992421901919184
              ],
              [
                -50.48525956899866,
                0.26845937633054195
              ],
              [
                -50.48058020701338,
                0.266017978108396
              ],
              [
                -50.4768774080073,
                0.26544831289023385
              ],
              [
                -50.47036699099614,
                0.26992421901919184
              ],
              [
                -50.469960089990344,
                0.2743187470852815
              ],
              [
                -50.43919837103045,
                0.39765046891765826
              ],
              [
                -50.43252519403617,
                0.41396720245792734
              ],
              [
                -50.43150794202118,
                0.4155948012760415
              ],
              [
                -50.42251542897945,
                0.41901275503887153
              ],
              [
                -50.41242428294481,
                0.4215762203611531
              ],
              [
                -50.40831458195543,
                0.42072173192038836
              ],
              [
                -50.40709387895921,
                0.4306501185106978
              ],
              [
                -50.41087805902792,
                0.4369164171488216
              ],
              [
                -50.416859503965064,
                0.4419619697318141
              ],
              [
                -50.42198645705808,
                0.44867586649594127
              ],
              [
                -50.42808997302415,
                0.46548086843078607
              ],
              [
                -50.430083787998626,
                0.4785830746058419
              ],
              [
                -50.429432746037165,
                0.5066592575304812
              ],
              [
                -50.43248450397984,
                0.5343285126009847
              ],
              [
                -50.43077552003728,
                0.5480004027922223
              ],
              [
                -50.421986457072585,
                0.5647647345065592
              ],
              [
                -50.379750129078225,
                0.6118024944861805
              ],
              [
                -50.36668860596394,
                0.6199404886112158
              ],
              [
                -50.366688605938,
                0.6151797404547147
              ],
              [
                -50.365061002004154,
                0.6124535189947885
              ],
              [
                -50.36266028597004,
                0.609930723917327
              ],
              [
                -50.36050371005035,
                0.606350014013659
              ],
              [
                -50.347320115991224,
                0.5712751297990533
              ],
              [
                -50.34605872301945,
                0.527533275315272
              ],
              [
                -50.35505123598266,
                0.4125430300212982
              ],
              [
                -50.35309811100062,
                0.40021393423902385
              ],
              [
                -50.348866339960786,
                0.3900820837190766
              ],
              [
                -50.33592688702689,
                0.36847566341829113
              ],
              [
                -50.323150193982535,
                0.34064361475028243
              ],
              [
                -50.31696961501273,
                0.30875124387299063
              ],
              [
                -50.32328549098838,
                0.2869603053164149
              ],
              [
                -50.33893375000877,
                0.2714113496083798
              ],
              [
                -50.34991904501221,
                0.252735947861054
              ],
              [
                -50.363972029009595,
                0.24808401050513412
              ],
              [
                -50.37802102101096,
                0.24498952234602428
              ]
            ]
          ],
          [
            [
              [
                -50.312123176036074,
                0.41396720245792734
              ],
              [
                -50.317250129053825,
                0.4579938988398286
              ],
              [
                -50.31505286404883,
                0.497259847114362
              ],
              [
                -50.30288652302904,
                0.5309919368939112
              ],
              [
                -50.278553840052815,
                0.5585391436605304
              ],
              [
                -50.25645911400404,
                0.5697289090393293
              ],
              [
                -50.25157630096014,
                0.5758324140150645
              ],
              [
                -50.25816809802501,
                0.5851911541924195
              ],
              [
                -50.24209550703191,
                0.5929629658028669
              ],
              [
                -50.186919725957715,
                0.592230525677691
              ],
              [
                -50.174916144996125,
                0.5954450530708295
              ],
              [
                -50.16759192607302,
                0.6054141475060184
              ],
              [
                -50.15062415304812,
                0.5971133597034933
              ],
              [
                -50.1203507149567,
                0.5716006420530328
              ],
              [
                -50.11510169206291,
                0.5862491065715495
              ],
              [
                -50.13475501207338,
                0.597560957829662
              ],
              [
                -50.13402258992082,
                0.6124941892499135
              ],
              [
                -50.1220596999987,
                0.6267764337202056
              ],
              [
                -50.102894661051316,
                0.6398379696878829
              ],
              [
                -50.082183397945464,
                0.6478945857551642
              ],
              [
                -50.06566321509787,
                0.6472842690544395
              ],
              [
                -50.03844153605003,
                0.606350014013659
              ],
              [
                -50.03327389204512,
                0.5935733200560572
              ],
              [
                -50.0313614570601,
                0.5848656419383255
              ],
              [
                -50.03156490795127,
                0.561672255434302
              ],
              [
                -50.03050696501516,
                0.5567894589659269
              ],
              [
                -50.02574622296846,
                0.5472679626678096
              ],
              [
                -50.02476966101001,
                0.5411644576960946
              ],
              [
                -50.02684485602548,
                0.5353050869154525
              ],
              [
                -50.03628495996629,
                0.5259463467486952
              ],
              [
                -50.04271399596278,
                0.5103213454893715
              ],
              [
                -50.16607662299403,
                0.41384819595935457
              ],
              [
                -50.19948366999293,
                0.3927155484447466
              ],
              [
                -50.22984338195553,
                0.3776376992223105
              ],
              [
                -50.24959507401015,
                0.36101558202292844
              ],
              [
                -50.281445907014295,
                0.356551542740605
              ],
              [
                -50.30068925703584,
                0.3754743646186549
              ],
              [
                -50.312123176036074,
                0.41396720245792734
              ]
            ]
          ],
          [
            [
              [
                -50.202416172954635,
                0.7496915961616338
              ],
              [
                -50.241398947881045,
                0.7445971866599874
              ],
              [
                -50.275274283973886,
                0.7456219419009052
              ],
              [
                -50.28336427319714,
                0.7691864305181546
              ],
              [
                -50.27495184702988,
                0.8091141814269008
              ],
              [
                -50.225476444882794,
                0.8592001079108791
              ],
              [
                -50.15880566518242,
                0.8866902714326829
              ],
              [
                -50.13212269197933,
                0.9142140076581553
              ],
              [
                -50.111665818043285,
                0.9182527179989886
              ],
              [
                -50.086114098936555,
                0.9161561907370221
              ],
              [
                -50.05857153104812,
                0.9017988019258393
              ],
              [
                -50.0269164509013,
                0.9037556308021915
              ],
              [
                -50.01572262596514,
                0.8924925612131119
              ],
              [
                -50.02293528384904,
                0.8731052044038269
              ],
              [
                -50.036284126825485,
                0.8527053347487054
              ],
              [
                -50.04967289916941,
                0.8210627494517587
              ],
              [
                -50.068117649108075,
                0.8078123577222396
              ],
              [
                -50.0763285139771,
                0.7986284657858933
              ],
              [
                -50.08356542102971,
                0.7792070106160773
              ],
              [
                -50.10338294210324,
                0.7556827040534781
              ],
              [
                -50.11192786397311,
                0.7523460907736471
              ],
              [
                -50.122181770127426,
                0.7512067978791273
              ],
              [
                -50.151218708839224,
                0.7496299335954549
              ],
              [
                -50.202416172954635,
                0.7496915961616338
              ]
            ]
          ],
          [
            [
              [
                -50.06258476287314,
                0.9232521176079329
              ],
              [
                -50.07176302595754,
                0.9314372412411296
              ],
              [
                -50.09934734322002,
                0.9386428238374812
              ],
              [
                -50.10031737797575,
                0.9590628972486963
              ],
              [
                -50.07369237199326,
                0.9773748769838975
              ],
              [
                -50.04918372305652,
                0.9855817815653576
              ],
              [
                -50.038441535845735,
                1.006740604109084
              ],
              [
                -50.03189042915949,
                1.0149600515123731
              ],
              [
                -50.016672329856014,
                1.0252139129825875
              ],
              [
                -49.99844316280876,
                1.0340029692919999
              ],
              [
                -49.967030403229124,
                1.0431176129703994
              ],
              [
                -49.946817100173774,
                1.062770922589027
              ],
              [
                -49.926380350780214,
                1.0698567101032714
              ],
              [
                -49.91620848610727,
                1.0565626812783915
              ],
              [
                -49.9366755851744,
                1.0234235955592186
              ],
              [
                -49.944081184209885,
                1.0082461921882726
              ],
              [
                -49.95250403611836,
                0.9966494987758909
              ],
              [
                -49.95645097577246,
                0.9865176105312573
              ],
              [
                -49.96401933499365,
                0.9738223320345673
              ],
              [
                -49.99730384011229,
                0.9524600455809479
              ],
              [
                -50.004872200127345,
                0.9452172100781407
              ],
              [
                -50.008290167883054,
                0.9409854005143067
              ],
              [
                -50.02525794183427,
                0.9369977626977389
              ],
              [
                -50.03156490799541,
                0.9346377612765338
              ],
              [
                -50.06258476287314,
                0.9232521176079329
              ]
            ]
          ],
          [
            [
              [
                -50.4543576911183,
                2.110940557944032
              ],
              [
                -50.441517191994635,
                2.1080491015964116
              ],
              [
                -50.42642770729505,
                2.110742276351263
              ],
              [
                -50.409641295442384,
                2.112945004591194
              ],
              [
                -50.399577600236135,
                2.115108376939624
              ],
              [
                -50.38683922200569,
                2.0971530774411873
              ],
              [
                -50.36636408841921,
                2.069679510480249
              ],
              [
                -50.35693424376075,
                2.059439768387185
              ],
              [
                -50.353197640807814,
                2.0343239498923067
              ],
              [
                -50.338853925050266,
                2.009692269001474
              ],
              [
                -50.32502810775191,
                1.9917592012343048
              ],
              [
                -50.31402721936813,
                1.9682656868008757
              ],
              [
                -50.3124955851042,
                1.9470651788302655
              ],
              [
                -50.32093895533778,
                1.9354141826452254
              ],
              [
                -50.33895114453804,
                1.912667979611345
              ],
              [
                -50.37657806938985,
                1.8783314666683117
              ],
              [
                -50.39449557278397,
                1.8706354371770144
              ],
              [
                -50.41911898399166,
                1.8629778623014022
              ],
              [
                -50.440852079860456,
                1.8698104655965757
              ],
              [
                -50.45860755175229,
                1.8810082681202773
              ],
              [
                -50.47663326722905,
                1.9426944216896798
              ],
              [
                -50.49550952638528,
                1.9672476910901031
              ],
              [
                -50.49763213139512,
                1.984560227570679
              ],
              [
                -50.508188340415096,
                1.9952349873934043
              ],
              [
                -50.523812725763456,
                2.0014820592133766
              ],
              [
                -50.520811916384915,
                2.0316561612071107
              ],
              [
                -50.51169695134869,
                2.0561556544150403
              ],
              [
                -50.511341926751086,
                2.079820111786076
              ],
              [
                -50.504230245766955,
                2.095691802189585
              ],
              [
                -50.488543506264094,
                2.0989221398014424
              ],
              [
                -50.47009353570245,
                2.0976627512620163
              ],
              [
                -50.4543576911183,
                2.110940557944032
              ]
            ]
          ],
          [
            [
              [
                -50.543521442392795,
                2.146196677540234
              ],
              [
                -50.55299503060003,
                2.1512829008383356
              ],
              [
                -50.55352275103467,
                2.1563091890206865
              ],
              [
                -50.541704970617026,
                2.1679483185687287
              ],
              [
                -50.5136310880631,
                2.1872861816573144
              ],
              [
                -50.4924006337714,
                2.186581530931592
              ],
              [
                -50.46334761487477,
                2.186938287587658
              ],
              [
                -50.44833469599781,
                2.176234836844557
              ],
              [
                -50.43054043607445,
                2.1649581720498072
              ],
              [
                -50.4178321754851,
                2.144794586333748
              ],
              [
                -50.415158088750495,
                2.126931067132537
              ],
              [
                -50.42469236831835,
                2.1197447113066414
              ],
              [
                -50.44144522446292,
                2.118182793122448
              ],
              [
                -50.45762113184066,
                2.1205204129323336
              ],
              [
                -50.46658644211199,
                2.1161178105032405
              ],
              [
                -50.47334443786871,
                2.107795992139039
              ],
              [
                -50.48617926399083,
                2.110110629307639
              ],
              [
                -50.49793202723409,
                2.107397926820309
              ],
              [
                -50.50965321303888,
                2.109705503962439
              ],
              [
                -50.5202374370356,
                2.1153533748774436
              ],
              [
                -50.52568474930987,
                2.137707371293283
              ],
              [
                -50.53570564207596,
                2.1444702757579432
              ],
              [
                -50.543521442392795,
                2.146196677540234
              ]
            ]
          ],
          [
            [
              [
                -29.33824622207132,
                -20.584161047573918
              ],
              [
                -29.348255989517742,
                -20.561293237275425
              ],
              [
                -29.344309049438493,
                -20.550957949705445
              ],
              [
                -29.33202063751531,
                -20.553317977234858
              ],
              [
                -29.31688391775911,
                -20.568780201216967
              ],
              [
                -29.32396399693356,
                -20.571465771539103
              ],
              [
                -29.328602667392133,
                -20.575290610934193
              ],
              [
                -29.332875129297197,
                -20.579685159899682
              ],
              [
                -29.33824622207132,
                -20.584161047573918
              ]
            ]
          ],
          [
            [
              [
                -28.88329016723084,
                -20.51873136248081
              ],
              [
                -28.881906704516236,
                -20.515394780238065
              ],
              [
                -28.881418423083492,
                -20.51238370350342
              ],
              [
                -28.88048255181603,
                -20.510837514471625
              ],
              [
                -28.87706458279071,
                -20.511651315962382
              ],
              [
                -28.87783769430691,
                -20.51425547319606
              ],
              [
                -28.879261848661766,
                -20.515720323357623
              ],
              [
                -28.8812556628706,
                -20.51685963038985
              ],
              [
                -28.88329016723084,
                -20.51873136248081
              ]
            ]
          ],
          [
            [
              [
                -48.43455969808626,
                -27.40471769120331
              ],
              [
                -48.42658443576945,
                -27.388929920988424
              ],
              [
                -48.40876218035693,
                -27.399590802197498
              ],
              [
                -48.39020748351952,
                -27.420505447825292
              ],
              [
                -48.37987219846116,
                -27.435723554115302
              ],
              [
                -48.377308726110556,
                -27.458184526987065
              ],
              [
                -48.38524328352318,
                -27.477308779034082
              ],
              [
                -48.395741332552674,
                -27.49358483673986
              ],
              [
                -48.40306555264705,
                -27.51238367322778
              ],
              [
                -48.40754147499057,
                -27.517266572296894
              ],
              [
                -48.41197668702098,
                -27.52369553281372
              ],
              [
                -48.41405190493789,
                -27.53411237546689
              ],
              [
                -48.412505681861234,
                -27.546075272423074
              ],
              [
                -48.40697181858753,
                -27.56861751930292
              ],
              [
                -48.40721594973862,
                -27.579196871003695
              ],
              [
                -48.41454017594811,
                -27.595147454643712
              ],
              [
                -48.4275610191302,
                -27.613051170498967
              ],
              [
                -48.44155841718748,
                -27.627699622976362
              ],
              [
                -48.45197506189952,
                -27.633721597030384
              ],
              [
                -48.49657141131392,
                -27.7027319784626
              ],
              [
                -48.49746658906596,
                -27.723890792931943
              ],
              [
                -48.48216710969249,
                -27.75945394884898
              ],
              [
                -48.48607335768767,
                -27.774346512865346
              ],
              [
                -48.49351965824379,
                -27.779066644278394
              ],
              [
                -48.512562646667035,
                -27.783949609728687
              ],
              [
                -48.52049720784435,
                -27.788344066905456
              ],
              [
                -48.53465736228167,
                -27.807875305092082
              ],
              [
                -48.54259191028202,
                -27.816664203260615
              ],
              [
                -48.55186926357249,
                -27.819431199872025
              ],
              [
                -48.55980385397328,
                -27.818454789620834
              ],
              [
                -48.56379145406111,
                -27.817315243663305
              ],
              [
                -48.565093554089195,
                -27.813653253668463
              ],
              [
                -48.56354734638577,
                -27.7398415273587
              ],
              [
                -48.557240361188256,
                -27.707940341781775
              ],
              [
                -48.54442297560256,
                -27.681573134181768
              ],
              [
                -48.55907141047282,
                -27.674493040063833
              ],
              [
                -48.55016030538181,
                -27.658298581803777
              ],
              [
                -48.523915165896376,
                -27.633721597030384
              ],
              [
                -48.52599035899196,
                -27.611423396921815
              ],
              [
                -48.54015053660746,
                -27.591485410418557
              ],
              [
                -48.54710852417239,
                -27.577243718838695
              ],
              [
                -48.52765866359355,
                -27.57170993665061
              ],
              [
                -48.515777165226375,
                -27.570001040397948
              ],
              [
                -48.50816811033391,
                -27.56487405012908
              ],
              [
                -48.504261843632214,
                -27.556410381643808
              ],
              [
                -48.503407348165766,
                -27.545017125120893
              ],
              [
                -48.506703245259324,
                -27.53997154617274
              ],
              [
                -48.51378331354876,
                -27.53541417990398
              ],
              [
                -48.523915168728756,
                -27.530694274574092
              ],
              [
                -48.52415929390379,
                -27.523532694486114
              ],
              [
                -48.52163652433341,
                -27.517836206208322
              ],
              [
                -48.51862545961016,
                -27.512872038307925
              ],
              [
                -48.517079226951886,
                -27.507093976983576
              ],
              [
                -48.52041581213469,
                -27.49578210635862
              ],
              [
                -48.53490150399268,
                -27.484144851319883
              ],
              [
                -48.53750566032949,
                -27.4761695085018
              ],
              [
                -48.530832482766975,
                -27.463067291156868
              ],
              [
                -48.51939857466783,
                -27.454522452972373
              ],
              [
                -48.51207434791471,
                -27.444756768343794
              ],
              [
                -48.51707923223152,
                -27.428317976490423
              ],
              [
                -48.49941972661004,
                -27.42644622670367
              ],
              [
                -48.44579016040129,
                -27.412367387292576
              ],
              [
                -48.43455969808626,
                -27.40471769120331
              ]
            ]
          ],
          [
            [
              [
                -48.544422982655846,
                -26.341892198837556
              ],
              [
                -48.54792233881469,
                -26.35182064459692
              ],
              [
                -48.57542884096778,
                -26.376234641060954
              ],
              [
                -48.579090947989194,
                -26.38543058026646
              ],
              [
                -48.57982336844306,
                -26.397556226741784
              ],
              [
                -48.57852128695481,
                -26.420993739326214
              ],
              [
                -48.583241344074835,
                -26.42107516181549
              ],
              [
                -48.58629310090679,
                -26.41961030812343
              ],
              [
                -48.59219316845731,
                -26.41415785530376
              ],
              [
                -48.611317503171996,
                -26.412774273737124
              ],
              [
                -48.628041138216794,
                -26.387953326617353
              ],
              [
                -48.64313716651221,
                -26.359063346639953
              ],
              [
                -48.65733801881967,
                -26.345310144162656
              ],
              [
                -48.69969641153216,
                -26.316664267018947
              ],
              [
                -48.70327715292812,
                -26.311944310143566
              ],
              [
                -48.70116126030116,
                -26.30722420281192
              ],
              [
                -48.68415280158501,
                -26.2813453316418
              ],
              [
                -48.67528235895857,
                -26.273858355788636
              ],
              [
                -48.664173964788425,
                -26.270765948285348
              ],
              [
                -48.64647376129594,
                -26.26832447109565
              ],
              [
                -48.639759891438224,
                -26.26165127010821
              ],
              [
                -48.63670813530468,
                -26.251885660760966
              ],
              [
                -48.630034960478255,
                -26.239678648021957
              ],
              [
                -48.60724850342175,
                -26.22730886397268
              ],
              [
                -48.577626102046665,
                -26.218438375667024
              ],
              [
                -48.55809485311068,
                -26.20549893160394
              ],
              [
                -48.56554114281512,
                -26.18132901551949
              ],
              [
                -48.547596808300824,
                -26.167250252077906
              ],
              [
                -48.531158010637505,
                -26.170342736817275
              ],
              [
                -48.51634681265983,
                -26.18401461198253
              ],
              [
                -48.49339758944534,
                -26.218926686315992
              ],
              [
                -48.49014237802868,
                -26.227797099479318
              ],
              [
                -48.48912512573106,
                -26.236016506425138
              ],
              [
                -48.49282792792865,
                -26.243829024969386
              ],
              [
                -48.50755774224165,
                -26.256605695360097
              ],
              [
                -48.51610267057604,
                -26.2813453316418
              ],
              [
                -48.53917394874502,
                -26.318942897887464
              ],
              [
                -48.544422982655846,
                -26.341892198837556
              ]
            ]
          ],
          [
            [
              [
                -47.51716060189097,
                -24.700941575959444
              ],
              [
                -47.506703249849345,
                -24.699802301414877
              ],
              [
                -47.4830216048975,
                -24.700941575959444
              ],
              [
                -47.473256002876745,
                -24.69768659180848
              ],
              [
                -47.45905515343887,
                -24.69019958905284
              ],
              [
                -47.44831294673018,
                -24.686700046949206
              ],
              [
                -47.44831294743445,
                -24.69353599189389
              ],
              [
                -47.49518794838812,
                -24.723890818463182
              ],
              [
                -47.53026281701572,
                -24.73251710718148
              ],
              [
                -47.55003820514722,
                -24.74236409508917
              ],
              [
                -47.785389768780995,
                -24.923760587063025
              ],
              [
                -47.82274329835276,
                -24.941664371941282
              ],
              [
                -47.838042758180485,
                -24.958265742213765
              ],
              [
                -47.85912025647071,
                -24.989027701166734
              ],
              [
                -47.87743079306404,
                -25.027113540605093
              ],
              [
                -47.88829505093836,
                -25.04119231541968
              ],
              [
                -47.900135870893294,
                -25.03679778299493
              ],
              [
                -47.899769661001706,
                -25.015720310016647
              ],
              [
                -47.883778446707566,
                -24.98211025281618
              ],
              [
                -47.87962806756257,
                -24.964776381229786
              ],
              [
                -47.872425913143026,
                -24.958591424344338
              ],
              [
                -47.831857891257464,
                -24.913262763988826
              ],
              [
                -47.71739660418181,
                -24.83033610146439
              ],
              [
                -47.67357336805365,
                -24.811455959559797
              ],
              [
                -47.612945126214846,
                -24.754489941204348
              ],
              [
                -47.56167559749181,
                -24.736016655636906
              ],
              [
                -47.53530841101186,
                -24.71005637504669
              ],
              [
                -47.51716060189097,
                -24.700941575959444
              ]
            ]
          ],
          [
            [
              [
                -46.32795163159095,
                -23.92644627094544
              ],
              [
                -46.31948808564122,
                -23.927666931837454
              ],
              [
                -46.3186742790093,
                -23.930840710460398
              ],
              [
                -46.31989497690159,
                -23.935316568048403
              ],
              [
                -46.3173721927402,
                -23.94060630066752
              ],
              [
                -46.302561000040626,
                -23.958428623150116
              ],
              [
                -46.29161535358673,
                -23.97918048633546
              ],
              [
                -46.29185949135838,
                -23.990899212773765
              ],
              [
                -46.34137937386315,
                -23.969903389649865
              ],
              [
                -46.35537674493069,
                -23.97063554683012
              ],
              [
                -46.36579343433547,
                -23.981622112642892
              ],
              [
                -46.37450109935193,
                -23.97795982346952
              ],
              [
                -46.39159094351905,
                -23.977308783264693
              ],
              [
                -46.399891728562814,
                -23.974786040152026
              ],
              [
                -46.4046524821569,
                -23.970473012140722
              ],
              [
                -46.420399547688014,
                -23.947442365802488
              ],
              [
                -46.40689041781529,
                -23.941826962098624
              ],
              [
                -46.40196692859019,
                -23.942803671537177
              ],
              [
                -46.39366614968534,
                -23.947442365802488
              ],
              [
                -46.390044729208405,
                -23.940850553123447
              ],
              [
                -46.38833574940308,
                -23.935723655408705
              ],
              [
                -46.389393676910345,
                -23.92945721453404
              ],
              [
                -46.39366613428554,
                -23.92017983188013
              ],
              [
                -46.3814591103155,
                -23.920342666746922
              ],
              [
                -46.34837806359294,
                -23.92644627094544
              ],
              [
                -46.32795163159095,
                -23.92644627094544
              ]
            ]
          ],
          [
            [
              [
                -45.21373449889042,
                -23.906508015100737
              ],
              [
                -45.22647050764399,
                -23.90927500504273
              ],
              [
                -45.22691810948057,
                -23.916762102467445
              ],
              [
                -45.222645637626016,
                -23.927666931837454
              ],
              [
                -45.22126216691205,
                -23.94060630066752
              ],
              [
                -45.21784421380668,
                -23.944919625061814
              ],
              [
                -45.21825111344006,
                -23.949476902126833
              ],
              [
                -45.22459875684355,
                -23.957696165817847
              ],
              [
                -45.22891191382945,
                -23.961114200034984
              ],
              [
                -45.241688619008364,
                -23.967950269573098
              ],
              [
                -45.2464900278923,
                -23.96347410697154
              ],
              [
                -45.25104731682957,
                -23.96209060963099
              ],
              [
                -45.256011509828106,
                -23.96209060963099
              ],
              [
                -45.26219641883006,
                -23.961114200034984
              ],
              [
                -45.27183998136781,
                -23.946221704156848
              ],
              [
                -45.280506973350974,
                -23.925225610099787
              ],
              [
                -45.29043535057825,
                -23.911879160396545
              ],
              [
                -45.303781694537236,
                -23.92017983188013
              ],
              [
                -45.30996660714881,
                -23.912693034095966
              ],
              [
                -45.346058716583464,
                -23.92815513612056
              ],
              [
                -45.385731572099736,
                -23.938083560466357
              ],
              [
                -45.421864374721736,
                -23.93523515057696
              ],
              [
                -45.44713294816743,
                -23.912693034095966
              ],
              [
                -45.45295162153271,
                -23.891371292434844
              ],
              [
                -45.44737709009207,
                -23.877211284266405
              ],
              [
                -45.434803846279415,
                -23.86728287856432
              ],
              [
                -45.41982988967857,
                -23.858086930926174
              ],
              [
                -45.355376769970405,
                -23.800062900574414
              ],
              [
                -45.34471594499715,
                -23.782403197924335
              ],
              [
                -45.337717257124034,
                -23.752129872544575
              ],
              [
                -45.33385168591183,
                -23.74521243077772
              ],
              [
                -45.32860267192758,
                -23.73748142139678
              ],
              [
                -45.327056450283216,
                -23.73088965045968
              ],
              [
                -45.32469641224881,
                -23.725274283394143
              ],
              [
                -45.31680254296992,
                -23.72087987099377
              ],
              [
                -45.30846106476336,
                -23.721368072248133
              ],
              [
                -45.2971085367448,
                -23.724297880782057
              ],
              [
                -45.28701738726433,
                -23.72820409225905
              ],
              [
                -45.23656164693181,
                -23.761813992935753
              ],
              [
                -45.22809810334036,
                -23.772393403395977
              ],
              [
                -45.234852655958214,
                -23.844414839714517
              ],
              [
                -45.265736451371254,
                -23.839287957184112
              ],
              [
                -45.27110754263275,
                -23.868910323321163
              ],
              [
                -45.25499427522314,
                -23.89820734712603
              ],
              [
                -45.22126217847324,
                -23.892266582982398
              ],
              [
                -45.21642003870537,
                -23.899102337428737
              ],
              [
                -45.21507727822953,
                -23.902032161512786
              ],
              [
                -45.21373449889042,
                -23.906508015100737
              ]
            ]
          ],
          [
            [
              [
                -44.10090085688577,
                -23.149021232540857
              ],
              [
                -44.08543860723009,
                -23.16179779853898
              ],
              [
                -44.08226478551018,
                -23.169528992723098
              ],
              [
                -44.09776769915137,
                -23.17392334233932
              ],
              [
                -44.10366776178087,
                -23.178643355605285
              ],
              [
                -44.107736782560295,
                -23.179620044812342
              ],
              [
                -44.11266028052912,
                -23.177422719447772
              ],
              [
                -44.11628169675847,
                -23.172539874732763
              ],
              [
                -44.118072058120575,
                -23.167657030564538
              ],
              [
                -44.11827552950528,
                -23.165460006230028
              ],
              [
                -44.128041136407575,
                -23.16497151156872
              ],
              [
                -44.135365373508954,
                -23.165460006230028
              ],
              [
                -44.14098059006265,
                -23.16773844634605
              ],
              [
                -44.14557858077197,
                -23.172784122105043
              ],
              [
                -44.15925045109292,
                -23.165785368913372
              ],
              [
                -44.1682022845409,
                -23.171563486111772
              ],
              [
                -44.17686928204406,
                -23.181329175870726
              ],
              [
                -44.18968665743665,
                -23.186618800228466
              ],
              [
                -44.230824354375265,
                -23.19353614094541
              ],
              [
                -44.24120032841318,
                -23.19345472511554
              ],
              [
                -44.25597082468345,
                -23.187676605006526
              ],
              [
                -44.26585852187805,
                -23.180840681031572
              ],
              [
                -44.276234493384926,
                -23.175225394194165
              ],
              [
                -44.29263261677452,
                -23.172784122105043
              ],
              [
                -44.3016658211982,
                -23.178317992826017
              ],
              [
                -44.31114661526744,
                -23.19133881487525
              ],
              [
                -44.318918428521116,
                -23.207207993995798
              ],
              [
                -44.3231094979163,
                -23.22063560375846
              ],
              [
                -44.32770747860257,
                -23.22128663038673
              ],
              [
                -44.32896888762953,
                -23.219659214048498
              ],
              [
                -44.32900955715408,
                -23.217054807266784
              ],
              [
                -44.329945436583024,
                -23.21379967454747
              ],
              [
                -44.3379614009131,
                -23.206638383436484
              ],
              [
                -44.341704874844034,
                -23.198662935116747
              ],
              [
                -44.34154210969668,
                -23.189629683422137
              ],
              [
                -44.33739173055797,
                -23.179620044812342
              ],
              [
                -44.354481576246435,
                -23.180352486625225
              ],
              [
                -44.36070715718361,
                -23.178155161223632
              ],
              [
                -44.36465410177576,
                -23.172784122105043
              ],
              [
                -44.36709550750234,
                -23.1652157588987
              ],
              [
                -44.365467909226666,
                -23.16399512311686
              ],
              [
                -44.36001542913344,
                -23.163832291567946
              ],
              [
                -44.32310949125416,
                -23.145602973013265
              ],
              [
                -44.29637610206657,
                -23.117608284603115
              ],
              [
                -44.28416907483903,
                -23.123223564102272
              ],
              [
                -44.27086341868332,
                -23.11516701569816
              ],
              [
                -44.24803626840175,
                -23.09099707872593
              ],
              [
                -44.24486243551007,
                -23.086032827870266
              ],
              [
                -44.24120033728646,
                -23.069756914553416
              ],
              [
                -44.23509681083561,
                -23.06878022775097
              ],
              [
                -44.23045813598494,
                -23.071465740974507
              ],
              [
                -44.22777258767301,
                -23.074883694434675
              ],
              [
                -44.22752844031466,
                -23.076755352278436
              ],
              [
                -44.219105598865276,
                -23.077732039251128
              ],
              [
                -44.20815997000154,
                -23.080743215490735
              ],
              [
                -44.19668534795955,
                -23.085218971981085
              ],
              [
                -44.18651283139286,
                -23.09099707872593
              ],
              [
                -44.18651282748185,
                -23.097100548387786
              ],
              [
                -44.19322667969826,
                -23.098076935371083
              ],
              [
                -44.197743301808586,
                -23.10003031025454
              ],
              [
                -44.20177160512736,
                -23.10230874701407
              ],
              [
                -44.2070206358431,
                -23.1045874843155
              ],
              [
                -44.186512821076334,
                -23.117608284603115
              ],
              [
                -44.170765753535946,
                -23.110121346508514
              ],
              [
                -44.162587052248824,
                -23.115899456441053
              ],
              [
                -44.155140751257115,
                -23.12590908055978
              ],
              [
                -44.14183508221759,
                -23.131280113960262
              ],
              [
                -44.135324676142865,
                -23.128106403352657
              ],
              [
                -44.13023840606228,
                -23.121026241549846
              ],
              [
                -44.12669835908406,
                -23.11394608086871
              ],
              [
                -44.124419724100036,
                -23.110772371492068
              ],
              [
                -44.113026485667554,
                -23.114678521591642
              ],
              [
                -44.11286374446061,
                -23.12070087919585
              ],
              [
                -44.116932747874095,
                -23.126722937184546
              ],
              [
                -44.11827551222178,
                -23.131280113960262
              ],
              [
                -44.110585085317055,
                -23.140313353609898
              ],
              [
                -44.10090085688577,
                -23.149021232540857
              ]
            ]
          ],
          [
            [
              [
                -32.40339108008729,
                -3.8378231815400006
              ],
              [
                -32.39216060985045,
                -3.834160979838419
              ],
              [
                -32.38658606689739,
                -3.8412411363211043
              ],
              [
                -32.38857988089018,
                -3.8527970500778523
              ],
              [
                -32.39972897020069,
                -3.8619931119697677
              ],
              [
                -32.41437740848862,
                -3.8654924824050463
              ],
              [
                -32.441517708193,
                -3.880792013573732
              ],
              [
                -32.45425370836647,
                -3.8830704498252526
              ],
              [
                -32.46279863101122,
                -3.878350445613665
              ],
              [
                -32.45714270661397,
                -3.870863511310109
              ],
              [
                -32.44676673217249,
                -3.86353940829769
              ],
              [
                -32.44127356739145,
                -3.8585751571774813
              ],
              [
                -32.43691972791742,
                -3.849867589136266
              ],
              [
                -32.42662512731672,
                -3.8457983092232233
              ],
              [
                -32.41417395738773,
                -3.8427060170031213
              ],
              [
                -32.40339108008729,
                -3.8378231815400006
              ]
            ]
          ],
          [
            [
              [
                -29.408029752119585,
                0.8848331090931117
              ],
              [
                -29.381459114043874,
                0.8913435044476393
              ],
              [
                -29.356190559112193,
                0.882757912124682
              ],
              [
                -29.34532630102318,
                0.866644604767953
              ],
              [
                -29.34902910094035,
                0.8526064943865237
              ],
              [
                -29.357736783071662,
                0.8411319244685654
              ],
              [
                -29.369374153108378,
                0.8335635767388135
              ],
              [
                -29.390126105958263,
                0.8317324764130624
              ],
              [
                -29.41026770699584,
                0.8348656257645787
              ],
              [
                -29.421213345008013,
                0.8447126343971817
              ],
              [
                -29.426380989043757,
                0.8585472808376504
              ],
              [
                -29.423410610897967,
                0.8715680715359809
              ],
              [
                -29.408029752119585,
                0.8848331090931117
              ]
            ]
          ],
          [
            [
              [
                -48.32232418986044,
                -25.383708038734913
              ],
              [
                -48.298471167318354,
                -25.366431601893623
              ],
              [
                -48.26896122824998,
                -25.348155051277548
              ],
              [
                -48.25537934198217,
                -25.348211948948386
              ],
              [
                -48.250917058572725,
                -25.364586952211525
              ],
              [
                -48.256674231887025,
                -25.3890965731322
              ],
              [
                -48.26816225336309,
                -25.42686418223755
              ],
              [
                -48.2671195658387,
                -25.446284999543668
              ],
              [
                -48.25588271234461,
                -25.46574511008812
              ],
              [
                -48.26952230176077,
                -25.475912474834434
              ],
              [
                -48.291107366998965,
                -25.489116798991247
              ],
              [
                -48.3092273251223,
                -25.48597960410496
              ],
              [
                -48.323867436044935,
                -25.46752163741195
              ],
              [
                -48.319268379731085,
                -25.45425302357564
              ],
              [
                -48.321474958626105,
                -25.44197785359905
              ],
              [
                -48.339524739750075,
                -25.425534651742314
              ],
              [
                -48.33830429255452,
                -25.40817106501847
              ],
              [
                -48.32232418986044,
                -25.383708038734913
              ]
            ]
          ],
          [
            [
              [
                -34.85274986304819,
                -7.697378755078559
              ],
              [
                -34.84614565818283,
                -7.695815034778356
              ],
              [
                -34.83605204042014,
                -7.696932621621218
              ],
              [
                -34.83019564188864,
                -7.703828312688067
              ],
              [
                -34.83209211358808,
                -7.711901075036067
              ],
              [
                -34.82781178114744,
                -7.72420294215849
              ],
              [
                -34.82233132056125,
                -7.738797063928491
              ],
              [
                -34.822296915292,
                -7.749181308169535
              ],
              [
                -34.8268798820838,
                -7.765328334715798
              ],
              [
                -34.83381307357695,
                -7.7784182204756975
              ],
              [
                -34.836876526276804,
                -7.795756738588139
              ],
              [
                -34.83801479708861,
                -7.810798495552681
              ],
              [
                -34.84537289995136,
                -7.8135041371356815
              ],
              [
                -34.85818140347119,
                -7.813159547873592
              ],
              [
                -34.8737220285884,
                -7.809366963001817
              ],
              [
                -34.88422883613047,
                -7.804025679213073
              ],
              [
                -34.88425892770748,
                -7.7882367613543435
              ],
              [
                -34.88277427124259,
                -7.765537431603877
              ],
              [
                -34.88050406840142,
                -7.753620110664985
              ],
              [
                -34.87084006528216,
                -7.74243522964265
              ],
              [
                -34.86000424397587,
                -7.727775314473231
              ],
              [
                -34.857737412954954,
                -7.714700750231567
              ],
              [
                -34.85660762188758,
                -7.704313802024963
              ],
              [
                -34.85274986304819,
                -7.697378755078559
              ]
            ]
          ],
          [
            [
              [
                -42.228702719592796,
                -2.6933110366617052
              ],
              [
                -42.21718260076483,
                -2.7019236685248145
              ],
              [
                -42.198939115164734,
                -2.7201121001918174
              ],
              [
                -42.16630975779058,
                -2.725834026622895
              ],
              [
                -42.14902376537503,
                -2.735402616194717
              ],
              [
                -42.12692359361364,
                -2.7545524132894847
              ],
              [
                -42.109630288927534,
                -2.763166246918132
              ],
              [
                -42.10577578893079,
                -2.7727492570105583
              ],
              [
                -42.131697108385985,
                -2.7737259441329143
              ],
              [
                -42.17009871541797,
                -2.7680025155376793
              ],
              [
                -42.18930712580476,
                -2.754599880704114
              ],
              [
                -42.21522236088679,
                -2.744080140259862
              ],
              [
                -42.24976710774586,
                -2.736440890781209
              ],
              [
                -42.25841502725378,
                -2.7201604688863203
              ],
              [
                -42.25843554803467,
                -2.6962095532024195
              ],
              [
                -42.25077462649579,
                -2.6818332356303958
              ],
              [
                -42.23926495086471,
                -2.6808652608915335
              ],
              [
                -42.228702719592796,
                -2.6933110366617052
              ]
            ]
          ],
          [
            [
              [
                -43.832879078675035,
                -2.4540790268813835
              ],
              [
                -43.833879146774116,
                -2.442237860087153
              ],
              [
                -43.840306444274276,
                -2.432368994360449
              ],
              [
                -43.848708011176114,
                -2.423979579752345
              ],
              [
                -43.841783430065306,
                -2.4165827748498088
              ],
              [
                -43.84030067018659,
                -2.415596624324544
              ],
              [
                -43.82349856073211,
                -2.407710123965827
              ],
              [
                -43.81312226101869,
                -2.409194081472576
              ],
              [
                -43.808181725410236,
                -2.4210335958812608
              ],
              [
                -43.8121352537112,
                -2.4353363085280595
              ],
              [
                -43.8136222227409,
                -2.454079327308055
              ],
              [
                -43.81362235706468,
                -2.4545724776792377
              ],
              [
                -43.80325174411029,
                -2.456545830230852
              ],
              [
                -43.80078235478739,
                -2.4550662289037635
              ],
              [
                -43.79090708721389,
                -2.441748164623225
              ],
              [
                -43.789919761469356,
                -2.439775112501208
              ],
              [
                -43.77510569550864,
                -2.428924602650314
              ],
              [
                -43.764242875675095,
                -2.4289253537169797
              ],
              [
                -43.75683420421,
                -2.447668522698288
              ],
              [
                -43.76127553975488,
                -2.4609852350667447
              ],
              [
                -43.76670593437644,
                -2.476274548941905
              ],
              [
                -43.77065824230074,
                -2.4960041689724104
              ],
              [
                -43.78152358557166,
                -2.505377781402121
              ],
              [
                -43.80917460788498,
                -2.512778041277558
              ],
              [
                -43.82597285692363,
                -2.5137686982125107
              ],
              [
                -43.83832577476006,
                -2.5073580437772516
              ],
              [
                -43.842771898440056,
                -2.493544876279764
              ],
              [
                -43.84277180177433,
                -2.4925582751068713
              ],
              [
                -43.84425354609618,
                -2.4802245587474996
              ],
              [
                -43.83783256493406,
                -2.4634509869246064
              ],
              [
                -43.832879078675035,
                -2.4540790268813835
              ]
            ]
          ],
          [
            [
              [
                -43.5647636628969,
                -2.361293152996007
              ],
              [
                -43.545983064826004,
                -2.3602921313562875
              ],
              [
                -43.54203934533279,
                -2.371152855640612
              ],
              [
                -43.54500221281792,
                -2.389905187528453
              ],
              [
                -43.555872711222605,
                -2.4037266166158444
              ],
              [
                -43.56080935472372,
                -2.4170491872460222
              ],
              [
                -43.56080927210603,
                -2.418035938624757
              ],
              [
                -43.57365589155722,
                -2.423468403782816
              ],
              [
                -43.585514195233806,
                -2.4150861994220754
              ],
              [
                -43.60181463416836,
                -2.4116388034512064
              ],
              [
                -43.6072479217157,
                -2.396840987696221
              ],
              [
                -43.61169166047365,
                -2.3850010226756964
              ],
              [
                -43.60774593942224,
                -2.3731633108688324
              ],
              [
                -43.591936376774065,
                -2.368711137938275
              ],
              [
                -43.57958551972442,
                -2.364756020923045
              ],
              [
                -43.5647636628969,
                -2.361293152996007
              ]
            ]
          ],
          [
            [
              [
                -49.47951392674854,
                -1.6553717829627845
              ],
              [
                -49.46476861764527,
                -1.6542656120552623
              ],
              [
                -49.436434250780735,
                -1.664522628364483
              ],
              [
                -49.422843699991795,
                -1.6741814952295295
              ],
              [
                -49.42172802473923,
                -1.6843815807032996
              ],
              [
                -49.4240184235205,
                -1.6968431277621119
              ],
              [
                -49.43197824068928,
                -1.7087302590839633
              ],
              [
                -49.44445942246709,
                -1.7126766635100832
              ],
              [
                -49.468287333892405,
                -1.719436263054916
              ],
              [
                -49.48021824200449,
                -1.7307509314202305
              ],
              [
                -49.49612417042136,
                -1.7426263461312248
              ],
              [
                -49.50860929442264,
                -1.7448720353177403
              ],
              [
                -49.52277360580044,
                -1.7352098637119697
              ],
              [
                -49.529545013858,
                -1.7170574848680795
              ],
              [
                -49.52781634515672,
                -1.7040233246041159
              ],
              [
                -49.52777519354756,
                -1.684185702530262
              ],
              [
                -49.525482445797145,
                -1.6728552618027297
              ],
              [
                -49.51355587521938,
                -1.6632413087220563
              ],
              [
                -49.50163755332564,
                -1.6581621456434847
              ],
              [
                -49.49200020317238,
                -1.6621510604261422
              ],
              [
                -49.47951392674854,
                -1.6553717829627845
              ]
            ]
          ]
        ]
      }

    }
  ]
};
export default brShape;